"use strict";
// THIS IS AUTO-GENERATED BY the-kitchen/tools/utils/documentation/index.ts. EDITS WILL BE LOST.
Object.defineProperty(exports, "__esModule", { value: true });
exports.fileExports = exports.kitchenVersion = exports.componentCategories = exports.categories = exports.allCategories = exports.isKitchenClass = exports.isKitchenInterface = exports.isKitchenVariable = exports.isKitchenType = exports.isKitchenEnum = exports.isKitchenFunction = exports.isComponent = exports.hasName = void 0;
var hasName = function (e) { return e.name !== undefined; };
exports.hasName = hasName;
var isComponent = function (e) {
    return e.type ? e.type.startsWith('React.FunctionComponent') || e.type.startsWith('MicroComponent_') : false;
};
exports.isComponent = isComponent;
var isKitchenFunction = function (e) { return e.kind === 'function'; };
exports.isKitchenFunction = isKitchenFunction;
var isKitchenEnum = function (e) { return e.kind === 'enum'; };
exports.isKitchenEnum = isKitchenEnum;
var isKitchenType = function (e) { return e.kind === 'type'; };
exports.isKitchenType = isKitchenType;
var isKitchenVariable = function (e) { return e.kind === 'variable'; };
exports.isKitchenVariable = isKitchenVariable;
var isKitchenInterface = function (e) { return e.kind === 'interface'; };
exports.isKitchenInterface = isKitchenInterface;
var isKitchenClass = function (e) { return e.kind === 'class'; };
exports.isKitchenClass = isKitchenClass;
exports.allCategories = [
    'Accordions',
    'Alerts',
    'Buttons',
    'Cards',
    'Charts',
    'Displays',
    'Drawers',
    'Dropdowns',
    'Functions',
    'Global',
    'Lists',
    'Media',
    'Micro Components',
    'Modals',
    'Pickers',
    'Pills',
    'Radios',
    'Searches',
    'Sliders',
    'Switches',
    'TabBars',
    'Tables',
    'TextFields',
    'Tiles',
    'ToolTips',
    'TopBars',
    'Visuals',
    '_XIFiles',
    'web-components',
];
exports.categories = [
    'Accordions',
    'Alerts',
    'Buttons',
    'Cards',
    'Charts',
    'Displays',
    'Drawers',
    'Dropdowns',
    'Functions',
    'Global',
    'Lists',
    'Media',
    'Micro Components',
    'Modals',
    'Pickers',
    'Pills',
    'Radios',
    'Searches',
    'Sliders',
    'Switches',
    'TabBars',
    'Tables',
    'TextFields',
    'Tiles',
    'ToolTips',
    'TopBars',
    'Visuals',
];
exports.componentCategories = [
    'Accordions',
    'Alerts',
    'Buttons',
    'Cards',
    'Charts',
    'Displays',
    'Drawers',
    'Dropdowns',
    'Lists',
    'Media',
    'Modals',
    'Pickers',
    'Pills',
    'Radios',
    'Searches',
    'Sliders',
    'Switches',
    'TabBars',
    'Tables',
    'TextFields',
    'Tiles',
    'ToolTips',
    'TopBars',
    'Visuals',
];
// #endregion Categories
exports.kitchenVersion = '18.6.0';
exports.fileExports = [
    {
        kind: 'type',
        name: 'Shadows',
        type: '0 | 3 | 2 | 1 | 6 | 4 | 5 | 7',
        filePath: './src/lib/_XIFiles/XIShadows.ts',
        fileName: 'XIShadows.ts',
        category: '_XIFiles',
    },
    {
        kind: 'variable',
        name: 'XIShadowsDown',
        type: '{ 0: string; 1: string; 2: string; 3: string; 4: string; 5: string; 6: string; 7: string; }',
        filePath: './src/lib/_XIFiles/XIShadows.ts',
        fileName: 'XIShadows.ts',
        category: '_XIFiles',
    },
    {
        kind: 'variable',
        name: 'XIShadowsLeft',
        type: '{ 0: string; 1: string; 2: string; 3: string; 4: string; 5: string; 6: string; 7: string; }',
        filePath: './src/lib/_XIFiles/XIShadows.ts',
        fileName: 'XIShadows.ts',
        category: '_XIFiles',
    },
    {
        kind: 'variable',
        name: 'XIShadowsRight',
        type: '{ 0: string; 1: string; 2: string; 3: string; 4: string; 5: string; 6: string; 7: string; }',
        filePath: './src/lib/_XIFiles/XIShadows.ts',
        fileName: 'XIShadows.ts',
        category: '_XIFiles',
    },
    {
        kind: 'variable',
        name: 'XIShadowsUp',
        type: '{ 0: string; 1: string; 2: string; 3: string; 4: string; 5: string; 6: string; 7: string; }',
        filePath: './src/lib/_XIFiles/XIShadows.ts',
        fileName: 'XIShadows.ts',
        category: '_XIFiles',
    },
    {
        kind: 'variable',
        name: 'Accordion',
        type: "React.ForwardRefExoticComponent<Omit<AccordionProps & AccordionEvents, 'ref'> & React.RefAttributes<HTMLDivElement>>",
        description: 'Description: Navigation component with expandable sections.',
        filePath: './src/lib/Accordions/Accordion/Accordion.tsx',
        fileName: 'Accordion.tsx',
        category: 'Accordions',
    },
    {
        kind: 'interface',
        name: 'Accordion_onItemClickEvent',
        properties: [
            {
                kind: 'interfaceProperty',
                name: 'id',
                type: 'string',
                description: 'The ID of the accordion item that was clicked.',
                required: true,
            },
        ],
        filePath: './src/lib/Accordions/Accordion.model.ts',
        fileName: 'Accordion.model.ts',
        category: 'Accordions',
    },
    {
        kind: 'interface',
        name: 'Accordion_onOpenChangeEvent',
        properties: [
            {
                kind: 'interfaceProperty',
                name: 'open',
                type: 'boolean',
                description: 'Whether the accordion is open.',
                required: true,
            },
        ],
        filePath: './src/lib/Accordions/Accordion.model.ts',
        fileName: 'Accordion.model.ts',
        category: 'Accordions',
    },
    {
        kind: 'class',
        name: 'AccordionEvents',
        extends: 'DivHTMLEvents',
        filePath: './src/lib/Accordions/Accordion/Accordion.tsx',
        fileName: 'Accordion.tsx',
        category: 'Accordions',
    },
    {
        kind: 'variable',
        name: 'AccordionItem',
        type: 'React.FunctionComponent<AccordionItemProps & AccordionItemEvents>',
        description: 'Description: Item to be used solely inside of the Accordion.',
        filePath: './src/lib/Accordions/AccordionItem/AccordionItem.tsx',
        fileName: 'AccordionItem.tsx',
        category: 'Accordions',
    },
    {
        kind: 'class',
        name: 'AccordionItemEvents',
        extends: 'DivHTMLEvents',
        properties: [
            {
                kind: 'classProperty',
                name: 'onItemClick',
                type: '(eventData: Accordion_onItemClickEvent) => void',
                description: 'Fires with the ID of the item that was clicked.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'onOpenChange',
                type: '(eventData: Accordion_onOpenChangeEvent) => void',
                description: 'Fires when the item opens or closes.',
                bound: true,
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Accordions/AccordionItem/AccordionItem.tsx',
        fileName: 'AccordionItem.tsx',
        category: 'Accordions',
    },
    {
        kind: 'class',
        name: 'AccordionItemProps',
        extends: 'ObservablePropsMixin(DivHTMLAttributes)',
        properties: [
            {
                kind: 'classProperty',
                name: 'title',
                type: 'string',
                description: 'Title for the AccordionItem.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'noPadding',
                type: 'boolean',
                description: 'Removes the padding on either side of the accordion item.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'color',
                type: 'Colors | ErrorStates',
                description: 'Color of the title for the AccordionItem.',
                bound: true,
                default: 'orca',
            },
            {
                kind: 'classProperty',
                name: 'id',
                type: 'string',
                description: 'ID that will be returned onItemClick.',
                bound: true,
                default: 'a random uuid',
            },
            {
                kind: 'classProperty',
                name: 'disabled',
                type: 'boolean',
                description: 'Disables the item.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'open',
                type: 'boolean',
                description: 'Controls whether or not the children content is visible.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'icon',
                type: 'Icons',
                description: 'Adds an icon to the bar.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'iconPlacement',
                type: "'text' | 'caret'",
                description: "When set to 'text' the icon is placed directly to the left of the text. When set to\n'caret' the icon is placed directly to the left of the caret.",
                bound: true,
                default: "'caret'",
            },
        ],
        filePath: './src/lib/Accordions/AccordionItem/AccordionItem.tsx',
        fileName: 'AccordionItem.tsx',
        category: 'Accordions',
    },
    {
        kind: 'class',
        name: 'AccordionProps',
        extends: 'DivHTMLAttributes',
        properties: [
            {
                kind: 'classProperty',
                name: 'hasShadow',
                type: 'boolean',
                description: 'Determines whether the accordion has a shadow.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'hasSideBorders',
                type: 'boolean',
                description: 'Shows or hide left & right borders so it can be standalone, or not.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'orientation',
                type: "'normal' | 'inverted'",
                description: "The accordion's orientation.",
                bound: true,
                default: "'normal'",
            },
            {
                kind: 'classProperty',
                name: 'ref',
                type: 'React.Ref<HTMLDivElement>',
                description: 'A react reference applied to the div.',
                default: 'null',
            },
        ],
        filePath: './src/lib/Accordions/Accordion/Accordion.tsx',
        fileName: 'Accordion.tsx',
        category: 'Accordions',
    },
    {
        kind: 'variable',
        name: 'AlertInlineMain',
        type: "React.ForwardRefExoticComponent<Omit<AlertInlineMainProps & AlertInlineMainEvents, 'ref'> & React.RefAttributes<HTMLDivElement>>",
        description: 'Description: Give the user feedback that is good, bad, or a warning.',
        filePath: './src/lib/Alerts/AlertInlineMain/AlertInlineMain.tsx',
        fileName: 'AlertInlineMain.tsx',
        category: 'Alerts',
    },
    {
        kind: 'interface',
        name: 'AlertInlineMainButtons',
        properties: [
            { kind: 'interfaceProperty', name: 'primary', type: 'ButtonObject', required: true },
            { kind: 'interfaceProperty', name: 'secondary', type: 'ButtonObject' },
        ],
        filePath: './src/lib/Alerts/Alert.model.ts',
        fileName: 'Alert.model.ts',
        category: 'Alerts',
    },
    {
        kind: 'class',
        name: 'AlertInlineMainEvents',
        extends: 'DivHTMLEvents',
        filePath: './src/lib/Alerts/AlertInlineMain/AlertInlineMain.tsx',
        fileName: 'AlertInlineMain.tsx',
        category: 'Alerts',
    },
    {
        kind: 'class',
        name: 'AlertInlineMainProps',
        extends: 'DivHTMLAttributes',
        properties: [
            {
                kind: 'classProperty',
                name: 'subtitle',
                type: 'string | JSX.Element',
                description: 'Text for the bottom location of the alert.',
                bound: true,
                required: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'title',
                type: 'string',
                description: 'Text for the top location of the alert.',
                bound: true,
                default: "''",
            },
            {
                kind: 'classProperty',
                name: 'color',
                type: 'AlertsColors',
                description: 'Controls the theme of the alert.',
                bound: true,
                default: "'orca'",
            },
            {
                kind: 'classProperty',
                name: 'isVisible',
                type: 'boolean',
                description: 'Shows or hides the component.',
                bound: true,
                default: 'true',
            },
            {
                kind: 'classProperty',
                name: 'buttons',
                type: 'AlertInlineMainButtons',
                description: 'Controls the buttons on the component.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'width',
                type: "React.CSSProperties['width']",
                description: "The alert's width. Accepts any valid CSS width.",
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'ref',
                type: 'React.Ref<HTMLDivElement>',
                description: 'React ref that is forwarded to the component.',
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Alerts/AlertInlineMain/AlertInlineMain.tsx',
        fileName: 'AlertInlineMain.tsx',
        category: 'Alerts',
    },
    {
        kind: 'type',
        name: 'AlertsColors',
        type: "'admin' | 'orca' | 'EX' | 'EMPLOYEE' | 'CX' | 'CUSTOMER' | 'MX' | 'MARKETING' | 'PX' | 'PRODUCT' | 'CXIC' | 'system' | 'success' | 'warning' | 'error'",
        filePath: './src/lib/Alerts/Alert.model.ts',
        fileName: 'Alert.model.ts',
        category: 'Alerts',
    },
    {
        kind: 'variable',
        name: 'SnackBar',
        type: "React.ForwardRefExoticComponent<Omit<SnackBarProps & SnackBarEvents, 'ref'> & React.RefAttributes<HTMLUListElement>>",
        description: "Description: A popover notification in the bottom right hand corner. Note: 'error' will never auto-dismiss. dismissTime is in milliseconds",
        filePath: './src/lib/Alerts/SnackBar/SnackBar.tsx',
        fileName: 'SnackBar.tsx',
        category: 'Alerts',
    },
    {
        kind: 'interface',
        name: 'SnackBar_onActionClickEvent',
        properties: [
            {
                kind: 'interfaceProperty',
                name: 'dismissedSnackBar',
                type: 'SnackBarProps',
                description: 'The SnackBar object that was dismissed.',
                required: true,
            },
        ],
        filePath: './src/lib/Alerts/Alert.model.ts',
        fileName: 'Alert.model.ts',
        category: 'Alerts',
    },
    {
        kind: 'interface',
        name: 'SnackBar_onDismissEvent',
        properties: [
            {
                kind: 'interfaceProperty',
                name: 'dismissedSnackBar',
                type: 'SnackBarProps',
                description: 'The SnackBar object that was dismissed.',
                required: true,
            },
        ],
        filePath: './src/lib/Alerts/Alert.model.ts',
        fileName: 'Alert.model.ts',
        category: 'Alerts',
    },
    {
        kind: 'interface',
        name: 'SnackBar_onDisplay',
        properties: [
            {
                kind: 'interfaceProperty',
                name: 'snackBar',
                type: 'SnackBarProps',
                description: 'The SnackBar object that was displayed.',
                required: true,
            },
            {
                kind: 'interfaceProperty',
                name: 'close',
                type: 'void',
                description: 'A function that will dismiss the SnackBar.',
                required: true,
            },
        ],
        filePath: './src/lib/Alerts/Alert.model.ts',
        fileName: 'Alert.model.ts',
        category: 'Alerts',
    },
    {
        kind: 'class',
        name: 'SnackBarEvents',
        extends: 'UListHTMLEvents',
        properties: [
            {
                kind: 'classProperty',
                name: 'onDismiss',
                type: '(eventData: SnackBar_onDismissEvent) => void',
                description: 'The callback for when the snack bar is dismissed.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'onActionClick',
                type: '(eventData: SnackBar_onActionClickEvent) => void',
                description: 'The callback for when the snack bar action is clicked.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'onDisplay',
                type: '(eventData: SnackBar_onDisplay) => void',
                description: 'Invoked when the snack bar is displayed.',
                bound: true,
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Alerts/SnackBar/SnackBar.tsx',
        fileName: 'SnackBar.tsx',
        category: 'Alerts',
    },
    {
        kind: 'type',
        name: 'SnackBarModes',
        type: "'error' | 'default'",
        filePath: './src/lib/Alerts/Alert.model.ts',
        fileName: 'Alert.model.ts',
        category: 'Alerts',
    },
    {
        kind: 'class',
        name: 'SnackBarProps',
        extends: 'UListHTMLAttributes',
        properties: [
            {
                kind: 'classProperty',
                name: 'autoDismiss',
                type: 'boolean',
                description: "Controls whether or not the snack bar auto dismisses.\nNote: Auto Dismiss is disabled for 'error' mode",
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'mode',
                type: 'SnackBarModes',
                description: 'Controls the mode that the snack bar is in',
                bound: true,
                default: "'default'",
            },
            {
                kind: 'classProperty',
                name: 'text',
                type: 'string',
                description: 'The text displayed in the snack bar',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'id',
                type: 'string',
                description: 'The id assigned to the snack bar, the id must be unique in order to create more snackbars.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'dismissTime',
                type: 'number',
                description: 'The time after which the snackbar will auto dismiss, in milliseconds.\nError mode snack bars do not auto dismiss',
                bound: true,
                default: '5000',
            },
            {
                kind: 'classProperty',
                name: 'actionText',
                type: 'string',
                description: 'The action text displayed on the button in the snack bar (dismisses the snack bar)',
                bound: true,
                default: "'Dismiss'",
            },
            {
                kind: 'classProperty',
                name: 'isActionTextBelow',
                type: 'boolean',
                description: 'Where the action text appears on the component. Either to the right of the text (false) or\nunder the text (true)',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'progressBarProps',
                type: 'ProgressBarPropsAndEvents',
                description: 'If provided, displays a progress bar with the specified props',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'ref',
                type: 'React.Ref<HTMLUListElement>',
                description: 'React ref that is forwarded to the component.',
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Alerts/SnackBar/SnackBar.tsx',
        fileName: 'SnackBar.tsx',
        category: 'Alerts',
    },
    {
        kind: 'type',
        name: 'SnackBarPropsAndEvents',
        type: "Omit<SnackBarProps & SnackBarEvents, 'ref'> & React.RefAttributes<HTMLUListElement>",
        filePath: './src/lib/Alerts/SnackBar/SnackBar.tsx',
        fileName: 'SnackBar.tsx',
        category: 'Alerts',
    },
    {
        kind: 'variable',
        name: 'SuccessToaster',
        type: "React.ForwardRefExoticComponent<Omit<SuccessToasterProps & SuccessToasterEvents, 'ref'> & React.RefAttributes<HTMLDivElement>>",
        description: 'Description: Toaster that pops up and displays a success message displaying to them a good time.',
        filePath: './src/lib/Alerts/SuccessToaster/SuccessToaster.tsx',
        fileName: 'SuccessToaster.tsx',
        category: 'Alerts',
    },
    {
        kind: 'class',
        name: 'SuccessToasterEvents',
        extends: 'DivHTMLEvents',
        filePath: './src/lib/Alerts/SuccessToaster/SuccessToaster.tsx',
        fileName: 'SuccessToaster.tsx',
        category: 'Alerts',
    },
    {
        kind: 'class',
        name: 'SuccessToasterProps',
        extends: 'DivHTMLAttributes',
        properties: [
            {
                kind: 'classProperty',
                name: 'title',
                type: 'string',
                description: 'The title of the success toaster',
                bound: true,
                required: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'subtitle',
                type: 'string',
                description: 'The subtitle of the success toaster',
                bound: true,
                required: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'isVisible',
                type: 'boolean',
                description: 'Shows and hides the success toaster.',
                bound: true,
                required: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'ref',
                type: 'React.Ref<HTMLDivElement>',
                description: 'React ref that is forwarded to the component.',
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Alerts/SuccessToaster/SuccessToaster.tsx',
        fileName: 'SuccessToaster.tsx',
        category: 'Alerts',
    },
    {
        kind: 'variable',
        name: 'WarningPopup',
        type: "React.ForwardRefExoticComponent<Omit<WarningPopupProps & WarningPopupEvents, 'ref'> & React.RefAttributes<HTMLDivElement>>",
        description: "Description: Modal when you want to warn the user of something. Can be used as an 'Are you sure?' reminder.",
        filePath: './src/lib/Alerts/WarningPopup/WarningPopup.tsx',
        fileName: 'WarningPopup.tsx',
        category: 'Alerts',
    },
    {
        kind: 'interface',
        name: 'WarningPopup_onCancelEvent',
        properties: [
            {
                kind: 'interfaceProperty',
                name: 'mouseEvent',
                type: 'React.MouseEvent<HTMLButtonElement, MouseEvent> | React.MouseEvent<HTMLDivElement, MouseEvent>',
                required: true,
            },
        ],
        filePath: './src/lib/Alerts/Alert.model.ts',
        fileName: 'Alert.model.ts',
        category: 'Alerts',
    },
    {
        kind: 'interface',
        name: 'WarningPopup_onProceedEvent',
        properties: [
            {
                kind: 'interfaceProperty',
                name: 'mouseEvent',
                type: 'React.MouseEvent<HTMLButtonElement, MouseEvent> | React.MouseEvent<HTMLDivElement, MouseEvent>',
                required: true,
            },
        ],
        filePath: './src/lib/Alerts/Alert.model.ts',
        fileName: 'Alert.model.ts',
        category: 'Alerts',
    },
    {
        kind: 'interface',
        name: 'WarningPopupButtons',
        properties: [
            { kind: 'interfaceProperty', name: 'cancel', type: 'ButtonObject', required: true },
            { kind: 'interfaceProperty', name: 'proceed', type: 'ButtonObject', required: true },
        ],
        filePath: './src/lib/Alerts/Alert.model.ts',
        fileName: 'Alert.model.ts',
        category: 'Alerts',
    },
    {
        kind: 'class',
        name: 'WarningPopupEvents',
        extends: 'DivHTMLEvents',
        properties: [
            {
                kind: 'classProperty',
                name: 'onProceed',
                type: '(eventData: WarningPopup_onProceedEvent) => void',
                description: 'Event that fires when you click on the Proceed button',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'onCancel',
                type: '(eventData: WarningPopup_onCancelEvent) => void',
                description: 'Event that fires when you click on the Cancel Button.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'genericModalEvents',
                type: 'GenericModalEvents',
                description: 'Allows users to pass events to control the generic modal',
                bound: true,
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Alerts/WarningPopup/WarningPopup.tsx',
        fileName: 'WarningPopup.tsx',
        category: 'Alerts',
    },
    {
        kind: 'class',
        name: 'WarningPopupProps',
        extends: 'ObservablePropsMixin(DivHTMLAttributes)',
        properties: [
            {
                kind: 'classProperty',
                name: 'isVisible',
                type: 'boolean',
                description: 'Determines whether or not the popup is visible.',
                bound: true,
                required: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'buttons',
                type: 'WarningPopupButtons',
                description: 'Controls the buttons on the component.',
                bound: true,
                required: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'title',
                type: 'string',
                description: 'Title in the component.',
                bound: true,
                default: "'Warning'",
            },
            {
                kind: 'classProperty',
                name: 'subtitle',
                type: 'string',
                description: 'Warning message text of the component.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'stretch',
                type: 'boolean',
                description: 'Allows stretching past the maximum length',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'genericModalProps',
                type: 'GenericModalProps',
                description: 'Allows users to pass props to control the generic modal',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'ref',
                type: 'React.Ref<HTMLDivElement>',
                description: 'React ref that is forwarded to the component.',
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Alerts/WarningPopup/WarningPopup.tsx',
        fileName: 'WarningPopup.tsx',
        category: 'Alerts',
    },
    {
        kind: 'type',
        name: 'ButtonColors',
        type: "'admin' | 'orca' | 'EX' | 'EMPLOYEE' | 'CX' | 'CUSTOMER' | 'MX' | 'MARKETING' | 'PX' | 'PRODUCT' | 'CXIC' | 'system' | 'success' | 'warning' | 'error'",
        filePath: './src/lib/Buttons/Button.model.ts',
        fileName: 'Button.model.ts',
        category: 'Buttons',
    },
    {
        kind: 'type',
        name: 'ButtonSizes',
        type: "'normal' | 'large' | 'small' | 'xxlarge'",
        filePath: './src/lib/Buttons/Button.model.ts',
        fileName: 'Button.model.ts',
        category: 'Buttons',
    },
    {
        kind: 'type',
        name: 'ButtonTypes',
        type: "'text' | 'fill' | 'no-fill' | 'outline' | 'link'",
        filePath: './src/lib/Buttons/Button.model.ts',
        fileName: 'Button.model.ts',
        category: 'Buttons',
    },
    {
        kind: 'variable',
        name: 'Checkbox',
        type: "React.ForwardRefExoticComponent<Omit<CheckboxProps & CheckboxEvents, 'ref'> & React.RefAttributes<HTMLInputElement>>",
        description: "Description: Your friendly standard InMoment neighborhood Checkbox. Does not support the 'text' attribute in status.",
        filePath: './src/lib/Buttons/Checkbox/Checkbox.tsx',
        fileName: 'Checkbox.tsx',
        category: 'Buttons',
    },
    {
        kind: 'interface',
        name: 'Checkbox_onCheckedChange',
        properties: [
            {
                kind: 'interfaceProperty',
                name: 'isChecked',
                type: 'boolean',
                description: 'Indicates whether the checkbox is currently checked.',
                required: true,
            },
        ],
        filePath: './src/lib/Buttons/Button.model.ts',
        fileName: 'Button.model.ts',
        category: 'Buttons',
    },
    {
        kind: 'class',
        name: 'CheckboxEvents',
        extends: 'InputHTMLEvents',
        properties: [
            {
                kind: 'classProperty',
                name: 'onCheckedChange',
                type: '(event: Checkbox_onCheckedChange) => void',
                description: 'Fired when the user toggles the checkbox.',
                bound: true,
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Buttons/Checkbox/Checkbox.tsx',
        fileName: 'Checkbox.tsx',
        category: 'Buttons',
    },
    {
        kind: 'class',
        name: 'CheckboxProps',
        extends: 'ObservablePropsMixin(InputHTMLAttributes)',
        properties: [
            {
                kind: 'classProperty',
                name: 'checked',
                type: 'boolean',
                description: 'Controls state of checkbox.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'color',
                type: 'Colors',
                description: 'Controls fill of checkbox.',
                bound: true,
                default: "'orca'",
            },
            {
                kind: 'classProperty',
                name: 'contrast',
                type: 'Contrasts',
                description: 'Determines how easy it will be to see on dark backgrounds.',
                bound: true,
                default: "'normal'",
            },
            {
                kind: 'classProperty',
                name: 'tooltip',
                type: 'ToolTipProps',
                description: 'Adds a tooltip to the component.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'label',
                type: 'string',
                description: 'Text shown next to the checkbox, acts as the label when provided.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'isLabelLeft',
                type: 'boolean',
                description: 'Controls which side the text goes on.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'isIndeterminate',
                type: 'boolean',
                description: 'Shows the indeterminate icon instead of the checkmark.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'status',
                type: 'ErrorStates | ErrorObject | null',
                description: 'Shows success, error, or warning state.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'inputId',
                type: 'string',
                description: 'Used only if you are using external labels with this input, NOT the regular ID.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'internalProps',
                type: 'InternalCheckboxProps',
                description: 'Contains additional prop objects, useful for further modification / information influencing the component.',
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'ref',
                type: 'React.Ref<HTMLInputElement>',
                description: 'Allows for ref passing to the wrapper component',
                default: 'null',
            },
        ],
        filePath: './src/lib/Buttons/Checkbox/Checkbox.tsx',
        fileName: 'Checkbox.tsx',
        category: 'Buttons',
    },
    {
        kind: 'type',
        name: 'CheckboxState',
        type: "'checked' | 'indeterminate' | 'unchecked'",
        filePath: './src/lib/Buttons/Button.model.ts',
        fileName: 'Button.model.ts',
        category: 'Buttons',
    },
    {
        kind: 'variable',
        name: 'DefaultButton',
        type: "React.ForwardRefExoticComponent<Omit<DefaultButtonProps & DefaultButtonEvents, 'ref'> & React.RefAttributes<HTMLButtonElement>>",
        description: "Description: This is standard button and should be used whenever possible. A small button is also acceptable. Don't use all caps in buttons. Status will override all colors.",
        filePath: './src/lib/Buttons/DefaultButton/DefaultButton.tsx',
        fileName: 'DefaultButton.tsx',
        category: 'Buttons',
    },
    {
        kind: 'interface',
        name: 'DefaultButton_onIconClickEvent',
        properties: [
            {
                kind: 'interfaceProperty',
                name: 'iconSide',
                type: "'Left' | 'Right'",
                description: 'The side that the icon is on inside the button',
                required: true,
            },
        ],
        filePath: './src/lib/Buttons/Button.model.ts',
        fileName: 'Button.model.ts',
        category: 'Buttons',
    },
    {
        kind: 'class',
        name: 'DefaultButtonEvents',
        extends: 'ButtonHTMLEvents',
        properties: [
            {
                kind: 'classProperty',
                name: 'onIconClick',
                type: '(eventData: DefaultButton_onIconClickEvent) => void',
                description: 'Fires onclick of the icon buttons',
                bound: true,
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Buttons/DefaultButton/DefaultButton.tsx',
        fileName: 'DefaultButton.tsx',
        category: 'Buttons',
    },
    {
        kind: 'class',
        name: 'DefaultButtonProps',
        extends: 'ButtonHTMLAttributes',
        properties: [
            {
                kind: 'classProperty',
                name: 'text',
                type: 'string',
                description: 'Text to display in the center of the button.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'fill',
                type: 'ButtonTypes',
                description: 'Changes the fill type of the button.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'buttonSize',
                type: 'ButtonSizes',
                description: "Controls if it's a large or small button, small button does not have an icon. Ignored if fill type is link.",
                bound: true,
                default: "'normal'",
            },
            {
                kind: 'classProperty',
                name: 'color',
                type: 'ButtonColors',
                description: 'Changes the color fill of the button. Default is CX when fill type is link and orca otherwise.',
                bound: true,
                default: "'orca'",
            },
            {
                kind: 'classProperty',
                name: 'sentimentIndicator',
                type: 'Sentiments',
                description: 'Controls if there is a line indicator below the button and what color it is',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'contrast',
                type: 'Contrasts',
                description: 'Determines how easy it will be to see on dark backgrounds.',
                bound: true,
                default: "'normal'",
            },
            {
                kind: 'classProperty',
                name: 'hasAnimation',
                type: 'boolean',
                description: 'Controls whether the button has a bounce animation (or shake on error).',
                bound: true,
                default: 'true',
            },
            {
                kind: 'classProperty',
                name: 'hasShadows',
                type: 'boolean',
                description: 'Controls whether or not shadows exist on the button.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'iconLeft',
                type: 'Icons | AppIcons',
                description: 'The icon displayed on the left hand side of the button.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'iconRight',
                type: 'Icons | AppIcons',
                description: 'The icon displayed on the right hand side of the button.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'isIconRightButton',
                type: 'boolean',
                description: "If true the icon displayed on the right hand side of the button\nwill be an icon button. Clicking the button will result in\nonIconClick('Right')",
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'isIconLeftButton',
                type: 'boolean',
                description: "If true the icon displayed on the left hand side of the button\nwill be an icon button. Clicking the button will result in\nonIconClick('Left')",
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'textIconAlignment',
                type: "React.CSSProperties['justifyContent']",
                description: 'Controls the alignment of the text and icon inside the button.',
                bound: true,
                default: "'center'",
            },
            {
                kind: 'classProperty',
                name: 'status',
                type: 'ErrorStates | null',
                description: 'Shows success, error, or warning state.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'tone',
                type: 'Tones',
                description: 'Determines if the button has a lighter colored background.',
                bound: true,
                default: "'normal'",
            },
            {
                kind: 'classProperty',
                name: 'wrap',
                type: 'WhiteSpaceProperty',
                description: "Allows to control the button's text wrap.",
                bound: true,
                default: "'nowrap'",
            },
            {
                kind: 'classProperty',
                name: 'ref',
                type: 'React.Ref<HTMLButtonElement>',
                description: 'Allows for ref passing to the wrapper component',
                bound: true,
                default: 'null',
            },
            {
                kind: 'classProperty',
                name: 'tooltip',
                type: 'ToolTipProps',
                description: 'Tooltip to display.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'tooltipDisplayOnDisabled',
                type: 'boolean',
                description: 'Forces the tooltip to display even when the button is disabled',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'stretch',
                type: 'boolean',
                description: 'Controls the ability to allow a button to stretch the full width of its parent container.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'tag',
                type: 'string',
                description: 'A Text value that will show in bold before the text for the button',
                bound: true,
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Buttons/DefaultButton/DefaultButton.tsx',
        fileName: 'DefaultButton.tsx',
        category: 'Buttons',
    },
    {
        kind: 'variable',
        name: 'FAB',
        type: "React.ForwardRefExoticComponent<Omit<FABProps & FABEvents, 'ref'> & React.RefAttributes<HTMLButtonElement>>",
        description: 'Description: Floating Action Button - used to put over the flow of the document.',
        filePath: './src/lib/Buttons/FAB/FAB.tsx',
        fileName: 'FAB.tsx',
        category: 'Buttons',
    },
    {
        kind: 'class',
        name: 'FABEvents',
        extends: 'ButtonHTMLEvents',
        filePath: './src/lib/Buttons/FAB/FAB.tsx',
        fileName: 'FAB.tsx',
        category: 'Buttons',
    },
    {
        kind: 'class',
        name: 'FABProps',
        extends: 'ButtonHTMLAttributes',
        properties: [
            {
                kind: 'classProperty',
                name: 'icon',
                type: 'Icons',
                description: 'The icon to display on the button.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'color',
                type: 'Colors',
                description: 'The color of the button.',
                bound: true,
                default: "'CX'",
            },
            {
                kind: 'classProperty',
                name: 'contrast',
                type: 'Contrasts',
                description: "Controls if the background is colored or the icon. 'high' is useful\nfor when placed on darker backgrounds.",
                bound: true,
                default: "'normal'",
            },
            {
                kind: 'classProperty',
                name: 'tooltip',
                type: 'ToolTipProps',
                description: 'Adds a tooltip to the component.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'buttonSize',
                type: 'FABSizes',
                description: "Determines the size of the fab button. 'xxlarge' is 54px (current size)\n'normal' is 36px. These are the only two supported sizes for FAB",
                bound: true,
                default: "'xxlarge'",
            },
            {
                kind: 'classProperty',
                name: 'ref',
                type: 'React.Ref<HTMLButtonElement>',
                description: 'A react reference applied to the button.',
                default: 'null',
            },
        ],
        filePath: './src/lib/Buttons/FAB/FAB.tsx',
        fileName: 'FAB.tsx',
        category: 'Buttons',
    },
    {
        kind: 'type',
        name: 'FABSizes',
        type: "'normal' | 'xxlarge' | 'xlarge'",
        filePath: './src/lib/Buttons/Button.model.ts',
        fileName: 'Button.model.ts',
        category: 'Buttons',
    },
    {
        kind: 'variable',
        name: 'FilterButton',
        type: "React.ForwardRefExoticComponent<Omit<FilterButtonProps & FilterButtonEvents, 'ref'> & React.RefAttributes<HTMLButtonElement>>",
        description: 'Description: Used for the filter row, has options to indicate the status of a filter.',
        filePath: './src/lib/Buttons/FilterButton/FilterButton.tsx',
        fileName: 'FilterButton.tsx',
        category: 'Buttons',
    },
    {
        kind: 'class',
        name: 'FilterButtonEvents',
        extends: 'ButtonHTMLEvents',
        properties: [
            {
                kind: 'classProperty',
                name: 'onCancelClick',
                type: '() => void',
                description: 'Fires onclick of the cancel icon.',
                bound: true,
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Buttons/FilterButton/FilterButton.tsx',
        fileName: 'FilterButton.tsx',
        category: 'Buttons',
    },
    {
        kind: 'type',
        name: 'FilterButtonFocus',
        type: "'focus' | 'blur'",
        filePath: './src/lib/Buttons/Button.model.ts',
        fileName: 'Button.model.ts',
        category: 'Buttons',
    },
    {
        kind: 'class',
        name: 'FilterButtonProps',
        extends: 'ButtonHTMLAttributes',
        properties: [
            {
                kind: 'classProperty',
                name: 'isActive',
                type: 'boolean',
                description: 'Controls whether the filter button is active or inactive.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'isFocused',
                type: 'boolean',
                description: 'Controls the focus state (if set, it will disable internal state tracking).',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'text',
                type: 'string',
                description: 'Controls text of the button.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'color',
                type: 'ButtonColors',
                description: 'Controls fill of button.',
                bound: true,
                default: "'orca'",
            },
            {
                kind: 'classProperty',
                name: 'status',
                type: 'ErrorStates | null',
                description: 'Shows success, error, or warning state.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'contrast',
                type: 'Contrasts',
                description: 'Controls contrast of the button.',
                bound: true,
                default: "'normal'",
            },
            {
                kind: 'classProperty',
                name: 'disabled',
                type: 'boolean',
                description: 'Controls whether the button is disabled.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'label',
                type: 'string',
                description: 'Controls whether the button has a label.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'hasRemoveIcon',
                type: 'boolean',
                description: 'Controls whether the cancel button is shown.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'isRemoveIconInline',
                type: 'boolean',
                description: 'Controls whether the icon appears inside the button or externally',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'wrap',
                type: 'WhiteSpaceProperty',
                description: "Allows to control the button's text wrap.",
                bound: true,
                default: "'nowrap'",
            },
            {
                kind: 'classProperty',
                name: 'ref',
                type: 'React.Ref<HTMLButtonElement>',
                description: 'Allows for ref passing to the wrapper component',
                default: 'null',
            },
        ],
        filePath: './src/lib/Buttons/FilterButton/FilterButton.tsx',
        fileName: 'FilterButton.tsx',
        category: 'Buttons',
    },
    {
        kind: 'type',
        name: 'FilterButtonTypes',
        type: "'active' | 'inactive'",
        filePath: './src/lib/Buttons/Button.model.ts',
        fileName: 'Button.model.ts',
        category: 'Buttons',
    },
    {
        kind: 'variable',
        name: 'HeadingButton',
        type: "React.ForwardRefExoticComponent<Omit<HeadingButtonProps & HeadingButtonEvents, 'ref'> & React.RefAttributes<HTMLButtonElement>>",
        description: 'Description: A clickable button with the only visual being text, commonly used in Headings.',
        filePath: './src/lib/Buttons/HeadingButton/HeadingButton.tsx',
        fileName: 'HeadingButton.tsx',
        category: 'Buttons',
    },
    {
        kind: 'class',
        name: 'HeadingButtonEvents',
        extends: 'ButtonHTMLEvents',
        filePath: './src/lib/Buttons/HeadingButton/HeadingButton.tsx',
        fileName: 'HeadingButton.tsx',
        category: 'Buttons',
    },
    {
        kind: 'class',
        name: 'HeadingButtonProps',
        extends: 'ButtonHTMLAttributes',
        properties: [
            {
                kind: 'classProperty',
                name: 'title',
                type: 'string',
                description: 'Text for the button.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'color',
                type: 'TextColors',
                description: 'Color of the button text.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'dangerouslySetInnerHTML',
                type: '{ __html: string }',
                description: "Access to Reacts 'dangerouslySetInnerHTML' - only for internal use. It will overwrite title.",
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'contrast',
                type: 'Contrasts',
                description: 'Determines how easy it will be to see on dark backgrounds.',
                bound: true,
                default: 'normal',
            },
            {
                kind: 'classProperty',
                name: 'ref',
                type: 'React.Ref<HTMLButtonElement>',
                description: 'Allows for ref passing to the wrapper component',
                default: 'null',
            },
        ],
        filePath: './src/lib/Buttons/HeadingButton/HeadingButton.tsx',
        fileName: 'HeadingButton.tsx',
        category: 'Buttons',
    },
    {
        kind: 'variable',
        name: 'IconButton',
        type: "React.ForwardRefExoticComponent<Omit<IconButtonProps & IconButtonEvents, 'ref'> & React.RefAttributes<HTMLButtonElement>>",
        description: 'Description: Button for when you want to use one of our icons, and make it clickable! Has an on and off state.',
        filePath: './src/lib/Buttons/IconButton/IconButton.tsx',
        fileName: 'IconButton.tsx',
        category: 'Buttons',
    },
    {
        kind: 'interface',
        name: 'IconButton_onActiveChangeEvent',
        properties: [
            {
                kind: 'interfaceProperty',
                name: 'isActive',
                type: 'boolean',
                description: 'True if the icon is currently active',
                required: true,
            },
        ],
        filePath: './src/lib/Buttons/Button.model.ts',
        fileName: 'Button.model.ts',
        category: 'Buttons',
    },
    {
        kind: 'class',
        name: 'IconButtonEvents',
        extends: 'ButtonHTMLEvents',
        properties: [
            {
                kind: 'classProperty',
                name: 'onActiveChange',
                type: '(eventData: IconButton_onActiveChangeEvent) => void',
                description: 'Fires on change of the active state',
                bound: true,
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Buttons/IconButton/IconButton.tsx',
        fileName: 'IconButton.tsx',
        category: 'Buttons',
    },
    {
        kind: 'class',
        name: 'IconButtonProps',
        extends: 'ObservablePropsMixin(ButtonHTMLAttributes)',
        properties: [
            {
                kind: 'classProperty',
                name: 'icon',
                type: 'Icons',
                description: 'Name of icon.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'color',
                type: 'IconColors',
                description: 'Color of icon.',
                bound: true,
                default: "'orca'",
            },
            {
                kind: 'classProperty',
                name: 'fill',
                type: 'ButtonTypes',
                description: 'Changes the fill type of the button.',
                bound: true,
                default: "'text'",
            },
            {
                kind: 'classProperty',
                name: 'contrast',
                type: 'Contrasts',
                description: 'Determines how easy it will be to see on dark backgrounds.',
                bound: true,
                default: "'normal'",
            },
            {
                kind: 'classProperty',
                name: 'hasAnimation',
                type: 'boolean',
                description: 'Controls whether the button has a bounce animation (or shake on error).',
                bound: true,
                default: 'true',
            },
            {
                kind: 'classProperty',
                name: 'disabled',
                type: 'boolean',
                description: 'Determines whether or not the button is clickable.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'hasState',
                type: 'boolean',
                description: 'Toggles the buttons ability to have an on / off state.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'active',
                type: 'boolean',
                description: 'Sets the active state.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'buttonSize',
                type: "ComponentSizes | 'small'",
                description: 'Size of the button.',
                bound: true,
                default: 'normal',
            },
            {
                kind: 'classProperty',
                name: 'tooltip',
                type: 'ToolTipProps',
                description: 'Tooltip to display.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'ref',
                type: 'React.Ref<HTMLButtonElement>',
                description: 'Allows for ref passing to the wrapper component',
                default: 'null',
            },
        ],
        filePath: './src/lib/Buttons/IconButton/IconButton.tsx',
        fileName: 'IconButton.tsx',
        category: 'Buttons',
    },
    {
        kind: 'interface',
        name: 'InternalCheckboxProps',
        properties: [
            {
                kind: 'interfaceProperty',
                name: 'outerWrapper',
                type: 'React.HTMLAttributes<HTMLDivElement>',
                description: 'Props for the outermost wrapper element of the Checkbox.',
            },
            {
                kind: 'interfaceProperty',
                name: 'wrapper',
                type: 'DivProps',
                description: 'Props for the element containing the visible checkbox element.',
            },
        ],
        filePath: './src/lib/Buttons/Button.model.ts',
        fileName: 'Button.model.ts',
        category: 'Buttons',
    },
    {
        kind: 'type',
        name: 'MenuButtonSizes',
        type: "'normal' | 'large'",
        filePath: './src/lib/Buttons/Button.model.ts',
        fileName: 'Button.model.ts',
        category: 'Buttons',
    },
    {
        kind: 'variable',
        name: 'MotionDiv',
        type: 'React.FunctionComponent<MotionDivProps>',
        description: 'Description: An internal component used for animation.',
        filePath: './src/lib/Buttons/DefaultButton/DefaultButton.tsx',
        fileName: 'DefaultButton.tsx',
        category: 'Buttons',
    },
    {
        kind: 'variable',
        name: 'SentimentButton',
        type: "React.ForwardRefExoticComponent<Omit<SentimentButtonProps & SentimentButtonEvents, 'ref'> & React.RefAttributes<HTMLButtonElement>>",
        description: 'Description: Button for displaying our various sentiments. Has a focused and non-focused state.',
        filePath: './src/lib/Buttons/SentimentButton/SentimentButton.tsx',
        fileName: 'SentimentButton.tsx',
        category: 'Buttons',
    },
    {
        kind: 'class',
        name: 'SentimentButtonEvents',
        extends: 'ButtonHTMLEvents',
        filePath: './src/lib/Buttons/SentimentButton/SentimentButton.tsx',
        fileName: 'SentimentButton.tsx',
        category: 'Buttons',
    },
    {
        kind: 'class',
        name: 'SentimentButtonProps',
        extends: 'ObservablePropsMixin(ButtonHTMLAttributes)',
        properties: [
            {
                kind: 'classProperty',
                name: 'sentiment',
                type: 'Sentiments',
                description: 'Controls the color and text of the button to match sentiment.',
                bound: true,
                required: true,
                default: "'neutral'",
            },
            {
                kind: 'classProperty',
                name: 'text',
                type: 'string',
                description: 'Allows for changing of hard-coded component text.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'isFocused',
                type: 'boolean',
                description: 'Controls the state of the button.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'wrap',
                type: 'WhiteSpaceProperty',
                description: "Allows to control the button's text wrap.",
                bound: true,
                default: "'nowrap'",
            },
            {
                kind: 'classProperty',
                name: 'ref',
                type: 'React.Ref<HTMLButtonElement>',
                description: 'Allows for ref passing to the wrapper component',
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Buttons/SentimentButton/SentimentButton.tsx',
        fileName: 'SentimentButton.tsx',
        category: 'Buttons',
    },
    {
        kind: 'variable',
        name: 'TileButton',
        type: "React.ForwardRefExoticComponent<Omit<TileButtonProps & TileButtonEvents, 'ref'> & React.RefAttributes<HTMLButtonElement>>",
        description: 'Description: A rectangular button.',
        filePath: './src/lib/Buttons/TileButton/TileButton.tsx',
        fileName: 'TileButton.tsx',
        category: 'Buttons',
    },
    {
        kind: 'interface',
        name: 'TileButton_onIsSelectedChangeEvent',
        properties: [
            { kind: 'interfaceProperty', name: 'isSelected', type: 'boolean', required: true },
            { kind: 'interfaceProperty', name: 'id', type: 'string' },
        ],
        filePath: './src/lib/Buttons/Button.model.ts',
        fileName: 'Button.model.ts',
        category: 'Buttons',
    },
    {
        kind: 'type',
        name: 'TileButtonCornerControlTypes',
        type: "'cancel' | 'checkmark'",
        filePath: './src/lib/Buttons/Button.model.ts',
        fileName: 'Button.model.ts',
        category: 'Buttons',
    },
    {
        kind: 'class',
        name: 'TileButtonEvents',
        extends: 'ButtonHTMLEvents',
        properties: [
            {
                kind: 'classProperty',
                name: 'onCornerControlClick',
                type: '() => void',
                description: 'A callback that fires when the corner control is clicked.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'onIsSelectedChange',
                type: '(eventData: TileButton_onIsSelectedChangeEvent) => void',
                description: 'A callback that fires when the isSelected value changes',
                bound: true,
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Buttons/TileButton/TileButton.tsx',
        fileName: 'TileButton.tsx',
        category: 'Buttons',
    },
    {
        kind: 'interface',
        name: 'TileButtonImageProps',
        properties: [
            { kind: 'interfaceProperty', name: 'src', type: 'string' },
            { kind: 'interfaceProperty', name: 'alt', type: 'string' },
        ],
        filePath: './src/lib/Buttons/Button.model.ts',
        fileName: 'Button.model.ts',
        category: 'Buttons',
    },
    {
        kind: 'interface',
        name: 'TileButtonLabelProps',
        properties: [
            { kind: 'interfaceProperty', name: 'width', type: "React.CSSProperties['width']" },
            { kind: 'interfaceProperty', name: 'fontSize', type: "React.CSSProperties['fontSize']" },
            { kind: 'interfaceProperty', name: 'truncate', type: 'boolean' },
        ],
        filePath: './src/lib/Buttons/Button.model.ts',
        fileName: 'Button.model.ts',
        category: 'Buttons',
    },
    {
        kind: 'class',
        name: 'TileButtonProps',
        extends: 'ObservablePropsMixin(ButtonHTMLAttributes)',
        properties: [
            {
                kind: 'classProperty',
                name: 'color',
                type: 'Colors',
                description: 'Top banner color.',
                bound: true,
                default: "'orca'",
            },
            {
                kind: 'classProperty',
                name: 'padding',
                type: "React.CSSProperties['padding']",
                description: 'Padding for the button (does not affect label).',
                bound: true,
                default: "(size === 'normal' && '6px') || ((size === 'large' || size === 'xlarge') && '18px') || '0px'",
            },
            {
                kind: 'classProperty',
                name: 'isSelected',
                type: 'boolean',
                description: 'Determines if the tile is selected.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'stretch',
                type: 'boolean',
                description: 'If true, component size will match its parent, otherwise the size is determined by its children.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'tooltipProps',
                type: 'ToolTipProps',
                description: 'Allows customizing the tooltip.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'contentType',
                type: 'TileButtonTypes',
                description: 'The type of the content in this button.',
                bound: true,
                default: "'icon'",
            },
            {
                kind: 'classProperty',
                name: 'iconProps',
                type: 'XIIconProps | XIAppIconProps',
                description: "If type is 'icon', allows customizing how the icon is displayed.",
                bound: true,
                default: "Object(color: 'orca')",
            },
            {
                kind: 'classProperty',
                name: 'imageProps',
                type: 'TileButtonImageProps',
                description: "If type is 'image', allows customizing how the image is displayed.",
                bound: true,
                default: "Object(alt: '')",
            },
            {
                kind: 'classProperty',
                name: 'size',
                type: 'TileButtonSizes',
                description: "Determines the button's size.",
                bound: true,
                default: "'normal'",
            },
            {
                kind: 'classProperty',
                name: 'label',
                type: 'string',
                description: 'The label to display along the bottom of the button.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'labelProps',
                type: 'TileButtonLabelProps',
                description: 'If label is present, allows customizing how the label is displayed.\ntruncate: Truncates label with ellipsis if it is too large. If truncated, hovering over the label will display a tooltip with the full text.',
                bound: true,
                default: "Object(truncate: false, fontSize: (size === 'normal' && '12px') || ((size === 'large' || size === 'xlarge') && '16px') || '14px')",
            },
            {
                kind: 'classProperty',
                name: 'hasShadow',
                type: 'boolean',
                description: 'Determines whether the button has a shadow.',
                bound: true,
                default: 'true',
            },
            {
                kind: 'classProperty',
                name: 'cornerControlType',
                type: 'TileButtonCornerControlTypes',
                description: 'If isSelected, determines what kind of control to show in the top-right corner, if any.',
                bound: true,
                default: "'none'",
            },
            {
                kind: 'classProperty',
                name: 'ref',
                type: 'React.Ref<HTMLButtonElement>',
                description: 'A react reference applied to the button.',
                default: 'null',
            },
        ],
        filePath: './src/lib/Buttons/TileButton/TileButton.tsx',
        fileName: 'TileButton.tsx',
        category: 'Buttons',
    },
    {
        kind: 'type',
        name: 'TileButtonSizes',
        type: "'normal' | 'large' | 'xlarge' | { width?: Property.Width<string | number> | undefined; height?: Property.Height<string | number> | undefined; }",
        filePath: './src/lib/Buttons/Button.model.ts',
        fileName: 'Button.model.ts',
        category: 'Buttons',
    },
    {
        kind: 'type',
        name: 'TileButtonTypes',
        type: "'icon' | 'image'",
        filePath: './src/lib/Buttons/Button.model.ts',
        fileName: 'Button.model.ts',
        category: 'Buttons',
    },
    {
        kind: 'type',
        name: 'Tones',
        type: "'normal' | 'light'",
        filePath: './src/lib/Buttons/Button.model.ts',
        fileName: 'Button.model.ts',
        category: 'Buttons',
    },
    {
        kind: 'variable',
        name: 'Comment',
        type: 'React.ForwardRefExoticComponent<CommentProps & CommentEvents & React.RefAttributes<HTMLDivElement>>',
        filePath: './src/lib/Cards/Comment/Comment.tsx',
        fileName: 'Comment.tsx',
        category: 'Cards',
    },
    {
        kind: 'interface',
        name: 'Comment_onSentimentClickEvent',
        properties: [
            {
                kind: 'interfaceProperty',
                name: 'sentiment',
                type: 'Sentiments',
                description: 'The array of sentiments that are currently selected',
                required: true,
            },
        ],
        filePath: './src/lib/Cards/Card.model.ts',
        fileName: 'Card.model.ts',
        category: 'Cards',
    },
    {
        kind: 'interface',
        name: 'Comment_onTagChangeEvent',
        properties: [
            {
                kind: 'interfaceProperty',
                name: 'tags',
                type: 'TagAnnotations[]',
                description: 'The list of tags that are currently passed into the comment component',
                required: true,
            },
            {
                kind: 'interfaceProperty',
                name: 'tagId',
                type: 'string | undefined',
                description: 'The tag id that is being changed',
                required: true,
            },
            {
                kind: 'interfaceProperty',
                name: 'answerId',
                type: 'string | undefined',
                description: 'The answerId (from the comment) that the tag being changed is associated with',
                required: true,
            },
            {
                kind: 'interfaceProperty',
                name: 'selectedTagIds',
                type: 'string[]',
                description: 'The currently selected tag ids',
                required: true,
            },
        ],
        filePath: './src/lib/Cards/Card.model.ts',
        fileName: 'Card.model.ts',
        category: 'Cards',
    },
    {
        kind: 'interface',
        name: 'Comment_onTagEvent',
        properties: [
            {
                kind: 'interfaceProperty',
                name: 'tags',
                type: 'Tag[]',
                description: 'A list of the tags that are currently passed into the comment component',
                required: true,
            },
            {
                kind: 'interfaceProperty',
                name: 'updatedTag',
                type: 'Tag',
                description: 'The tag that has been updated',
                required: true,
            },
            {
                kind: 'interfaceProperty',
                name: 'answerId',
                type: 'string | undefined',
                description: 'The answerId (from the comment) that the tag being changed is associated with',
                required: true,
            },
            {
                kind: 'interfaceProperty',
                name: 'activeTags',
                type: 'Tag[]',
                description: 'The currently active tag ids',
                required: true,
            },
            {
                kind: 'interfaceProperty',
                name: 'eventType',
                type: 'EventTypes',
                description: 'The type of event being fired. Add, click, delete, edit',
                required: true,
            },
        ],
        filePath: './src/lib/Cards/Card.model.ts',
        fileName: 'Card.model.ts',
        category: 'Cards',
    },
    {
        kind: 'interface',
        name: 'Comment_shouldPreventExpressTagEvent',
        properties: [
            {
                kind: 'interfaceProperty',
                name: 'userTagText',
                type: 'string',
                description: 'The text that the use has typed in and should be evaluated',
                required: true,
            },
        ],
        filePath: './src/lib/Cards/Card.model.ts',
        fileName: 'Card.model.ts',
        category: 'Cards',
    },
    {
        kind: 'interface',
        name: 'Comment_shouldPreventUserTagEvent',
        properties: [
            {
                kind: 'interfaceProperty',
                name: 'userTagText',
                type: 'string',
                description: 'The text that the use has typed in and should be evaluated',
                required: true,
            },
        ],
        filePath: './src/lib/Cards/Card.model.ts',
        fileName: 'Card.model.ts',
        category: 'Cards',
    },
    {
        kind: 'class',
        name: 'CommentEvents',
        extends: 'DivHTMLEvents',
        properties: [
            {
                kind: 'classProperty',
                name: 'onTagChange',
                type: '(eventData: Comment_onTagChangeEvent) => void',
                description: 'Fires when a tag is updated / added.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'onTagEvent',
                type: '(eventData: Comment_onTagEvent) => void',
                description: 'Fires when a tag is updated / added / removed.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'onSentimentClick',
                type: '(eventData: Comment_onSentimentClickEvent) => void',
                description: 'Fires when a Sentiment is clicked.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'shouldPreventExpressTag',
                type: "(\n    eventData: Comment_shouldPreventExpressTagEvent\n  ) => 'express' | 'industry' | undefined",
                description: 'Deprecated: Callback to determine if tags (not included in the experience card) duplicate the\nuser tag being typed in. Fires on each change of the user tag text. Return true to\ndisable the add tag button, false to enable it.\n\nReplaced by shouldPreventUserTag',
                deprecated: true,
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'shouldPreventUserTag',
                type: '(eventData: Comment_shouldPreventUserTagEvent) => string',
                description: "Callback to determine if tags (not included in the experience card) duplicate the\nuser tag being typed in. Fires on each change of the user tag text. Return a\nlocalized error message to be displayed to the user to prevent the user from adding a\ntag, or return and empty string '' to allow the user to add the tag",
                bound: true,
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Cards/Comment/Comment.tsx',
        fileName: 'Comment.tsx',
        category: 'Cards',
    },
    {
        kind: 'class',
        name: 'CommentProps',
        extends: 'ObservablePropsMixin(DivHTMLAttributes)',
        properties: [
            {
                kind: 'classProperty',
                name: 'externalId',
                type: 'string',
                description: 'External ID from database.',
                bound: true,
                required: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'answerId',
                type: 'string',
                description: 'Answer ID from database.',
                bound: true,
                required: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'promptLabel',
                type: 'string | null',
                description: 'Label for the comment question.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'text',
                type: 'string',
                description: 'Main comment text.',
                bound: true,
                required: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'sentimentAnnotations',
                type: 'SentimentAnnotations[]',
                description: 'Annotations of the text.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'tagAnnotations',
                type: 'TagAnnotations[]',
                description: 'Deprecated: Annotations of the tags. Replaced by tags',
                deprecated: true,
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'tags',
                type: 'Tag[]',
                description: 'An array of tags to display on the comment',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'tabs',
                type: 'TagTab[]',
                description: 'An array of tabs that categorize the tags',
                bound: true,
                default: '[]',
            },
            {
                kind: 'classProperty',
                name: 'tagSearch',
                type: '(tag: string) => Promise<TagAnnotations[]>',
                description: 'Deprecated: A function that will be called on input change when the user is adding a tag.\nreplaced by getTagSuggestions',
                deprecated: true,
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'getTagSuggestions',
                type: '(tag: string) => Promise<Tag[]>',
                description: 'A function that will be called on input change when the user is adding a tag. Should\nreturn a promise for an array of tags to display to the user as suggestions',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'maxSuggestions',
                type: 'number',
                description: 'Number of items that will show before scroll.',
                bound: true,
                default: '5',
            },
            {
                kind: 'classProperty',
                name: 'audioSrcUrl',
                type: 'string',
                description: 'URL to audio on comment.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'imageSrcUrls',
                type: 'string[]',
                description: 'URL to pictures on comment.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'videoSrcUrl',
                type: 'string | null',
                description: 'URL to video on comment.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'mediaActions',
                type: 'ExperienceCardMediaActionButtons[]',
                description: 'Action buttons under the video media component.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'genericModalProps',
                type: 'GenericModalProps & GenericModalEvents',
                description: 'Props passed into the generic modal component displayed\nwhen viewing the video or images.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'sentimentScore',
                type: 'number',
                description: 'Main score on card.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'sentimentConfidence',
                type: 'number | null',
                description: 'Percent score of confidence.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'sentimentBarExpanded',
                type: 'boolean',
                description: 'Controls the tags / sentiments bar expanded state.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'showMoreMomentsLink',
                type: 'boolean',
                description: "Shows or hides the 'More Moments like These' Link.",
                bound: true,
                default: 'undefined',
            },
            { kind: 'classProperty', name: 'addTagVisible', type: 'boolean', bound: true, default: 'true' },
            {
                kind: 'classProperty',
                name: 'highlightedText',
                type: 'string | string[]',
                description: "Word(s) to be highlighted within the comment text. To highlight multiple words, pass them in as a string array.\nex. => ['like', 'this'] will highlight all occurrences of the words 'like' and 'this'.",
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'localization',
                type: 'ExperienceCardCommentLocalization',
                description: 'Localization of the Comment',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'selectedTagIds',
                type: 'string[]',
                description: 'The ids of the initially selected tags',
                bound: true,
                default: '[]',
            },
            {
                kind: 'classProperty',
                name: 'selectedSentiments',
                type: 'Sentiments[]',
                description: 'The initially selected sentiments',
                bound: true,
                default: '[]',
            },
            {
                kind: 'classProperty',
                name: 'printView',
                type: 'boolean',
                description: 'The component will automatically adjust its appearance when printing occurs,\n  but this prop allows you to force the component into its print appearance.',
                bound: true,
                default: 'false',
            },
        ],
        filePath: './src/lib/Cards/Comment/Comment.tsx',
        fileName: 'Comment.tsx',
        category: 'Cards',
    },
    {
        kind: 'variable',
        name: 'CondensedExperienceCard',
        type: "React.ForwardRefExoticComponent<Omit<CondensedExperienceCardProps & CondensedExperienceCardEvents, 'ref'> & React.RefAttributes<HTMLDivElement>>",
        description: 'Description: A more condensed version of the Experience Card.',
        filePath: './src/lib/Cards/CondensedExperienceCard/CondensedExperienceCard.tsx',
        fileName: 'CondensedExperienceCard.tsx',
        category: 'Cards',
    },
    {
        kind: 'interface',
        name: 'CondensedExperienceCard_onSelectedChangeEvent',
        properties: [
            {
                kind: 'interfaceProperty',
                name: 'event',
                type: 'React.ChangeEvent<HTMLInputElement>',
                description: 'The React event that was fired when the checkbox changes',
                required: true,
            },
        ],
        filePath: './src/lib/Cards/Card.model.ts',
        fileName: 'Card.model.ts',
        category: 'Cards',
    },
    {
        kind: 'class',
        name: 'CondensedExperienceCardEvents',
        extends: 'DivHTMLEvents',
        properties: [
            {
                kind: 'classProperty',
                name: 'onAttachmentsClick',
                type: '() => void',
                description: 'Callback when the attachments link has been clicked.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'onCardClick',
                type: '() => void',
                description: 'Callback when the whole card is clicked if isInteractable is true, or if false the view details text has been clicked.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'onKabobChange',
                type: '(eventData: Dropdown_onValueChangeEvent) => void',
                description: 'Callback when the kabob dropdown menu value is changed.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'onSelectedChange',
                type: '(eventData: CondensedExperienceCard_onSelectedChangeEvent) => void',
                description: 'Callback when the checkbox is changed.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'onNotesChange',
                type: '(eventData: Notes_onNotesChangeEvent) => void',
                description: 'Callback that fires when the notes are updated.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'onNotesDelete',
                type: '(eventData: Notes_onNotesDeleteEvent) => void',
                description: 'Callback that fires when the delete button on a note is pressed',
                bound: true,
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Cards/CondensedExperienceCard/CondensedExperienceCard.tsx',
        fileName: 'CondensedExperienceCard.tsx',
        category: 'Cards',
    },
    {
        kind: 'interface',
        name: 'CondensedExperienceCardLocalization',
        properties: [
            { kind: 'interfaceProperty', name: 'dueDate', type: 'string' },
            { kind: 'interfaceProperty', name: 'attachments', type: 'string' },
            { kind: 'interfaceProperty', name: 'details', type: 'string' },
            { kind: 'interfaceProperty', name: 'newMessage', type: 'string' },
            { kind: 'interfaceProperty', name: 'notes', type: 'ExperienceCardNotesLocalization' },
            { kind: 'interfaceProperty', name: 'additionalCount', type: 'string' },
        ],
        filePath: './src/lib/Cards/Card.model.ts',
        fileName: 'Card.model.ts',
        category: 'Cards',
    },
    {
        kind: 'class',
        name: 'CondensedExperienceCardProps',
        extends: 'ObservablePropsMixin(DivHTMLAttributes)',
        properties: [
            {
                kind: 'classProperty',
                name: 'comment',
                type: 'CondensedExperienceCommentModel',
                description: 'Shows a condensed comment text and bolded tags.',
                bound: true,
                required: true,
                default: 'true',
            },
            {
                kind: 'classProperty',
                name: 'title',
                type: 'string',
                description: 'Title of the CondensedExperienceCard.',
                bound: true,
                required: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'bannerSentiment',
                type: 'CondensedExperienceCardSentiment',
                description: 'The sentiment of the banner left border. Only applies when caseState is undefined.\n\nNOTE: In a future major version:\n- noSentiment option will be removed and changed to the undefined option\n- The default will be changing to undefined',
                bound: true,
                default: "'neutral'",
            },
            {
                kind: 'classProperty',
                name: 'caseState',
                type: 'ExperienceCardCases',
                description: 'Determines if the case is open or collapsed, if no case is provided (undefined), the default style with a banner is displayed.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'dueDateSentiment',
                type: 'Sentiments',
                description: 'The sentiment of the dueDateTitle.',
                bound: true,
                default: "'neutral'",
            },
            {
                kind: 'classProperty',
                name: 'dueDateTitle',
                type: 'string',
                description: "The time in which the card is due. Ex: '8 days'.",
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'dropdownDirection',
                type: 'ClockDirection',
                description: 'Direction of the dropdown of the action kebab.',
                bound: true,
                default: '7',
            },
            {
                kind: 'classProperty',
                name: 'hasAttachments',
                type: 'boolean',
                description: 'Determines if the card has attachments.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'iconButtons',
                type: 'ExperienceCardIconButton[]',
                description: 'Configurable buttons that display on the top right of the experience card.',
                bound: true,
                default: '[]',
            },
            {
                kind: 'classProperty',
                name: 'isFavorite',
                type: 'boolean',
                description: 'State of the ExperienceCard favorite icon (if included in the array).',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'isInteractable',
                type: 'boolean',
                description: 'Determines if the whole card can be clicked.',
                bound: true,
                default: 'true',
            },
            {
                kind: 'classProperty',
                name: 'isOverdue',
                type: 'boolean',
                description: 'Determines if the card is overdue. Provides a red background color.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'isSelectable',
                type: 'boolean',
                description: "Determines if there is a checkbox to select the card with. Fires 'onSelectedChange' when changed.",
                bound: true,
                default: 'true',
            },
            {
                kind: 'classProperty',
                name: 'selected',
                type: 'boolean',
                description: 'State of the checkbox select (if isSelectable is true).',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'isTruncated',
                type: 'boolean',
                description: 'Determines if the text will truncate instead of wrap. Useful for saving height.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'kabobOptions',
                type: 'DropdownObject[]',
                description: 'Configurable options for a kabob menu. No kabob will be present if no options are set.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'localization',
                type: 'CondensedExperienceCardLocalization',
                description: 'Exposes the static text on the card to be configured.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'newMessageCount',
                type: 'number',
                description: 'The number of new messages, if any, on the case. Shows up at the end of the meta.',
                bound: true,
                default: '0',
            },
            {
                kind: 'classProperty',
                name: 'meta',
                type: 'string[]',
                description: 'Descriptive meta tags that display underneath the title.',
                bound: true,
                default: '[]',
            },
            {
                kind: 'classProperty',
                name: 'titleScore',
                type: 'number',
                description: "A number to display in front of the title indicating the card's score.",
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'titleSentiment',
                type: 'Sentiments',
                description: 'The sentiment of the card title.',
                bound: true,
                default: "'neutral'",
            },
            {
                kind: 'classProperty',
                name: 'dueDateTooltip',
                type: 'ToolTipProps',
                description: 'Tooltip for due date.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'highlightedText',
                type: 'string | string[]',
                description: 'String passed in to highlight matching text in the comment.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'hasNotes',
                type: 'boolean',
                description: 'Allows for initial adding of a note, even when no notes are present (does nothing when notes are present).',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'notesData',
                type: 'ExperienceCardNotes',
                description: 'Notes display for the ExperienceCard (can edit and add notes from within).',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'isFlagged',
                type: 'boolean',
                description: 'Determines if the case is flagged.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'showViewDetails',
                type: 'boolean',
                description: 'Determines if the View Details text appears in the footer of the card.',
                bound: true,
                default: 'true',
            },
            {
                kind: 'classProperty',
                name: 'metaIcon',
                type: 'Icons | false',
                description: 'The icon that appears to the left of the meta text\n\nPass undefined to have the icon automatically populated based on the case of the card:\nIf case is open icon will be: email\nIf case is expired icon will be: clock_2\nIf case is inProgress icon will be email_open\n\nPass false to remove icon completely\n\nPass the name of icon for specific icon',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'ref',
                type: 'React.Ref<HTMLDivElement>',
                description: 'A react reference applied to the div.',
                default: 'null',
            },
        ],
        filePath: './src/lib/Cards/CondensedExperienceCard/CondensedExperienceCard.tsx',
        fileName: 'CondensedExperienceCard.tsx',
        category: 'Cards',
    },
    {
        kind: 'type',
        name: 'CondensedExperienceCardSentiment',
        type: "'negative' | 'neutral' | 'positive' | 'noSentiment'",
        filePath: './src/lib/Cards/Card.model.ts',
        fileName: 'Card.model.ts',
        category: 'Cards',
    },
    {
        kind: 'interface',
        name: 'CondensedExperienceCommentModel',
        properties: [
            { kind: 'interfaceProperty', name: 'text', type: 'string', required: true },
            { kind: 'interfaceProperty', name: 'tagAnnotations', type: 'CondensedTagAnnotations[]' },
        ],
        filePath: './src/lib/Cards/Card.model.ts',
        fileName: 'Card.model.ts',
        category: 'Cards',
    },
    {
        kind: 'interface',
        name: 'CondensedTagAnnotations',
        properties: [
            { kind: 'interfaceProperty', name: 'beginIndex', type: 'number', required: true },
            { kind: 'interfaceProperty', name: 'endIndex', type: 'number', required: true },
        ],
        filePath: './src/lib/Cards/Card.model.ts',
        fileName: 'Card.model.ts',
        category: 'Cards',
    },
    {
        kind: 'interface',
        name: 'DeprecatedTagProps',
        properties: [
            { kind: 'interfaceProperty', name: 'className', type: 'string' },
            { kind: 'interfaceProperty', name: 'tags', type: 'TagItemProps[]', required: true },
            { kind: 'interfaceProperty', name: 'showAddTag', type: 'boolean' },
            { kind: 'interfaceProperty', name: 'localization', type: 'ExperienceCardTagsLocalization', required: true },
            { kind: 'interfaceProperty', name: 'maxSuggestions', type: 'number' },
            { kind: 'interfaceProperty', name: 'selectedTagInput', type: 'string[]' },
            { kind: 'interfaceProperty', name: 'tagSearch', type: '(tag: string) => Promise<TagAnnotations[]>' },
            {
                kind: 'interfaceProperty',
                name: 'onTagUpdate',
                type: '(tags: TagItemProps[], id?: string) => void',
                required: true,
            },
            { kind: 'interfaceProperty', name: 'onTagClick', type: '(tag: TagItemProps) => void', required: true },
            {
                kind: 'interfaceProperty',
                name: 'shouldPreventExpressTag',
                type: "(eventData: Comment_shouldPreventExpressTagEvent) => 'express' | 'industry' | undefined",
            },
        ],
        filePath: './src/lib/Cards/Card.model.ts',
        fileName: 'Card.model.ts',
        category: 'Cards',
    },
    {
        kind: 'type',
        name: 'EventTypes',
        type: "'add' | 'click' | 'delete' | 'edit'",
        filePath: './src/lib/Cards/Card.model.ts',
        fileName: 'Card.model.ts',
        category: 'Cards',
    },
    {
        kind: 'variable',
        name: 'ExperienceCard',
        type: 'React.ForwardRefExoticComponent<ExperienceCardProps & ExperienceCardEvents & React.RefAttributes<HTMLDivElement>>',
        description: 'Description: Smart Experience Card - highly configurable for all your Experience needs.',
        filePath: './src/lib/Cards/ExperienceCard/ExperienceCard.tsx',
        fileName: 'ExperienceCard.tsx',
        category: 'Cards',
    },
    {
        kind: 'interface',
        name: 'ExperienceCard_onMoreClickEvent',
        properties: [
            { kind: 'interfaceProperty', name: 'commentId', type: 'string', description: 'The commentId that was clicked' },
        ],
        filePath: './src/lib/Cards/Card.model.ts',
        fileName: 'Card.model.ts',
        category: 'Cards',
    },
    {
        kind: 'interface',
        name: 'ExperienceCard_onSelectionChangeEvent',
        properties: [
            {
                kind: 'interfaceProperty',
                name: 'event',
                type: 'React.ChangeEvent<HTMLInputElement>',
                description: 'The React event that was fired when the checkbox changes',
                required: true,
            },
        ],
        filePath: './src/lib/Cards/Card.model.ts',
        fileName: 'Card.model.ts',
        category: 'Cards',
    },
    {
        kind: 'type',
        name: 'ExperienceCardCases',
        type: "'open' | 'inProgress' | 'closed' | 'expired'",
        filePath: './src/lib/Cards/Card.model.ts',
        fileName: 'Card.model.ts',
        category: 'Cards',
    },
    {
        kind: 'interface',
        name: 'ExperienceCardCommentLocalization',
        properties: [
            { kind: 'interfaceProperty', name: 'tags', type: 'ExperienceCardTagsLocalization' },
            { kind: 'interfaceProperty', name: 'comments', type: 'ExperienceCardCommentsLocalization' },
            { kind: 'interfaceProperty', name: 'sentimentButtons', type: 'ExperienceCardSentimentButtonsLocalization' },
            { kind: 'interfaceProperty', name: 'emptyCommentText', type: 'string' },
        ],
        filePath: './src/lib/Cards/Card.model.ts',
        fileName: 'Card.model.ts',
        category: 'Cards',
    },
    {
        kind: 'interface',
        name: 'ExperienceCardCommentsLocalization',
        properties: [
            { kind: 'interfaceProperty', name: 'sentimentScore', type: 'string' },
            { kind: 'interfaceProperty', name: 'confidenceLevel', type: 'string' },
            { kind: 'interfaceProperty', name: 'moreMoments', type: 'string' },
            { kind: 'interfaceProperty', name: 'tags', type: 'string' },
            { kind: 'interfaceProperty', name: 'sentiment', type: 'string' },
            { kind: 'interfaceProperty', name: 'andSentiment', type: 'string' },
            { kind: 'interfaceProperty', name: 'confident', type: 'string' },
        ],
        filePath: './src/lib/Cards/Card.model.ts',
        fileName: 'Card.model.ts',
        category: 'Cards',
    },
    {
        kind: 'class',
        name: 'ExperienceCardEvents',
        extends: 'DivHTMLEvents',
        properties: [
            {
                kind: 'classProperty',
                name: 'onSelectionChange',
                type: '(eventData: ExperienceCard_onSelectionChangeEvent) => void',
                description: 'Callback that fires when the card selector is clicked.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'onNotesChange',
                type: '(eventData: Notes_onNotesChangeEvent) => void',
                description: 'Callback that fires when the notes are updated.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'onMoreClick',
                type: '(eventData: ExperienceCard_onMoreClickEvent) => void',
                description: "Callback that fires when any 'More Moments Like This' link is clicked. Passes undefined if the same ID was clicked.",
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'onMarkValidClick',
                type: '() => void',
                description: "Callback that fires when any 'Mark Valid' button is clicked.",
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'onTagChange',
                type: '(eventData: Comment_onTagChangeEvent) => void',
                description: 'Callback that fires when any tag is updated on the card.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'onNotesDelete',
                type: '(eventData: Notes_onNotesDeleteEvent) => void',
                description: 'Callback that fires when the delete button on a note is pressed',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'onTagEvent',
                type: '(eventData: Comment_onTagEvent) => void',
                description: 'Fires when a tag is updated / added / removed.',
                bound: true,
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Cards/ExperienceCard/ExperienceCard.tsx',
        fileName: 'ExperienceCard.tsx',
        category: 'Cards',
    },
    {
        kind: 'interface',
        name: 'ExperienceCardHighlight',
        properties: [
            { kind: 'interfaceProperty', name: 'isHighlighted', type: 'boolean', required: true },
            { kind: 'interfaceProperty', name: 'id', type: 'string', required: true },
        ],
        filePath: './src/lib/Cards/Card.model.ts',
        fileName: 'Card.model.ts',
        category: 'Cards',
    },
    {
        kind: 'interface',
        name: 'ExperienceCardIconButton',
        properties: [
            { kind: 'interfaceProperty', name: 'type', type: 'ExperienceCardIconButtonTypes', required: true },
            { kind: 'interfaceProperty', name: 'icon', type: 'Icons', required: true },
            { kind: 'interfaceProperty', name: 'alwaysDisplay', type: 'boolean' },
            { kind: 'interfaceProperty', name: 'title', type: 'string' },
            { kind: 'interfaceProperty', name: 'dropdownData', type: 'DropdownObject[]' },
            {
                kind: 'interfaceProperty',
                name: 'onClick',
                type: '(e: React.MouseEvent<HTMLButtonElement, MouseEvent> | DropdownObject | DropdownObject[]) => void',
                required: true,
            },
        ],
        filePath: './src/lib/Cards/Card.model.ts',
        fileName: 'Card.model.ts',
        category: 'Cards',
    },
    {
        kind: 'type',
        name: 'ExperienceCardIconButtonTypes',
        type: "'tooltip' | 'dropdown' | 'favorite' | 'notes'",
        filePath: './src/lib/Cards/Card.model.ts',
        fileName: 'Card.model.ts',
        category: 'Cards',
    },
    {
        kind: 'interface',
        name: 'ExperienceCardKabobDropdownObject',
        extends: ['DropdownObject'],
        properties: [
            {
                kind: 'interfaceProperty',
                name: 'onClick',
                type: '(e: React.MouseEvent<HTMLButtonElement, MouseEvent> | DropdownObject | DropdownObject[]) => void',
                required: true,
            },
        ],
        filePath: './src/lib/Cards/Card.model.ts',
        fileName: 'Card.model.ts',
        category: 'Cards',
    },
    {
        kind: 'interface',
        name: 'ExperienceCardLocalization',
        extends: ['ExperienceCardCommentLocalization', 'ExperienceHeaderLocalization'],
        properties: [{ kind: 'interfaceProperty', name: 'notes', type: 'ExperienceCardNotesLocalization' }],
        filePath: './src/lib/Cards/Card.model.ts',
        fileName: 'Card.model.ts',
        category: 'Cards',
    },
    {
        kind: 'type',
        name: 'ExperienceCardLogos',
        type: "'inmoment_favicon_blue' | 'inmoment_favicon_orca' | 'inmoment_favicon_purple' | 'inmoment_favicon_teal'",
        filePath: './src/lib/Cards/Card.model.ts',
        fileName: 'Card.model.ts',
        category: 'Cards',
    },
    {
        kind: 'interface',
        name: 'ExperienceCardMediaActionButtons',
        properties: [
            { kind: 'interfaceProperty', name: 'icon', type: 'Icons', required: true },
            { kind: 'interfaceProperty', name: 'tooltip', type: 'ToolTipProps' },
            { kind: 'interfaceProperty', name: 'onClick', type: '() => void' },
        ],
        filePath: './src/lib/Cards/Card.model.ts',
        fileName: 'Card.model.ts',
        category: 'Cards',
    },
    {
        kind: 'interface',
        name: 'ExperienceCardNoteLocalization',
        properties: [
            { kind: 'interfaceProperty', name: 'cancel', type: 'string' },
            { kind: 'interfaceProperty', name: 'edit', type: 'string' },
            { kind: 'interfaceProperty', name: 'locale', type: 'string' },
            { kind: 'interfaceProperty', name: 'save', type: 'string' },
            { kind: 'interfaceProperty', name: 'youWrote', type: 'string' },
        ],
        filePath: './src/lib/Cards/Card.model.ts',
        fileName: 'Card.model.ts',
        category: 'Cards',
    },
    {
        kind: 'interface',
        name: 'ExperienceCardNotes',
        properties: [
            { kind: 'interfaceProperty', name: 'notes', type: 'NoteObject[]', required: true },
            { kind: 'interfaceProperty', name: 'onNoteChange', type: '(obj: NoteObject[]) => void' },
        ],
        filePath: './src/lib/Cards/Card.model.ts',
        fileName: 'Card.model.ts',
        category: 'Cards',
    },
    {
        kind: 'interface',
        name: 'ExperienceCardNotesLocalization',
        extends: ['ExperienceCardNoteLocalization'],
        properties: [
            { kind: 'interfaceProperty', name: 'add', type: 'string' },
            { kind: 'interfaceProperty', name: 'notes', type: 'string' },
            { kind: 'interfaceProperty', name: 'placeholder', type: 'string' },
        ],
        filePath: './src/lib/Cards/Card.model.ts',
        fileName: 'Card.model.ts',
        category: 'Cards',
    },
    {
        kind: 'class',
        name: 'ExperienceCardProps',
        extends: 'ObservablePropsMixin(DivHTMLAttributes)',
        properties: [
            {
                kind: 'classProperty',
                name: 'addTagVisible',
                type: 'boolean',
                description: 'Displays the add tag button',
                bound: true,
                default: 'true',
            },
            {
                kind: 'classProperty',
                name: 'titleScore',
                type: 'number',
                description: 'Score to live at the top of the Experience Card.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'sentiment',
                type: 'ExperienceCardSentiments',
                description: 'Overall color for the title score.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'dropdownDirection',
                type: 'ClockDirection',
                description: 'Direction of the dropdown of the action kebab.',
                bound: true,
                default: '7',
            },
            {
                kind: 'classProperty',
                name: 'title',
                type: 'string',
                description: 'Title of the ExperienceCard.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'subtitle',
                type: 'string',
                description: 'Subtitle of the ExperienceCard.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'subtitleLogo',
                type: 'ExperienceCardLogos',
                description: 'Logo that can accompany the card subtitle.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'selectable',
                type: 'boolean',
                description: 'Controls whether or not the card is selectable.',
                bound: true,
                default: 'true',
            },
            {
                kind: 'classProperty',
                name: 'selected',
                type: 'boolean',
                description: 'State of the ExperienceCard select (if selectable is true).',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'isFavorite',
                type: 'boolean',
                description: 'State of the ExperienceCard favorite icon (if included in the array).',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'collapsed',
                type: 'boolean',
                description: "Controls whether or not the card is collapsed. Hides all visuals besides top text & buttons.\nDefaults to `true` if sentiment is 'invalid' and `false` otherwise.",
                bound: true,
                default: "sentiment === 'invalid'",
            },
            {
                kind: 'classProperty',
                name: 'highlightedCommentId',
                type: 'string',
                description: 'ID of any single comment that should be highlighted.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'meta',
                type: 'string[]',
                description: 'Descriptive meta tags that display underneath the subtitle.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'comments',
                type: '(CommentProps & CommentEvents)[]',
                description: 'Comment data for the Experience Card.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'iconButtons',
                type: 'ExperienceCardIconButton[]',
                description: 'Configurable buttons that display on the top right of the experience card.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'notesData',
                type: 'ExperienceCardNotes',
                description: 'Notes display for the ExperienceCard (can edit and add notes from within).',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'hasNotes',
                type: 'boolean',
                description: 'Allows for initial adding of a note, even when no notes are present (does nothing when notes are present).',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'canMarkValid',
                type: 'boolean',
                description: "Determines whether the user can mark a card as valid. Only applies when sentiment is 'invalid'.",
                bound: true,
                default: 'true',
            },
            {
                kind: 'classProperty',
                name: 'viewDetailsButton',
                type: 'ButtonObject',
                description: 'Configurable button that displays in the invalid state of the card.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'footerButton',
                type: 'ButtonObject',
                description: 'Deprecated: Configurable button that display in the footer of the card.\nDue to design requirement changes the footer button now displays in the header.\nThe footer button is functionally equivalent to the header button and will be replaced by the header button in a later release.',
                deprecated: true,
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'headerButton',
                type: 'ButtonObject',
                description: 'Configurable button that will display in the header of the card.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'maxSuggestions',
                type: 'number',
                description: 'Number of items that will show before scroll in the AddTagBox.',
                bound: true,
                default: '5',
            },
            {
                kind: 'classProperty',
                name: 'localization',
                type: 'ExperienceCardLocalization',
                description: 'Allows for constant text to be passed into the component, helpful for languages.',
                bound: true,
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Cards/ExperienceCard/ExperienceCard.tsx',
        fileName: 'ExperienceCard.tsx',
        category: 'Cards',
    },
    {
        kind: 'interface',
        name: 'ExperienceCardSentimentButtonsLocalization',
        properties: [
            { kind: 'interfaceProperty', name: 'positive', type: 'string' },
            { kind: 'interfaceProperty', name: 'neutral', type: 'string' },
            { kind: 'interfaceProperty', name: 'negative', type: 'string' },
        ],
        filePath: './src/lib/Cards/Card.model.ts',
        fileName: 'Card.model.ts',
        category: 'Cards',
    },
    {
        kind: 'type',
        name: 'ExperienceCardSentiments',
        type: "'invalid' | 'negative' | 'neutral' | 'positive'",
        filePath: './src/lib/Cards/Card.model.ts',
        fileName: 'Card.model.ts',
        category: 'Cards',
    },
    {
        kind: 'interface',
        name: 'ExperienceCardTagsLocalization',
        properties: [
            { kind: 'interfaceProperty', name: 'add', type: 'string' },
            { kind: 'interfaceProperty', name: 'save', type: 'string' },
            { kind: 'interfaceProperty', name: 'addConfirm', type: 'string' },
            { kind: 'interfaceProperty', name: 'cancel', type: 'string' },
            { kind: 'interfaceProperty', name: 'industryTagExistsError', type: 'string' },
            { kind: 'interfaceProperty', name: 'expressTagExistsError', type: 'string' },
            { kind: 'interfaceProperty', name: 'noTags', type: 'string' },
        ],
        filePath: './src/lib/Cards/Card.model.ts',
        fileName: 'Card.model.ts',
        category: 'Cards',
    },
    {
        kind: 'variable',
        name: 'ExperienceHeader',
        type: "React.ForwardRefExoticComponent<Omit<ExperienceHeaderProps & ExperienceHeaderEvents, 'ref'> & React.RefAttributes<HTMLDivElement>>",
        description: 'Description: The header for the experience card, to be used in areas where experience card styling is needed, but where the experience card does not fill that need.',
        filePath: './src/lib/Cards/ExperienceHeader/ExperienceHeader.tsx',
        fileName: 'ExperienceHeader.tsx',
        category: 'Cards',
    },
    {
        kind: 'class',
        name: 'ExperienceHeaderEvents',
        extends: 'DivHTMLEvents',
        properties: [
            {
                kind: 'classProperty',
                name: 'onMarkValidClick',
                type: '() => void',
                description: "Callback that fires when any 'Mark Valid' button is clicked.",
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'onSelectionChange',
                type: '(eventData: ExperienceCard_onSelectionChangeEvent) => void',
                description: 'Callback that fires when the card selector is clicked.',
                bound: true,
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Cards/ExperienceHeader/ExperienceHeader.tsx',
        fileName: 'ExperienceHeader.tsx',
        category: 'Cards',
    },
    {
        kind: 'interface',
        name: 'ExperienceHeaderLocalization',
        properties: [{ kind: 'interfaceProperty', name: 'markValid', type: 'string' }],
        filePath: './src/lib/Cards/Card.model.ts',
        fileName: 'Card.model.ts',
        category: 'Cards',
    },
    {
        kind: 'class',
        name: 'ExperienceHeaderProps',
        extends: 'ObservablePropsMixin(DivHTMLAttributes)',
        properties: [
            {
                kind: 'classProperty',
                name: 'title',
                type: 'string',
                description: 'Title of the ExperienceCard.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'titleScore',
                type: 'number',
                description: 'Score to live at the top of the Experience Card.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'sentiment',
                type: "ExperienceCardSentiments | ''",
                description: 'Overall color for the title score.',
                bound: true,
                default: "'positive'",
            },
            {
                kind: 'classProperty',
                name: 'viewDetailsButton',
                type: 'ButtonObject',
                description: 'Configurable button that displays in the invalid state of the card.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'localization',
                type: 'ExperienceHeaderLocalization',
                description: 'Allows for constant text to be passed into the component, helpful for languages.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'headerButton',
                type: 'ButtonObject',
                description: 'Configurable button that display in the header of the card.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'selectable',
                type: 'boolean',
                description: 'Controls whether or not the card is selectable.',
                bound: true,
                default: 'true',
            },
            {
                kind: 'classProperty',
                name: 'iconButtons',
                type: 'ExperienceCardIconButton[]',
                description: 'Configurable buttons that display on the top right of the experience card.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'subtitleLogo',
                type: 'ExperienceCardLogos',
                description: 'Logo that can accompany the card subtitle.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'subtitle',
                type: 'string',
                description: 'Subtitle of the ExperienceCard.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'isFavorite',
                type: 'boolean',
                description: 'State of the ExperienceCard favorite icon (if included in the array).',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'isNotesOpen',
                type: 'boolean',
                description: 'State of the ExperienceCard notes icon (if included).',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'dropdownDirection',
                type: 'ClockDirection',
                description: 'Direction of the dropdown of the action kebab.',
                bound: true,
                default: '7',
            },
            {
                kind: 'classProperty',
                name: 'meta',
                type: 'string[]',
                description: 'Descriptive meta tags that display underneath the subtitle.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'canMarkValid',
                type: 'boolean',
                description: "Determines whether the user can mark a card as valid. Only applies when sentiment is 'invalid'.",
                bound: true,
                default: 'true',
            },
            {
                kind: 'classProperty',
                name: 'selected',
                type: 'boolean',
                description: 'State of the ExperienceCard select (if selectable is true).',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'ref',
                type: 'React.Ref<HTMLDivElement>',
                description: 'A react reference applied to the div.',
                default: 'null',
            },
        ],
        filePath: './src/lib/Cards/ExperienceHeader/ExperienceHeader.tsx',
        fileName: 'ExperienceHeader.tsx',
        category: 'Cards',
    },
    {
        kind: 'interface',
        name: 'InternalNotesProps',
        properties: [
            { kind: 'interfaceProperty', name: 'notesState', type: 'NoteObject[]', required: true },
            { kind: 'interfaceProperty', name: 'notesRef', type: 'React.RefObject<HTMLTextAreaElement>' },
            { kind: 'interfaceProperty', name: 'notesWrapperRef', type: 'React.RefObject<HTMLDivElement>' },
            { kind: 'interfaceProperty', name: 'hasNotes', type: 'boolean', required: true },
            { kind: 'interfaceProperty', name: 'isAddingNote', type: 'boolean', required: true },
            { kind: 'interfaceProperty', name: 'newNotePlaceholder', type: 'string', required: true },
            { kind: 'interfaceProperty', name: 'localization', type: 'ExperienceCardNotesLocalization' },
            { kind: 'interfaceProperty', name: 'observer', type: 'Record<string, unknown> | undefined' },
            {
                kind: 'interfaceProperty',
                name: 'setNotesState',
                type: 'React.Dispatch<React.SetStateAction<NoteObject[]>>',
                required: true,
            },
            {
                kind: 'interfaceProperty',
                name: 'setIsNotesOpen',
                type: 'React.Dispatch<React.SetStateAction<boolean>>',
                required: true,
            },
            {
                kind: 'interfaceProperty',
                name: 'setIsAddingNote',
                type: 'React.Dispatch<React.SetStateAction<boolean>>',
                required: true,
            },
            { kind: 'interfaceProperty', name: 'onDelete', type: '(obj: NoteObject[], id: string) => void' },
            { kind: 'interfaceProperty', name: 'onChange', type: '(obj: NoteObject[], id: string) => void' },
        ],
        filePath: './src/lib/Cards/Card.model.ts',
        fileName: 'Card.model.ts',
        category: 'Cards',
    },
    {
        kind: 'interface',
        name: 'NoteObject',
        properties: [
            { kind: 'interfaceProperty', name: 'text', type: 'string', required: true },
            { kind: 'interfaceProperty', name: 'meta', type: "[date: Date, author: string | 'self']", required: true },
            { kind: 'interfaceProperty', name: 'id', type: 'string' },
        ],
        filePath: './src/lib/Cards/Card.model.ts',
        fileName: 'Card.model.ts',
        category: 'Cards',
    },
    {
        kind: 'variable',
        name: 'Notes',
        type: 'React.FunctionComponent<NotesProps & NotesEvents>',
        description: 'Description: A list of notes.',
        filePath: './src/lib/Cards/Notes/Notes.tsx',
        fileName: 'Notes.tsx',
        category: 'Cards',
    },
    {
        kind: 'interface',
        name: 'Notes_onNotesChangeEvent',
        properties: [
            {
                kind: 'interfaceProperty',
                name: 'notes',
                type: 'NoteObject[]',
                description: 'A list of the new notes array',
                required: true,
            },
            {
                kind: 'interfaceProperty',
                name: 'noteId',
                type: 'string',
                description: 'The id of the note that was deleted',
                required: true,
            },
        ],
        filePath: './src/lib/Cards/Card.model.ts',
        fileName: 'Card.model.ts',
        category: 'Cards',
    },
    {
        kind: 'interface',
        name: 'Notes_onNotesDeleteEvent',
        properties: [
            {
                kind: 'interfaceProperty',
                name: 'notes',
                type: 'NoteObject[]',
                description: 'A list of the new notes array (not including the deleted note)',
                required: true,
            },
            {
                kind: 'interfaceProperty',
                name: 'noteId',
                type: 'string',
                description: 'The id of the note that was deleted',
                required: true,
            },
        ],
        filePath: './src/lib/Cards/Card.model.ts',
        fileName: 'Card.model.ts',
        category: 'Cards',
    },
    {
        kind: 'variable',
        name: 'NotesContext',
        type: 'React.Context<readonly [isEditingNote: boolean, setIsEditingNote: React.Dispatch<React.SetStateAction<boolean>>]>',
        description: 'Stores whether any note in the current list of notes is being edited.',
        filePath: './src/lib/Cards/Notes/Notes.tsx',
        fileName: 'Notes.tsx',
        category: 'Cards',
    },
    {
        kind: 'interface',
        name: 'NotesData',
        properties: [
            { kind: 'interfaceProperty', name: 'isNotesOpen', type: 'boolean', required: true },
            { kind: 'interfaceProperty', name: 'setIsNotesOpen', type: 'React.Dispatch<React.SetStateAction<boolean>>' },
        ],
        filePath: './src/lib/Cards/Card.model.ts',
        fileName: 'Card.model.ts',
        category: 'Cards',
    },
    {
        kind: 'class',
        name: 'NotesEvents',
        extends: 'DivHTMLEvents',
        properties: [
            {
                kind: 'classProperty',
                name: 'onNotesDelete',
                type: '(eventData: Notes_onNotesDeleteEvent) => void',
                description: 'Callback that fires when the delete button on a note is pressed.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'onNotesChange',
                type: '(eventData: Notes_onNotesChangeEvent) => void',
                description: 'Callback that fires when the notes are updated.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'onCancelAddingNote',
                type: '() => void',
                description: 'Callback that fires on when the user cancels adding a note.',
                bound: true,
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Cards/Notes/Notes.tsx',
        fileName: 'Notes.tsx',
        category: 'Cards',
    },
    {
        kind: 'class',
        name: 'NotesProps',
        extends: 'ObservablePropsMixin(DivHTMLAttributes)',
        properties: [
            {
                kind: 'classProperty',
                name: 'notesData',
                type: 'NoteObject[]',
                description: 'Notes (can edit and add notes from within).',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'isAddingNote',
                type: 'boolean',
                description: 'Determines whether a note is currently being added.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'localization',
                type: 'ExperienceCardNotesLocalization',
                description: 'Localization data for Notes.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'hasSeparator',
                type: 'boolean',
                description: 'Determines if a separator bar should display along the top of the component',
                bound: true,
                default: 'false',
            },
        ],
        filePath: './src/lib/Cards/Notes/Notes.tsx',
        fileName: 'Notes.tsx',
        category: 'Cards',
    },
    {
        kind: 'interface',
        name: 'SentimentAnnotations',
        properties: [
            { kind: 'interfaceProperty', name: 'sentiment', type: 'SentimentEnum', required: true },
            { kind: 'interfaceProperty', name: 'beginIndex', type: 'number', required: true },
            { kind: 'interfaceProperty', name: 'endIndex', type: 'number', required: true },
            { kind: 'interfaceProperty', name: 'sentimentId', type: 'string', required: true },
            { kind: 'interfaceProperty', name: 'sentimentScore', type: 'number' },
            { kind: 'interfaceProperty', name: 'sentimentConfidence', type: 'number' },
        ],
        filePath: './src/lib/Cards/Card.model.ts',
        fileName: 'Card.model.ts',
        category: 'Cards',
    },
    {
        kind: 'interface',
        name: 'Tag',
        properties: [
            { kind: 'interfaceProperty', name: 'id', type: 'string', required: true },
            { kind: 'interfaceProperty', name: 'label', type: 'string', required: true },
            {
                kind: 'interfaceProperty',
                name: 'highlighting',
                type: '{\n    beginIndex: number;\n    endIndex: number;\n  }[]',
            },
            { kind: 'interfaceProperty', name: 'userAdded', type: 'boolean' },
            { kind: 'interfaceProperty', name: 'sentiment', type: 'Sentiments' },
            { kind: 'interfaceProperty', name: 'tabId', type: 'string', required: true },
            { kind: 'interfaceProperty', type: '[key: string]: any;' },
        ],
        filePath: './src/lib/Cards/Card.model.ts',
        fileName: 'Card.model.ts',
        category: 'Cards',
    },
    {
        kind: 'interface',
        name: 'TagAnnotations',
        properties: [
            { kind: 'interfaceProperty', name: 'tag', type: 'string', required: true },
            { kind: 'interfaceProperty', name: 'beginIndex', type: 'number' },
            { kind: 'interfaceProperty', name: 'endIndex', type: 'number' },
            { kind: 'interfaceProperty', name: 'tagId', type: 'string' },
            { kind: 'interfaceProperty', name: 'sentiment', type: 'SentimentEnum' },
            { kind: 'interfaceProperty', name: 'userAdded', type: 'boolean' },
            { kind: 'interfaceProperty', type: '[key: string]: any;' },
        ],
        filePath: './src/lib/Cards/Card.model.ts',
        fileName: 'Card.model.ts',
        category: 'Cards',
    },
    {
        kind: 'interface',
        name: 'TagProps',
        properties: [
            { kind: 'interfaceProperty', name: 'tags', type: 'Tag[]', required: true },
            { kind: 'interfaceProperty', name: 'tabs', type: 'TagTab[]', required: true },
            { kind: 'interfaceProperty', name: 'printView', type: 'boolean' },
            { kind: 'interfaceProperty', name: 'localization', type: 'ExperienceCardTagsLocalization', required: true },
            { kind: 'interfaceProperty', name: 'maxSuggestions', type: 'number' },
            { kind: 'interfaceProperty', name: 'expanded', type: 'boolean', required: true },
            { kind: 'interfaceProperty', name: 'condensedView', type: 'boolean' },
            { kind: 'interfaceProperty', name: 'activeTags', type: 'Tag[]' },
            {
                kind: 'interfaceProperty',
                name: 'onTagUpdate',
                type: "(tags: Tag[], updatedTag: Tag, event: 'add' | 'delete' | 'click' | 'edit') => void",
                required: true,
            },
            { kind: 'interfaceProperty', name: 'onTagClick', type: '(tag: Tag, selected: boolean) => void', required: true },
            { kind: 'interfaceProperty', name: 'onSelectedTagsUpdate', type: '(tags: Tag[]) => void', required: true },
            { kind: 'interfaceProperty', name: 'onTagSearch', type: '(tag: string) => Promise<Tag[]>' },
            {
                kind: 'interfaceProperty',
                name: 'shouldPreventExpressTag',
                type: '(eventData: Comment_shouldPreventExpressTagEvent) => string',
            },
            { kind: 'interfaceProperty', name: 'onExpand', type: '() => void', required: true },
        ],
        filePath: './src/lib/Cards/Card.model.ts',
        fileName: 'Card.model.ts',
        category: 'Cards',
    },
    {
        kind: 'interface',
        name: 'TagTab',
        properties: [
            { kind: 'interfaceProperty', name: 'id', type: 'string', required: true },
            { kind: 'interfaceProperty', name: 'label', type: 'string', required: true },
            { kind: 'interfaceProperty', name: 'showAddTag', type: 'boolean' },
        ],
        filePath: './src/lib/Cards/Card.model.ts',
        fileName: 'Card.model.ts',
        category: 'Cards',
    },
    {
        kind: 'interface',
        name: 'AxisLabelSettings',
        properties: [
            { kind: 'interfaceProperty', name: 'axisTitleEnabled', type: 'boolean' },
            { kind: 'interfaceProperty', name: 'axisTitle', type: 'string', required: true },
            { kind: 'interfaceProperty', name: 'axisTitleFontSize', type: 'CHART_FONT_SIZES | string' },
            { kind: 'interfaceProperty', name: 'axisNumbersEnabled', type: 'boolean' },
            { kind: 'interfaceProperty', name: 'axisNumberSize', type: 'CHART_FONT_SIZES | string' },
            { kind: 'interfaceProperty', name: 'color', type: 'string' },
        ],
        filePath: './src/lib/Charts/Chart.model.ts',
        fileName: 'Chart.model.ts',
        category: 'Charts',
    },
    {
        kind: 'variable',
        name: 'BigNumber',
        type: "React.ForwardRefExoticComponent<Omit<BigNumberProps & BigNumberEvents, 'ref'> & React.RefAttributes<HTMLDivElement>>",
        description: 'Description: Component displaying various numbers in a big fashion. Card onClick event will only fire if isInteractive is true.',
        filePath: './src/lib/Charts/BigNumber/BigNumber.tsx',
        fileName: 'BigNumber.tsx',
        category: 'Charts',
    },
    {
        kind: 'type',
        name: 'BigNumber_onIsSelectedChangeEvent',
        type: 'BasicTile_onIsSelectedChangeEvent',
        filePath: './src/lib/Charts/Chart.model.ts',
        fileName: 'Chart.model.ts',
        category: 'Charts',
    },
    {
        kind: 'type',
        name: 'BigNumberAlignments',
        type: "'center' | 'right'",
        filePath: './src/lib/Charts/Chart.model.ts',
        fileName: 'Chart.model.ts',
        category: 'Charts',
    },
    {
        kind: 'interface',
        name: 'BigNumberColorObject',
        properties: [
            { kind: 'interfaceProperty', name: 'title', type: 'BigNumberColors' },
            { kind: 'interfaceProperty', name: 'titleIcon', type: 'BigNumberColors' },
            { kind: 'interfaceProperty', name: 'bigNumber', type: 'BigNumberColors' },
        ],
        filePath: './src/lib/Charts/Chart.model.ts',
        fileName: 'Chart.model.ts',
        category: 'Charts',
    },
    {
        kind: 'type',
        name: 'BigNumberColors',
        type: "'admin' | 'orca' | 'EX' | 'EMPLOYEE' | 'CX' | 'CUSTOMER' | 'MX' | 'MARKETING' | 'PX' | 'PRODUCT' | 'CXIC' | 'system' | 'success' | 'warning' | 'error' | 'new' | 'open' | 'inProgress' | 'closed' | 'expired' | 'overdue' | 'negative' | 'neutral' | 'positive'",
        filePath: './src/lib/Charts/Chart.model.ts',
        fileName: 'Chart.model.ts',
        category: 'Charts',
    },
    {
        kind: 'interface',
        name: 'BigNumberContextData',
        properties: [
            { kind: 'interfaceProperty', name: 'heading', type: 'string', required: true },
            { kind: 'interfaceProperty', name: 'icon', type: 'Icons' },
            { kind: 'interfaceProperty', name: 'contextNumber', type: 'number | string', required: true },
            { kind: 'interfaceProperty', name: 'color', type: 'BigNumberColors' },
            { kind: 'interfaceProperty', name: 'isPercentage', type: 'boolean' },
            { kind: 'interfaceProperty', name: 'tooltip', type: 'ToolTipProps' },
            { kind: 'interfaceProperty', name: 'id', type: 'string' },
        ],
        filePath: './src/lib/Charts/Chart.model.ts',
        fileName: 'Chart.model.ts',
        category: 'Charts',
    },
    {
        kind: 'class',
        name: 'BigNumberEvents',
        extends: 'BasicTileEvents',
        properties: [
            {
                kind: 'classProperty',
                name: 'onBigNumberPress',
                type: '() => void',
                description: 'Fires when the big number component is clicked. For accessibility reasons, use this\ninstead of onClick/onKeypress.',
                bound: true,
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Charts/BigNumber/BigNumber.tsx',
        fileName: 'BigNumber.tsx',
        category: 'Charts',
    },
    {
        kind: 'interface',
        name: 'BigNumberLink',
        properties: [
            { kind: 'interfaceProperty', name: 'text', type: 'string', required: true },
            { kind: 'interfaceProperty', name: 'href', type: 'string', required: true },
        ],
        filePath: './src/lib/Charts/Chart.model.ts',
        fileName: 'Chart.model.ts',
        category: 'Charts',
    },
    {
        kind: 'interface',
        name: 'BigNumberLocalization',
        properties: [
            { kind: 'interfaceProperty', name: 'noDataFound', type: 'string' },
            { kind: 'interfaceProperty', name: 'noDataFoundSubtext', type: 'string' },
        ],
        filePath: './src/lib/Charts/Chart.model.ts',
        fileName: 'Chart.model.ts',
        category: 'Charts',
    },
    {
        kind: 'class',
        name: 'BigNumberProps',
        extends: 'BasicTileProps',
        properties: [
            {
                kind: 'classProperty',
                name: 'bigNumber',
                type: 'number | Duration | Date',
                description: 'If `number`, the main number to be displayed.\nIf `Duration`, the main amount of time to be displayed.\nIf `Date`, the duration between now and the given date will be used as the main amount of time to be displayed.\n\nIf not a number, you must provide a new object for each change - simply changing\na property on the existing object is not sufficient.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'bigNumberAlignment',
                type: 'BigNumberAlignments',
                description: "Controls the text alignment of the big number; also controls the alignment of the context data so they remain consistent. Can be 'center' or 'right'",
                bound: true,
                default: "'center'",
            },
            {
                kind: 'classProperty',
                name: 'bigNumberFontSize',
                type: 'BigNumberSizes',
                description: "Sets the default font size for the literal big number.\nNote: font will still shrink a little if the number becomes too large\nfor the size of the card, if the card size is not set\n\n'big': 96px\n'small': 64px",
                bound: true,
                default: "'big'",
            },
            {
                kind: 'classProperty',
                name: 'colors',
                type: 'BigNumberColorObject',
                description: 'Color object representing different areas of the card.',
                bound: true,
                default: "'orca'",
            },
            { kind: 'classProperty', name: 'containerlessView', type: 'boolean', bound: true, default: 'false' },
            {
                kind: 'classProperty',
                name: 'contextData',
                type: 'BigNumberContextData[]',
                description: 'Context numbers displayed underneath main number (up to 3).',
                bound: true,
                default: '[]',
            },
            {
                kind: 'classProperty',
                name: 'contextDataAlignment',
                type: 'BigNumberAlignments',
                description: 'Sets the alignment for the context data area.',
                bound: true,
                default: "'center'",
            },
            {
                kind: 'classProperty',
                name: 'contextNumberSize',
                type: 'BigNumberSizes',
                description: 'Size of the numbers that accompany the contexts.',
                bound: true,
                default: "'big'",
            },
            {
                kind: 'classProperty',
                name: 'contextText',
                type: 'string',
                description: 'Main context text displayed above the context data.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'links',
                type: 'BigNumberLink[]',
                description: 'List of links displayed under the subtitle.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'locale',
                type: 'string',
                description: 'Locale for the number display.',
                bound: true,
                default: "'en-US'",
            },
            {
                kind: 'classProperty',
                name: 'localization',
                type: 'BigNumberLocalization',
                description: 'Localization for the BigNumber',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'numberOfDurationUnits',
                type: '1 | 2',
                description: 'If `bigNumber` is a `Date` or `Duration`, this property represents\nhow many units (e.g., days, hours, minutes) to show.',
                bound: true,
                default: '2',
            },
            { kind: 'classProperty', name: 'selected', type: 'boolean', bound: true, default: 'false' },
            {
                kind: 'classProperty',
                name: 'showContextTrendArrows',
                type: 'boolean',
                description: 'Determines if there should be a trend arrow showing for context numbers.',
                bound: true,
                default: 'true',
            },
            {
                kind: 'classProperty',
                name: 'showPercent',
                type: 'boolean',
                description: "Will show a '%' after the big number if enabled.",
                bound: true,
                default: 'false',
            },
            { kind: 'classProperty', name: 'titleIcon', type: 'Icons', bound: true, default: 'undefined' },
            {
                kind: 'classProperty',
                name: 'tooltip',
                type: 'ToolTipProps',
                description: 'Props for displaying the tooltip on the Big Number itself',
                bound: true,
                default: 'undefined',
            },
            { kind: 'classProperty', name: 'useCondensedPadding', type: 'boolean', bound: true, default: 'undefined' },
        ],
        filePath: './src/lib/Charts/BigNumber/BigNumber.tsx',
        fileName: 'BigNumber.tsx',
        category: 'Charts',
    },
    {
        kind: 'type',
        name: 'BigNumberSizes',
        type: "'small' | 'big'",
        filePath: './src/lib/Charts/Chart.model.ts',
        fileName: 'Chart.model.ts',
        category: 'Charts',
    },
    {
        kind: 'enum',
        name: 'CHART_FONT_SIZES',
        properties: ['SMALL', 'DEFAULT', 'MEDIUM', 'LARGE', 'EXTRA_LARGE'],
        filePath: './src/lib/Charts/Chart.model.ts',
        fileName: 'Chart.model.ts',
        category: 'Charts',
    },
    {
        kind: 'enum',
        name: 'CHART_TYPE',
        properties: ['LINE', 'BAR', 'COLUMN'],
        filePath: './src/lib/Charts/Chart.model.ts',
        fileName: 'Chart.model.ts',
        category: 'Charts',
    },
    {
        kind: 'interface',
        name: 'ChartAxis',
        properties: [
            { kind: 'interfaceProperty', name: 'categories', type: 'any[]' },
            { kind: 'interfaceProperty', name: 'min', type: 'number' },
            { kind: 'interfaceProperty', name: 'max', type: 'number' },
            { kind: 'interfaceProperty', name: 'labels', type: 'AxisLabelSettings', required: true },
            { kind: 'interfaceProperty', name: 'showGridLines', type: 'boolean' },
        ],
        filePath: './src/lib/Charts/Chart.model.ts',
        fileName: 'Chart.model.ts',
        category: 'Charts',
    },
    {
        kind: 'interface',
        name: 'ChartData',
        properties: [
            { kind: 'interfaceProperty', name: 'type', type: 'CHART_TYPE | string', required: true },
            { kind: 'interfaceProperty', name: 'title', type: 'string', required: true },
            { kind: 'interfaceProperty', name: 'subTitle', type: 'string', required: true },
            { kind: 'interfaceProperty', name: 'legendTitle', type: 'string' },
            { kind: 'interfaceProperty', name: 'legendVisibility', type: 'boolean', required: true },
            { kind: 'interfaceProperty', name: 'xAxisSettings', type: 'ChartAxis', required: true },
            { kind: 'interfaceProperty', name: 'yAxisSettings', type: 'ChartAxis', required: true },
            { kind: 'interfaceProperty', name: 'secondaryYAxisSettings', type: 'ChartAxis' },
            { kind: 'interfaceProperty', name: 'seriesOptions', type: 'SeriesOptions' },
            { kind: 'interfaceProperty', name: 'data', type: 'SeriesData[]', required: true },
            { kind: 'interfaceProperty', name: 'secondaryYData', type: 'SeriesData' },
        ],
        filePath: './src/lib/Charts/Chart.model.ts',
        fileName: 'Chart.model.ts',
        category: 'Charts',
    },
    {
        kind: 'variable',
        name: 'ChartWrapper',
        type: "React.ForwardRefExoticComponent<Omit<ChartWrapperProps & ChartWrapperEvents, 'ref'> & React.RefAttributes<HTMLDivElement>>",
        description: 'Description: This component wraps a Highchart chart component (not included) to provide standard looking charts',
        filePath: './src/lib/Charts/ChartWrapper/ChartWrapper.tsx',
        fileName: 'ChartWrapper.tsx',
        category: 'Charts',
    },
    {
        kind: 'class',
        name: 'ChartWrapperEvents',
        extends: 'BasicTileEvents',
        properties: [
            {
                kind: 'classProperty',
                name: 'onChartWrapperPress',
                type: '() => void',
                description: 'Fires, if `isInteractive`, when the chart wrapper component is clicked or activated via key press.\nFor accessibility reasons, use this instead of onClick/onKeypress.',
                bound: true,
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Charts/ChartWrapper/ChartWrapper.tsx',
        fileName: 'ChartWrapper.tsx',
        category: 'Charts',
    },
    {
        kind: 'interface',
        name: 'ChartWrapperLocalization',
        description: 'Localization for the chart wrapper.',
        properties: [
            {
                kind: 'interfaceProperty',
                name: 'noDataFound',
                type: 'string',
                description: 'Text displayed when the chart slot is empty.',
            },
            {
                kind: 'interfaceProperty',
                name: 'noDataFoundSubtext',
                type: 'string',
                description: 'Subtext displayed when the chart slot is empty.',
            },
        ],
        filePath: './src/lib/Charts/Chart.model.ts',
        fileName: 'Chart.model.ts',
        category: 'Charts',
    },
    {
        kind: 'class',
        name: 'ChartWrapperProps',
        extends: 'BasicTileProps',
        properties: [
            {
                kind: 'classProperty',
                name: 'containerView',
                type: 'boolean',
                description: 'Sets if the inner content should be rendered within a Basic Title',
                bound: true,
                default: 'true',
            },
            {
                kind: 'classProperty',
                name: 'hasSeparatorBar',
                type: 'boolean',
                description: 'Adds a separator bar between the title and the chart',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'localization',
                type: 'ChartWrapperLocalization',
                description: 'Localization for the Chart Wrapper',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'minChartHeight',
                type: "React.CSSProperties['minHeight']",
                bound: true,
                default: 'undefined',
            },
            { kind: 'classProperty', name: 'useCondensedPadding', type: 'boolean', bound: true, default: 'false' },
            {
                kind: 'classProperty',
                name: 'ref',
                type: 'React.Ref<HTMLDivElement>',
                description: 'A react reference applied to the div.',
                default: 'null',
            },
        ],
        filePath: './src/lib/Charts/ChartWrapper/ChartWrapper.tsx',
        fileName: 'ChartWrapper.tsx',
        category: 'Charts',
    },
    {
        kind: 'interface',
        name: 'DataLabelSettings',
        properties: [
            { kind: 'interfaceProperty', name: 'enabled', type: 'boolean', required: true },
            { kind: 'interfaceProperty', name: 'showBackground', type: 'boolean', required: true },
            { kind: 'interfaceProperty', name: 'fontSize', type: 'CHART_FONT_SIZES | string' },
        ],
        filePath: './src/lib/Charts/Chart.model.ts',
        fileName: 'Chart.model.ts',
        category: 'Charts',
    },
    {
        kind: 'variable',
        name: 'HighchartsAngularStyle',
        type: "'width: 100%; height: 100%; display: block; overflow: visible;'",
        filePath: './src/lib/Charts/ChartWrapper/HighChartDefaults.ts',
        fileName: 'HighChartDefaults.ts',
        category: 'Charts',
    },
    {
        kind: 'variable',
        name: 'HighchartsDefaultTheme',
        type: '{ chart: { reflow: boolean; events: { load: (event: any) => void; }; }; credits: { enabled: boolean; }; legend: { itemStyle: { color: string; fontWeight: string; fontFamily: string; fontSize: string; }; itemHoverStyle: { color: string; }; itemHiddenStyle: { color: string; }; title: { style: { color: string; fontWeight: string; fontFamily: string; fontSize: string; }; text: string; }; align: AlignValue; }; title: boolean; subtitle: boolean; xAxis: { labels: { style: { color: string; fontWeight: string; fontFamily: string; fontSize: string; }; align: AlignValue; }; gridLineDashStyle: DashStyleValue; tickLength: number; gridLineColor: string; gridLineWidth: number; lineColor: string; title: { text: string; style: { color: string; fontWeight: string; fontFamily: string; fontSize: string; }; }; }[]; yAxis: { labels: { style: { color: string; fontSize: string; fontWeight: string; fontFamily: string; }; align: AlignValue; }; gridLineDashStyle: DashStyleValue; tickLength: number; gridLineColor: string; gridLineWidth: number; title: { style: { color: string; fontWeight: string; fontFamily: string; fontSize: string; }; }; }[]; tooltip: { backgroundColor: string; borderRadius: number; borderColor: string; borderWidth: number; padding: number; shadow: boolean; shape: TooltipShapeValue; style: { color: string; fontWeight: string; fontFamily: string; fontSize: string; }; }; }',
        filePath: './src/lib/Charts/ChartWrapper/HighChartDefaults.ts',
        fileName: 'HighChartDefaults.ts',
        category: 'Charts',
    },
    {
        kind: 'variable',
        name: 'HighchartsStyleMerge',
        type: 'any',
        filePath: './src/lib/Charts/ChartWrapper/HighChartDefaults.ts',
        fileName: 'HighChartDefaults.ts',
        category: 'Charts',
    },
    {
        kind: 'interface',
        name: 'SeriesData',
        properties: [
            { kind: 'interfaceProperty', name: 'name', type: 'string', required: true },
            { kind: 'interfaceProperty', name: 'data', type: 'number[] | SeriesData[]' },
            { kind: 'interfaceProperty', name: 'color', type: 'string' },
            { kind: 'interfaceProperty', name: 'y', type: 'number' },
        ],
        filePath: './src/lib/Charts/Chart.model.ts',
        fileName: 'Chart.model.ts',
        category: 'Charts',
    },
    {
        kind: 'interface',
        name: 'SeriesOptions',
        properties: [
            { kind: 'interfaceProperty', name: 'colors', type: 'string[]' },
            { kind: 'interfaceProperty', name: 'dataLabels', type: 'DataLabelSettings' },
            { kind: 'interfaceProperty', name: 'isStacked', type: 'boolean' },
        ],
        filePath: './src/lib/Charts/Chart.model.ts',
        fileName: 'Chart.model.ts',
        category: 'Charts',
    },
    {
        kind: 'variable',
        name: 'AppSideDisplay',
        type: "React.ForwardRefExoticComponent<Omit<AppSideDisplayProps & AppSideDisplayEvents, 'ref'> & React.RefAttributes<HTMLDivElement>>",
        description: "Description: Shows a large blue box with an icon, placed on the App Pages. Size is it's parent's container.",
        filePath: './src/lib/Displays/AppSideDisplay/AppSideDisplay.tsx',
        fileName: 'AppSideDisplay.tsx',
        category: 'Displays',
    },
    {
        kind: 'class',
        name: 'AppSideDisplayEvents',
        extends: 'DivHTMLEvents',
        filePath: './src/lib/Displays/AppSideDisplay/AppSideDisplay.tsx',
        fileName: 'AppSideDisplay.tsx',
        category: 'Displays',
    },
    {
        kind: 'class',
        name: 'AppSideDisplayProps',
        extends: 'DivHTMLAttributes',
        properties: [
            {
                kind: 'classProperty',
                name: 'icon',
                type: 'AppIconsWhite',
                description: 'Name of the SVG that will be shown.',
                bound: true,
                required: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'text',
                type: 'string',
                description: 'Text that will go above the large text.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'color',
                type: 'Colors',
                description: 'The appropriate Experience Cloud.',
                bound: true,
                default: "'CX'",
            },
            {
                kind: 'classProperty',
                name: 'title',
                type: 'string',
                description: 'Large text on the component.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'ref',
                type: 'React.Ref<HTMLDivElement>',
                description: 'Allows for ref passing to the wrapper component',
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Displays/AppSideDisplay/AppSideDisplay.tsx',
        fileName: 'AppSideDisplay.tsx',
        category: 'Displays',
    },
    {
        kind: 'variable',
        name: 'Drawer',
        type: "React.ForwardRefExoticComponent<Omit<DrawerProps & DrawerEvents, 'ref'> & React.RefAttributes<HTMLDivElement>>",
        description: 'Description: Generic drawer component that animates out from the right side of the screen, place whatever you want inside!',
        filePath: './src/lib/Drawers/Drawer/Drawer.tsx',
        fileName: 'Drawer.tsx',
        category: 'Drawers',
    },
    {
        kind: 'class',
        name: 'DrawerEvents',
        extends: 'DivHTMLEvents',
        properties: [
            {
                kind: 'classProperty',
                name: 'onClose',
                type: '() => void',
                description: 'This event is triggered when the closeButton is clicked.',
                bound: true,
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Drawers/Drawer/Drawer.tsx',
        fileName: 'Drawer.tsx',
        category: 'Drawers',
    },
    {
        kind: 'class',
        name: 'DrawerProps',
        extends: 'ObservablePropsMixin(DivHTMLAttributes)',
        properties: [
            {
                kind: 'classProperty',
                name: 'size',
                type: 'DrawerSizes',
                description: 'The size of the slide out drawer',
                bound: true,
                default: "'large'",
            },
            {
                kind: 'classProperty',
                name: 'open',
                type: 'boolean',
                description: 'Whether or not the drawer is open.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'color',
                type: 'Colors',
                description: 'Color of the bar on the Drawer.',
                bound: true,
                default: "'CX'",
            },
            {
                kind: 'classProperty',
                name: 'silverBg',
                type: 'boolean',
                description: 'Sets if the background color of the drawer should be grey instead of white.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'closeButtonIcon',
                type: 'Icons',
                description: 'Icon that displays on the top left of the drawer',
                bound: true,
                default: "'cancel'",
            },
            {
                kind: 'classProperty',
                name: 'interceptClose',
                type: 'boolean',
                description: 'Enables manually closing of the drawer.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'ref',
                type: 'React.Ref<HTMLDivElement>',
                description: 'Allows for ref passing to the wrapper component',
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Drawers/Drawer/Drawer.tsx',
        fileName: 'Drawer.tsx',
        category: 'Drawers',
    },
    {
        kind: 'type',
        name: 'DrawerSizes',
        type: "'large' | 'small'",
        filePath: './src/lib/Drawers/Drawer.model.ts',
        fileName: 'Drawer.model.ts',
        category: 'Drawers',
    },
    {
        kind: 'variable',
        name: 'SidePanel',
        type: "React.ForwardRefExoticComponent<Omit<SidePanelProps & SidePanelEvents, 'ref'> & React.RefAttributes<HTMLDivElement>>",
        description: 'Description: Left side panel that allows you to control the internal components!',
        filePath: './src/lib/Drawers/SidePanel/SidePanel.tsx',
        fileName: 'SidePanel.tsx',
        category: 'Drawers',
    },
    {
        kind: 'class',
        name: 'SidePanelEvents',
        extends: 'DivHTMLEvents',
        properties: [
            {
                kind: 'classProperty',
                name: 'onClose',
                type: '() => void',
                description: 'This event is triggered when the closeButton is clicked.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'onOpen',
                type: '() => void',
                description: 'This event is triggered when the closeButton is clicked.',
                bound: true,
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Drawers/SidePanel/SidePanel.tsx',
        fileName: 'SidePanel.tsx',
        category: 'Drawers',
    },
    {
        kind: 'class',
        name: 'SidePanelProps',
        extends: 'ObservablePropsMixin(DivHTMLAttributes)',
        properties: [
            {
                kind: 'classProperty',
                name: 'open',
                type: 'boolean',
                description: 'Whether or not the drawer is open.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'closeButtonIcon',
                type: 'Icons',
                description: 'Icon that displays on the top left of the drawer',
                bound: true,
                default: "'single_arrow_left'",
            },
            {
                kind: 'classProperty',
                name: 'openButtonIcon',
                type: 'Icons',
                description: 'Icon that displays on the top left of the drawer',
                bound: true,
                default: "'single_arrow_right'",
            },
            {
                kind: 'classProperty',
                name: 'interceptClose',
                type: 'boolean',
                description: 'Enables manually closing of the drawer.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'interceptOpen',
                type: 'boolean',
                description: 'Enables manually opening of the drawer.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'panelWidth',
                type: 'number',
                description: 'The width of the side panel when open.  Cannot override Mobile setting (100%)',
                bound: true,
                default: '300px',
            },
            {
                kind: 'classProperty',
                name: 'closedPanelWidth',
                type: 'number',
                description: 'The width of the side panel when closed.  Cannot override Mobile setting (0)',
                bound: true,
                default: '50px',
            },
            {
                kind: 'classProperty',
                name: 'ref',
                type: 'React.Ref<HTMLDivElement>',
                description: 'Allows for ref passing to the wrapper component',
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Drawers/SidePanel/SidePanel.tsx',
        fileName: 'SidePanel.tsx',
        category: 'Drawers',
    },
    {
        kind: 'variable',
        name: 'Dropdown',
        type: "React.ForwardRefExoticComponent<Omit<DropdownProps & DropdownEvents, 'ref'> & React.RefAttributes<HTMLInputElement>>",
        description: 'Description: One stop shop for all your dropdown needs.',
        filePath: './src/lib/Dropdowns/Dropdown/Dropdown.tsx',
        fileName: 'Dropdown.tsx',
        category: 'Dropdowns',
    },
    {
        kind: 'interface',
        name: 'Dropdown_onOpenChangeEvent',
        properties: [
            {
                kind: 'interfaceProperty',
                name: 'isOpen',
                type: 'boolean',
                description: 'The current state of the dropdown',
                required: true,
            },
        ],
        filePath: './src/lib/Dropdowns/Dropdown.model.ts',
        fileName: 'Dropdown.model.ts',
        category: 'Dropdowns',
    },
    {
        kind: 'interface',
        name: 'Dropdown_onSearchEvent',
        properties: [
            {
                kind: 'interfaceProperty',
                name: 'query',
                type: 'string | undefined',
                description: 'The current search query. A value of `undefined` means that the user is not currently searching.',
                required: true,
            },
        ],
        filePath: './src/lib/Dropdowns/Dropdown.model.ts',
        fileName: 'Dropdown.model.ts',
        category: 'Dropdowns',
    },
    {
        kind: 'interface',
        name: 'Dropdown_onValueChangeEvent',
        properties: [
            {
                kind: 'interfaceProperty',
                name: 'selected',
                type: 'DropdownObject[] | DropdownObject',
                description: 'The currently selected items in the dropdown',
                required: true,
            },
        ],
        filePath: './src/lib/Dropdowns/Dropdown.model.ts',
        fileName: 'Dropdown.model.ts',
        category: 'Dropdowns',
    },
    {
        kind: 'class',
        name: 'DropdownButtons',
        properties: [
            { kind: 'classProperty', name: 'primary', type: 'ButtonObject' },
            { kind: 'classProperty', name: 'secondary', type: 'ButtonObject' },
        ],
        filePath: './src/lib/Dropdowns/Dropdown.model.ts',
        fileName: 'Dropdown.model.ts',
        category: 'Dropdowns',
    },
    {
        kind: 'type',
        name: 'DropdownButtonTypes',
        type: "'icon' | 'pill' | 'layered' | 'fab' | 'button'",
        filePath: './src/lib/Dropdowns/Dropdown.model.ts',
        fileName: 'Dropdown.model.ts',
        category: 'Dropdowns',
    },
    {
        kind: 'interface',
        name: 'DropdownDataGroup',
        properties: [
            { kind: 'interfaceProperty', name: 'title', type: 'string', required: true },
            { kind: 'interfaceProperty', name: 'data', type: 'DropdownObject[]', required: true },
        ],
        filePath: './src/lib/Dropdowns/Dropdown.model.ts',
        fileName: 'Dropdown.model.ts',
        category: 'Dropdowns',
    },
    {
        kind: 'class',
        name: 'DropdownEvents',
        description: "The component's outputs. In Angular, each property is equivalent to `@Output()` decorated properties.",
        extends: 'InputHTMLEvents',
        properties: [
            {
                kind: 'classProperty',
                name: 'onValueChange',
                type: '(eventData: Dropdown_onValueChangeEvent) => void',
                description: "Function to fire when the value of the dropdown changes.\nFor 'multi' select the value doesn't officially change until the user hits the Apply button or clicks off of the menu.\nReturns an array of selected objects or a single selected object.",
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'onOpenChange',
                type: '(eventData: Dropdown_onOpenChangeEvent) => void',
                description: 'Fires on change of the open status on Dropdown.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'onEndOfScroll',
                type: '() => void',
                description: 'Fires when the user has scrolled to the bottom of the Dropdown list. Useful for lazy loading data.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'onSearch',
                type: '(eventData: Dropdown_onSearchEvent) => void',
                description: 'Fires when the user searches.',
                bound: true,
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Dropdowns/Dropdown/Dropdown.tsx',
        fileName: 'Dropdown.tsx',
        category: 'Dropdowns',
    },
    {
        kind: 'class',
        name: 'DropdownGroup',
        properties: [
            { kind: 'classProperty', name: 'title', type: 'string', required: true },
            { kind: 'classProperty', name: 'ids', type: 'string[]', required: true },
        ],
        filePath: './src/lib/Dropdowns/Dropdown.model.ts',
        fileName: 'Dropdown.model.ts',
        category: 'Dropdowns',
    },
    {
        kind: 'class',
        name: 'DropdownObject',
        properties: [
            { kind: 'classProperty', name: 'title', type: 'string', required: true },
            { kind: 'classProperty', name: 'subtitle', type: 'string' },
            { kind: 'classProperty', name: 'id', type: 'string', required: true },
            { kind: 'classProperty', name: 'visual', type: 'Icons | XIClouds' },
            { kind: 'classProperty', name: 'isSelected', type: 'boolean' },
            { kind: 'classProperty', name: 'disabled', type: 'boolean' },
            { kind: 'classProperty', name: 'color', type: "ErrorStates | Clouds | 'orca'" },
            { kind: 'classProperty', name: 'submenu', type: 'DropdownObject[]' },
            { kind: 'classProperty', name: 'tooltip', type: 'ToolTipProps' },
            { kind: 'classProperty', name: 'action', type: '() => void' },
            { kind: 'classProperty', type: 'DropdownObject', required: true },
        ],
        filePath: './src/lib/Dropdowns/Dropdown.model.ts',
        fileName: 'Dropdown.model.ts',
        category: 'Dropdowns',
    },
    {
        kind: 'class',
        name: 'DropdownProps',
        description: "The component's inputs. Only `@Bound()` decorated properties are available in web components.",
        extends: 'ObservablePropsMixin(InputHTMLAttributes)',
        properties: [
            {
                kind: 'classProperty',
                name: 'data',
                type: 'DropdownObject[] | null',
                description: "An array of items to display in the dropdown's menu.",
                bound: true,
                default: '[]',
            },
            {
                kind: 'classProperty',
                name: 'value',
                type: 'string | readonly string[]',
                description: 'The ids of the selected DropdownObjects.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'groups',
                type: 'DropdownGroup[]',
                description: 'An array of groups into which the data is sorted.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'textSize',
                type: 'TextSizes',
                description: "Controls the font size of the input field. Options are 'small' (14px)\nand 'normal' (16px).",
                bound: true,
                default: "'normal'",
            },
            {
                kind: 'classProperty',
                name: 'buttons',
                type: 'DropdownButtons',
                description: 'Adds action buttons to the dropdown menu. Multi select dropdown will automatically add them for you, but this will overwrite the default.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'color',
                type: 'Colors | White',
                description: "Determines the color of the checkmark icon for menu items, and, if 'single' select, determines the background color of the selected menu item.",
                bound: true,
                default: "'CX'",
            },
            {
                kind: 'classProperty',
                name: 'elementsToDisableScroll',
                type: 'HTMLElement | (HTMLElement | null)[] | null',
                bound: true,
                default: 'document.body',
            },
            {
                kind: 'classProperty',
                name: 'isFetchingData',
                type: 'boolean',
                description: 'A flag indicating whether data is currently being fetched for the Dropdown.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'status',
                type: 'ErrorObject | null',
                description: 'The error state of the component.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'label',
                type: 'string',
                description: 'Text for a label that appears above the dropdown.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'direction',
                type: 'ClockDirection',
                description: "The direction the dropdown menu tries to open. If the menu can't fit, it will automatically switch directions.",
                bound: true,
                default: '7',
            },
            {
                kind: 'classProperty',
                name: 'disabled',
                type: 'boolean',
                description: 'Disallows typing, and changes style to reflect it.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'placeholder',
                type: 'string',
                description: "The placeholder text for dropdown's input (only applicable to pill type).",
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'visualState',
                type: 'DropdownVisualState',
                description: 'The visual type of the dropdown, either normal or condensed',
                bound: true,
                default: "'normal'",
            },
            {
                kind: 'classProperty',
                name: 'select',
                type: 'DropdownSelects',
                description: "Determines how many items can be selected in the menu. 'none' is used for action\ntype menus, where there should be no memory of previous selections.",
                bound: true,
                default: "'single'",
            },
            {
                kind: 'classProperty',
                name: 'stretch',
                type: 'boolean',
                description: "Controls how the dropdown input should size itself. 'true' takes up 100% of the space it's given, 'false'\nstretches based on the size of the placeholder/value of the input. FAB/IconButton types always take up\nthe size of their button and do not stretch.",
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'type',
                type: 'DropdownButtonTypes',
                description: 'The type of dropdown button displayed. (An input will always exist for forms but could be hidden).',
                bound: true,
                default: "'pill'",
            },
            {
                kind: 'classProperty',
                name: 'fullWidthMobileMenu',
                type: 'boolean',
                description: 'On mobile views, the menu should appear starting at the left side, to the width of\nthe largest item, or the device size, whichever is smaller. Setting to false will\nforce the menu size to be the width of the dropdown, and aligned (direction 6 or 12)\nwith the dropdown.',
                bound: true,
                default: 'true',
            },
            {
                kind: 'classProperty',
                name: 'contrast',
                type: 'Contrasts',
                description: 'The contrast level that will be displayed',
                bound: true,
                default: "'normal'",
            },
            {
                kind: 'classProperty',
                name: 'localization',
                type: 'DropdownTextObject',
                description: 'Allows for constant text to be passed into the component, helpful for languages.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'inMenuSearch',
                type: 'boolean',
                description: 'Forces the dropdown search to appear within the menu and not on the input/button. Has no effect on Icon/FAB type dropdowns as this is already their functionality.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'internalProps',
                type: 'InternalDropdownProps',
                description: "Contains additional prop objects controlling the internal FAB/IconButton, as well as allows overriding the dropdown's outer div wrapper.",
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'itemSearchCount',
                type: 'number',
                description: 'Determines the amount of items required for a search box to appear.',
                bound: true,
                default: '7',
            },
            {
                kind: 'classProperty',
                name: 'inMenuSearchProps',
                type: 'Parameters<typeof SearchBox>[0]',
                description: 'Allows for passing input events and props to the search box inside the dropdown menu',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'selectedIcon',
                type: 'true | Icons',
                description: "The icon to display when an option is selected. Only applies to pill/text type dropdowns.\nUse `true` to automatically select the icon based on the selected value (only applies when select is 'single').",
                bound: true,
                default: 'true',
            },
            {
                kind: 'classProperty',
                name: 'tooltip',
                type: 'ToolTipProps',
                description: 'Allows for configuring the tooltip on the dropdown when the text overflows',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'endOfScrollOffset',
                type: 'number',
                description: 'An offset, in number of Dropdown items, from the bottom of the menu.\nWhen the user scrolls the menu item at that position into view, the onEndOfScroll\nevent will fire.\nCan be used to load more data before the user gets to the bottom of the menu.',
                bound: true,
                default: '0',
            },
            {
                kind: 'classProperty',
                name: 'ref',
                type: 'React.Ref<HTMLInputElement>',
                description: 'Allows for ref passing to the wrapper component',
                default: 'undefined',
            },
            { kind: 'classProperty', type: 'DropdownProps', required: true },
        ],
        filePath: './src/lib/Dropdowns/Dropdown/Dropdown.tsx',
        fileName: 'Dropdown.tsx',
        category: 'Dropdowns',
    },
    {
        kind: 'type',
        name: 'DropdownSelects',
        type: "'none' | 'single' | 'multi' | 'multiSelectAll'",
        filePath: './src/lib/Dropdowns/Dropdown.model.ts',
        fileName: 'Dropdown.model.ts',
        category: 'Dropdowns',
    },
    {
        kind: 'class',
        name: 'DropdownTextObject',
        properties: [
            { kind: 'classProperty', name: 'noResultsFound', type: 'string' },
            { kind: 'classProperty', name: 'selectAll', type: 'string' },
            { kind: 'classProperty', name: 'selected', type: 'string' },
            { kind: 'classProperty', name: 'more', type: 'string' },
            { kind: 'classProperty', name: 'search', type: 'string' },
        ],
        filePath: './src/lib/Dropdowns/Dropdown.model.ts',
        fileName: 'Dropdown.model.ts',
        category: 'Dropdowns',
    },
    {
        kind: 'type',
        name: 'DropdownVisualState',
        type: "'normal' | 'condensed'",
        filePath: './src/lib/Dropdowns/Dropdown.model.ts',
        fileName: 'Dropdown.model.ts',
        category: 'Dropdowns',
    },
    {
        kind: 'class',
        name: 'InternalDropdownProps',
        properties: [
            { kind: 'classProperty', name: 'wrapper', type: 'DivProps' },
            { kind: 'classProperty', name: 'menu', type: 'Partial<React.HTMLAttributes<HTMLDivElement>>' },
            { kind: 'classProperty', name: 'iconButton', type: 'Partial<Parameters<typeof IconButton>>[0]' },
            { kind: 'classProperty', name: 'fab', type: 'Partial<Parameters<typeof FAB>>[0]' },
            { kind: 'classProperty', name: 'defaultButton', type: 'Partial<Parameters<typeof DefaultButton>>[0]' },
        ],
        filePath: './src/lib/Dropdowns/Dropdown.model.ts',
        fileName: 'Dropdown.model.ts',
        category: 'Dropdowns',
    },
    {
        kind: 'enum',
        name: 'SelectAllState',
        properties: ['SELECTED', 'UNSPECIFIED', 'UNSELECTED'],
        filePath: './src/lib/Dropdowns/Dropdown.model.ts',
        fileName: 'Dropdown.model.ts',
        category: 'Dropdowns',
    },
    {
        kind: 'function',
        name: 'isURL',
        type: 'boolean',
        description: 'This function was adapted from https://stackoverflow.com/questions/161738/what-is-the-best-regular-expression-to-check-if-a-string-is-a-valid-url\nIt takes a string and outputs wether or not its a URL',
        parameters: [{ kind: 'functionParameter', name: 'possibleURL', type: 'string', description: 'The URL to test' }],
        filePath: './src/lib/_Utils/PublicFunctions/isURL.ts',
        fileName: 'isURL.ts',
        category: 'Functions',
    },
    {
        kind: 'type',
        name: 'Admin',
        type: "'admin'",
        filePath: './src/lib/Global.model.ts',
        fileName: 'Global.model.ts',
        category: 'Global',
    },
    {
        kind: 'type',
        name: 'AllColors',
        type: "'red_primary' | 'green_primary' | 'yellow_primary' | 'admin_primary' | 'orca_primary' | 'blue_primary' | 'purple_primary' | 'teal_primary' | 'white_primary' | 'magenta_primary' | 'grey_primary' | 'red_light_95' | 'red_light_90' | 'red_light_80' | 'red_light_70' | 'red_light_60' | 'red_light_50' | 'red_light_40' | 'red_light_30' | 'red_light_15' | 'green_light_95' | 'green_light_90' | 'green_light_80' | 'green_light_70' | 'green_light_60' | 'green_light_50' | 'green_light_40' | 'green_light_30' | 'green_light_15' | 'yellow_light_95' | 'yellow_light_90' | 'yellow_light_80' | 'yellow_light_70' | 'yellow_light_60' | 'yellow_light_50' | 'yellow_light_40' | 'yellow_light_30' | 'yellow_light_15' | 'admin_light_95' | 'admin_light_90' | 'admin_light_80' | 'admin_light_70' | 'admin_light_60' | 'admin_light_50' | 'admin_light_40' | 'admin_light_30' | 'admin_light_15' | 'orca_light_95' | 'orca_light_90' | 'orca_light_80' | 'orca_light_70' | 'orca_light_60' | 'orca_light_50' | 'orca_light_40' | 'orca_light_30' | 'orca_light_15' | 'blue_light_95' | 'blue_light_90' | 'blue_light_80' | 'blue_light_70' | 'blue_light_60' | 'blue_light_50' | 'blue_light_40' | 'blue_light_30' | 'blue_light_15' | 'purple_light_95' | 'purple_light_90' | 'purple_light_80' | 'purple_light_70' | 'purple_light_60' | 'purple_light_50' | 'purple_light_40' | 'purple_light_30' | 'purple_light_15' | 'teal_light_95' | 'teal_light_90' | 'teal_light_80' | 'teal_light_70' | 'teal_light_60' | 'teal_light_50' | 'teal_light_40' | 'teal_light_30' | 'teal_light_15' | 'white_light_95' | 'white_light_90' | 'white_light_80' | 'white_light_70' | 'white_light_60' | 'white_light_50' | 'white_light_40' | 'white_light_30' | 'white_light_15' | 'magenta_light_95' | 'magenta_light_90' | 'magenta_light_80' | 'magenta_light_70' | 'magenta_light_60' | 'magenta_light_50' | 'magenta_light_40' | 'magenta_light_30' | 'magenta_light_15' | 'grey_light_95' | 'grey_light_90' | 'grey_light_80' | 'grey_light_70' | 'grey_light_60' | 'grey_light_50' | 'grey_light_40' | 'grey_light_30' | 'grey_light_15' | 'red_dark_40' | 'red_dark_15' | 'red_dark_55' | 'green_dark_40' | 'green_dark_15' | 'green_dark_55' | 'yellow_dark_40' | 'yellow_dark_15' | 'yellow_dark_55' | 'admin_dark_40' | 'admin_dark_15' | 'admin_dark_55' | 'orca_dark_40' | 'orca_dark_15' | 'orca_dark_55' | 'blue_dark_40' | 'blue_dark_15' | 'blue_dark_55' | 'purple_dark_40' | 'purple_dark_15' | 'purple_dark_55' | 'teal_dark_40' | 'teal_dark_15' | 'teal_dark_55' | 'white_dark_40' | 'white_dark_15' | 'white_dark_55' | 'magenta_dark_40' | 'magenta_dark_15' | 'magenta_dark_55' | 'grey_dark_40' | 'grey_dark_15' | 'grey_dark_55' | 'silver'",
        filePath: './src/lib/Global.model.ts',
        fileName: 'Global.model.ts',
        category: 'Global',
    },
    {
        kind: 'type',
        name: 'Booleanish',
        type: "'false' | 'true' | boolean",
        filePath: './src/lib/Global.model.ts',
        fileName: 'Global.model.ts',
        category: 'Global',
    },
    {
        kind: 'class',
        name: 'ButtonObject',
        properties: [
            { kind: 'classProperty', name: 'text', type: 'string', required: true },
            { kind: 'classProperty', name: 'onClick', type: '(e?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void' },
        ],
        filePath: './src/lib/Global.model.ts',
        fileName: 'Global.model.ts',
        category: 'Global',
    },
    {
        kind: 'type',
        name: 'ButtonProps',
        type: 'React.ClassAttributes<HTMLButtonElement> & React.ButtonHTMLAttributes<HTMLButtonElement>',
        filePath: './src/lib/Global.model.ts',
        fileName: 'Global.model.ts',
        category: 'Global',
    },
    {
        kind: 'type',
        name: 'Clouds',
        type: "'EX' | 'EMPLOYEE' | 'CX' | 'CUSTOMER' | 'MX' | 'MARKETING' | 'PX' | 'PRODUCT' | 'CXIC'",
        filePath: './src/lib/Global.model.ts',
        fileName: 'Global.model.ts',
        category: 'Global',
    },
    {
        kind: 'type',
        name: 'ColorNames',
        type: "'admin' | 'orca' | 'blue' | 'purple' | 'teal' | 'white' | 'magenta' | 'grey'",
        filePath: './src/lib/Global.model.ts',
        fileName: 'Global.model.ts',
        category: 'Global',
    },
    {
        kind: 'type',
        name: 'Colors',
        type: "'admin' | 'orca' | 'EX' | 'EMPLOYEE' | 'CX' | 'CUSTOMER' | 'MX' | 'MARKETING' | 'PX' | 'PRODUCT' | 'CXIC' | 'system'",
        filePath: './src/lib/Global.model.ts',
        fileName: 'Global.model.ts',
        category: 'Global',
    },
    {
        kind: 'interface',
        name: 'ColorTemplate',
        properties: [
            { kind: 'interfaceProperty', name: 'light', type: 'LightColorTemplate', required: true },
            { kind: 'interfaceProperty', name: 'primary', type: 'string', required: true },
            { kind: 'interfaceProperty', name: 'dark', type: 'DarkColorTemplate', required: true },
        ],
        filePath: './src/lib/Global.model.ts',
        fileName: 'Global.model.ts',
        category: 'Global',
    },
    {
        kind: 'type',
        name: 'ComponentSizes',
        type: "'normal' | 'large'",
        filePath: './src/lib/Global.model.ts',
        fileName: 'Global.model.ts',
        category: 'Global',
    },
    {
        kind: 'type',
        name: 'Constructor',
        type: 'new (...args: any[]) => T',
        filePath: './src/lib/Global.model.ts',
        fileName: 'Global.model.ts',
        category: 'Global',
    },
    {
        kind: 'type',
        name: 'Contrasts',
        type: "'normal' | 'high'",
        filePath: './src/lib/Global.model.ts',
        fileName: 'Global.model.ts',
        category: 'Global',
    },
    {
        kind: 'type',
        name: 'CX',
        type: "'CX' | 'CUSTOMER'",
        filePath: './src/lib/Global.model.ts',
        fileName: 'Global.model.ts',
        category: 'Global',
    },
    {
        kind: 'type',
        name: 'CXIC',
        type: "'CXIC'",
        filePath: './src/lib/Global.model.ts',
        fileName: 'Global.model.ts',
        category: 'Global',
    },
    {
        kind: 'type',
        name: 'DarkColor',
        type: "'red_dark_40' | 'red_dark_15' | 'red_dark_55' | 'green_dark_40' | 'green_dark_15' | 'green_dark_55' | 'yellow_dark_40' | 'yellow_dark_15' | 'yellow_dark_55' | 'admin_dark_40' | 'admin_dark_15' | 'admin_dark_55' | 'orca_dark_40' | 'orca_dark_15' | 'orca_dark_55' | 'blue_dark_40' | 'blue_dark_15' | 'blue_dark_55' | 'purple_dark_40' | 'purple_dark_15' | 'purple_dark_55' | 'teal_dark_40' | 'teal_dark_15' | 'teal_dark_55' | 'white_dark_40' | 'white_dark_15' | 'white_dark_55' | 'magenta_dark_40' | 'magenta_dark_15' | 'magenta_dark_55' | 'grey_dark_40' | 'grey_dark_15' | 'grey_dark_55'",
        filePath: './src/lib/Global.model.ts',
        fileName: 'Global.model.ts',
        category: 'Global',
    },
    {
        kind: 'type',
        name: 'DarkColorTemplate',
        type: '{ 40: string; 15: string; 55: string; }',
        filePath: './src/lib/Global.model.ts',
        fileName: 'Global.model.ts',
        category: 'Global',
    },
    {
        kind: 'type',
        name: 'DarkNumbers',
        type: '40 | 15 | 55',
        filePath: './src/lib/Global.model.ts',
        fileName: 'Global.model.ts',
        category: 'Global',
    },
    {
        kind: 'type',
        name: 'Disabled',
        type: "'disabled'",
        filePath: './src/lib/Global.model.ts',
        fileName: 'Global.model.ts',
        category: 'Global',
    },
    {
        kind: 'type',
        name: 'DivProps',
        type: 'React.ClassAttributes<HTMLDivElement> & React.HTMLAttributes<HTMLDivElement>',
        filePath: './src/lib/Global.model.ts',
        fileName: 'Global.model.ts',
        category: 'Global',
    },
    {
        kind: 'enum',
        name: 'EnumClouds',
        properties: ['EX', 'EMPLOYEE', 'MX', 'MARKETING', 'CX', 'CUSTOMER', 'PX', 'PRODUCT', 'CXIC'],
        filePath: './src/lib/Global.model.ts',
        fileName: 'Global.model.ts',
        category: 'Global',
    },
    {
        kind: 'enum',
        name: 'EnumErrorStates',
        properties: ['SUCCESS', 'WARNING', 'ERROR'],
        filePath: './src/lib/Global.model.ts',
        fileName: 'Global.model.ts',
        category: 'Global',
    },
    {
        kind: 'type',
        name: 'ErrorStates',
        type: "'success' | 'warning' | 'error'",
        filePath: './src/lib/Global.model.ts',
        fileName: 'Global.model.ts',
        category: 'Global',
    },
    {
        kind: 'type',
        name: 'EX',
        type: "'EX' | 'EMPLOYEE'",
        filePath: './src/lib/Global.model.ts',
        fileName: 'Global.model.ts',
        category: 'Global',
    },
    {
        kind: 'type',
        name: 'InputProps',
        type: 'React.ClassAttributes<HTMLInputElement> & React.InputHTMLAttributes<HTMLInputElement>',
        filePath: './src/lib/Global.model.ts',
        fileName: 'Global.model.ts',
        category: 'Global',
    },
    {
        kind: 'type',
        name: 'Invalid',
        type: "'invalid'",
        filePath: './src/lib/Global.model.ts',
        fileName: 'Global.model.ts',
        category: 'Global',
    },
    {
        kind: 'variable',
        name: 'isAllColors',
        type: "(value: unknown) => value is 'red_primary' | 'green_primary' | 'yellow_primary' | 'admin_primary' | 'orca_primary' | 'blue_primary' | 'purple_primary' | 'teal_primary' | 'white_primary' | 'magenta_primary' | 'grey_primary' | 'red_light_95' | 'red_light_90' | 'red_light_80' | 'red_light_70' | 'red_light_60' | 'red_light_50' | 'red_light_40' | 'red_light_30' | 'red_light_15' | 'green_light_95' | 'green_light_90' | 'green_light_80' | 'green_light_70' | 'green_light_60' | 'green_light_50' | 'green_light_40' | 'green_light_30' | 'green_light_15' | 'yellow_light_95' | 'yellow_light_90' | 'yellow_light_80' | 'yellow_light_70' | 'yellow_light_60' | 'yellow_light_50' | 'yellow_light_40' | 'yellow_light_30' | 'yellow_light_15' | 'admin_light_95' | 'admin_light_90' | 'admin_light_80' | 'admin_light_70' | 'admin_light_60' | 'admin_light_50' | 'admin_light_40' | 'admin_light_30' | 'admin_light_15' | 'orca_light_95' | 'orca_light_90' | 'orca_light_80' | 'orca_light_70' | 'orca_light_60' | 'orca_light_50' | 'orca_light_40' | 'orca_light_30' | 'orca_light_15' | 'blue_light_95' | 'blue_light_90' | 'blue_light_80' | 'blue_light_70' | 'blue_light_60' | 'blue_light_50' | 'blue_light_40' | 'blue_light_30' | 'blue_light_15' | 'purple_light_95' | 'purple_light_90' | 'purple_light_80' | 'purple_light_70' | 'purple_light_60' | 'purple_light_50' | 'purple_light_40' | 'purple_light_30' | 'purple_light_15' | 'teal_light_95' | 'teal_light_90' | 'teal_light_80' | 'teal_light_70' | 'teal_light_60' | 'teal_light_50' | 'teal_light_40' | 'teal_light_30' | 'teal_light_15' | 'white_light_95' | 'white_light_90' | 'white_light_80' | 'white_light_70' | 'white_light_60' | 'white_light_50' | 'white_light_40' | 'white_light_30' | 'white_light_15' | 'magenta_light_95' | 'magenta_light_90' | 'magenta_light_80' | 'magenta_light_70' | 'magenta_light_60' | 'magenta_light_50' | 'magenta_light_40' | 'magenta_light_30' | 'magenta_light_15' | 'grey_light_95' | 'grey_light_90' | 'grey_light_80' | 'grey_light_70' | 'grey_light_60' | 'grey_light_50' | 'grey_light_40' | 'grey_light_30' | 'grey_light_15' | 'red_dark_40' | 'red_dark_15' | 'red_dark_55' | 'green_dark_40' | 'green_dark_15' | 'green_dark_55' | 'yellow_dark_40' | 'yellow_dark_15' | 'yellow_dark_55' | 'admin_dark_40' | 'admin_dark_15' | 'admin_dark_55' | 'orca_dark_40' | 'orca_dark_15' | 'orca_dark_55' | 'blue_dark_40' | 'blue_dark_15' | 'blue_dark_55' | 'purple_dark_40' | 'purple_dark_15' | 'purple_dark_55' | 'teal_dark_40' | 'teal_dark_15' | 'teal_dark_55' | 'white_dark_40' | 'white_dark_15' | 'white_dark_55' | 'magenta_dark_40' | 'magenta_dark_15' | 'magenta_dark_55' | 'grey_dark_40' | 'grey_dark_15' | 'grey_dark_55' | 'silver'",
        filePath: './src/lib/Global.model.ts',
        fileName: 'Global.model.ts',
        category: 'Global',
    },
    {
        kind: 'function',
        name: 'isClouds',
        type: 'boolean',
        parameters: [{ kind: 'functionParameter', name: 'value', type: 'unknown' }],
        filePath: './src/lib/Global.model.ts',
        fileName: 'Global.model.ts',
        category: 'Global',
    },
    {
        kind: 'function',
        name: 'isXIClouds',
        type: 'boolean',
        parameters: [{ kind: 'functionParameter', name: 'value', type: 'unknown' }],
        filePath: './src/lib/Global.model.ts',
        fileName: 'Global.model.ts',
        category: 'Global',
    },
    {
        kind: 'type',
        name: 'KitchenComponentType',
        type: 'React.FunctionComponent<Props> | React.NamedExoticComponent<Props>',
        filePath: './src/lib/Global.model.ts',
        fileName: 'Global.model.ts',
        category: 'Global',
    },
    {
        kind: 'type',
        name: 'LeftRight',
        type: "'left' | 'right'",
        filePath: './src/lib/Global.model.ts',
        fileName: 'Global.model.ts',
        category: 'Global',
    },
    {
        kind: 'type',
        name: 'LightColor',
        type: "'red_light_95' | 'red_light_90' | 'red_light_80' | 'red_light_70' | 'red_light_60' | 'red_light_50' | 'red_light_40' | 'red_light_30' | 'red_light_15' | 'green_light_95' | 'green_light_90' | 'green_light_80' | 'green_light_70' | 'green_light_60' | 'green_light_50' | 'green_light_40' | 'green_light_30' | 'green_light_15' | 'yellow_light_95' | 'yellow_light_90' | 'yellow_light_80' | 'yellow_light_70' | 'yellow_light_60' | 'yellow_light_50' | 'yellow_light_40' | 'yellow_light_30' | 'yellow_light_15' | 'admin_light_95' | 'admin_light_90' | 'admin_light_80' | 'admin_light_70' | 'admin_light_60' | 'admin_light_50' | 'admin_light_40' | 'admin_light_30' | 'admin_light_15' | 'orca_light_95' | 'orca_light_90' | 'orca_light_80' | 'orca_light_70' | 'orca_light_60' | 'orca_light_50' | 'orca_light_40' | 'orca_light_30' | 'orca_light_15' | 'blue_light_95' | 'blue_light_90' | 'blue_light_80' | 'blue_light_70' | 'blue_light_60' | 'blue_light_50' | 'blue_light_40' | 'blue_light_30' | 'blue_light_15' | 'purple_light_95' | 'purple_light_90' | 'purple_light_80' | 'purple_light_70' | 'purple_light_60' | 'purple_light_50' | 'purple_light_40' | 'purple_light_30' | 'purple_light_15' | 'teal_light_95' | 'teal_light_90' | 'teal_light_80' | 'teal_light_70' | 'teal_light_60' | 'teal_light_50' | 'teal_light_40' | 'teal_light_30' | 'teal_light_15' | 'white_light_95' | 'white_light_90' | 'white_light_80' | 'white_light_70' | 'white_light_60' | 'white_light_50' | 'white_light_40' | 'white_light_30' | 'white_light_15' | 'magenta_light_95' | 'magenta_light_90' | 'magenta_light_80' | 'magenta_light_70' | 'magenta_light_60' | 'magenta_light_50' | 'magenta_light_40' | 'magenta_light_30' | 'magenta_light_15' | 'grey_light_95' | 'grey_light_90' | 'grey_light_80' | 'grey_light_70' | 'grey_light_60' | 'grey_light_50' | 'grey_light_40' | 'grey_light_30' | 'grey_light_15'",
        filePath: './src/lib/Global.model.ts',
        fileName: 'Global.model.ts',
        category: 'Global',
    },
    {
        kind: 'type',
        name: 'LightColorTemplate',
        type: '{ 95: string; 90: string; 80: string; 70: string; 60: string; 50: string; 40: string; 30: string; 15: string; }',
        filePath: './src/lib/Global.model.ts',
        fileName: 'Global.model.ts',
        category: 'Global',
    },
    {
        kind: 'type',
        name: 'LightNumbers',
        type: '95 | 90 | 80 | 70 | 60 | 50 | 40 | 30 | 15',
        filePath: './src/lib/Global.model.ts',
        fileName: 'Global.model.ts',
        category: 'Global',
    },
    {
        kind: 'type',
        name: 'LIProps',
        type: 'React.ClassAttributes<HTMLLIElement> & React.HTMLAttributes<HTMLLIElement>',
        filePath: './src/lib/Global.model.ts',
        fileName: 'Global.model.ts',
        category: 'Global',
    },
    {
        kind: 'type',
        name: 'MakeRequired',
        type: 'Omit<T, K> & PickRequired<T, K>',
        filePath: './src/lib/Global.model.ts',
        fileName: 'Global.model.ts',
        category: 'Global',
    },
    {
        kind: 'type',
        name: 'MakeRequiredNullable',
        type: '{ [Key in keyof PickRequired<T, keyof T>]: T[Key]; }',
        filePath: './src/lib/Global.model.ts',
        fileName: 'Global.model.ts',
        category: 'Global',
    },
    {
        kind: 'interface',
        name: 'MenuObject',
        properties: [
            { kind: 'interfaceProperty', name: 'item_id', type: 'number', required: true },
            { kind: 'interfaceProperty', name: 'menuItem', type: 'string', required: true },
            { kind: 'interfaceProperty', name: 'checked', type: 'boolean', required: true },
            { kind: 'interfaceProperty', name: 'indeterminate', type: 'boolean', required: true },
        ],
        filePath: './src/lib/Global.model.ts',
        fileName: 'Global.model.ts',
        category: 'Global',
    },
    {
        kind: 'type',
        name: 'MX',
        type: "'MX' | 'MARKETING'",
        filePath: './src/lib/Global.model.ts',
        fileName: 'Global.model.ts',
        category: 'Global',
    },
    {
        kind: 'type',
        name: 'PickRequired',
        type: '{ [P in K]: Required<T>[P]; }',
        filePath: './src/lib/Global.model.ts',
        fileName: 'Global.model.ts',
        category: 'Global',
    },
    {
        kind: 'type',
        name: 'PickRequiredNullable',
        type: '{ [Key in keyof PickRequired<T, K>]: Pick<T, K>[Key]; }',
        filePath: './src/lib/Global.model.ts',
        fileName: 'Global.model.ts',
        category: 'Global',
    },
    {
        kind: 'type',
        name: 'PrimaryColor',
        type: "'red_primary' | 'green_primary' | 'yellow_primary' | 'admin_primary' | 'orca_primary' | 'blue_primary' | 'purple_primary' | 'teal_primary' | 'white_primary' | 'magenta_primary' | 'grey_primary'",
        filePath: './src/lib/Global.model.ts',
        fileName: 'Global.model.ts',
        category: 'Global',
    },
    {
        kind: 'type',
        name: 'PX',
        type: "'PX' | 'PRODUCT'",
        filePath: './src/lib/Global.model.ts',
        fileName: 'Global.model.ts',
        category: 'Global',
    },
    {
        kind: 'enum',
        name: 'SentimentEnum',
        properties: ["'negative'", "'neutral'", "'positive'"],
        filePath: './src/lib/Global.model.ts',
        fileName: 'Global.model.ts',
        category: 'Global',
    },
    {
        kind: 'type',
        name: 'Sentiments',
        type: "'negative' | 'neutral' | 'positive'",
        filePath: './src/lib/Global.model.ts',
        fileName: 'Global.model.ts',
        category: 'Global',
    },
    {
        kind: 'type',
        name: 'SpanProps',
        type: 'React.ClassAttributes<HTMLSpanElement> & React.HTMLAttributes<HTMLSpanElement>',
        filePath: './src/lib/Global.model.ts',
        fileName: 'Global.model.ts',
        category: 'Global',
    },
    {
        kind: 'type',
        name: 'StatusColorNames',
        type: "'red' | 'green' | 'yellow'",
        filePath: './src/lib/Global.model.ts',
        fileName: 'Global.model.ts',
        category: 'Global',
    },
    {
        kind: 'type',
        name: 'StatusStatesOptions',
        type: "'new' | 'open' | 'inProgress' | 'closed' | 'expired' | 'overdue'",
        filePath: './src/lib/Global.model.ts',
        fileName: 'Global.model.ts',
        category: 'Global',
    },
    {
        kind: 'type',
        name: 'System',
        type: "'orca' | 'system'",
        filePath: './src/lib/Global.model.ts',
        fileName: 'Global.model.ts',
        category: 'Global',
    },
    {
        kind: 'type',
        name: 'TextAlignProperty',
        type: "'-moz-initial' | 'inherit' | 'initial' | 'revert' | 'revert-layer' | 'unset' | 'center' | 'end' | 'justify' | 'left' | 'match-parent' | 'right' | 'start'",
        filePath: './src/lib/Global.model.ts',
        fileName: 'Global.model.ts',
        category: 'Global',
    },
    {
        kind: 'type',
        name: 'TextColors',
        type: "'admin' | 'orca' | 'white' | 'EX' | 'EMPLOYEE' | 'CX' | 'CUSTOMER' | 'MX' | 'MARKETING' | 'PX' | 'PRODUCT' | 'CXIC' | 'system' | 'disabled' | 'success' | 'warning' | 'error'",
        filePath: './src/lib/Global.model.ts',
        fileName: 'Global.model.ts',
        category: 'Global',
    },
    {
        kind: 'type',
        name: 'TextLevels',
        type: '3 | 2 | 1 | 4',
        filePath: './src/lib/Global.model.ts',
        fileName: 'Global.model.ts',
        category: 'Global',
    },
    {
        kind: 'type',
        name: 'TextSizes',
        type: "'normal' | 15 | 9 | 3 | 8 | 11 | 2 | 1 | 12 | 6 | 4 | 'small' | 'body' | 5 | 7 | 10 | 13 | 14",
        filePath: './src/lib/Global.model.ts',
        fileName: 'Global.model.ts',
        category: 'Global',
    },
    {
        kind: 'type',
        name: 'TextWeights',
        type: "'normal' | 300 | 400 | 600 | 'light' | 'semi-bold'",
        filePath: './src/lib/Global.model.ts',
        fileName: 'Global.model.ts',
        category: 'Global',
    },
    {
        kind: 'type',
        name: 'UListProps',
        type: 'React.ClassAttributes<HTMLUListElement> & React.HTMLAttributes<HTMLUListElement>',
        filePath: './src/lib/Global.model.ts',
        fileName: 'Global.model.ts',
        category: 'Global',
    },
    {
        kind: 'type',
        name: 'White',
        type: "'white'",
        filePath: './src/lib/Global.model.ts',
        fileName: 'Global.model.ts',
        category: 'Global',
    },
    {
        kind: 'type',
        name: 'WhiteSpaceProperty',
        type: "'-moz-initial' | 'inherit' | 'initial' | 'revert' | 'revert-layer' | 'unset' | '-moz-pre-wrap' | 'break-spaces' | 'normal' | 'nowrap' | 'pre' | 'pre-line' | 'pre-wrap'",
        filePath: './src/lib/Global.model.ts',
        fileName: 'Global.model.ts',
        category: 'Global',
    },
    {
        kind: 'type',
        name: 'XIClouds',
        type: "'EX' | 'EMPLOYEE' | 'CX' | 'CUSTOMER' | 'MX' | 'MARKETING' | 'PX' | 'PRODUCT'",
        filePath: './src/lib/Global.model.ts',
        fileName: 'Global.model.ts',
        category: 'Global',
    },
    {
        kind: 'type',
        name: 'XIColorTemplate',
        type: '{ red: ColorTemplate; green: ColorTemplate; yellow: ColorTemplate; admin: ColorTemplate; orca: ColorTemplate; blue: ColorTemplate; purple: ColorTemplate; teal: ColorTemplate; white: ColorTemplate; magenta: ColorTemplate; grey: ColorTemplate; } & { silver: string; }',
        filePath: './src/lib/Global.model.ts',
        fileName: 'Global.model.ts',
        category: 'Global',
    },
    {
        kind: 'interface',
        name: 'InternalListProps',
        properties: [
            {
                kind: 'interfaceProperty',
                name: 'searchBox',
                type: 'SearchBoxProps & SearchBoxEvents & InputProps',
                required: true,
            },
        ],
        filePath: './src/lib/Lists/List.model.ts',
        fileName: 'List.model.ts',
        category: 'Lists',
    },
    {
        kind: 'variable',
        name: 'List',
        type: "React.ForwardRefExoticComponent<Omit<ListProps & ListEvents, 'ref'> & React.RefAttributes<HTMLUListElement>>",
        description: 'Description: Displays a list of items in a pretty way.',
        filePath: './src/lib/Lists/List/List.tsx',
        fileName: 'List.tsx',
        category: 'Lists',
    },
    {
        kind: 'interface',
        name: 'List_onSelectionChangeEvent',
        properties: [{ kind: 'interfaceProperty', name: 'selectedItems', type: 'any | any[]', required: true }],
        filePath: './src/lib/Lists/List.model.ts',
        fileName: 'List.model.ts',
        category: 'Lists',
    },
    {
        kind: 'class',
        name: 'ListEvents',
        extends: 'UListHTMLEvents',
        properties: [
            {
                kind: 'classProperty',
                name: 'onSelectionChange',
                type: '(eventData: List_onSelectionChangeEvent) => void',
                description: "Returns the selected item/s. Will return an array if select = 'multi' or 'multiple'",
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'onEndOfScroll',
                type: '() => void',
                description: 'Fires when the user has scrolled to the bottom of the list. Useful for lazy loading data.',
                bound: true,
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Lists/List/List.tsx',
        fileName: 'List.tsx',
        category: 'Lists',
    },
    {
        kind: 'variable',
        name: 'ListItem',
        type: "React.ForwardRefExoticComponent<Omit<ListItemProps & ListItemEvents, 'ref'> & React.RefAttributes<HTMLLIElement>>",
        description: 'Description: For use inside of the List component, this contains an individual item.',
        filePath: './src/lib/Lists/ListItem/ListItem.tsx',
        fileName: 'ListItem.tsx',
        category: 'Lists',
    },
    {
        kind: 'interface',
        name: 'ListItem_onCheckedChangeEvent',
        properties: [{ kind: 'interfaceProperty', name: 'checked', type: 'boolean', required: true }],
        filePath: './src/lib/Lists/List.model.ts',
        fileName: 'List.model.ts',
        category: 'Lists',
    },
    {
        kind: 'interface',
        name: 'ListItem_onItemClickEvent',
        properties: [
            {
                kind: 'interfaceProperty',
                name: 'event',
                type: 'React.MouseEvent<HTMLLIElement> | React.KeyboardEvent<HTMLLIElement>',
                required: true,
            },
            { kind: 'interfaceProperty', name: 'value', type: "ListItemProps['value']", required: true },
        ],
        filePath: './src/lib/Lists/List.model.ts',
        fileName: 'List.model.ts',
        category: 'Lists',
    },
    {
        kind: 'class',
        name: 'ListItemEvents',
        extends: 'LiHTMLEvents',
        properties: [
            {
                kind: 'classProperty',
                name: 'onItemClick',
                type: '(eventData: ListItem_onItemClickEvent) => void',
                description: 'Click listener.  Called with a KeyboardEvent when the user "clicks" a list item using the keyboard.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'onCheckedChange',
                type: '(eventData: ListItem_onCheckedChangeEvent) => void',
                description: "Fires when the list item's `checked` status changes.",
                bound: true,
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Lists/ListItem/ListItem.tsx',
        fileName: 'ListItem.tsx',
        category: 'Lists',
    },
    {
        kind: 'class',
        name: 'ListItemProps',
        extends: 'ObservablePropsMixin(LiHTMLAttributes)',
        properties: [
            {
                kind: 'classProperty',
                name: 'value',
                type: 'any',
                description: "The value of the item, it is returned from the event of the List the ListItem is in when it's selected. Must be unique inside the List or it will select everything with the same value.",
                bound: true,
                required: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'contrast',
                type: 'Contrasts',
                description: "The list item's contrast.",
                bound: true,
                default: "'normal'",
            },
            {
                kind: 'classProperty',
                name: 'checked',
                type: 'boolean',
                description: 'controls whether the item is selected or not.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'disabled',
                type: 'boolean',
                description: 'controls whether the item is allowed to be selected/clicked or not.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'select',
                type: 'DropdownSelects',
                description: "Determines how many item's can be selected in the list. 'none' is used for action\ntype lists, where there should be no memory of previous selections or visual indicator\nfor what has been selected.\nIn React mode, this will be inherited from the containing list.\nIn Web Component mode, this will have to be supplied",
                bound: true,
                default: "'none'",
            },
            {
                kind: 'classProperty',
                name: 'hasDragging',
                type: 'boolean',
                description: 'controls whether the item will be draggable.\nIn React mode, this will be inherited from the containing list.\nIn Web Component mode, this will have to be supplied',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'color',
                type: 'Colors',
                description: 'Determines the background color of the selected menu item and the color of the check mark icon. Only effects isMulti = false.\nIn React mode, this will be inherited from the containing list.\nIn Web Component mode, this will have to be supplied',
                bound: true,
                default: "'CX'",
            },
            {
                kind: 'classProperty',
                name: 'tooltip',
                type: 'ToolTipProps',
                description: 'Tooltip to display.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'ref',
                type: 'React.Ref<HTMLLIElement>',
                description: 'Allows for ref passing to the wrapper component',
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Lists/ListItem/ListItem.tsx',
        fileName: 'ListItem.tsx',
        category: 'Lists',
    },
    {
        kind: 'class',
        name: 'ListProps',
        extends: 'ObservablePropsMixin(UListHTMLAttributes)',
        properties: [
            {
                kind: 'classProperty',
                name: 'children',
                type: 'any',
                description: 'A collection of ListItem components to display.',
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'color',
                type: 'Colors',
                description: "Determines the background color of the selected menu item and the color of the checkmark icon. Only affects checkmark on select 'single'.",
                bound: true,
                default: "'CX'",
            },
            {
                kind: 'classProperty',
                name: 'select',
                type: 'DropdownSelects',
                description: "Determines how many item's can be selected in the list. 'none' is used for action\ntype lists, where there should be no memory of previous selections or visual indicator\nfor what has been selected.",
                bound: true,
                default: "'none'",
            },
            {
                kind: 'classProperty',
                name: 'hasBorder',
                type: 'boolean',
                description: 'Determines whether the List will have a border.',
                bound: true,
                default: 'true',
            },
            {
                kind: 'classProperty',
                name: 'hasSearch',
                type: 'boolean',
                description: 'Shows a search box at the top of the list and allows searching through the list.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'hasDragging',
                type: 'boolean',
                description: '[Not fully implemented yet] Allows the items to be reordered by drag and drop.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'hasZebraStriping',
                type: 'boolean',
                description: 'Whether the background color of every other row is different.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'isFetchingData',
                type: 'boolean',
                description: 'A flag indicating whether data is currently being fetched for the list.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'maxHeight',
                type: "React.CSSProperties['maxHeight']",
                description: 'Sets the maximum height for the list',
                bound: true,
                default: "'auto'",
            },
            {
                kind: 'classProperty',
                name: 'value',
                type: 'any | any[]',
                description: 'The selected set of items in the list.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'label',
                type: 'string',
                description: 'Text that populates the HTML label tag.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'localization',
                type: 'ListTextObject',
                description: 'Allows for constant text to be passed into the component, helpful for languages.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'endOfScrollOffset',
                type: 'number',
                description: 'An offset, in number of list items, from the bottom of the list.\nWhen the user scrolls the menu item at that position into view, the onEndOfScroll\nevent will fire.\nCan be used to load more data before the user gets to the bottom of the list.',
                bound: true,
                default: '0',
            },
            {
                kind: 'classProperty',
                name: 'internalProps',
                type: 'InternalListProps',
                description: 'Contains additional prop objects, useful for further modification / information influencing the component.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'status',
                type: 'ErrorObject | null',
                description: 'The error state of the component.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'contrast',
                type: 'Contrasts',
                description: 'The contrast level that will be displayed',
                bound: true,
                default: "'normal'",
            },
            {
                kind: 'classProperty',
                name: 'size',
                type: 'ListSize',
                description: 'Determines the size of the list.',
                bound: true,
                default: "'large'",
            },
            {
                kind: 'classProperty',
                name: 'ref',
                type: 'React.Ref<HTMLUListElement>',
                description: 'Allows for ref passing to the wrapper component',
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Lists/List/List.tsx',
        fileName: 'List.tsx',
        category: 'Lists',
    },
    {
        kind: 'type',
        name: 'ListSize',
        type: "'normal' | 'large' | 'small'",
        filePath: './src/lib/Lists/List.model.ts',
        fileName: 'List.model.ts',
        category: 'Lists',
    },
    {
        kind: 'interface',
        name: 'ListTextObject',
        properties: [
            {
                kind: 'interfaceProperty',
                name: 'noResultsFound',
                type: 'string',
                description: 'Displayed when no list items match the current search query.',
            },
            {
                kind: 'interfaceProperty',
                name: 'clearSearch',
                type: 'string',
                description: 'Displayed when no list items match the current search query.',
            },
            {
                kind: 'interfaceProperty',
                name: 'selectAll',
                type: 'string',
                description: "The text displayed for the 'Select All' list item when `select` is `'multiSelectAll'`.",
            },
        ],
        filePath: './src/lib/Lists/List.model.ts',
        fileName: 'List.model.ts',
        category: 'Lists',
    },
    {
        kind: 'variable',
        name: 'AudioPlayer',
        type: 'React.ForwardRefExoticComponent<AudioPlayerProps & AudioPlayerEvents & React.RefAttributes<HTMLDivElement>>',
        description: 'Description: InMoment themed audio player.',
        filePath: './src/lib/Media/AudioPlayer/AudioPlayer.tsx',
        fileName: 'AudioPlayer.tsx',
        category: 'Media',
    },
    {
        kind: 'class',
        name: 'AudioPlayerEvents',
        extends: 'DivHTMLEvents',
        properties: [
            {
                kind: 'classProperty',
                name: 'audioPlayerEvents',
                type: 'AudioHTMLEvents',
                description: 'An object containing event handlers to pass to the AudioPlayer',
                bound: true,
                default: '{}',
            },
        ],
        filePath: './src/lib/Media/AudioPlayer/AudioPlayer.tsx',
        fileName: 'AudioPlayer.tsx',
        category: 'Media',
    },
    {
        kind: 'class',
        name: 'AudioPlayerProps',
        extends: 'DivHTMLAttributes',
        properties: [
            {
                kind: 'classProperty',
                name: 'source',
                type: 'string',
                description: 'The source url of the audio.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'audioPlayerProperties',
                type: 'AudioHTMLAttributes',
                description: 'An object containing props to pass to the AudioPlayer',
                bound: true,
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Media/AudioPlayer/AudioPlayer.tsx',
        fileName: 'AudioPlayer.tsx',
        category: 'Media',
    },
    {
        kind: 'variable',
        name: 'ImageCarousel',
        type: 'React.ForwardRefExoticComponent<ImageCarouselProps & ImageCarouselEvents & React.RefAttributes<HTMLDivElement>>',
        description: 'Description: Convenient Carousel to display all your favorite images.',
        filePath: './src/lib/Media/ImageCarousel/ImageCarousel.tsx',
        fileName: 'ImageCarousel.tsx',
        category: 'Media',
    },
    {
        kind: 'interface',
        name: 'ImageCarousel_onImagePressEvent',
        properties: [{ kind: 'interfaceProperty', name: 'image', type: 'string', required: true }],
        filePath: './src/lib/Media/Media.model.ts',
        fileName: 'Media.model.ts',
        category: 'Media',
    },
    {
        kind: 'class',
        name: 'ImageCarouselEvents',
        extends: 'DivHTMLEvents',
        properties: [
            {
                kind: 'classProperty',
                name: 'onImagePress',
                type: '(eventData: ImageCarousel_onImagePressEvent) => void',
                description: 'Fires when an image is clicked, returns the URL.',
                bound: true,
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Media/ImageCarousel/ImageCarousel.tsx',
        fileName: 'ImageCarousel.tsx',
        category: 'Media',
    },
    {
        kind: 'class',
        name: 'ImageCarouselProps',
        extends: 'DivHTMLAttributes',
        properties: [
            {
                kind: 'classProperty',
                name: 'images',
                type: 'string[]',
                description: 'Array of images the carousel accepts.',
                bound: true,
                required: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'activeIndex',
                type: 'number',
                description: 'Active index of the carousel.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'indicatorColor',
                type: 'Colors',
                description: 'Controls the color of the carousel indicators.',
                bound: true,
                default: "'orca'",
            },
            {
                kind: 'classProperty',
                name: 'genericModalProps',
                type: 'GenericModalProps & GenericModalEvents',
                description: 'Props passed into the generic modal component displayed\nwhen viewing the images full screen',
                bound: true,
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Media/ImageCarousel/ImageCarousel.tsx',
        fileName: 'ImageCarousel.tsx',
        category: 'Media',
    },
    {
        kind: 'interface',
        name: 'MediaPlayer_onFullScreenEvent',
        properties: [{ kind: 'interfaceProperty', name: 'event', type: 'React.MouseEvent', required: true }],
        filePath: './src/lib/Media/Media.model.ts',
        fileName: 'Media.model.ts',
        category: 'Media',
    },
    {
        kind: 'variable',
        name: 'VideoPlayer',
        type: 'React.ForwardRefExoticComponent<VideoPlayerProps & VideoPlayerEvents & React.RefAttributes<HTMLDivElement>>',
        description: 'Description: InMoment themed video player.',
        filePath: './src/lib/Media/VideoPlayer/VideoPlayer.tsx',
        fileName: 'VideoPlayer.tsx',
        category: 'Media',
    },
    {
        kind: 'class',
        name: 'VideoPlayerEvents',
        extends: 'DivHTMLEvents',
        filePath: './src/lib/Media/VideoPlayer/VideoPlayer.tsx',
        fileName: 'VideoPlayer.tsx',
        category: 'Media',
    },
    {
        kind: 'class',
        name: 'VideoPlayerProps',
        extends: 'DivHTMLAttributes',
        properties: [
            {
                kind: 'classProperty',
                name: 'source',
                type: 'string',
                description: 'The source url of the video.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'contrast',
                type: 'Contrasts',
                description: 'Sets the contrast of the play Icon.',
                bound: true,
                default: "'high'",
            },
            {
                kind: 'classProperty',
                name: 'height',
                type: 'number',
                description: 'Sets the height of the thumbnail.',
                bound: true,
                default: '122',
            },
            {
                kind: 'classProperty',
                name: 'width',
                type: 'number',
                description: 'Sets the width of the thumbnail.',
                bound: true,
                default: '216',
            },
            {
                kind: 'classProperty',
                name: 'genericModalProps',
                type: 'GenericModalProps & GenericModalEvents',
                description: 'Props passed into the generic modal component displayed\nwhen viewing the video',
                bound: true,
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Media/VideoPlayer/VideoPlayer.tsx',
        fileName: 'VideoPlayer.tsx',
        category: 'Media',
    },
    {
        kind: 'interface',
        name: 'MicroComponent_TextToLink',
        description: 'The return value from the TextToLink Micro Component',
        properties: [
            {
                kind: 'interfaceProperty',
                name: 'isLink',
                type: 'boolean',
                description: 'Whether or not the provided text is a link',
                required: true,
            },
            {
                kind: 'interfaceProperty',
                name: 'isTruncating',
                type: 'boolean',
                description: 'Whether or not the returned text is truncated',
                required: true,
            },
            {
                kind: 'interfaceProperty',
                name: 'text',
                type: 'string',
                description: 'The returned text (could be truncated or not, see isTruncating Property)',
                required: true,
            },
            {
                kind: 'interfaceProperty',
                name: 'linkProps',
                type: "Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'style'> & { class?: string }",
                description: 'The props to pass into an anchor tag. Simply spread the props on the anchor tag and\neverything should work as expected',
            },
            {
                kind: 'interfaceProperty',
                name: 'wrapperProps',
                type: 'ToolTipProps',
                description: 'The props to pass into a Kitchen Tooltip wrapper. Simply spread the props on the\nwrapper that encloses the anchor tag and everything should work as expected',
            },
            {
                kind: 'interfaceProperty',
                name: 'class',
                type: 'string',
                description: 'The class name of the text if the text is not a link, spread it onto whatever element\ncontains the text. This property only appears if the framework is `angular`. For\nReact based frameworks see the `className` property',
            },
            {
                kind: 'interfaceProperty',
                name: 'className',
                type: 'string',
                description: 'The class name of the text if the text is not a link, spread it onto whatever element\ncontains the text. This property only appears if the framework is `angular`. For\nReact based frameworks see the `className` property',
            },
        ],
        filePath: './src/lib/_Utils/MicroComponents/TextToLink.ts',
        fileName: 'TextToLink.ts',
        category: 'Micro Components',
    },
    {
        kind: 'variable',
        name: 'TextToLink',
        type: 'MicroComponent_TextToLink',
        description: 'Description: This micro component takes text and outputs the correct properties to pass into either\nan anchor tag or span tag. If the text is a link all of the correct anchor properties\nget set including style.\n\nNote: if truncated wrap the anchor tag in a ToolTipWrapper and use the wrapper props\n\nNote: you need to include the `kxi-text-to-link` or `kxi-text-to-link-bold` classes for\nthe component to display properly',
        filePath: './src/lib/_Utils/MicroComponents/TextToLink.ts',
        fileName: 'TextToLink.ts',
        category: 'Micro Components',
    },
    {
        kind: 'class',
        name: 'TextToLinkEvents',
        filePath: './src/lib/_Utils/MicroComponents/TextToLink.ts',
        fileName: 'TextToLink.ts',
        category: 'Micro Components',
    },
    {
        kind: 'class',
        name: 'TextToLinkProps',
        description: 'The props to pass into the TextToLink Micro Component',
        properties: [
            {
                kind: 'classProperty',
                name: 'truncate',
                type: 'number',
                description: 'The number of characters to truncate the links to. If not provided the links will not\nbe truncated',
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'text',
                type: 'string',
                description: 'The text of the component to check',
                required: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'framework',
                type: "'angular' | 'react'",
                description: 'The framework that the output will be used in. Changes the mapping of the style properties',
                default: "'angular'",
            },
            {
                kind: 'classProperty',
                name: 'textStyle',
                type: "'meta' | 'bold'",
                description: 'The style of the output text',
                default: "'meta'",
            },
            {
                kind: 'classProperty',
                name: 'rel',
                type: "React.AnchorHTMLAttributes<HTMLAnchorElement>['rel']",
                description: 'The default rel for the link. Defaults to requesting a prefetch of the target page to\nenable faster load times for external pages',
                default: "'prefetch'",
            },
        ],
        filePath: './src/lib/_Utils/MicroComponents/TextToLink.ts',
        fileName: 'TextToLink.ts',
        category: 'Micro Components',
    },
    {
        kind: 'interface',
        name: 'CreateNewNameModalButtons',
        properties: [{ kind: 'interfaceProperty', name: 'action', type: 'ButtonObject', required: true }],
        filePath: './src/lib/Modals/Modal.model.ts',
        fileName: 'Modal.model.ts',
        category: 'Modals',
    },
    {
        kind: 'variable',
        name: 'GenericModal',
        type: "React.ForwardRefExoticComponent<Omit<GenericModalProps & GenericModalEvents, 'ref'> & React.RefAttributes<HTMLDivElement>>",
        description: 'Description: Modal used for overlaying page and displaying anything.\nOnly has a background on contrast=high for legacy implementations (useLegacy=true).',
        filePath: './src/lib/Modals/GenericModal/GenericModal.tsx',
        fileName: 'GenericModal.tsx',
        category: 'Modals',
    },
    {
        kind: 'interface',
        name: 'GenericModalCustomPadding',
        properties: [
            { kind: 'interfaceProperty', name: 'top', type: 'string', required: true },
            { kind: 'interfaceProperty', name: 'right', type: 'string', required: true },
            { kind: 'interfaceProperty', name: 'bottom', type: 'string', required: true },
            { kind: 'interfaceProperty', name: 'left', type: 'string', required: true },
        ],
        filePath: './src/lib/Modals/Modal.model.ts',
        fileName: 'Modal.model.ts',
        category: 'Modals',
    },
    {
        kind: 'class',
        name: 'GenericModalEvents',
        extends: 'DivHTMLEvents',
        properties: [
            {
                kind: 'classProperty',
                name: 'onClose',
                type: '() => void',
                description: "Callback that fires when 'X' or backdrop is clicked.",
                bound: true,
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Modals/GenericModal/GenericModal.tsx',
        fileName: 'GenericModal.tsx',
        category: 'Modals',
    },
    {
        kind: 'class',
        name: 'GenericModalProps',
        extends: 'ObservablePropsMixin(DivHTMLAttributes)',
        properties: [
            {
                kind: 'classProperty',
                name: 'children',
                type: 'any',
                description: 'Any content inside the modal.',
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'allowScroll',
                type: 'boolean',
                description: 'Determines whether to allow the user to scroll within the modal if the content overflows.\nThis defaults to `false` for backwards compatibility, but devs are encouraged to pass `true`.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'allowPropagation',
                type: 'boolean',
                description: 'Allows the click event to propagate inside the contents of the modal.',
                bound: true,
                default: 'false',
            },
            { kind: 'classProperty', name: 'isVisualModal', type: 'boolean', bound: true, default: 'false' },
            { kind: 'classProperty', name: 'contrast', type: 'Contrasts', bound: true, default: "'normal'" },
            { kind: 'classProperty', name: 'fullScreen', type: 'boolean', bound: true, default: 'false' },
            {
                kind: 'classProperty',
                name: 'isVisible',
                type: 'boolean',
                description: 'Controls if modal is visible or not.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'isCancelVisible',
                type: 'boolean',
                description: 'Controls if X button is visible or not.',
                bound: true,
                default: 'true',
            },
            { kind: 'classProperty', name: 'canScrimClose', type: 'boolean', bound: true, default: 'false' },
            {
                kind: 'classProperty',
                name: 'canBackdropClose',
                type: 'boolean',
                description: 'Allows the ability to close the modal when you select the grey backdrop.',
                bound: true,
                default: 'true',
            },
            {
                kind: 'classProperty',
                name: 'targetElement',
                type: 'string',
                description: 'Query selector string to get a reference to the element that the generic modal\nshould appear over.\n\nOtherwise the modal is fixed and can be contained with `contain: content`',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'useLegacy',
                type: 'boolean',
                description: 'Determines if the modal should use legacy configuration and styling.\nProps that will only work when `useLegacy` is true: `canScrimClose`, `fullScreen`, `contrast`, `isVisualModal`.\nThis & aforementioned props, and the legacy styling as a whole will be removed in a future major version.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'maxWidth',
                type: 'string',
                description: 'Sets the maximum width of the modal. Value should contain unit (px, %, vw)',
                bound: true,
                default: "'720px'",
            },
            {
                kind: 'classProperty',
                name: 'minWidth',
                type: 'string',
                description: 'Sets the minimum width for the modal. Value should contain unit (px, %, vw)',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'minHeight',
                type: 'string',
                description: 'Sets the minimum height for the modal. Value should contain unit (px, %, vw)',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'secondaryStyle',
                type: 'boolean',
                description: 'Sets if the modal has secondary styling options: lighter scrim & X icon.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'customPadding',
                type: 'GenericModalCustomPadding',
                description: 'Sets custom padding for the modal. If no padding is desired, provide 0 for all sides.\n\nAccepts an object with the following types: top: string, right: string, bottom: string, left: string',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'slotName',
                type: 'string',
                description: 'Allows setting a custom slot name.',
                bound: true,
                default: "'children'",
            },
            {
                kind: 'classProperty',
                name: 'ref',
                type: 'React.Ref<HTMLDivElement>',
                description: 'Allows for ref passing to the wrapper component',
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Modals/GenericModal/GenericModal.tsx',
        fileName: 'GenericModal.tsx',
        category: 'Modals',
    },
    {
        kind: 'interface',
        name: 'InternalCreateNewNameModalProps',
        properties: [{ kind: 'interfaceProperty', name: 'input', type: 'InputFieldProps' }],
        filePath: './src/lib/Modals/Modal.model.ts',
        fileName: 'Modal.model.ts',
        category: 'Modals',
    },
    {
        kind: 'variable',
        name: 'Popout',
        type: 'React.ForwardRefExoticComponent<PopoutProps & PopoutEvents & React.RefAttributes<HTMLDivElement>>',
        description: 'A component that handles the "popout" logic and displaying of a popout. The popout\nattaches to an element. The popout is then displayed in a direction around the anchor\nelement. There is logic inside this component to handle small screen sizes, popouts appearing\noff the edge of the screen, and various other possibilities. As such, the popout is\nnot guaranteed to display in the direction provided, but the one provided will be used\nas a "first choice".',
        filePath: './src/lib/Modals/Popout/Popout.tsx',
        fileName: 'Popout.tsx',
        category: 'Modals',
    },
    {
        kind: 'interface',
        name: 'Popout_onEscapeEvent',
        properties: [{ kind: 'interfaceProperty', name: 'event', type: 'KeyboardEvent', required: true }],
        filePath: './src/lib/Modals/Modal.model.ts',
        fileName: 'Modal.model.ts',
        category: 'Modals',
    },
    {
        kind: 'interface',
        name: 'Popout_onExternalClickEvent',
        properties: [{ kind: 'interfaceProperty', name: 'event', type: 'MouseEvent', required: true }],
        filePath: './src/lib/Modals/Modal.model.ts',
        fileName: 'Modal.model.ts',
        category: 'Modals',
    },
    {
        kind: 'interface',
        name: 'Popout_onFocusOutEvent',
        properties: [{ kind: 'interfaceProperty', name: 'event', type: 'FocusEvent', required: true }],
        filePath: './src/lib/Modals/Modal.model.ts',
        fileName: 'Modal.model.ts',
        category: 'Modals',
    },
    {
        kind: 'class',
        name: 'PopoutEvents',
        extends: 'DivHTMLEvents',
        properties: [
            {
                kind: 'classProperty',
                name: 'onExternalClick',
                type: '(eventData: Popout_onExternalClickEvent) => void',
                description: 'Callback that fires when anything outside the popout is clicked',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'onEscape',
                type: '(eventData: Popout_onEscapeEvent) => void',
                description: 'Callback that fires when escape is pressed',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'onFocusOut',
                type: '(eventData: Popout_onFocusOutEvent) => void',
                description: 'Callback that fires when escape is pressed',
                bound: true,
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Modals/Popout/Popout.tsx',
        fileName: 'Popout.tsx',
        category: 'Modals',
    },
    {
        kind: 'class',
        name: 'PopoutProps',
        extends: 'ObservablePropsMixin(DivHTMLAttributes)',
        properties: [
            {
                kind: 'classProperty',
                name: 'anchorElement',
                type: 'HTMLElement | null',
                description: 'The element that the position of the popout is referenced off of. If this is not\nprovided the popout will be forced to appear in the upper right corner of the screen.\nNote that the anchor element MUST be in the DOM before isVisible is set to `true`',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'isVisible',
                type: 'boolean',
                description: 'Controls whether or not the popout is visible.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'direction',
                type: 'ClockDirection',
                description: 'The clock direction that the popout attempts to appear towards. See additional documentation.',
                bound: true,
                default: '6',
            },
            {
                kind: 'classProperty',
                name: 'internalPadding',
                type: "React.CSSProperties['margin']",
                description: 'The spacing between the content inside of the popout and the border of the popout.',
                bound: true,
                default: '6',
            },
            {
                kind: 'classProperty',
                name: 'edgeClearance',
                type: 'number',
                description: 'The minimum px from the screen edges. Do not use this property to attempt to position\nthe popout on screen.',
                bound: true,
                default: '6',
            },
            {
                kind: 'classProperty',
                name: 'popoutId',
                type: 'string',
                description: 'The id of the popout box',
                bound: true,
                default: "'kxi-xi-popout'",
            },
            {
                kind: 'classProperty',
                name: 'elementsToDisableScroll',
                type: 'HTMLElement | null | (HTMLElement | null)[]',
                description: 'Deprecated: Disables scrolling on the provided element(s). Note: Disabled in v15.5 and later.\nPrevents scroll by default when popout is open. If you must enable scroll, set the\nthe allowScroll property to true',
                deprecated: true,
                bound: true,
                default: 'null',
            },
            {
                kind: 'classProperty',
                name: 'slotName',
                type: 'string',
                description: 'Allows setting a custom slot name. Useful when there are multiple popouts on a\nsingle page',
                bound: true,
                default: "'children'",
            },
            {
                kind: 'classProperty',
                name: 'preventFocus',
                type: 'boolean',
                description: 'Prevents the first selectable element from receiving focus when the popout pops out.\nNote: in most cases this should be false. If it is true you must handle keyboard\naccessibility by listening for the tab event and focusing on the appropriate element.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'stretch',
                type: 'boolean',
                description: 'Stretches the popout to match the width of the anchor element.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'offset',
                type: '{ horizontal?: number; vertical?: number } | number',
                description: 'Allows the ability to control the offset from the anchor element per direction\nFor instance if the direction ends up being left or right the horizontal component\nwill apply, if its top or bottom the vertical number will apply. You can also just\npass a single number that will apply correctly in all use cases.',
                bound: true,
                default: '6',
            },
            {
                kind: 'classProperty',
                name: 'containedPopoutIds',
                type: 'string[]',
                description: 'The IDs of any popouts that are (logically) inside this popout. This prevents the\nonExternalClick event from firing when popouts that inside the logical structure of\nthe popout (but not the DOM structure) are clicked.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'allowScroll',
                type: 'boolean',
                description: 'Allows the popout to scroll with the content. If the anchor disappears off the page,\nthe popout will remain ON the page abutting the edge.\n\nNote: this should only be used for tooltips and other content that is unobstructive\nand can always close once the anchor disappears off the page.\n\nSetting this property to true also prevents the popout from consuming and trapping focus.\n\nIf you are using this property, there is a high likely hood that the implementation\nor designs are incorrect. Please reach out to the Kitchen team to verify your use case.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'trapFocus',
                type: 'boolean',
                description: 'Traps the focus within the popout and anchor element so that the tab flow will not\nleave the popout while it is open. If `preventFocus` is false the tab flow will also\ninclude the anchor element.\n\nNote: ensure that the user can leave the popout by use of the escape key to ensure accessibility',
                bound: true,
                default: 'true',
            },
            {
                kind: 'classProperty',
                name: 'children',
                type: 'React.ReactNode',
                description: 'Content inside the popout component. React only. Automatically passed if there are\nchildren in the jsx file.',
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Modals/Popout/Popout.tsx',
        fileName: 'Popout.tsx',
        category: 'Modals',
    },
    {
        kind: 'variable',
        name: 'Calendar',
        type: "React.ForwardRefExoticComponent<Omit<CalendarProps & CalendarEvents, 'ref'> & React.RefAttributes<HTMLDivElement>>",
        description: 'Description: Standard XI themed Custom Date Range selector.',
        filePath: './src/lib/Pickers/Calendar/Calendar.tsx',
        fileName: 'Calendar.tsx',
        category: 'Pickers',
    },
    {
        kind: 'interface',
        name: 'Calendar_onDateClickEvent',
        properties: [{ kind: 'interfaceProperty', name: 'dates', type: 'Dates', required: true }],
        filePath: './src/lib/Pickers/Picker.model.ts',
        fileName: 'Picker.model.ts',
        category: 'Pickers',
    },
    {
        kind: 'interface',
        name: 'Calendar_onDateErrorEvent',
        properties: [{ kind: 'interfaceProperty', name: 'dates', type: 'ErrorDates', required: true }],
        filePath: './src/lib/Pickers/Picker.model.ts',
        fileName: 'Picker.model.ts',
        category: 'Pickers',
    },
    {
        kind: 'interface',
        name: 'Calendar_onToggleEvent',
        properties: [{ kind: 'interfaceProperty', name: 'mode', type: 'CalendarModes', required: true }],
        filePath: './src/lib/Pickers/Picker.model.ts',
        fileName: 'Picker.model.ts',
        category: 'Pickers',
    },
    {
        kind: 'interface',
        name: 'Calendar_onValueChangeEvent',
        properties: [
            { kind: 'interfaceProperty', name: 'dates', type: 'Dates', required: true },
            { kind: 'interfaceProperty', name: 'title', type: 'string' },
            { kind: 'interfaceProperty', name: 'optionId', type: 'string' },
            {
                kind: 'interfaceProperty',
                name: 'value',
                type: 'number',
                description: 'Will be provided if the value is a custom relative date.',
            },
            {
                kind: 'interfaceProperty',
                name: 'unit',
                type: 'CalendarCustomListItemUnit',
                description: 'Will be provided if the value is a custom relative date.',
            },
        ],
        filePath: './src/lib/Pickers/Picker.model.ts',
        fileName: 'Picker.model.ts',
        category: 'Pickers',
    },
    {
        kind: 'type',
        name: 'CalendarCustomListItemUnit',
        type: "'day' | 'week' | 'month'",
        filePath: './src/lib/Pickers/Picker.model.ts',
        fileName: 'Picker.model.ts',
        category: 'Pickers',
    },
    {
        kind: 'interface',
        name: 'CalendarData',
        description: 'Object passed into the Calendar data object',
        properties: [
            {
                kind: 'interfaceProperty',
                name: 'initialDateRange',
                type: 'Dates',
                description: 'The initial date range. Do NOT update this with every click, only update on initial\nload, and if you would like to reset the dates to some value.',
            },
            {
                kind: 'interfaceProperty',
                name: 'customCalendarListOption',
                type: 'CustomCalendarListItem',
                description: 'If provided, adds an option to the beginning of the relative dates list that allows users to enter a custom date.',
            },
            {
                kind: 'interfaceProperty',
                name: 'preselectedCalendarListOptions',
                type: 'PreselectedCalendarListOptions[]',
                description: 'The list options provided in the relative list. Despite the name, these are not\nautomatically selected, just a list of items.',
            },
        ],
        filePath: './src/lib/Pickers/Picker.model.ts',
        fileName: 'Picker.model.ts',
        category: 'Pickers',
    },
    {
        kind: 'class',
        name: 'CalendarEvents',
        extends: 'DOMEvents<HTMLDivElement>',
        properties: [
            {
                kind: 'classProperty',
                name: 'onDateClick',
                type: '(eventData: Calendar_onDateClickEvent) => void',
                description: 'Callback that fires when a Date is clicked (deprecated)',
                deprecated: true,
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'onValueChange',
                type: '(eventData: Calendar_onValueChangeEvent) => void',
                description: 'Callback that fires when a Date is clicked or a list item is clicked',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'onDateError',
                type: '(eventData: Calendar_onDateErrorEvent) => void',
                description: 'Callback that fires when the date is invalid',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'onToggle',
                type: '(eventData: Calendar_onToggleEvent) => void',
                description: 'Callback that fires when toggle is clicked.',
                bound: true,
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Pickers/Calendar/Calendar.tsx',
        fileName: 'Calendar.tsx',
        category: 'Pickers',
    },
    {
        kind: 'type',
        name: 'CalendarModes',
        type: "'relative' | 'fixed'",
        filePath: './src/lib/Pickers/Picker.model.ts',
        fileName: 'Picker.model.ts',
        category: 'Pickers',
    },
    {
        kind: 'type',
        name: 'CalendarOutlines',
        type: "'none' | 'shadow' | 'border'",
        filePath: './src/lib/Pickers/Picker.model.ts',
        fileName: 'Picker.model.ts',
        category: 'Pickers',
    },
    {
        kind: 'class',
        name: 'CalendarProps',
        extends: 'ObservablePropsMixin(DivHTMLAttributes)',
        properties: [
            {
                kind: 'classProperty',
                name: 'data',
                type: 'CalendarData',
                description: 'Options for the dropdown, that allow preselected date ranges. Custom is automatically added and is anything that does not have the same id as the predefined ranges.',
                bound: true,
                default: '{}',
            },
            {
                kind: 'classProperty',
                name: 'groups',
                type: 'DropdownGroup[]',
                description: 'Grouping for the dropdown, allows passing an array of groups to categorize the preselected date ranges. // Deprecated',
                deprecated: true,
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'mode',
                type: 'CalendarModes',
                description: 'Programmatically controls which side of the Calendar is active (List view or Calendar view).',
                bound: true,
                default: "'fixed'",
            },
            {
                kind: 'classProperty',
                name: 'outline',
                type: 'CalendarOutlines',
                description: 'Controls the type of outline used for the Calendar.',
                bound: true,
                default: "'none'",
            },
            {
                kind: 'classProperty',
                name: 'maxDate',
                type: 'Date',
                description: 'Controls the furthest date that is selectable for the future.',
                bound: true,
                default: '2 Months From Today',
            },
            {
                kind: 'classProperty',
                name: 'minDate',
                type: 'Date',
                description: 'Controls the furthest date that is selectable for the past.',
                bound: true,
                default: 'January 1st 1970',
            },
            {
                kind: 'classProperty',
                name: 'locale',
                type: 'string',
                description: 'Controls the locale of the Calendar, using the standard Date object options.',
                bound: true,
                default: "'en-US'",
            },
            {
                kind: 'classProperty',
                name: 'contrast',
                type: 'Contrasts',
                description: 'Controls ease of visibility on different backgrounds.',
                bound: true,
                default: "'normal'",
            },
            {
                kind: 'classProperty',
                name: 'checkedListId',
                type: 'DefaultPreselectedCalendarListIds | string | null',
                description: 'Controls which item in the list is checked.',
                bound: true,
                default: 'DefaultPreselectedCalendarListIds.TODAY',
            },
            {
                kind: 'classProperty',
                name: 'listColor',
                type: 'Colors',
                description: 'Controls the background / selected color of the internal list.',
                bound: true,
                default: "'normal'",
            },
            {
                kind: 'classProperty',
                name: 'hasInternalPadding',
                type: 'boolean',
                description: 'If set to false, allows for the calendar to be more compact, to fit better into other containers.',
                bound: true,
                default: 'true',
            },
            {
                kind: 'classProperty',
                name: 'popoutView',
                type: 'boolean',
                description: 'Determines if the calendar should appear in a popout via an opener',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'direction',
                type: 'ClockDirection',
                description: "The direction the popout tries to open. If the popout can't fit, it will automatically switch directions.",
                bound: true,
                default: '7',
            },
            {
                kind: 'classProperty',
                name: 'condensedPopoutDropper',
                type: 'boolean',
                description: 'Sets if the popout opener should have condensed padding',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'localization',
                type: 'CalendarTextObject',
                description: 'Controls text that is displayed with the component.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'ref',
                type: 'React.Ref<HTMLDivElement>',
                description: 'Allows for ref passing to the wrapper component',
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Pickers/Calendar/Calendar.tsx',
        fileName: 'Calendar.tsx',
        category: 'Pickers',
    },
    {
        kind: 'type',
        name: 'CalendarPropsAndEvents',
        type: "Omit<CalendarProps & CalendarEvents, 'ref'> & React.RefAttributes<HTMLDivElement>",
        filePath: './src/lib/Pickers/Calendar/Calendar.tsx',
        fileName: 'Calendar.tsx',
        category: 'Pickers',
    },
    {
        kind: 'interface',
        name: 'CalendarTextObject',
        properties: [
            { kind: 'interfaceProperty', name: 'firstInputPlaceholder', type: 'string' },
            { kind: 'interfaceProperty', name: 'secondInputPlaceholder', type: 'string' },
            { kind: 'interfaceProperty', name: 'startDate', type: 'string' },
            { kind: 'interfaceProperty', name: 'endDate', type: 'string' },
            { kind: 'interfaceProperty', name: 'errorString', type: 'string' },
            { kind: 'interfaceProperty', name: 'leftText', type: 'string' },
            { kind: 'interfaceProperty', name: 'rightText', type: 'string' },
            { kind: 'interfaceProperty', name: 'to', type: 'string' },
            { kind: 'interfaceProperty', name: 'custom', type: 'string' },
            { kind: 'interfaceProperty', name: 'applyBtn', type: 'string' },
            { kind: 'interfaceProperty', name: 'cancelBtn', type: 'string' },
            { kind: 'interfaceProperty', name: 'noSelection', type: 'string' },
            {
                kind: 'interfaceProperty',
                name: 'last',
                type: 'string',
                description: 'Used in the custom relative date selector.',
            },
            {
                kind: 'interfaceProperty',
                name: 'min',
                type: 'string',
                description: 'Used in the status for invalid custom relative dates.',
            },
            {
                kind: 'interfaceProperty',
                name: 'max',
                type: 'string',
                description: 'Used in the status for invalid custom relative dates.',
            },
            {
                kind: 'interfaceProperty',
                name: 'days',
                type: 'string',
                description: 'Used in the unit dropdown for custom relative dates.',
            },
            {
                kind: 'interfaceProperty',
                name: 'weeks',
                type: 'string',
                description: 'Used in the unit dropdown for custom relative dates.',
            },
            {
                kind: 'interfaceProperty',
                name: 'months',
                type: 'string',
                description: 'Used in the unit dropdown for custom relative dates.',
            },
        ],
        filePath: './src/lib/Pickers/Picker.model.ts',
        fileName: 'Picker.model.ts',
        category: 'Pickers',
    },
    {
        kind: 'variable',
        name: 'ColorPicker',
        type: "React.ForwardRefExoticComponent<Omit<ColorPickerProps & ColorPickerEvents, 'ref'> & React.RefAttributes<HTMLDivElement>>",
        description: 'Description: Allows the user to pick a color from a 2D chart',
        filePath: './src/lib/Pickers/ColorPicker/ColorPicker.tsx',
        fileName: 'ColorPicker.tsx',
        category: 'Pickers',
    },
    {
        kind: 'interface',
        name: 'ColorPicker_onColorChangeEvent',
        properties: [{ kind: 'interfaceProperty', name: 'color', type: 'RGBAColor', required: true }],
        filePath: './src/lib/Pickers/Picker.model.ts',
        fileName: 'Picker.model.ts',
        category: 'Pickers',
    },
    {
        kind: 'class',
        name: 'ColorPickerEvents',
        extends: 'DivHTMLEvents',
        properties: [
            {
                kind: 'classProperty',
                name: 'onColorChange',
                type: '(eventData: ColorPicker_onColorChangeEvent) => void',
                description: 'Called when the user changes the color',
                bound: true,
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Pickers/ColorPicker/ColorPicker.tsx',
        fileName: 'ColorPicker.tsx',
        category: 'Pickers',
    },
    {
        kind: 'class',
        name: 'ColorPickerProps',
        extends: 'ObservablePropsMixin(DivHTMLAttributes)',
        properties: [
            {
                kind: 'classProperty',
                name: 'selectedColor',
                type: 'RGBAColorInput | string',
                description: 'The current color of the picker. 2 way bindable.\nAccepts RGB values between 0-255 and an alpha value from 0-1',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'direction',
                type: 'ClockDirection',
                description: "The direction the popout tries to open. If the popout can't fit, it will automatically switch directions.",
                bound: true,
                default: '7',
            },
            {
                kind: 'classProperty',
                name: 'inputType',
                type: "'HEX' | 'RGB' | 'none'",
                description: 'The type of text input to display at the bottom of the color picker.',
                bound: true,
                default: "'RGB'",
            },
            {
                kind: 'classProperty',
                name: 'hexContainsAlpha',
                type: 'boolean',
                description: 'Controls whether the output hex is 6 digits (without alpha) or 8 digits (with alpha)',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'tooltip',
                type: 'ToolTipProps',
                description: 'Props for displaying the tooltip on the Color Picker',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'localization',
                type: 'ColorPickerTextObject',
                description: 'Sets localization strings for Color Picker',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'ref',
                type: 'React.Ref<HTMLDivElement>',
                description: 'A react reference applied to the div.',
                default: 'null',
            },
        ],
        filePath: './src/lib/Pickers/ColorPicker/ColorPicker.tsx',
        fileName: 'ColorPicker.tsx',
        category: 'Pickers',
    },
    {
        kind: 'type',
        name: 'ColorPickerPropsAndEvents',
        type: "Omit<ColorPickerProps & ColorPickerEvents, 'ref'> & React.RefAttributes<HTMLDivElement>",
        filePath: './src/lib/Pickers/ColorPicker/ColorPicker.tsx',
        fileName: 'ColorPicker.tsx',
        category: 'Pickers',
    },
    {
        kind: 'interface',
        name: 'ColorPickerTextObject',
        properties: [
            { kind: 'interfaceProperty', name: 'red', type: 'string' },
            { kind: 'interfaceProperty', name: 'green', type: 'string' },
            { kind: 'interfaceProperty', name: 'blue', type: 'string' },
            { kind: 'interfaceProperty', name: 'alpha', type: 'string' },
            { kind: 'interfaceProperty', name: 'rgb', type: 'string' },
            { kind: 'interfaceProperty', name: 'hex', type: 'string' },
        ],
        filePath: './src/lib/Pickers/Picker.model.ts',
        fileName: 'Picker.model.ts',
        category: 'Pickers',
    },
    {
        kind: 'interface',
        name: 'CustomCalendarListItem',
        extends: ['Partial<MaxUnits>'],
        properties: [
            { kind: 'interfaceProperty', name: 'title', type: 'string' },
            { kind: 'interfaceProperty', name: 'id', type: 'string', required: true },
            { kind: 'interfaceProperty', name: 'disabled', type: 'boolean' },
            { kind: 'interfaceProperty', name: 'tooltip', type: 'ToolTipProps' },
            { kind: 'interfaceProperty', name: 'unit', type: 'CalendarCustomListItemUnit' },
            { kind: 'interfaceProperty', name: 'value', type: 'number' },
        ],
        filePath: './src/lib/Pickers/Picker.model.ts',
        fileName: 'Picker.model.ts',
        category: 'Pickers',
    },
    {
        kind: 'variable',
        name: 'DatePicker',
        type: "React.ForwardRefExoticComponent<Omit<DatePickerProps & DatePickerEvents, 'ref'> & React.RefAttributes<HTMLInputElement>>",
        description: 'Description: Standard InMoment branded Date Picker.',
        filePath: './src/lib/Pickers/DatePicker/DatePicker.tsx',
        fileName: 'DatePicker.tsx',
        category: 'Pickers',
    },
    {
        kind: 'interface',
        name: 'DatePicker_onDateChangeEvent',
        properties: [{ kind: 'interfaceProperty', name: 'date', type: 'Date', required: true }],
        filePath: './src/lib/Pickers/Picker.model.ts',
        fileName: 'Picker.model.ts',
        category: 'Pickers',
    },
    {
        kind: 'class',
        name: 'DatePickerEvents',
        extends: 'InputFieldEvents',
        properties: [
            {
                kind: 'classProperty',
                name: 'onDateChange',
                type: '(eventData: DatePicker_onDateChangeEvent) => void',
                description: 'Callback that fires whenever a date is selected or entered. (will not fire until valid date is entered)',
                bound: true,
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Pickers/DatePicker/DatePicker.tsx',
        fileName: 'DatePicker.tsx',
        category: 'Pickers',
    },
    {
        kind: 'class',
        name: 'DatePickerProps',
        extends: 'InputFieldProps',
        properties: [
            {
                kind: 'classProperty',
                name: 'minDate',
                type: 'Date',
                description: 'The minimum valid date (inclusive).',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'maxDate',
                type: 'Date',
                description: 'The maximum valid date (inclusive).',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'locale',
                type: 'string',
                description: 'The locale for the calendar',
                bound: true,
                default: "'en-US'",
            },
            {
                kind: 'classProperty',
                name: 'dateValue',
                type: 'Date',
                description: "The calendar's value.",
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'status',
                type: 'ErrorObject | null',
                description: 'Shows accompanying text with success, error, or warning state.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'direction',
                type: 'ClockDirection',
                description: "Determines the calendar's direction.",
                bound: true,
                default: '7',
            },
            {
                kind: 'classProperty',
                name: 'placeholder',
                type: 'string',
                description: 'Placeholder shown before any value is set.\n\nIf you provide an empty string, it will be used - do not set this property\n(or set it to `undefined`) to use the default placeholder.',
                bound: true,
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Pickers/DatePicker/DatePicker.tsx',
        fileName: 'DatePicker.tsx',
        category: 'Pickers',
    },
    {
        kind: 'interface',
        name: 'Dates',
        properties: [
            { kind: 'interfaceProperty', name: 'first', type: 'Date | undefined', required: true },
            { kind: 'interfaceProperty', name: 'last', type: 'Date | undefined', required: true },
            { kind: 'interfaceProperty', name: 'id', type: 'string' },
        ],
        filePath: './src/lib/Pickers/Picker.model.ts',
        fileName: 'Picker.model.ts',
        category: 'Pickers',
    },
    {
        kind: 'variable',
        name: 'defaultText',
        type: 'LeftRightPickerTextObject',
        filePath: './src/lib/Pickers/LeftRightPicker/LeftRightPicker.tsx',
        fileName: 'LeftRightPicker.tsx',
        category: 'Pickers',
    },
    {
        kind: 'interface',
        name: 'ErrorDates',
        properties: [
            { kind: 'interfaceProperty', name: 'first', type: 'Date | undefined | string', required: true },
            { kind: 'interfaceProperty', name: 'last', type: 'Date | undefined | string', required: true },
        ],
        filePath: './src/lib/Pickers/Picker.model.ts',
        fileName: 'Picker.model.ts',
        category: 'Pickers',
    },
    {
        kind: 'variable',
        name: 'HierarchyPicker',
        type: "React.ForwardRefExoticComponent<Omit<HierarchyPickerProps & HierarchyPickerEvents, 'ref'> & React.RefAttributes<HTMLDivElement>>",
        description: 'Description: A picker of items sorted by categories and filtered by hierarchy.',
        filePath: './src/lib/Pickers/HierarchyPicker/HierarchyPicker.tsx',
        fileName: 'HierarchyPicker.tsx',
        category: 'Pickers',
    },
    {
        kind: 'interface',
        name: 'HierarchyPicker_onOpenChangeEvent',
        properties: [
            {
                kind: 'interfaceProperty',
                name: 'isOpen',
                type: 'boolean',
                description: 'Indicates whether the picker is now open.',
                required: true,
            },
        ],
        filePath: './src/lib/Pickers/Picker.model.ts',
        fileName: 'Picker.model.ts',
        category: 'Pickers',
    },
    {
        kind: 'class',
        name: 'HierarchyPickerEvents',
        extends: 'TreePickerEvents',
        properties: [
            {
                kind: 'classProperty',
                name: 'onOpenChange',
                type: '(eventData: HierarchyPicker_onOpenChangeEvent) => void',
                description: 'Fires when the user opens or closes the picker.',
                bound: true,
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Pickers/HierarchyPicker/HierarchyPicker.tsx',
        fileName: 'HierarchyPicker.tsx',
        category: 'Pickers',
    },
    {
        kind: 'interface',
        name: 'HierarchyPickerLocalization',
        properties: [
            { kind: 'interfaceProperty', name: 'clearAll', type: 'string' },
            { kind: 'interfaceProperty', name: 'cancel', type: 'string' },
            { kind: 'interfaceProperty', name: 'apply', type: 'string' },
        ],
        filePath: './src/lib/Pickers/Picker.model.ts',
        fileName: 'Picker.model.ts',
        category: 'Pickers',
    },
    {
        kind: 'class',
        name: 'HierarchyPickerProps',
        extends: 'TreePickerProps',
        properties: [
            {
                kind: 'classProperty',
                name: 'contrast',
                type: 'Contrasts',
                description: "The component's contrast.",
                bound: true,
                default: "'normal'",
            },
            {
                kind: 'classProperty',
                name: 'disabled',
                type: 'boolean',
                description: 'Determines if the picker is disabled.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'filterProps',
                type: "Omit<Parameters<typeof Dropdown>[0], 'condensed'>",
                description: 'Props passed to the filter Dropdown.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'label',
                type: 'string',
                description: "The toggle's label.",
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'localization',
                type: 'HierarchyPickerLocalization',
                description: 'Localized messages for the component.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'popoutView',
                type: 'boolean',
                description: 'Determines whether the picker is displayed in a popout.',
                bound: true,
                default: 'true',
            },
            {
                kind: 'classProperty',
                name: 'toggleProps',
                type: 'HierarchyPickerToggleProps',
                description: 'Props for the various toggle types.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'toggleType',
                type: 'DropdownButtonTypes',
                description: 'The type of toggle used for the picker.',
                bound: true,
                default: "'pill'",
            },
            {
                kind: 'classProperty',
                name: 'tooltip',
                type: 'ToolTipProps',
                description: 'Tooltip props.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'ref',
                type: 'React.Ref<HTMLDivElement>',
                description: 'A React reference applied to the div.',
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Pickers/HierarchyPicker/HierarchyPicker.tsx',
        fileName: 'HierarchyPicker.tsx',
        category: 'Pickers',
    },
    {
        kind: 'type',
        name: 'HierarchyPickerPropsAndEvents',
        type: "Omit<HierarchyPickerProps & HierarchyPickerEvents, 'ref'> & React.RefAttributes<HTMLDivElement>",
        filePath: './src/lib/Pickers/HierarchyPicker/HierarchyPicker.tsx',
        fileName: 'HierarchyPicker.tsx',
        category: 'Pickers',
    },
    {
        kind: 'interface',
        name: 'InfiniteLoaderSettings',
        properties: [
            { kind: 'interfaceProperty', name: 'isItemLoaded', type: 'boolean', required: true },
            { kind: 'interfaceProperty', name: 'itemCount', type: 'number', required: true },
            { kind: 'interfaceProperty', name: 'loadMoreItems', type: 'Promise<void>', required: true },
            { kind: 'interfaceProperty', name: 'minimumBatchSize', type: 'number' },
            { kind: 'interfaceProperty', name: 'threshold', type: 'number' },
        ],
        filePath: './src/lib/Pickers/Picker.model.ts',
        fileName: 'Picker.model.ts',
        category: 'Pickers',
    },
    {
        kind: 'variable',
        name: 'LeftRightPicker',
        type: "React.ForwardRefExoticComponent<Omit<LeftRightPickerProps & LeftRightPickerEvents, 'ref'> & React.RefAttributes<HTMLDivElement>>",
        description: 'Description: Move items from one side of any given list to another, all done from within the component.',
        filePath: './src/lib/Pickers/LeftRightPicker/LeftRightPicker.tsx',
        fileName: 'LeftRightPicker.tsx',
        category: 'Pickers',
    },
    {
        kind: 'interface',
        name: 'LeftRightPicker_onItemsChangedEvent',
        properties: [
            { kind: 'interfaceProperty', name: 'availableItems', type: 'LRPickerItem[]', required: true },
            { kind: 'interfaceProperty', name: 'selectedItems', type: 'LRPickerItem[]', required: true },
        ],
        filePath: './src/lib/Pickers/Picker.model.ts',
        fileName: 'Picker.model.ts',
        category: 'Pickers',
    },
    {
        kind: 'class',
        name: 'LeftRightPickerEvents',
        extends: 'DivHTMLEvents',
        properties: [
            {
                kind: 'classProperty',
                name: 'onItemsChanged',
                type: '(eventData: LeftRightPicker_onItemsChangedEvent) => void',
                description: 'Callback that fires whenever an item moves categories.\n_useLegacyFormControl is for internal use and will not be emitted.',
                bound: true,
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Pickers/LeftRightPicker/LeftRightPicker.tsx',
        fileName: 'LeftRightPicker.tsx',
        category: 'Pickers',
    },
    {
        kind: 'class',
        name: 'LeftRightPickerProps',
        extends: 'DivHTMLAttributes',
        properties: [
            {
                kind: 'classProperty',
                name: 'title',
                type: 'string',
                description: 'Title of the Left Right Picker',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'data',
                type: 'LRPickerInputObject',
                description: 'Data structure for the component.',
                bound: true,
                required: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'availableLoaderSettings',
                type: 'InfiniteLoaderSettings',
                description: 'Settings to enable and configure infinite loading on the available items list. See https://github.com/bvaughn/react-window-infinite-loader#documentation for more information.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'selectedLoaderSettings',
                type: 'InfiniteLoaderSettings',
                description: 'Settings to enable and configure infinite loading on the selected items list. Only kicks in while over length of selectedItemsThreshold. See https://github.com/bvaughn/react-window-infinite-loader#documentation for more information.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'selectedItemsThreshold',
                type: 'number',
                description: 'Sets the threshold in which the window optimization kicks in on the selected items list. Warning: The optimization makes reordering buggy.',
                bound: true,
                default: '30',
            },
            {
                kind: 'classProperty',
                name: 'localization',
                type: 'LeftRightPickerTextObject',
                description: 'Allows for changing of hard-coded component text.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'dragAndDropEnabled',
                type: 'boolean',
                description: 'Enables or disables drag and drop',
                bound: true,
                default: 'true',
            },
            {
                kind: 'classProperty',
                name: 'useLegacyFormControl',
                type: 'boolean',
                description: "Determines the type of the value of the LRPicker as seen by ngModel, formControl, and formControlName.\nIf true, the value's type will be LRPickerItem[] and will contain just the selected items.\nIf false, the value's type will match what is emitted by onItemsChanged.\nWARNING: This value must be hard-coded. Changes to this value after initial load will result in unexpected behavior.",
                bound: true,
                default: 'true',
            },
            {
                kind: 'classProperty',
                name: 'compareFunction',
                type: '(a: LRPickerItem, b: LRPickerItem) => number',
                description: 'A function to control the sorting of LRPicker items. By default will sort by alphabetical order by title.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'ref',
                type: 'React.Ref<HTMLDivElement>',
                description: 'Allows for ref passing to the wrapper component',
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Pickers/LeftRightPicker/LeftRightPicker.tsx',
        fileName: 'LeftRightPicker.tsx',
        category: 'Pickers',
    },
    {
        kind: 'interface',
        name: 'LeftRightPickerTextObject',
        properties: [
            { kind: 'interfaceProperty', name: 'available', type: 'string' },
            { kind: 'interfaceProperty', name: 'selected', type: 'string' },
            { kind: 'interfaceProperty', name: 'addButton', type: 'string' },
            { kind: 'interfaceProperty', name: 'removeButton', type: 'string' },
            { kind: 'interfaceProperty', name: 'addAll', type: 'string' },
            { kind: 'interfaceProperty', name: 'removeAll', type: 'string' },
            { kind: 'interfaceProperty', name: 'searchPlaceholder', type: 'string' },
            { kind: 'interfaceProperty', name: 'results', type: 'string' },
        ],
        filePath: './src/lib/Pickers/Picker.model.ts',
        fileName: 'Picker.model.ts',
        category: 'Pickers',
    },
    {
        kind: 'interface',
        name: 'LRPickerInputObject',
        properties: [
            { kind: 'interfaceProperty', name: 'initialAvailableItems', type: 'LRPickerItemInput[]' },
            { kind: 'interfaceProperty', name: 'initialSelectedItems', type: 'LRPickerItemInput[]' },
        ],
        filePath: './src/lib/Pickers/Picker.model.ts',
        fileName: 'Picker.model.ts',
        category: 'Pickers',
    },
    {
        kind: 'type',
        name: 'LRPickerItem',
        type: "Omit<LRPickerItemInput, 'id'> & Required<Pick<LRPickerItemInput, 'id'>>",
        filePath: './src/lib/Pickers/Picker.model.ts',
        fileName: 'Picker.model.ts',
        category: 'Pickers',
    },
    {
        kind: 'interface',
        name: 'LRPickerItemInput',
        properties: [
            {
                kind: 'interfaceProperty',
                name: 'title',
                type: 'string',
                description: 'The title of the item',
                required: true,
            },
            {
                kind: 'interfaceProperty',
                name: 'component',
                type: 'any',
                description: "Deprecated: Will be removed with a future major version as it doesn't appear to serve a purpose. If you are\ncurrently using this prop, please reach out to the Kitchen team",
                deprecated: true,
            },
            {
                kind: 'interfaceProperty',
                name: 'disabled',
                type: 'boolean',
                description: 'Whether or not the item is disabled',
            },
            {
                kind: 'interfaceProperty',
                name: 'tooltip',
                type: 'string',
                description: 'The the text in the tooltip that is displayed when the text inside the LR picker\noverflows off screen. This defaults to undefined meaning no tooltip is displayed. In\ncase of long text we recommend setting this to `title`.',
            },
            {
                kind: 'interfaceProperty',
                name: 'searchTags',
                type: 'string[]',
                description: 'A list of strings that will make this item appear in a search. By default the\ncomponent searches the text of the `title` prop. This prop expands that functionality\nto also include exact matches of these search tags (case insensitive)',
            },
            {
                kind: 'interfaceProperty',
                name: 'id',
                type: 'string | number',
                description: 'A unique id. Ideally not changing. IDs can be replicated elsewhere on the page, but just\nnot in the same LR picker. Having multiple items with the same ID may throw some strange\nerrors (primarily related to keys) and affect the component in unusual ways.',
            },
        ],
        filePath: './src/lib/Pickers/Picker.model.ts',
        fileName: 'Picker.model.ts',
        category: 'Pickers',
    },
    {
        kind: 'type',
        name: 'LRPickerObject',
        type: '{ initialAvailableItems?: LRPickerItem[] | undefined; initialSelectedItems?: LRPickerItem[] | undefined; }',
        filePath: './src/lib/Pickers/Picker.model.ts',
        fileName: 'Picker.model.ts',
        category: 'Pickers',
    },
    {
        kind: 'type',
        name: 'MaxUnits',
        type: '{ maxDays: number; maxWeeks: number; maxMonths: number; }',
        filePath: './src/lib/Pickers/Picker.model.ts',
        fileName: 'Picker.model.ts',
        category: 'Pickers',
    },
    {
        kind: 'interface',
        name: 'PreselectedCalendarListOptions',
        properties: [
            { kind: 'interfaceProperty', name: 'first', type: 'Date', required: true },
            { kind: 'interfaceProperty', name: 'last', type: 'Date', required: true },
            { kind: 'interfaceProperty', name: 'title', type: 'string', required: true },
            { kind: 'interfaceProperty', name: 'id', type: 'string', required: true },
            { kind: 'interfaceProperty', name: 'disabled', type: 'boolean' },
            { kind: 'interfaceProperty', name: 'tooltip', type: 'ToolTipProps' },
        ],
        filePath: './src/lib/Pickers/Picker.model.ts',
        fileName: 'Picker.model.ts',
        category: 'Pickers',
    },
    {
        kind: 'interface',
        name: 'SelectedCalendarState',
        properties: [
            { kind: 'interfaceProperty', name: 'dates', type: 'Dates', required: true },
            { kind: 'interfaceProperty', name: 'title', type: 'string' },
            { kind: 'interfaceProperty', name: 'id', type: 'string' },
            { kind: 'interfaceProperty', name: 'mode', type: 'CalendarModes', required: true },
        ],
        filePath: './src/lib/Pickers/Picker.model.ts',
        fileName: 'Picker.model.ts',
        category: 'Pickers',
    },
    {
        kind: 'variable',
        name: 'TreePicker',
        type: "React.ForwardRefExoticComponent<Omit<TreePickerProps & TreePickerEvents, 'ref'> & React.RefAttributes<HTMLDivElement>>",
        description: 'Description: A picker of items sorted by categories.',
        filePath: './src/lib/Pickers/TreePicker/TreePicker.tsx',
        fileName: 'TreePicker.tsx',
        category: 'Pickers',
    },
    {
        kind: 'interface',
        name: 'TreePicker_onEndOfScrollEvent',
        properties: [
            {
                kind: 'interfaceProperty',
                name: 'path',
                type: 'string[]',
                description: 'An array containing the IDs of the event target and all of its ancestors.\nThe array is sorted bottom-up, so the target of the event is at path[0], its parent (if present) at path[1], and so on.',
                required: true,
            },
            {
                kind: 'interfaceProperty',
                name: 'type',
                type: "'category' | 'option'",
                description: 'Indicates whether the target of the event is a (sub)category or an option.',
                required: true,
            },
        ],
        filePath: './src/lib/Pickers/Picker.model.ts',
        fileName: 'Picker.model.ts',
        category: 'Pickers',
    },
    {
        kind: 'interface',
        name: 'TreePicker_onExpansionChangeEvent',
        properties: [
            {
                kind: 'interfaceProperty',
                name: 'id',
                type: "TreePickerCategory['id']",
                description: "The category's id.",
                required: true,
            },
            {
                kind: 'interfaceProperty',
                name: 'isExpanded',
                type: 'boolean',
                description: 'Indicates whether the category is now expanded.',
                required: true,
            },
        ],
        filePath: './src/lib/Pickers/Picker.model.ts',
        fileName: 'Picker.model.ts',
        category: 'Pickers',
    },
    {
        kind: 'interface',
        name: 'TreePicker_onItemsChangedEvent',
        properties: [{ kind: 'interfaceProperty', name: 'selectedIds', type: 'string[]', required: true }],
        filePath: './src/lib/Pickers/Picker.model.ts',
        fileName: 'Picker.model.ts',
        category: 'Pickers',
    },
    {
        kind: 'interface',
        name: 'TreePicker_onSearchChangeEvent',
        properties: [
            { kind: 'interfaceProperty', name: 'query', type: 'string', description: 'The search query.', required: true },
        ],
        filePath: './src/lib/Pickers/Picker.model.ts',
        fileName: 'Picker.model.ts',
        category: 'Pickers',
    },
    {
        kind: 'interface',
        name: 'TreePickerCategory',
        extends: ['TreePickerItemBase'],
        properties: [
            { kind: 'interfaceProperty', name: 'options', type: 'TreePickerOption[]', required: true },
            { kind: 'interfaceProperty', name: 'subcategories', type: 'TreePickerCategory[]' },
            { kind: 'interfaceProperty', name: 'id', type: 'string' },
        ],
        filePath: './src/lib/Pickers/Picker.model.ts',
        fileName: 'Picker.model.ts',
        category: 'Pickers',
    },
    {
        kind: 'type',
        name: 'TreePickerCategoryIsFetchingDataMap',
        type: '{ [x: string]: TreePickerCategoryIsFetchingDataMapEntry | undefined; }',
        description: "An object that maps a category's id to a  {@link  TreePickerCategoryIsFetchingDataMapEntry } .",
        filePath: './src/lib/Pickers/Picker.model.ts',
        fileName: 'Picker.model.ts',
        category: 'Pickers',
    },
    {
        kind: 'interface',
        name: 'TreePickerCategoryIsFetchingDataMapEntry',
        description: 'The data fetching state of a particular TreePicker category.',
        properties: [
            {
                kind: 'interfaceProperty',
                name: 'options',
                type: 'boolean',
                description: 'Indicates whether a loading animation should appear below the last option in this category.',
            },
            {
                kind: 'interfaceProperty',
                name: 'categories',
                type: 'boolean',
                description: 'Indicates whether a loading animation should appear below the last subcategory in this category.',
            },
        ],
        filePath: './src/lib/Pickers/Picker.model.ts',
        fileName: 'Picker.model.ts',
        category: 'Pickers',
    },
    {
        kind: 'class',
        name: 'TreePickerEvents',
        extends: 'DivHTMLEvents',
        properties: [
            {
                kind: 'classProperty',
                name: 'onItemsChanged',
                type: '(eventData: TreePicker_onItemsChangedEvent) => void',
                description: 'Callback that fires whenever a category is selected or unselected.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'onSearchChange',
                type: '(eventData: TreePicker_onSearchChangeEvent) => void',
                description: 'Fires when the user modifies their current search.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'onExpansionChange',
                type: '(eventData: TreePicker_onExpansionChangeEvent) => void',
                description: 'Fires when the user expands or collapses a category.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'onEndOfScroll',
                type: '(eventData: TreePicker_onEndOfScrollEvent) => void',
                description: 'Fires when the option or (sub)category  {@link  TreePicker.endOfScrollOffset endOfScrollOffset }  items from the end has been scrolled into view.\n\nWill not be fired if the containing category is currently fetching data for the current item type.\nFor top-level categories, will not be fired if  {@link  TreePickerProps.isFetchingData isFetchingData }  is `true`.',
                bound: true,
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Pickers/TreePicker/TreePicker.tsx',
        fileName: 'TreePicker.tsx',
        category: 'Pickers',
    },
    {
        kind: 'interface',
        name: 'TreePickerItemBase',
        properties: [
            { kind: 'interfaceProperty', name: 'title', type: 'string', required: true },
            { kind: 'interfaceProperty', name: 'disabled', type: 'boolean' },
            { kind: 'interfaceProperty', name: 'bold', type: 'boolean' },
            { kind: 'interfaceProperty', name: 'tooltip', type: 'ToolTipProps' },
        ],
        filePath: './src/lib/Pickers/Picker.model.ts',
        fileName: 'Picker.model.ts',
        category: 'Pickers',
    },
    {
        kind: 'interface',
        name: 'TreePickerOption',
        extends: ['TreePickerItemBase'],
        properties: [{ kind: 'interfaceProperty', name: 'id', type: 'string', required: true }],
        filePath: './src/lib/Pickers/Picker.model.ts',
        fileName: 'Picker.model.ts',
        category: 'Pickers',
    },
    {
        kind: 'class',
        name: 'TreePickerProps',
        extends: 'DivHTMLAttributes',
        properties: [
            {
                kind: 'classProperty',
                name: 'categories',
                type: 'TreePickerCategory[]',
                description: 'A list of categories to display on the picker, and their options/subcategories.',
                bound: true,
                required: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'color',
                type: 'Colors',
                description: 'Controls fill of checkbox.',
                bound: true,
                default: "'CX'",
            },
            {
                kind: 'classProperty',
                name: 'categoryIsFetchingDataMap',
                type: 'TreePickerCategoryIsFetchingDataMap',
                description: "A record mapping a  {@link  TreePickerCategory.id category's id }  to a boolean indicating whether it is currently fetching data.",
                bound: true,
                default: '{}',
            },
            {
                kind: 'classProperty',
                name: 'endOfScrollOffset',
                type: 'number',
                description: 'An offset, in number of Picker items, from the bottom of the (sub)category.\nWhen the user scrolls the item at that position into view, the onEndOfScroll\nevent will fire.\nCan be used to load more data before the user gets to the bottom of the (sub)category.',
                bound: true,
                default: '0',
            },
            {
                kind: 'classProperty',
                name: 'isFetchingData',
                type: 'boolean',
                description: 'Determines whether top-level data is being fetched.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'stretch',
                type: 'boolean',
                description: 'Determines whether the picker will dynamically determine its height based on its size, or stretch within its parent component.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'selectedIds',
                type: "Array<NonNullable<TreePickerOption['id']>>",
                description: 'If provided, the options with the provided IDs (and only those options) will be selected.\nIf `multiSelect` is `false`, provide only 0 or 1 IDs in the array.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'selectionMode',
                type: 'TreePickerSelectionMode',
                description: 'Determines whether more than one option may be selected simultaneously.',
                bound: true,
                default: 'TreePickerSelectionMode.Multiple',
            },
            {
                kind: 'classProperty',
                name: 'boldCategoryTitles',
                type: 'boolean',
                description: 'Determines whether category titles will have a bold font weight.\nIf the `bold` property of a category object is `true` or `false` (i.e., not undefined),\nit will override this property for the corresponding category title.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'ref',
                type: 'React.Ref<HTMLDivElement>',
                description: 'A react reference applied to the div.',
                default: 'null',
            },
        ],
        filePath: './src/lib/Pickers/TreePicker/TreePicker.tsx',
        fileName: 'TreePicker.tsx',
        category: 'Pickers',
    },
    {
        kind: 'type',
        name: 'TreePickerPropsAndEvents',
        type: "Omit<TreePickerProps & TreePickerEvents, 'ref'> & React.RefAttributes<HTMLDivElement>",
        filePath: './src/lib/Pickers/TreePicker/TreePicker.tsx',
        fileName: 'TreePicker.tsx',
        category: 'Pickers',
    },
    {
        kind: 'enum',
        name: 'TreePickerSelectionMode',
        properties: ['SingleOption', 'Multiple'],
        filePath: './src/lib/Pickers/Picker.model.ts',
        fileName: 'Picker.model.ts',
        category: 'Pickers',
    },
    {
        kind: 'variable',
        name: 'CloudPill',
        type: "React.ForwardRefExoticComponent<Omit<CloudPillProps & CloudPillEvents, 'ref'> & React.RefAttributes<HTMLDivElement>>",
        description: 'Description: Small pill indicating one of the three clouds.',
        filePath: './src/lib/Pills/CloudPill/CloudPill.tsx',
        fileName: 'CloudPill.tsx',
        category: 'Pills',
    },
    {
        kind: 'class',
        name: 'CloudPillEvents',
        extends: 'DivHTMLEvents',
        filePath: './src/lib/Pills/CloudPill/CloudPill.tsx',
        fileName: 'CloudPill.tsx',
        category: 'Pills',
    },
    {
        kind: 'class',
        name: 'CloudPillProps',
        extends: 'DivHTMLAttributes',
        properties: [
            {
                kind: 'classProperty',
                name: 'cloud',
                type: 'XIClouds',
                description: 'Experience Cloud determining pill.',
                bound: true,
                required: true,
                default: "'CX'",
            },
            {
                kind: 'classProperty',
                name: 'contrast',
                type: 'Contrasts',
                description: 'Flips the background / foreground color of the pill.',
                bound: true,
                default: "'normal'",
            },
            {
                kind: 'classProperty',
                name: 'ref',
                type: 'React.Ref<HTMLDivElement>',
                description: 'Allows for ref passing to the wrapper component',
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Pills/CloudPill/CloudPill.tsx',
        fileName: 'CloudPill.tsx',
        category: 'Pills',
    },
    {
        kind: 'variable',
        name: 'CustomPill',
        type: "React.ForwardRefExoticComponent<Omit<CustomPillProps & CustomPillEvents, 'ref'> & React.RefAttributes<HTMLDivElement>>",
        description: 'Description: Small pill containing arbitrary strings',
        filePath: './src/lib/Pills/CustomPill/CustomPill.tsx',
        fileName: 'CustomPill.tsx',
        category: 'Pills',
    },
    {
        kind: 'class',
        name: 'CustomPillEvents',
        extends: 'DivHTMLEvents',
        filePath: './src/lib/Pills/CustomPill/CustomPill.tsx',
        fileName: 'CustomPill.tsx',
        category: 'Pills',
    },
    {
        kind: 'class',
        name: 'CustomPillProps',
        extends: 'DivHTMLAttributes',
        properties: [
            {
                kind: 'classProperty',
                name: 'text',
                type: 'string',
                description: 'Text to display in the pill',
                bound: true,
                required: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'color',
                type: 'Colors | ErrorStates',
                description: 'Controls the theme of the pill.',
                bound: true,
                default: "'orca'",
            },
            {
                kind: 'classProperty',
                name: 'contrast',
                type: 'Contrasts',
                description: 'Flips the background / foreground color of the pill.',
                bound: true,
                default: "'normal'",
            },
            {
                kind: 'classProperty',
                name: 'ref',
                type: 'React.Ref<HTMLDivElement>',
                description: 'Allows for ref passing to the wrapper component',
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Pills/CustomPill/CustomPill.tsx',
        fileName: 'CustomPill.tsx',
        category: 'Pills',
    },
    {
        kind: 'interface',
        name: 'PillObject',
        properties: [
            { kind: 'interfaceProperty', name: 'text', type: 'string', required: true },
            { kind: 'interfaceProperty', name: 'sentiment', type: 'Sentiments', required: true },
            { kind: 'interfaceProperty', name: 'id', type: 'string' },
            { kind: 'interfaceProperty', name: 'isActive', type: 'boolean' },
        ],
        filePath: './src/lib/Pills/Pill.model.ts',
        fileName: 'Pill.model.ts',
        category: 'Pills',
    },
    {
        kind: 'interface',
        name: 'InternalRadioProps',
        properties: [{ kind: 'interfaceProperty', name: 'wrapper', type: 'DivProps' }],
        filePath: './src/lib/Radios/Radio.model.ts',
        fileName: 'Radio.model.ts',
        category: 'Radios',
    },
    {
        kind: 'variable',
        name: 'Radio',
        type: "React.ForwardRefExoticComponent<Omit<RadioProps & RadioEvents, 'ref'> & React.RefAttributes<HTMLInputElement>>",
        description: 'Description: Standard InMoment branded Radio button, works the same as an HTML radio button.',
        filePath: './src/lib/Radios/Radio/Radio.tsx',
        fileName: 'Radio.tsx',
        category: 'Radios',
    },
    {
        kind: 'class',
        name: 'RadioEvents',
        extends: 'InputHTMLEvents',
        filePath: './src/lib/Radios/Radio/Radio.tsx',
        fileName: 'Radio.tsx',
        category: 'Radios',
    },
    {
        kind: 'class',
        name: 'RadioProps',
        extends: 'ObservablePropsMixin(InputHTMLAttributes)',
        properties: [
            {
                kind: 'classProperty',
                name: 'checked',
                type: 'boolean',
                description: 'Sets the radio button checked property if the input is fully controlled, or the\ninital start if uncontrolled.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'color',
                type: 'Colors',
                description: 'Color of the radio button.',
                bound: true,
                default: "'orca'",
            },
            {
                kind: 'classProperty',
                name: 'contrast',
                type: 'Contrasts',
                description: 'Determines how easy it will be to see on dark backgrounds.',
                bound: true,
                default: "'normal'",
            },
            {
                kind: 'classProperty',
                name: 'inputId',
                type: 'string',
                description: 'Used only if you are using external labels with this input, NOT the regular ID.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'label',
                type: 'string',
                description: 'Text accompanying button, acts as a label if present. Accepts HTML.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'isLabelLeft',
                type: 'boolean',
                description: 'Controls which side text is on.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'isInlineFlex',
                type: 'boolean',
                description: 'WARNING will default to false in a future major version and will be removed in the following version.\n\nControls whether the radio button wrapper displays inline-flex or flex',
                bound: true,
                default: 'true',
            },
            {
                kind: 'classProperty',
                name: 'internalProps',
                type: 'InternalRadioProps',
                description: "Extends React.Component<'div'> attributes, that will be directly applied to the wrapper.",
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'status',
                type: 'ErrorStates | null',
                description: 'Shows success, error, or warning state.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'ref',
                type: 'React.Ref<HTMLInputElement>',
                description: 'Allows for ref passing to the wrapper component',
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Radios/Radio/Radio.tsx',
        fileName: 'Radio.tsx',
        category: 'Radios',
    },
    {
        kind: 'type',
        name: 'RadioPropsAndEvents',
        type: "Omit<RadioProps & RadioEvents, 'ref'> & React.RefAttributes<HTMLInputElement>",
        filePath: './src/lib/Radios/Radio/Radio.tsx',
        fileName: 'Radio.tsx',
        category: 'Radios',
    },
    {
        kind: 'interface',
        name: 'InternalSearchBoxProps',
        properties: [{ kind: 'interfaceProperty', name: 'wrapper', type: 'DivProps', required: true }],
        filePath: './src/lib/Searches/Search.model.ts',
        fileName: 'Search.model.ts',
        category: 'Searches',
    },
    {
        kind: 'variable',
        name: 'SearchBox',
        type: "React.ForwardRefExoticComponent<Omit<SearchBoxProps & SearchBoxEvents, 'ref'> & React.RefAttributes<HTMLInputElement>>",
        description: 'Description: InMoment branded text input field to be used as a search field.',
        filePath: './src/lib/Searches/SearchBox/SearchBox.tsx',
        fileName: 'SearchBox.tsx',
        category: 'Searches',
    },
    {
        kind: 'interface',
        name: 'SearchBox_onChangeOverrideEvent',
        properties: [{ kind: 'interfaceProperty', name: 'searchText', type: 'string', required: true }],
        filePath: './src/lib/Searches/Search.model.ts',
        fileName: 'Search.model.ts',
        category: 'Searches',
    },
    {
        kind: 'interface',
        name: 'SearchBox_onSuggestionClickEvent',
        properties: [{ kind: 'interfaceProperty', name: 'suggestion', type: 'SuggestionObject', required: true }],
        filePath: './src/lib/Searches/Search.model.ts',
        fileName: 'Search.model.ts',
        category: 'Searches',
    },
    {
        kind: 'class',
        name: 'SearchBoxEvents',
        extends: 'InputHTMLEvents',
        properties: [
            {
                kind: 'classProperty',
                name: 'onCancelClick',
                type: '() => void',
                description: "Callback that fires when the 'X' circle is clicked.",
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'onChangeOverride',
                type: '(eventData: SearchBox_onChangeOverrideEvent) => void',
                description: 'Callback that fires at different times depending on the isFiredOnEnter prop.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'onSuggestionClick',
                type: '(eventData: SearchBox_onSuggestionClickEvent) => void',
                description: 'Callback that fires when a suggestion item is clicked.',
                bound: true,
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Searches/SearchBox/SearchBox.tsx',
        fileName: 'SearchBox.tsx',
        category: 'Searches',
    },
    {
        kind: 'class',
        name: 'SearchBoxProps',
        extends: 'ObservablePropsMixin(InputHTMLAttributes)',
        properties: [
            {
                kind: 'classProperty',
                name: 'placeholder',
                type: 'string',
                description: 'Text shown before any value is set.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'value',
                type: 'string',
                description: 'Value of the text.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'isFiredOnEnter',
                type: 'boolean',
                description: 'Controls whether onChangeOverride callback fires onEnter, or onChange.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'contrast',
                type: 'Contrasts',
                description: 'Controls whether the text has light or dark colors (for varying backgrounds).',
                bound: true,
                default: "'normal'",
            },
            {
                kind: 'classProperty',
                name: 'textSize',
                type: 'TextSizes',
                description: "Controls the font size of the input field. Options are 'small' (14px)\nand 'normal' (16px).",
                bound: true,
                default: "'normal'",
            },
            {
                kind: 'classProperty',
                name: 'hasOutline',
                type: 'boolean',
                description: 'Deprecated. Use outline property instead\nControls whether the outline is shown.',
                deprecated: true,
                bound: true,
                default: 'true',
            },
            {
                kind: 'classProperty',
                name: 'outline',
                type: "'outline' | 'none' | 'underline'",
                description: 'Controls how the outline is shown.\noutline shows the whole outline, text shows no outline and underline shows a line\nunder the search box',
                bound: true,
                default: "'undefined'",
            },
            {
                kind: 'classProperty',
                name: 'data',
                type: 'SuggestionObject[]',
                description: 'Array of items to act as possible suggestions',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'maxSuggestions',
                type: 'number',
                description: 'The maximum number of suggestions to show',
                bound: true,
                default: '4',
            },
            {
                kind: 'classProperty',
                name: 'maxLength',
                type: 'number',
                description: 'The maximum number of characters that a user is allowed to enter',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'status',
                type: 'ErrorObject | null',
                description: 'Shows accompanying text with success, error, or warning state.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'prePopulateStatus',
                type: 'boolean',
                description: "Useful for spacing - places hidden text underneath field so shifting doesn't happen when status is set.",
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'componentSize',
                type: 'ComponentSizes',
                description: "Controls if it's a large or normal size button",
                bound: true,
                default: "'normal'",
            },
            {
                kind: 'classProperty',
                name: 'stretch',
                type: 'boolean',
                description: 'Allows stretching past the maximum length',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'type',
                type: 'TextInputType',
                description: 'Type of input component.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'ref',
                type: 'React.Ref<HTMLInputElement>',
                description: 'Allows for ref passing to the wrapper component',
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Searches/SearchBox/SearchBox.tsx',
        fileName: 'SearchBox.tsx',
        category: 'Searches',
    },
    {
        kind: 'interface',
        name: 'SuggestionObject',
        properties: [
            { kind: 'interfaceProperty', name: 'text', type: 'string', required: true },
            { kind: 'interfaceProperty', name: 'id', type: 'string' },
        ],
        filePath: './src/lib/Searches/Search.model.ts',
        fileName: 'Search.model.ts',
        category: 'Searches',
    },
    {
        kind: 'interface',
        name: 'EndLabels',
        properties: [
            { kind: 'interfaceProperty', name: 'left', type: 'SliderLabel' },
            { kind: 'interfaceProperty', name: 'right', type: 'SliderLabel' },
        ],
        filePath: './src/lib/Sliders/Slider.model.ts',
        fileName: 'Slider.model.ts',
        category: 'Sliders',
    },
    {
        kind: 'interface',
        name: 'Inflection',
        properties: [
            { kind: 'interfaceProperty', name: 'inflectionPoint', type: 'number', required: true },
            { kind: 'interfaceProperty', name: 'sentimentLeft', type: 'Sentiments', required: true },
            { kind: 'interfaceProperty', name: 'sentimentRight', type: 'Sentiments', required: true },
        ],
        filePath: './src/lib/Sliders/Slider.model.ts',
        fileName: 'Slider.model.ts',
        category: 'Sliders',
    },
    {
        kind: 'variable',
        name: 'Slider',
        type: "React.ForwardRefExoticComponent<Omit<SliderProps & SliderEvents, 'ref'> & React.RefAttributes<HTMLDivElement>>",
        description: 'Description: Range slider allowing you to get input as a number / range of numbers.',
        filePath: './src/lib/Sliders/Slider/Slider.tsx',
        fileName: 'Slider.tsx',
        category: 'Sliders',
    },
    {
        kind: 'interface',
        name: 'Slider_onSliderChangeEvent',
        properties: [{ kind: 'interfaceProperty', name: 'value', type: 'number | [number, number]', required: true }],
        filePath: './src/lib/Sliders/Slider.model.ts',
        fileName: 'Slider.model.ts',
        category: 'Sliders',
    },
    {
        kind: 'class',
        name: 'SliderEvents',
        extends: 'DivHTMLEvents',
        properties: [
            {
                kind: 'classProperty',
                name: 'onSliderChange',
                type: '(eventData: Slider_onSliderChangeEvent) => void',
                description: 'Callback fires when the slider moves, will either return an array or a number.',
                bound: true,
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Sliders/Slider/Slider.tsx',
        fileName: 'Slider.tsx',
        category: 'Sliders',
    },
    {
        kind: 'interface',
        name: 'SliderLabel',
        properties: [
            { kind: 'interfaceProperty', name: 'icon', type: 'Icons', required: true },
            { kind: 'interfaceProperty', name: 'sentiment', type: 'Sentiments' },
            { kind: 'interfaceProperty', name: 'displayValue', type: 'boolean' },
        ],
        filePath: './src/lib/Sliders/Slider.model.ts',
        fileName: 'Slider.model.ts',
        category: 'Sliders',
    },
    {
        kind: 'class',
        name: 'SliderProps',
        extends: 'ObservablePropsMixin(DivHTMLAttributes)',
        properties: [
            {
                kind: 'classProperty',
                name: 'min',
                type: 'number',
                description: 'Low end of the slider.',
                bound: true,
                default: '0',
            },
            {
                kind: 'classProperty',
                name: 'max',
                type: 'number',
                description: 'High end of the slider.',
                bound: true,
                default: '100',
            },
            {
                kind: 'classProperty',
                name: 'color',
                type: 'Clouds',
                description: 'Changes the color of the slider.',
                bound: true,
                default: "'CX'",
            },
            {
                kind: 'classProperty',
                name: 'contrast',
                type: 'Contrasts',
                description: 'Determines how easy it will be to see on dark backgrounds.',
                bound: true,
                default: "'normal'",
            },
            {
                kind: 'classProperty',
                name: 'disabled',
                type: 'boolean',
                description: 'HTML disabled attribute.',
                bound: true,
                default: "'normal'",
            },
            {
                kind: 'classProperty',
                name: 'value',
                type: 'number | [number, number] | []',
                description: 'Programmatically updates the value of the slider.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'unit',
                type: "string | 'media'",
                description: "Controls which unit is visible for the slider. If 'media' it will display in timestamps (for audio/video).",
                bound: true,
                default: "''",
            },
            {
                kind: 'classProperty',
                name: "'data-qa'",
                type: 'string',
                description: 'Custom attribute hook for automation',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'endLabels',
                type: 'EndLabels',
                description: 'Labels for either end of the slider bar to show min/max value, an icon, and sentiment',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'increment',
                type: 'number',
                description: 'The value to increment the slider by. Max precision is 1e-6',
                bound: true,
                default: '1',
            },
            {
                kind: 'classProperty',
                name: 'inflection',
                type: 'Inflection',
                description: 'Changes the bar color on either side of the inflection point',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'displayCurrentPosition',
                type: 'boolean',
                description: 'Controls whether the text stating position is visible above the slider bar.',
                bound: true,
                default: 'true',
            },
            {
                kind: 'classProperty',
                name: 'ref',
                type: 'React.Ref<HTMLDivElement>',
                description: 'Allows for ref passing to the wrapper component',
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Sliders/Slider/Slider.tsx',
        fileName: 'Slider.tsx',
        category: 'Sliders',
    },
    {
        kind: 'type',
        name: 'OnOff',
        type: "'on' | 'off'",
        filePath: './src/lib/Switches/Switch.model.ts',
        fileName: 'Switch.model.ts',
        category: 'Switches',
    },
    {
        kind: 'type',
        name: 'Side',
        type: "'left' | 'right'",
        filePath: './src/lib/Switches/Switch.model.ts',
        fileName: 'Switch.model.ts',
        category: 'Switches',
    },
    {
        kind: 'variable',
        name: 'ToggleSwitch',
        type: "React.ForwardRefExoticComponent<Omit<ToggleSwitchProps & ToggleSwitchEvents, 'ref'> & React.RefAttributes<HTMLButtonElement>>",
        description: 'Description: Classic InMoment branded ToggleSwitch.',
        filePath: './src/lib/Switches/ToggleSwitch/ToggleSwitch.tsx',
        fileName: 'ToggleSwitch.tsx',
        category: 'Switches',
    },
    {
        kind: 'interface',
        name: 'ToggleSwitch_onToggleEvent',
        properties: [
            { kind: 'interfaceProperty', name: 'isToggled', type: 'boolean', required: true },
            { kind: 'interfaceProperty', name: 'text', type: 'string' },
        ],
        filePath: './src/lib/Switches/Switch.model.ts',
        fileName: 'Switch.model.ts',
        category: 'Switches',
    },
    {
        kind: 'class',
        name: 'ToggleSwitchEvents',
        extends: 'ButtonHTMLEvents',
        properties: [
            {
                kind: 'classProperty',
                name: 'onToggle',
                type: '(eventData: ToggleSwitch_onToggleEvent) => void',
                description: 'Callback that fires when toggle is clicked.',
                bound: true,
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Switches/ToggleSwitch/ToggleSwitch.tsx',
        fileName: 'ToggleSwitch.tsx',
        category: 'Switches',
    },
    {
        kind: 'class',
        name: 'ToggleSwitchProps',
        extends: 'ObservablePropsMixin(ButtonHTMLAttributes)',
        properties: [
            {
                kind: 'classProperty',
                name: 'color',
                type: 'Colors',
                description: 'Color of the ToggleSwitch.',
                bound: true,
                default: "'orca'",
            },
            {
                kind: 'classProperty',
                name: 'toggleMatchesColor',
                type: 'boolean',
                description: "Determines if the toggle button color should match the `color` property, even if the control has a status.\nNeeded for integration of ToggleText component where toggle button remains orca.\nSet to 'false' if you want the toggle indicator to remain the primary color",
                bound: true,
                default: 'true',
            },
            {
                kind: 'classProperty',
                name: 'changeColorOnToggle',
                type: 'boolean',
                description: "Determines if when the toggle is on the left side (previously 'OFF'), it should turn a lighter shade of orca.\nThis behavior was default but now can be turned off, so the toggle remains the primary color.",
                bound: true,
                default: 'true',
            },
            {
                kind: 'classProperty',
                name: 'isToggled',
                type: 'boolean',
                description: 'State of the toggle switch.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'contrast',
                type: 'Contrasts',
                description: 'Determines how easy it will be to see on dark backgrounds.',
                bound: true,
                default: "'normal'",
            },
            {
                kind: 'classProperty',
                name: 'stretch',
                type: 'boolean',
                description: 'Controls the ability to allow the switch container to stretch the full width of its parent container.\nThis does not stretch the actual switch, just the container. Use to align button and label to opposite\nsides of the container.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'stretchToggle',
                type: 'boolean',
                description: 'Stretches the actual toggle control to expand to the whole width of the container',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'label',
                type: 'string',
                description: 'Label for the component.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'isLabelInline',
                type: 'boolean',
                description: 'Controls whether the label is above, or aligned with the switch.',
                bound: true,
                default: 'true',
            },
            {
                kind: 'classProperty',
                name: 'isLabelLeft',
                type: 'boolean',
                description: 'Controls whether the label is left or right of the switch. Has no effect if isLabelInline is false.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'status',
                type: 'ErrorStates | null',
                description: 'Shows success, error, or warning state.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'leftText',
                type: 'string',
                description: 'Sets the text to appear on the left/Off side of the toggle.',
                bound: true,
                default: "'OFF'",
            },
            {
                kind: 'classProperty',
                name: 'rightText',
                type: 'string',
                description: 'Sets the text to appear on the right/On side of the toggle.',
                bound: true,
                default: "'ON'",
            },
            {
                kind: 'classProperty',
                name: 'size',
                type: "Extract<ButtonSizes, 'small' | 'xxlarge'>",
                description: "Controls the size of the ToggleSwitch component. Size 'small' matches the standard appearance of the toggle switch.\nSize 'xxlarge' is a larger switch that matches the look of the previously used ToggleText component.",
                bound: true,
                default: "'small'",
            },
            {
                kind: 'classProperty',
                name: 'hideInactiveText',
                type: 'boolean',
                description: 'Determines whether the text representing the inactive value should be hidden.\n(If `isToggled`, `leftText` will be hidden, otherwise `rightText` will be.)',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'tooltip',
                type: 'ToolTipProps',
                description: 'Adds a tooltip to the component.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'ref',
                type: 'React.Ref<HTMLButtonElement>',
                description: 'Allows for ref passing to the wrapper component',
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Switches/ToggleSwitch/ToggleSwitch.tsx',
        fileName: 'ToggleSwitch.tsx',
        category: 'Switches',
    },
    {
        kind: 'type',
        name: 'ToggleSwitchPropsAndEvents',
        type: "Omit<ToggleSwitchProps & ToggleSwitchEvents, 'ref'> & React.RefAttributes<HTMLButtonElement>",
        filePath: './src/lib/Switches/ToggleSwitch/ToggleSwitch.tsx',
        fileName: 'ToggleSwitch.tsx',
        category: 'Switches',
    },
    {
        kind: 'variable',
        name: 'ToggleText',
        type: "React.ForwardRefExoticComponent<Omit<ToggleTextProps & ToggleTextEvents, 'ref'> & React.RefAttributes<HTMLButtonElement>>",
        description: 'Description: DEPRECATED. Use toggle switch instead. All stylings of this component are available as toggle switch. Works like ToggleSwitch, but with customizable text.',
        deprecated: true,
        filePath: './src/lib/Switches/ToggleText/ToggleText.tsx',
        fileName: 'ToggleText.tsx',
        category: 'Switches',
    },
    {
        kind: 'interface',
        name: 'ToggleText_onToggleEvent',
        properties: [{ kind: 'interfaceProperty', name: 'text', type: 'string', required: true }],
        filePath: './src/lib/Switches/Switch.model.ts',
        fileName: 'Switch.model.ts',
        category: 'Switches',
    },
    {
        kind: 'class',
        name: 'ToggleTextEvents',
        extends: 'ButtonHTMLEvents',
        properties: [
            {
                kind: 'classProperty',
                name: 'onToggle',
                type: '(eventData: ToggleText_onToggleEvent) => void',
                description: 'Callback that fires when toggle is clicked.',
                bound: true,
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Switches/ToggleText/ToggleText.tsx',
        fileName: 'ToggleText.tsx',
        category: 'Switches',
    },
    {
        kind: 'class',
        name: 'ToggleTextProps',
        extends: 'ObservablePropsMixin(ButtonHTMLAttributes)',
        properties: [
            {
                kind: 'classProperty',
                name: 'stretch',
                type: 'boolean',
                description: 'Determines whether the button width is based on its content or its parent.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'leftText',
                type: 'string',
                description: 'Left side text of the switch.',
                bound: true,
                required: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'rightText',
                type: 'string',
                description: 'Right side text of the switch.',
                bound: true,
                required: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'status',
                type: 'ErrorStates | null',
                description: 'Shows success, error, or warning state.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'color',
                type: 'Colors',
                description: 'Color of the switch.',
                bound: true,
                default: "'orca'",
            },
            {
                kind: 'classProperty',
                name: 'label',
                type: 'string',
                description: 'Label for the component.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'contrast',
                type: 'Contrasts',
                description: 'Controls outline of switch, helpful on varying backgrounds.',
                bound: true,
                default: "'normal'",
            },
            {
                kind: 'classProperty',
                name: 'side',
                type: 'Side',
                description: 'Indicates the side of the slider',
                bound: true,
                default: "'left'",
            },
            {
                kind: 'classProperty',
                name: 'ref',
                type: 'React.Ref<HTMLButtonElement>',
                description: 'Allows for ref passing to the wrapper component',
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Switches/ToggleText/ToggleText.tsx',
        fileName: 'ToggleText.tsx',
        category: 'Switches',
    },
    {
        kind: 'interface',
        name: 'ComputedTab',
        extends: ['TabObject'],
        properties: [{ kind: 'interfaceProperty', name: 'width', type: 'number', required: true }],
        filePath: './src/lib/TabBars/TabBar.model.ts',
        fileName: 'TabBar.model.ts',
        category: 'TabBars',
    },
    {
        kind: 'variable',
        name: 'HorizontalTabBar',
        type: "React.ForwardRefExoticComponent<Omit<HorizontalTabBarProps & HorizontalTabBarEvents, 'ref'> & React.RefAttributes<HTMLDivElement>>",
        description: 'Description: Navigational component that contains clickable data.',
        filePath: './src/lib/TabBars/HorizontalTabBar/HorizontalTabBar.tsx',
        fileName: 'HorizontalTabBar.tsx',
        category: 'TabBars',
    },
    {
        kind: 'interface',
        name: 'HorizontalTabBar_onTabChangeEvent',
        properties: [{ kind: 'interfaceProperty', name: 'tab', type: 'TabObject', required: true }],
        filePath: './src/lib/TabBars/TabBar.model.ts',
        fileName: 'TabBar.model.ts',
        category: 'TabBars',
    },
    {
        kind: 'interface',
        name: 'HorizontalTabBar_onTabCloseEvent',
        properties: [{ kind: 'interfaceProperty', name: 'tab', type: 'TabObject', required: true }],
        filePath: './src/lib/TabBars/TabBar.model.ts',
        fileName: 'TabBar.model.ts',
        category: 'TabBars',
    },
    {
        kind: 'interface',
        name: 'HorizontalTabBar_onTabUnpinEvent',
        properties: [{ kind: 'interfaceProperty', name: 'tab', type: 'TabObject', required: true }],
        filePath: './src/lib/TabBars/TabBar.model.ts',
        fileName: 'TabBar.model.ts',
        category: 'TabBars',
    },
    {
        kind: 'class',
        name: 'HorizontalTabBarEvents',
        extends: 'DivHTMLEvents',
        properties: [
            {
                kind: 'classProperty',
                name: 'onTabChange',
                type: '(eventData: HorizontalTabBar_onTabChangeEvent) => void',
                description: 'Fires when a tab is selected.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'onTabClose',
                type: '(eventData: HorizontalTabBar_onTabCloseEvent) => void',
                description: "Fires when the user presses the 'x' button.",
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'onTabUnpin',
                type: '(eventData: HorizontalTabBar_onTabUnpinEvent) => void',
                description: 'Fires when the user presses the pin icon.',
                bound: true,
                default: 'undefined',
            },
        ],
        filePath: './src/lib/TabBars/HorizontalTabBar/HorizontalTabBar.tsx',
        fileName: 'HorizontalTabBar.tsx',
        category: 'TabBars',
    },
    {
        kind: 'class',
        name: 'HorizontalTabBarProps',
        extends: 'ObservablePropsMixin(DivHTMLAttributes)',
        properties: [
            {
                kind: 'classProperty',
                name: 'data',
                type: 'TabObject[]',
                description: 'Data structure for the tabs. If using TabObject[], id fields must be unique.',
                bound: true,
                required: true,
                default: 'N/A',
            },
            {
                kind: 'classProperty',
                name: 'color',
                type: 'Colors',
                description: 'Controls the color of the entire bar.',
                bound: true,
                default: "'orca'",
            },
            {
                kind: 'classProperty',
                name: 'contrast',
                type: 'Contrasts',
                description: 'Determines how easy it will be to see on dark backgrounds.',
                bound: true,
                default: "'normal'",
            },
            {
                kind: 'classProperty',
                name: 'activeTabId',
                type: 'string',
                description: "Programmatically selects active tab based on the tab's data id.\nIf both activeTabId and activeTabIndex are provided, activeTabIndex takes precedence\nTo hide the tab indicator provide an id that is not in the dataset.",
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'tabSpacing',
                type: "React.CSSProperties['marginRight']",
                description: 'The amount of space (in px) to display after each tab.',
                bound: true,
                default: '0',
            },
            {
                kind: 'classProperty',
                name: 'hasTransparentBackground',
                type: 'boolean',
                description: 'Removes the background from the tab bar (convenient when using inside pre-existing element).',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'stretch',
                type: 'boolean',
                description: "Tells the tab bar to take 100% of it's parents height. (Useful in things like AppTitleBar)",
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'maxCharsAllowed',
                type: 'number',
                description: 'Controls how many characters are allowed in the tab name before truncation.',
                bound: true,
                default: '30',
            },
            {
                kind: 'classProperty',
                name: 'tooltip',
                type: 'ToolTipProps',
                description: 'Allows for configuring the tooltips on the tab items.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'arrowTooltip',
                type: 'ToolTipProps',
                description: 'Allows for configuring the tooltips on the arrows. To be used in conjunction with the\nmoreTabsTemplate option.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'moveOnSelectChange',
                type: 'boolean',
                description: 'Determines if the component should scroll to the currently selected tab when the tab\nselection changes',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'moreTabsTemplate',
                type: 'string',
                description: "Template for tooltip showing more tabs. `<%n>` is the number of tabs hidden\n`<%p[text]>` is shown when plural, `<%s[text]> is shown when singular. Adding any\nvalue to this template will enable tooltips on either arrow.\nExample: '<%n> tab<%p[s]>' will show `1 tab` when only one tab is left or `3 tabs`\nwhen 3 tabs are left.",
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'addButtonProps',
                type: 'IconButtonProps & IconButtonEvents',
                description: 'Props passed into the Add icon button. If not provided, the Add button is not displayed.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'visualState',
                type: 'HorizontalTabBarVisualState',
                description: 'Determines the styling to apply to the tab bar.',
                bound: true,
                default: "'normal'",
            },
            {
                kind: 'classProperty',
                name: 'ref',
                type: 'React.Ref<HTMLDivElement>',
                description: 'Allows for ref passing to the wrapper component',
                default: 'undefined',
            },
        ],
        filePath: './src/lib/TabBars/HorizontalTabBar/HorizontalTabBar.tsx',
        fileName: 'HorizontalTabBar.tsx',
        category: 'TabBars',
    },
    {
        kind: 'type',
        name: 'HorizontalTabBarVisualState',
        type: "'normal' | 'stacked'",
        filePath: './src/lib/TabBars/TabBar.model.ts',
        fileName: 'TabBar.model.ts',
        category: 'TabBars',
    },
    {
        kind: 'interface',
        name: 'Tab',
        extends: ['ComputedTab'],
        properties: [
            { kind: 'interfaceProperty', name: 'isInMenu', type: 'boolean' },
            { kind: 'interfaceProperty', name: 'isSelected', type: 'boolean', required: true },
        ],
        filePath: './src/lib/TabBars/TabBar.model.ts',
        fileName: 'TabBar.model.ts',
        category: 'TabBars',
    },
    {
        kind: 'variable',
        name: 'TabBar',
        type: "React.ForwardRefExoticComponent<Omit<TabBarProps & TabBarEvents, 'ref'> & React.RefAttributes<HTMLDivElement>>",
        description: 'Description: Navigational component that contains clickable data.',
        filePath: './src/lib/TabBars/TabBar/TabBar.tsx',
        fileName: 'TabBar.tsx',
        category: 'TabBars',
    },
    {
        kind: 'interface',
        name: 'TabBar_onTabChangeEvent',
        properties: [{ kind: 'interfaceProperty', name: 'tab', type: 'Tab' }],
        filePath: './src/lib/TabBars/TabBar.model.ts',
        fileName: 'TabBar.model.ts',
        category: 'TabBars',
    },
    {
        kind: 'class',
        name: 'TabBarEvents',
        extends: 'DivHTMLEvents',
        properties: [
            {
                kind: 'classProperty',
                name: 'onTabChange',
                type: '(eventData: TabBar_onTabChangeEvent) => void',
                description: 'Another function that fires on tab click, returns tab object.',
                bound: true,
                default: 'undefined',
            },
        ],
        filePath: './src/lib/TabBars/TabBar/TabBar.tsx',
        fileName: 'TabBar.tsx',
        category: 'TabBars',
    },
    {
        kind: 'class',
        name: 'TabBarProps',
        extends: 'ObservablePropsMixin(DivHTMLAttributes)',
        properties: [
            {
                kind: 'classProperty',
                name: 'data',
                type: 'TabObject[]',
                description: 'Data structure for the tabs. If using TabObject[], id fields must be unique.',
                bound: true,
                required: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'color',
                type: 'Colors',
                description: 'Controls the color of the entire bar.',
                bound: true,
                default: "'orca'",
            },
            {
                kind: 'classProperty',
                name: 'contrast',
                type: 'Contrasts',
                description: 'Determines how easy it will be to see on dark backgrounds.',
                bound: true,
                default: "'normal'",
            },
            {
                kind: 'classProperty',
                name: 'activeTabId',
                type: 'string',
                description: "Programmatically selects active tab based on the tab's data id.\nIf both activeTabId and activeTabIndex are provided, activeTabIndex takes precedence\nTo hide the tab indicator provide an id that is not in the dataset.",
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'tabSpacing',
                type: 'number',
                description: 'Controls space in between data (in px).',
                bound: true,
                default: '0',
            },
            {
                kind: 'classProperty',
                name: 'hasTransparentBackground',
                type: 'boolean',
                description: 'Removes the background from the tab bar (convenient when using inside pre-existing element.)',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'stretch',
                type: 'boolean',
                description: "Tells the tab bar to take 100% of it's parents height. (Useful in things like AppTitleBar)",
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'maxTabs',
                type: 'number',
                description: 'Specifies the maximum number of visible tabs',
                bound: true,
                default: '10',
            },
            {
                kind: 'classProperty',
                name: 'localization',
                type: 'TabBarTextObject',
                description: 'Allows for constant text to be passed into the component, helpful for languages.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'maxCharsAllowed',
                type: 'number',
                description: 'Controls how many characters are allowed in the tab name before truncation',
                bound: true,
                default: '30',
            },
            {
                kind: 'classProperty',
                name: 'tooltip',
                type: 'ToolTipProps',
                description: 'Allows for configuring the tooltip',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'dropdown',
                type: 'DropdownProps',
                description: "Allows for configuring the 'more' dropdown",
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'componentControlledTabChange',
                type: 'boolean',
                description: 'Determines if the component allows a tab change, or relies on an external\ncomponent to inform the component that a tab has changed',
                bound: true,
                default: 'true',
            },
            {
                kind: 'classProperty',
                name: 'ref',
                type: 'React.Ref<HTMLDivElement>',
                description: 'Allows for ref passing to the wrapper component',
                default: 'undefined',
            },
        ],
        filePath: './src/lib/TabBars/TabBar/TabBar.tsx',
        fileName: 'TabBar.tsx',
        category: 'TabBars',
    },
    {
        kind: 'interface',
        name: 'TabBarTextObject',
        properties: [
            { kind: 'interfaceProperty', name: 'more', type: 'string', required: true },
            { kind: 'interfaceProperty', name: 'dropdown', type: 'DropdownTextObject' },
        ],
        filePath: './src/lib/TabBars/TabBar.model.ts',
        fileName: 'TabBar.model.ts',
        category: 'TabBars',
    },
    {
        kind: 'interface',
        name: 'TabItem',
        extends: ['TabObject'],
        properties: [
            { kind: 'interfaceProperty', name: 'tabSpacing', type: 'number' },
            { kind: 'interfaceProperty', name: 'onClick', type: '(tabId: string) => void' },
            { kind: 'interfaceProperty', name: 'selected', type: 'boolean' },
            { kind: 'interfaceProperty', name: 'color', type: 'Colors' },
            { kind: 'interfaceProperty', name: 'contrast', type: 'Contrasts' },
            { kind: 'interfaceProperty', name: 'maxCharsAllowed', type: 'number' },
            { kind: 'interfaceProperty', name: 'onWidthChange', type: '(width: number) => void' },
        ],
        filePath: './src/lib/TabBars/TabBar.model.ts',
        fileName: 'TabBar.model.ts',
        category: 'TabBars',
    },
    {
        kind: 'interface',
        name: 'TabObject',
        properties: [
            { kind: 'interfaceProperty', name: 'title', type: 'string', required: true },
            { kind: 'interfaceProperty', name: 'category', type: 'string' },
            { kind: 'interfaceProperty', name: 'id', type: 'string', required: true },
            { kind: 'interfaceProperty', name: 'disabled', type: 'boolean' },
            { kind: 'interfaceProperty', name: 'disabledReason', type: 'string' },
            { kind: 'interfaceProperty', name: 'alert', type: 'boolean' },
            { kind: 'interfaceProperty', name: 'isCloseShown', type: 'boolean' },
            { kind: 'interfaceProperty', name: 'isPinned', type: 'boolean' },
            { kind: 'interfaceProperty', name: 'isHome', type: 'boolean' },
        ],
        filePath: './src/lib/TabBars/TabBar.model.ts',
        fileName: 'TabBar.model.ts',
        category: 'TabBars',
    },
    {
        kind: 'interface',
        name: 'VerticalTab',
        properties: [
            { kind: 'interfaceProperty', name: 'icon', type: 'Icons' },
            { kind: 'interfaceProperty', name: 'hasSeparator', type: 'boolean' },
            { kind: 'interfaceProperty', name: 'id', type: 'string' },
            { kind: 'interfaceProperty', name: 'hint', type: 'string' },
            { kind: 'interfaceProperty', name: 'disabled', type: 'boolean' },
            { kind: 'interfaceProperty', name: 'disabledReason', type: 'string' },
        ],
        filePath: './src/lib/TabBars/TabBar.model.ts',
        fileName: 'TabBar.model.ts',
        category: 'TabBars',
    },
    {
        kind: 'variable',
        name: 'VerticalTabBar',
        type: "React.ForwardRefExoticComponent<Omit<VerticalTabBarProps & VerticalTabBarEvents, 'ref'> & React.RefAttributes<HTMLDivElement>>",
        description: 'Description: A vertical version of the tab bar using icons only',
        filePath: './src/lib/TabBars/VerticalTabBar/VerticalTabBar.tsx',
        fileName: 'VerticalTabBar.tsx',
        category: 'TabBars',
    },
    {
        kind: 'interface',
        name: 'VerticalTabBar_onTabChangeEvent',
        properties: [{ kind: 'interfaceProperty', name: 'tab', type: 'VerticalTab', required: true }],
        filePath: './src/lib/TabBars/TabBar.model.ts',
        fileName: 'TabBar.model.ts',
        category: 'TabBars',
    },
    {
        kind: 'class',
        name: 'VerticalTabBarEvents',
        extends: 'DivHTMLEvents',
        properties: [
            {
                kind: 'classProperty',
                name: 'onTabChange',
                type: '(eventData: VerticalTabBar_onTabChangeEvent) => void',
                description: 'Function that fires on tab click, returns vertical tab object.',
                bound: true,
                default: 'undefined',
            },
        ],
        filePath: './src/lib/TabBars/VerticalTabBar/VerticalTabBar.tsx',
        fileName: 'VerticalTabBar.tsx',
        category: 'TabBars',
    },
    {
        kind: 'class',
        name: 'VerticalTabBarProps',
        extends: 'ObservablePropsMixin(DivHTMLAttributes)',
        properties: [
            {
                kind: 'classProperty',
                name: 'data',
                type: 'VerticalTab[]',
                description: 'A list of tabs',
                bound: true,
                required: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'color',
                type: 'Colors',
                description: 'Controls color of selected indicator.',
                bound: true,
                default: "'orca'",
            },
            {
                kind: 'classProperty',
                name: 'activeTabId',
                type: 'string',
                description: 'The Id of the selected tab',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'tooltipOptions',
                type: 'ToolTipProps',
                description: 'Tooltip options',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'ref',
                type: 'React.Ref<HTMLDivElement>',
                description: 'A react reference applied to the div.',
                default: 'null',
            },
        ],
        filePath: './src/lib/TabBars/VerticalTabBar/VerticalTabBar.tsx',
        fileName: 'VerticalTabBar.tsx',
        category: 'TabBars',
    },
    {
        kind: 'interface',
        name: 'Header',
        properties: [
            { kind: 'interfaceProperty', name: 'id', type: 'string', required: true },
            { kind: 'interfaceProperty', name: 'field', type: 'string', required: true },
            { kind: 'interfaceProperty', name: 'title', type: 'string', required: true },
            { kind: 'interfaceProperty', name: 'bgColor', type: 'string' },
            { kind: 'interfaceProperty', name: 'textColor', type: 'string' },
        ],
        filePath: './src/lib/Tables/Table.model.ts',
        fileName: 'Table.model.ts',
        category: 'Tables',
    },
    {
        kind: 'interface',
        name: 'Row',
        properties: [
            { kind: 'interfaceProperty', name: 'id', type: 'string', required: true },
            { kind: 'interfaceProperty', type: '[key: string]: string | number;' },
        ],
        filePath: './src/lib/Tables/Table.model.ts',
        fileName: 'Table.model.ts',
        category: 'Tables',
    },
    {
        kind: 'variable',
        name: 'Table',
        type: "React.ForwardRefExoticComponent<Omit<TableProps & TableEvents, 'ref'> & React.RefAttributes<HTMLDivElement>>",
        description: 'Description: A standard table component that can display data in a formatted way.',
        filePath: './src/lib/Tables/Table/Table.tsx',
        fileName: 'Table.tsx',
        category: 'Tables',
    },
    {
        kind: 'interface',
        name: 'Table_onSortEvent',
        properties: [
            { kind: 'interfaceProperty', name: 'key', type: 'string', required: true },
            { kind: 'interfaceProperty', name: 'dir', type: 'string', required: true },
        ],
        filePath: './src/lib/Tables/Table.model.ts',
        fileName: 'Table.model.ts',
        category: 'Tables',
    },
    {
        kind: 'class',
        name: 'TableEvents',
        extends: 'DivHTMLEvents',
        properties: [
            {
                kind: 'classProperty',
                name: 'onSort',
                type: '(eventData: Table_onSortEvent) => void',
                description: 'Function for what to do when sorting.',
                bound: true,
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Tables/Table/Table.tsx',
        fileName: 'Table.tsx',
        category: 'Tables',
    },
    {
        kind: 'class',
        name: 'TableProps',
        extends: 'DivHTMLAttributes',
        properties: [
            {
                kind: 'classProperty',
                name: 'title',
                type: 'string',
                description: 'Title for the table.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'subtitle',
                type: 'string',
                description: 'Subtitle for the table.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'semiboldTitle',
                type: 'boolean',
                description: 'Determines if title is semibold.',
                bound: true,
                default: 'true',
            },
            {
                kind: 'classProperty',
                name: 'headerData',
                type: 'Header[]',
                description: 'Data to create the headers for the table.',
                bound: true,
                required: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'rowData',
                type: 'Row[]',
                description: 'Data to create the rows for the table.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'sortable',
                type: 'boolean',
                description: 'Allows table to be sortable.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'total',
                type: 'number',
                description: 'Represents the total for a <future> total row.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'containerView',
                type: 'boolean',
                description: 'Sets if the table should be rendered in a BasicTile or just the regular container.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'ref',
                type: 'React.Ref<HTMLDivElement>',
                description: 'A react reference applied to the div.',
                default: 'null',
            },
        ],
        filePath: './src/lib/Tables/Table/Table.tsx',
        fileName: 'Table.tsx',
        category: 'Tables',
    },
    {
        kind: 'type',
        name: 'ButtonInputType',
        type: "'button' | 'reset' | 'submit'",
        filePath: './src/lib/TextFields/TextField.model.ts',
        fileName: 'TextField.model.ts',
        category: 'TextFields',
    },
    {
        kind: 'variable',
        name: 'defaultLocalization',
        type: 'InputLocalization',
        filePath: './src/lib/TextFields/TextField.model.ts',
        fileName: 'TextField.model.ts',
        category: 'TextFields',
    },
    {
        kind: 'variable',
        name: 'EditableText',
        type: "React.ForwardRefExoticComponent<Omit<EditableTextProps & EditableTextEvents, 'ref'> & React.RefAttributes<HTMLInputElement>>",
        description: 'Description: TextField where the input grows with the text typed.',
        filePath: './src/lib/TextFields/EditableText/EditableText.tsx',
        fileName: 'EditableText.tsx',
        category: 'TextFields',
    },
    {
        kind: 'interface',
        name: 'EditableText_onInputEnterEvent',
        properties: [{ kind: 'interfaceProperty', name: 'text', type: 'string', required: true }],
        filePath: './src/lib/TextFields/TextField.model.ts',
        fileName: 'TextField.model.ts',
        category: 'TextFields',
    },
    {
        kind: 'class',
        name: 'EditableTextEvents',
        extends: 'InputHTMLEvents',
        properties: [
            {
                kind: 'classProperty',
                name: 'onInputEnter',
                type: '(eventData: EditableText_onInputEnterEvent) => void',
                description: 'Callback that is fired when enter is pressed (while text is focused).',
                bound: true,
                default: 'undefined',
            },
        ],
        filePath: './src/lib/TextFields/EditableText/EditableText.tsx',
        fileName: 'EditableText.tsx',
        category: 'TextFields',
    },
    {
        kind: 'class',
        name: 'EditableTextProps',
        extends: 'ObservablePropsMixin(InputHTMLAttributes)',
        properties: [
            {
                kind: 'classProperty',
                name: 'contrast',
                type: 'Contrasts',
                description: 'Controls whether the text has light or dark colors (for varying backgrounds).',
                bound: true,
                default: "'normal'",
            },
            {
                kind: 'classProperty',
                name: 'placeholder',
                type: 'string',
                description: 'Text shown before any value is set.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'prePopulateStatus',
                type: 'boolean',
                description: "Useful for spacing - places hidden text underneath field so shifting doesn't happen when status is set.",
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'value',
                type: 'string',
                description: 'Value of the text.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'stretch',
                type: 'boolean',
                description: 'Controls whether or not the outline grows with the text, or fits parent container.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'disabled',
                type: 'boolean',
                description: 'Disallows typing, and changes style to reflect it.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'status',
                type: 'ErrorObject | null',
                description: 'Shows accompanying text with success, error, or warning state.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'type',
                type: 'TextInputType',
                description: 'Type of input component.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'ref',
                type: 'React.Ref<HTMLInputElement>',
                description: 'Allows for ref passing to the wrapper component',
                default: 'null',
            },
        ],
        filePath: './src/lib/TextFields/EditableText/EditableText.tsx',
        fileName: 'EditableText.tsx',
        category: 'TextFields',
    },
    {
        kind: 'class',
        name: 'ErrorObject',
        properties: [
            { kind: 'classProperty', name: 'state', type: 'ErrorStates', required: true },
            { kind: 'classProperty', name: 'text', type: 'string' },
        ],
        filePath: './src/lib/TextFields/TextField.model.ts',
        fileName: 'TextField.model.ts',
        category: 'TextFields',
    },
    {
        kind: 'variable',
        name: 'InputField',
        type: "React.ForwardRefExoticComponent<Omit<InputFieldProps & InputFieldEvents, 'ref'> & React.RefAttributes<HTMLInputElement>>",
        description: 'Description: Standard InMoment branded InputField.',
        filePath: './src/lib/TextFields/InputField/InputField.tsx',
        fileName: 'InputField.tsx',
        category: 'TextFields',
    },
    {
        kind: 'interface',
        name: 'InputField_onInputEnterEvent',
        properties: [{ kind: 'interfaceProperty', name: 'text', type: 'string | number', required: true }],
        filePath: './src/lib/TextFields/TextField.model.ts',
        fileName: 'TextField.model.ts',
        category: 'TextFields',
    },
    {
        kind: 'interface',
        name: 'InputField_onSuggestionClickEvent',
        properties: [{ kind: 'interfaceProperty', name: 'suggestion', type: 'KeyValuePair', required: true }],
        filePath: './src/lib/TextFields/TextField.model.ts',
        fileName: 'TextField.model.ts',
        category: 'TextFields',
    },
    {
        kind: 'class',
        name: 'InputFieldEvents',
        extends: 'InputHTMLEvents',
        properties: [
            {
                kind: 'classProperty',
                name: 'onInputEnter',
                type: '(eventData: InputField_onInputEnterEvent) => void',
                description: 'Callback that is fired when enter is pressed (while text is focused).',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'onIconClick',
                type: '() => void',
                description: 'Callback that is fired when icon is clicked.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'onSuggestionClick',
                type: '(eventData: InputField_onSuggestionClickEvent) => void',
                description: 'Callback that is fired when a suggestion is clicked.',
                bound: true,
                default: 'undefined',
            },
        ],
        filePath: './src/lib/TextFields/InputField/InputField.tsx',
        fileName: 'InputField.tsx',
        category: 'TextFields',
    },
    {
        kind: 'class',
        name: 'InputFieldProps',
        extends: 'ObservablePropsMixin(InputHTMLAttributes)',
        properties: [
            {
                kind: 'classProperty',
                name: 'placeholder',
                type: 'string',
                description: 'Text shown before any value is set.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'value',
                type: 'string',
                description: 'Value of the text.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'textSize',
                type: 'TextSizes',
                description: "Controls the font size of the input field. Options are 'small' (14px)\nand 'normal' (16px).",
                bound: true,
                default: "'normal'",
            },
            {
                kind: 'classProperty',
                name: 'contrast',
                type: 'Contrasts',
                description: 'Controls whether the text has light or dark colors (for varying backgrounds).',
                bound: true,
                default: "'normal'",
            },
            {
                kind: 'classProperty',
                name: 'status',
                type: 'ErrorObject | null',
                description: 'Shows accompanying text with success, error, or warning state.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'prePopulateStatus',
                type: 'boolean',
                description: "Useful for spacing - places hidden text underneath field so shifting doesn't happen when status is set.",
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'label',
                type: 'string',
                description: 'Text describing the InputField, acts as the label when provided.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'inputId',
                type: 'string',
                description: 'Used only if you are using external labels with this input, NOT the regular ID.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'maxCharsAllowed',
                type: 'MaximumCharacterAllowance',
                description: 'Used to show / limit the amount of characters typed into the InputField.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'popoutProps',
                type: 'Parameters<typeof Popout>[0]',
                description: 'Props passed into the suggestion popout. Use this for setting popout IDs and offsets.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'type',
                type: 'TextInputType',
                description: 'Type of input component.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'readOnly',
                type: 'boolean',
                description: 'Determines if the input is read only.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'icon',
                type: 'Icons',
                description: 'The icon to include inside of the input field.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'localization',
                type: 'InputLocalization',
                description: 'The translatable text options for the input field',
                bound: true,
                default: 'empty',
            },
            {
                kind: 'classProperty',
                name: 'mask',
                type: 'string',
                description: 'String containing pattern for inputs (such as dates, phone numbers, etc) See below for more information. This property overrides the properties maxLength, value, maxCharsAllowed.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'errorOnIncompleteMask',
                type: 'boolean',
                description: 'Show an error when the mask is incomplete on blur',
                bound: true,
                default: 'true',
            },
            {
                kind: 'classProperty',
                name: 'maskErrorMessage',
                type: 'string',
                description: 'Message that will show up onBlur if the mask is not completely filled out (along with an error state)',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'suggestions',
                type: 'KeyValuePair[]',
                description: 'Suggested items for type ahead or auto complete options',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'selectAllOnFocus',
                type: 'boolean',
                description: 'Selects the entire value of the text box when the user focuses onto the text box',
                bound: true,
                default: 'true',
            },
            {
                kind: 'classProperty',
                name: 'maxSuggestions',
                type: 'number',
                description: 'Number of items that will show before scroll.',
                bound: true,
                default: '5',
            },
            {
                kind: 'classProperty',
                name: 'visualState',
                type: 'InputFieldVisualState',
                description: 'The visual type of the inputField, either normal or condensed',
                bound: true,
                default: "'normal'",
            },
            {
                kind: 'classProperty',
                name: 'internalProps',
                type: 'InternalInputFieldProps',
                description: 'Contains additional prop objects, useful for further modification / information influencing the component.',
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'ref',
                type: 'React.Ref<HTMLInputElement>',
                description: 'Allows for ref passing to the wrapper component',
                default: 'undefined',
            },
        ],
        filePath: './src/lib/TextFields/InputField/InputField.tsx',
        fileName: 'InputField.tsx',
        category: 'TextFields',
    },
    {
        kind: 'type',
        name: 'InputFieldPropsAndEvents',
        type: "Omit<InputFieldProps & InputFieldEvents, 'ref'> & React.RefAttributes<HTMLInputElement>",
        filePath: './src/lib/TextFields/InputField/InputField.tsx',
        fileName: 'InputField.tsx',
        category: 'TextFields',
    },
    {
        kind: 'type',
        name: 'InputFieldVisualState',
        type: "'normal' | 'condensed'",
        filePath: './src/lib/TextFields/TextField.model.ts',
        fileName: 'TextField.model.ts',
        category: 'TextFields',
    },
    {
        kind: 'interface',
        name: 'InputLocalization',
        properties: [
            { kind: 'interfaceProperty', name: 'hidePassword', type: 'string' },
            { kind: 'interfaceProperty', name: 'showPassword', type: 'string' },
        ],
        filePath: './src/lib/TextFields/TextField.model.ts',
        fileName: 'TextField.model.ts',
        category: 'TextFields',
    },
    {
        kind: 'interface',
        name: 'InternalInputFieldProps',
        properties: [{ kind: 'interfaceProperty', name: 'wrapper', type: 'DivProps' }],
        filePath: './src/lib/TextFields/TextField.model.ts',
        fileName: 'TextField.model.ts',
        category: 'TextFields',
    },
    {
        kind: 'interface',
        name: 'InternalTextAreaProps',
        properties: [{ kind: 'interfaceProperty', name: 'wrapper', type: 'DivProps' }],
        filePath: './src/lib/TextFields/TextField.model.ts',
        fileName: 'TextField.model.ts',
        category: 'TextFields',
    },
    {
        kind: 'interface',
        name: 'KeyValuePair',
        properties: [
            { kind: 'interfaceProperty', name: 'key', type: 'any', required: true },
            { kind: 'interfaceProperty', name: 'value', type: 'string', required: true },
        ],
        filePath: './src/lib/TextFields/TextField.model.ts',
        fileName: 'TextField.model.ts',
        category: 'TextFields',
    },
    {
        kind: 'interface',
        name: 'MaximumCharacterAllowance',
        properties: [
            { kind: 'interfaceProperty', name: 'max', type: 'number', required: true },
            { kind: 'interfaceProperty', name: 'errorMessage', type: 'string', required: true },
            { kind: 'interfaceProperty', name: 'allowOvertype', type: 'boolean', required: true },
        ],
        filePath: './src/lib/TextFields/TextField.model.ts',
        fileName: 'TextField.model.ts',
        category: 'TextFields',
    },
    {
        kind: 'variable',
        name: 'TextArea',
        type: "React.ForwardRefExoticComponent<Omit<TextAreaProps & TextAreaEvents, 'ref'> & React.RefAttributes<HTMLTextAreaElement>>",
        description: 'Description: XI Themed textarea.',
        filePath: './src/lib/TextFields/TextArea/TextArea.tsx',
        fileName: 'TextArea.tsx',
        category: 'TextFields',
    },
    {
        kind: 'class',
        name: 'TextAreaEvents',
        extends: 'TextAreaHTMLEvents',
        filePath: './src/lib/TextFields/TextArea/TextArea.tsx',
        fileName: 'TextArea.tsx',
        category: 'TextFields',
    },
    {
        kind: 'class',
        name: 'TextAreaProps',
        extends: 'ObservablePropsMixin(TextAreaHTMLAttributes)',
        properties: [
            {
                kind: 'classProperty',
                name: 'placeholder',
                type: 'string',
                description: 'Text shown before any value is set.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'value',
                type: 'string',
                description: 'Value of the text.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'contrast',
                type: 'Contrasts',
                description: 'Controls whether the text has light or dark colors (for varying backgrounds).',
                bound: true,
                default: "'normal'",
            },
            {
                kind: 'classProperty',
                name: 'textSize',
                type: 'TextSizes',
                description: "Controls the font size of the input field - options are 'small' (14px) and 'normal' (16px).",
                bound: true,
                default: "'normal'",
            },
            {
                kind: 'classProperty',
                name: 'status',
                type: 'ErrorObject | null',
                description: 'Shows accompanying text with success, error, or warning state.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'prePopulateStatus',
                type: 'boolean',
                description: "Useful for spacing - places hidden text underneath field so shifting doesn't happen when status is set.",
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'label',
                type: 'string',
                description: 'Text describing the InputField, acts as the label when provided.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'inputId',
                type: 'string',
                description: 'Used only if you are using external labels with this input, NOT the regular ID.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'maxCharsAllowed',
                type: 'MaximumCharacterAllowance',
                description: 'Used to show / limit the amount of characters typed into the InputField.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'height',
                type: 'number',
                description: 'Sets the height of the TextArea (TextArea has a min-height of 96).',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'resize',
                type: 'boolean',
                description: 'Allows the user to resize the component.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'visualState',
                type: 'TextAreaVisualState',
                description: 'The visual type of the TextArea, either normal or condensed',
                bound: true,
                default: "'normal'",
            },
            {
                kind: 'classProperty',
                name: 'selectAllOnFocus',
                type: 'boolean',
                description: 'When the user clicks into the text area, all text is highlighted allowing ease of\noverwriting data.',
                bound: true,
                default: 'true',
            },
            {
                kind: 'classProperty',
                name: 'localization',
                type: 'InputLocalization',
                description: 'The translatable text options for the input field',
                bound: true,
                default: 'empty',
            },
            {
                kind: 'classProperty',
                name: 'internalProps',
                type: 'InternalTextAreaProps',
                description: 'Contains additional prop objects, useful for further modification / information influencing the component.',
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'ref',
                type: 'React.Ref<HTMLTextAreaElement>',
                description: 'A react reference applied to the textarea.',
                default: 'null',
            },
        ],
        filePath: './src/lib/TextFields/TextArea/TextArea.tsx',
        fileName: 'TextArea.tsx',
        category: 'TextFields',
    },
    {
        kind: 'type',
        name: 'TextAreaVisualState',
        type: "'normal' | 'condensed'",
        filePath: './src/lib/TextFields/TextField.model.ts',
        fileName: 'TextField.model.ts',
        category: 'TextFields',
    },
    {
        kind: 'type',
        name: 'TextInputType',
        type: "'number' | 'hidden' | 'text' | 'search' | 'email' | 'password' | 'tel' | 'url'",
        filePath: './src/lib/TextFields/TextField.model.ts',
        fileName: 'TextField.model.ts',
        category: 'TextFields',
    },
    {
        kind: 'variable',
        name: 'BasicTile',
        type: "React.ForwardRefExoticComponent<Omit<BasicTileProps & BasicTileEvents, 'ref'> & React.RefAttributes<HTMLDivElement>>",
        description: 'Description: Tile that has a generic wrapper, that you can pass anything inside of as children of the component.\n\nSlots: The Basic Tile component has 2 slots, "action" is a slot for buttons/dropdowns\nin the upper right hand side. "children" is the slot for the main area of the component.',
        filePath: './src/lib/Tiles/BasicTile/BasicTile.tsx',
        fileName: 'BasicTile.tsx',
        category: 'Tiles',
    },
    {
        kind: 'interface',
        name: 'BasicTile_onIsSelectedChangeEvent',
        properties: [{ kind: 'interfaceProperty', name: 'isSelected', type: 'boolean', required: true }],
        filePath: './src/lib/Tiles/Tile.model.ts',
        fileName: 'Tile.model.ts',
        category: 'Tiles',
    },
    {
        kind: 'class',
        name: 'BasicTileEvents',
        extends: 'DivHTMLEvents',
        properties: [
            {
                kind: 'classProperty',
                name: 'onValueChange',
                type: '(eventData: Dropdown_onValueChangeEvent) => void',
                description: 'Function to fire when the value of the dropdown changes.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'onIsSelectedChange',
                type: '(eventData: BasicTile_onIsSelectedChangeEvent) => void',
                description: 'Callback to fire when selection changes',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'onBasicTilePress',
                type: '() => void',
                description: 'Fires when the basic tile component is clicked. For accessibility reasons, use this\ninstead of onClick/onKeypress.',
                bound: true,
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Tiles/BasicTile/BasicTile.tsx',
        fileName: 'BasicTile.tsx',
        category: 'Tiles',
    },
    {
        kind: 'class',
        name: 'BasicTileProps',
        extends: 'ObservablePropsMixin(DivHTMLAttributes)',
        properties: [
            {
                kind: 'classProperty',
                name: 'color',
                type: 'Colors',
                description: 'Top banner color.',
                bound: true,
                default: "'orca'",
            },
            {
                kind: 'classProperty',
                name: 'disabled',
                type: 'boolean',
                description: 'Controls the disabled state of the Tile.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'dropdownProps',
                type: 'DropdownProps',
                description: 'Properties for dropdown inside the Kabob. `type` and `label` props will be overridden if provided.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'hasBorder',
                type: 'boolean',
                description: 'Sets border.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'hasTopBar',
                type: 'boolean',
                description: 'Sets the component to have the topBar',
                bound: true,
                default: 'true',
            },
            {
                kind: 'classProperty',
                name: 'isInteractive',
                type: 'boolean',
                description: 'Controls whether you can click / interact with the tile.',
                bound: true,
                default: 'true',
            },
            {
                kind: 'classProperty',
                name: 'isSelected',
                type: 'boolean',
                description: 'Determines if the tile is selected.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'isSelectable',
                type: 'boolean',
                description: 'Controls whether the component holds state upon an interaction when\nisInteractive is true. If this is false setting selected will not result in any\nvisible changes.',
                bound: true,
                default: 'true',
            },
            {
                kind: 'classProperty',
                name: 'padding',
                type: "React.CSSProperties['padding']",
                description: "Padding for the component's content.",
                bound: true,
                default: '0',
            },
            {
                kind: 'classProperty',
                name: 'semiboldTitle',
                type: 'boolean',
                description: 'Determines if the title should be semibold.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'stretch',
                type: 'boolean',
                description: 'If true, component size will match its parent, otherwise the size is determined by its children.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'stretchSlot',
                type: 'boolean',
                description: 'Make the entire slot container stretch with the basic tile. Slot will only stretch if\nthe `stretch` property is true\n\nNote: Default will change to `true` in a future major version',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'minContentHeight',
                type: "React.CSSProperties['maxHeight']",
                description: 'Sets the min height for the content area of the Basic Tile.\nIf the content is taller than the max height, a scrollbar will appear.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'maxContentHeight',
                type: "React.CSSProperties['maxHeight']",
                description: 'Sets the max height for the content area of the Basic Tile.\nIf the content is taller than the max height, a scrollbar will appear.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'minHeight',
                type: "React.CSSProperties['minHeight']",
                description: 'Sets the min height for the BasicTile.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'maxHeight',
                type: "React.CSSProperties['maxHeight']",
                description: 'Sets the max height for the BasicTile.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'subtitle',
                type: 'string',
                description: 'Allows optional subtitle for the Basic Tile.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'title',
                type: 'string',
                description: 'Allows optional title for the Basic Tile.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'titleColor',
                type: 'BasicTileTitleColor',
                description: 'The color of the title, if provided',
                bound: true,
                default: "'orca'",
            },
            {
                kind: 'classProperty',
                name: 'titleIconProps',
                type: 'XIIconProps',
                description: 'If provided, displays an icon next to the title.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'titleSeparator',
                type: 'boolean',
                description: 'Determines if there is a border line separator between the title and Tile content.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'tabBarProps',
                type: 'Parameters<typeof HorizontalTabBar>[0]',
                description: 'If present, displays a HorizontalTabBar at the top of the tile.\n\nNote that the tab bar will be forced into a condensed visual state.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'visualState',
                type: 'BasicTileVisualState',
                description: 'Determines the visual state of the tile.',
                bound: true,
                default: "'condensed'",
            },
            {
                kind: 'classProperty',
                name: 'ref',
                type: 'React.Ref<HTMLDivElement>',
                description: 'Allows for ref passing to the wrapper component',
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Tiles/BasicTile/BasicTile.tsx',
        fileName: 'BasicTile.tsx',
        category: 'Tiles',
    },
    {
        kind: 'type',
        name: 'BasicTileTitleColor',
        type: "'admin' | 'orca' | 'EX' | 'EMPLOYEE' | 'CX' | 'CUSTOMER' | 'MX' | 'MARKETING' | 'PX' | 'PRODUCT' | 'CXIC' | 'system' | 'success' | 'warning' | 'error' | 'new' | 'open' | 'inProgress' | 'closed' | 'expired' | 'overdue' | 'negative' | 'neutral' | 'positive'",
        filePath: './src/lib/Tiles/Tile.model.ts',
        fileName: 'Tile.model.ts',
        category: 'Tiles',
    },
    {
        kind: 'type',
        name: 'BasicTileVisualState',
        type: "'normal' | 'auto' | 'condensed' | 'minimal'",
        filePath: './src/lib/Tiles/Tile.model.ts',
        fileName: 'Tile.model.ts',
        category: 'Tiles',
    },
    {
        kind: 'variable',
        name: 'WaveTile',
        type: "React.ForwardRefExoticComponent<Omit<WaveTileProps & WaveTileEvents, 'ref'> & React.RefAttributes<HTMLButtonElement>>",
        description: 'Description: Standard, convenient tile that shows a lovely wave.',
        filePath: './src/lib/Tiles/WaveTile/WaveTile.tsx',
        fileName: 'WaveTile.tsx',
        category: 'Tiles',
    },
    {
        kind: 'class',
        name: 'WaveTileEvents',
        extends: 'ButtonHTMLEvents',
        filePath: './src/lib/Tiles/WaveTile/WaveTile.tsx',
        fileName: 'WaveTile.tsx',
        category: 'Tiles',
    },
    {
        kind: 'class',
        name: 'WaveTileProps',
        extends: 'ButtonHTMLAttributes',
        properties: [
            {
                kind: 'classProperty',
                name: 'title',
                type: 'string',
                description: 'Main text for the tile.',
                bound: true,
                required: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'subtitle',
                type: 'string',
                description: 'Secondary text for the tile.',
                bound: true,
                required: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'size',
                type: 'WaveTileSize',
                description: 'Controls the size of the tile.',
                bound: true,
                default: "'large'",
            },
            {
                kind: 'classProperty',
                name: 'icon',
                type: 'Icons',
                description: "Icon accompanying the tile, only displays on 'large' size.",
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'color',
                type: 'Colors',
                description: 'Sets the color based on the cloud.',
                bound: true,
                default: "'CX'",
            },
            {
                kind: 'classProperty',
                name: 'isActive',
                type: 'boolean',
                description: 'Sets the tile to active.',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'hasWave',
                type: 'boolean',
                description: 'Controls whether or not header waves are shown.',
                bound: true,
                default: 'true',
            },
            {
                kind: 'classProperty',
                name: 'hideSubtitleOnMobile',
                type: 'boolean',
                description: 'Hides the subtitle only when the mobile view of the component is shown',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'ref',
                type: 'React.Ref<HTMLButtonElement>',
                description: 'Allows for ref passing to the wrapper component',
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Tiles/WaveTile/WaveTile.tsx',
        fileName: 'WaveTile.tsx',
        category: 'Tiles',
    },
    {
        kind: 'type',
        name: 'WaveTileSize',
        type: "'large' | 'small'",
        filePath: './src/lib/Tiles/Tile.model.ts',
        fileName: 'Tile.model.ts',
        category: 'Tiles',
    },
    {
        kind: 'type',
        name: 'ClockDirection',
        type: "9 | 3 | 8 | 11 | 2 | 1 | 12 | 6 | 4 | 5 | 7 | 10 | 'top-right' | 'right-top' | 'right-middle' | 'right-bottom' | 'bottom-right' | 'bottom-middle' | 'bottom-left' | 'left-bottom' | 'left-middle' | 'left-top' | 'top-left' | 'top-middle'",
        description: "A direction based on the positions of the numbers on a clock.\n\nFor string options:\n- Each property name has the following format `'position1-position2'`.\n    `position1` refers to the side of the element on which\n    the element is primarily positioned.\n    `position2` determines how the element will be positioned\n    on that side.\n- Examples\n  - 'top-right' (1 o'clock) means position on the right side of the top of the element.\n  - 'right-top' (2 o'clock) means position on the top part of right side of the element.\n\nThe following are equivalent:\n- 1 and 'top-right'\n- 2 and 'right-top'\n- 3 and 'right-middle'\n- 4 and 'right-bottom'\n- 5 and 'bottom-right'\n- 6 and 'bottom-middle'\n- 7 and 'bottom-left'\n- 8 and 'left-bottom'\n- 9 and 'left-middle'\n- 10 and 'left-top'\n- 11 and 'top-left'\n- 12 and 'top-middle'\n\nElement growth by direction (vertical/horizontal):\n```text\n|          | left       | right     | middle     | top        | bottom\n| top-     | up/right   | up/left   | up/both    | N/A        | N/A\n| bottom-  | down/right | down/left | down/both  | N/A        | N/A\n| left-    | N/A        | N/A       | both/left  | down/left  | up/left\n| right-   | N/A        | N/A       | both/right | down/right | up/right\n```\nExample: top-left grows up vertically and right horizontally.",
        filePath: './src/lib/ToolTips/ToolTip.model.ts',
        fileName: 'ToolTip.model.ts',
        category: 'ToolTips',
    },
    {
        kind: 'function',
        name: 'isClockDirection',
        type: 'boolean',
        parameters: [{ kind: 'functionParameter', name: 'value', type: 'any' }],
        filePath: './src/lib/ToolTips/ToolTip.model.ts',
        fileName: 'ToolTip.model.ts',
        category: 'ToolTips',
    },
    {
        kind: 'function',
        name: 'isNamedClockDirection',
        type: 'boolean',
        parameters: [{ kind: 'functionParameter', name: 'value', type: 'any' }],
        filePath: './src/lib/ToolTips/ToolTip.model.ts',
        fileName: 'ToolTip.model.ts',
        category: 'ToolTips',
    },
    {
        kind: 'function',
        name: 'isNumberedClockDirection',
        type: 'boolean',
        parameters: [{ kind: 'functionParameter', name: 'value', type: 'any' }],
        filePath: './src/lib/ToolTips/ToolTip.model.ts',
        fileName: 'ToolTip.model.ts',
        category: 'ToolTips',
    },
    {
        kind: 'type',
        name: 'NamedClockDirection',
        type: "'top-right' | 'right-top' | 'right-middle' | 'right-bottom' | 'bottom-right' | 'bottom-middle' | 'bottom-left' | 'left-bottom' | 'left-middle' | 'left-top' | 'top-left' | 'top-middle'",
        filePath: './src/lib/ToolTips/ToolTip.model.ts',
        fileName: 'ToolTip.model.ts',
        category: 'ToolTips',
    },
    {
        kind: 'type',
        name: 'NumberedClockDirection',
        type: '9 | 3 | 8 | 11 | 2 | 1 | 12 | 6 | 4 | 5 | 7 | 10',
        filePath: './src/lib/ToolTips/ToolTip.model.ts',
        fileName: 'ToolTip.model.ts',
        category: 'ToolTips',
    },
    {
        kind: 'variable',
        name: 'ToolTipContent',
        type: "React.ForwardRefExoticComponent<Omit<ToolTipContentProps & ToolTipContentEvents, 'ref'> & React.RefAttributes<HTMLDivElement>>",
        description: 'Description: Render this tooltip, and have a convenient informational popup!',
        filePath: './src/lib/ToolTips/ToolTipContent/ToolTipContent.tsx',
        fileName: 'ToolTipContent.tsx',
        category: 'ToolTips',
    },
    {
        kind: 'class',
        name: 'ToolTipContentEvents',
        extends: 'DivHTMLEvents',
        filePath: './src/lib/ToolTips/ToolTipContent/ToolTipContent.tsx',
        fileName: 'ToolTipContent.tsx',
        category: 'ToolTips',
    },
    {
        kind: 'class',
        name: 'ToolTipContentProps',
        extends: 'DivHTMLAttributes',
        properties: [
            {
                kind: 'classProperty',
                name: 'text',
                type: 'string',
                description: 'Text for link.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'link',
                type: 'string',
                description: 'URL destination.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'tooltip',
                type: 'ToolTipProps',
                description: 'Allows for configuring the tooltip',
                bound: true,
                required: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'iconSize',
                type: 'ButtonSizes',
                description: 'Size of accompanying icon (in px). Icon will only show if text and link are undefined.',
                bound: true,
                default: 'normal',
            },
            {
                kind: 'classProperty',
                name: 'contrast',
                type: 'Contrasts',
                description: 'The contrast of the icon to allow use on darker backgrounds.',
                bound: true,
                default: 'normal',
            },
            {
                kind: 'classProperty',
                name: 'ref',
                type: 'React.Ref<HTMLDivElement>',
                description: 'Allows for ref passing to the wrapper component',
                default: 'undefined',
            },
        ],
        filePath: './src/lib/ToolTips/ToolTipContent/ToolTipContent.tsx',
        fileName: 'ToolTipContent.tsx',
        category: 'ToolTips',
    },
    {
        kind: 'class',
        name: 'ToolTipEvents',
        extends: 'DivHTMLEvents',
        properties: [
            {
                kind: 'classProperty',
                name: 'onOpenChange',
                type: '(state: boolean) => void',
                description: 'Fires on change of the open status of Tooltip.',
                bound: true,
                default: 'undefined',
            },
        ],
        filePath: './src/lib/ToolTips/ToolTipWrapper/ToolTipWrapper.tsx',
        fileName: 'ToolTipWrapper.tsx',
        category: 'ToolTips',
    },
    {
        kind: 'class',
        name: 'ToolTipProps',
        extends: 'DivHTMLAttributes',
        properties: [
            {
                kind: 'classProperty',
                name: 'direction',
                type: 'ClockDirection',
                description: 'Direction of the tooltip to open compared to the component',
                bound: true,
                default: '6',
            },
            {
                kind: 'classProperty',
                name: 'isOpenOnClick',
                type: 'boolean',
                description: 'Determines if the tooltip opens on click or on hover',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'text',
                type: 'string | JSX.Element',
                description: 'The text the tooltip displays. Accepts HTML strings, but the only Kitchen component(s) permitted is/are: XIIcon.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'title',
                type: 'string | JSX.Element',
                description: 'The title the tooltip displays. Accepts HTML strings, but the only Kitchen component(s) permitted is/are: XIIcon.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'maxWidth',
                type: "React.CSSProperties['maxWidth']",
                description: 'The maximum width of the tooltip.',
                bound: true,
                default: '320',
            },
            {
                kind: 'classProperty',
                name: 'stretch',
                type: 'boolean',
                description: 'Controls the ability to allow a button to stretch the full width of its parent container.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'innerStyle',
                type: 'React.CSSProperties',
                description: 'Exposed styles for inside of tooltip',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'space',
                type: 'number',
                description: 'Additional space around the item for the tooltip.',
                bound: true,
                default: '3',
            },
            {
                kind: 'classProperty',
                name: 'enabled',
                type: 'boolean',
                description: 'Allows for programmatic enable/disable of the tooltip',
                bound: true,
                default: 'true',
            },
            {
                kind: 'classProperty',
                name: 'slotName',
                type: 'string',
                description: 'If provided and used on supported components, the tooltip will substitute all content\nwith a slot.\n\nCurrently supported components: Big Number - Context only',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'anchorElement',
                type: 'HTMLElement | null',
                description: "An element relative to which to position the tooltip.\nIf unspecified, uses the first child provided to the component.\n\nThis does not mean that the anchor element will control the tooltip visibility,\nrather it just means that the tooltip's position will be calculated with respect to\nthe anchor.\n\n**REACT USERS**: If in React, the value passed to this prop needs to be stored in `useState`,\nor the component will not update as expected.",
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'ref',
                type: 'React.Ref<HTMLDivElement>',
                description: 'Allows for ref passing to the wrapper component',
                default: 'undefined',
            },
            { kind: 'classProperty', type: 'ToolTipProps', required: true },
        ],
        filePath: './src/lib/ToolTips/ToolTipWrapper/ToolTipWrapper.tsx',
        fileName: 'ToolTipWrapper.tsx',
        category: 'ToolTips',
    },
    {
        kind: 'variable',
        name: 'ToolTipWrapper',
        type: "React.ForwardRefExoticComponent<Omit<ToolTipProps & ToolTipEvents, 'ref'> & React.RefAttributes<HTMLDivElement>>",
        description: 'Description: An internal wrapper for ToolTips.',
        filePath: './src/lib/ToolTips/ToolTipWrapper/ToolTipWrapper.tsx',
        fileName: 'ToolTipWrapper.tsx',
        category: 'ToolTips',
    },
    {
        kind: 'variable',
        name: 'AppTitleBar',
        type: "React.ForwardRefExoticComponent<Omit<AppTitleBarProps & AppTitleBarEvents, 'ref'> & React.RefAttributes<HTMLDivElement>>",
        description: 'Description: Previously GradientTopBar, this slick gradient bar can display icons, texts, and anything you want in a cloud-based fashion.',
        filePath: './src/lib/TopBars/AppTitleBar/AppTitleBar.tsx',
        fileName: 'AppTitleBar.tsx',
        category: 'TopBars',
    },
    {
        kind: 'interface',
        name: 'AppTitleBar_onButtonClickEvent',
        properties: [
            {
                kind: 'interfaceProperty',
                name: 'event',
                type: 'React.MouseEvent<HTMLButtonElement | HTMLDivElement, MouseEvent>',
                required: true,
            },
        ],
        filePath: './src/lib/TopBars/TopBar.model.ts',
        fileName: 'TopBar.model.ts',
        category: 'TopBars',
    },
    {
        kind: 'class',
        name: 'AppTitleBarEvents',
        extends: 'DivHTMLEvents',
        properties: [
            {
                kind: 'classProperty',
                name: 'onButtonClick',
                type: '(eventData: AppTitleBar_onButtonClickEvent) => void',
                description: 'Callback for Heading Button click.',
                bound: true,
                default: 'undefined',
            },
        ],
        filePath: './src/lib/TopBars/AppTitleBar/AppTitleBar.tsx',
        fileName: 'AppTitleBar.tsx',
        category: 'TopBars',
    },
    {
        kind: 'class',
        name: 'AppTitleBarProps',
        extends: 'ObservablePropsMixin(DivHTMLAttributes)',
        properties: [
            {
                kind: 'classProperty',
                name: 'text',
                type: 'string',
                description: 'Header text that will go inside the top bar (will act as the Header Button Text if onButtonClick is defined)\nThis text is automatically hidden in mobile views.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'color',
                type: 'Colors',
                description: 'Sets the gradient color.',
                bound: true,
                default: "'CX'",
            },
            {
                kind: 'classProperty',
                name: 'icon',
                type: 'Icons',
                description: 'Icon Name inside of the top bar (left side.)',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'appIcon',
                type: 'AppIconsWhite',
                description: 'App Icon that will go inside top bar.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'disableButton',
                type: 'boolean',
                description: 'Changes button to disabled state (disables click and changes text to opacity .4).',
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'isTextButton',
                type: 'boolean',
                description: 'Set to false if you want the text & icon to not be clickable. (text will stay opacity 1).',
                bound: true,
                default: 'true',
            },
            {
                kind: 'classProperty',
                name: 'ref',
                type: 'React.Ref<HTMLDivElement>',
                description: 'Allows for ref passing to the wrapper component',
                default: 'undefined',
            },
        ],
        filePath: './src/lib/TopBars/AppTitleBar/AppTitleBar.tsx',
        fileName: 'AppTitleBar.tsx',
        category: 'TopBars',
    },
    {
        kind: 'type',
        name: 'AppIcons',
        type: "'admin' | 'placeholder' | 'summary' | 'kitchen' | 'market_survey' | 'reporting' | 'admin_white' | 'announcements' | 'announcements_white' | 'benchmark' | 'benchmark_white' | 'campaign_insights' | 'campaign_insights_white' | 'case_management' | 'case_management_new' | 'case_management_new_white' | 'case_management_white' | 'coach' | 'coach_location' | 'coach_white' | 'cx_analyst' | 'cx_analyst_white' | 'cxic_admin' | 'cxic_reporting' | 'dashboard' | 'dashboard_white' | 'data_exploration' | 'data_exploration_white' | 'discover' | 'discover_insights' | 'discover_insights_white' | 'discover_white' | 'exec_reporting' | 'exec_reporting_white' | 'explore' | 'explore_white' | 'field_reporting' | 'field_reporting_white' | 'home' | 'home_white' | 'invitation_management' | 'invitation_management_white' | 'market_survey_white' | 'mcx' | 'mcx_white' | 'metrics' | 'metrics_white' | 'microsurvey' | 'microsurvey_white' | 'moments' | 'moments_white' | 'placeholder_white' | 'reporting_white' | 'research' | 'research_white' | 'resolve' | 'resolve_white' | 'review_trackers' | 'review_trackers_white' | 'seo' | 'seo_white' | 'spotlight' | 'spotlight_white' | 'studio' | 'studio_white' | 'summary_white' | 'survey' | 'survey_white' | 'text_analytics' | 'text_analytics_white' | 'watch_list' | 'watch_list_white' | 'workflow'",
        filePath: './src/lib/Visuals/XIAppIcon/_Util/AppIcon.model.ts',
        fileName: 'AppIcon.model.ts',
        category: 'Visuals',
    },
    {
        kind: 'type',
        name: 'AppIconsColor',
        type: "'admin' | 'placeholder' | 'summary' | 'kitchen' | 'market_survey' | 'reporting' | 'announcements' | 'benchmark' | 'campaign_insights' | 'case_management' | 'case_management_new' | 'coach' | 'coach_location' | 'cx_analyst' | 'cxic_admin' | 'cxic_reporting' | 'dashboard' | 'data_exploration' | 'discover' | 'discover_insights' | 'exec_reporting' | 'explore' | 'field_reporting' | 'home' | 'invitation_management' | 'mcx' | 'metrics' | 'microsurvey' | 'moments' | 'research' | 'resolve' | 'review_trackers' | 'seo' | 'spotlight' | 'studio' | 'survey' | 'text_analytics' | 'watch_list' | 'workflow'",
        filePath: './src/lib/Visuals/XIAppIcon/_Util/AppIcon.model.ts',
        fileName: 'AppIcon.model.ts',
        category: 'Visuals',
    },
    {
        kind: 'type',
        name: 'AppIconsWhite',
        type: "'admin_white' | 'announcements_white' | 'benchmark_white' | 'campaign_insights_white' | 'case_management_new_white' | 'case_management_white' | 'coach_white' | 'cx_analyst_white' | 'dashboard_white' | 'data_exploration_white' | 'discover_insights_white' | 'discover_white' | 'exec_reporting_white' | 'explore_white' | 'field_reporting_white' | 'home_white' | 'invitation_management_white' | 'market_survey_white' | 'mcx_white' | 'metrics_white' | 'microsurvey_white' | 'moments_white' | 'placeholder_white' | 'reporting_white' | 'research_white' | 'resolve_white' | 'review_trackers_white' | 'seo_white' | 'spotlight_white' | 'studio_white' | 'summary_white' | 'survey_white' | 'text_analytics_white' | 'watch_list_white'",
        filePath: './src/lib/Visuals/XIAppIcon/_Util/AppIcon.model.ts',
        fileName: 'AppIcon.model.ts',
        category: 'Visuals',
    },
    {
        kind: 'enum',
        name: 'EnumLottiesProd',
        properties: [
            'admin_loader',
            'confetti_hat',
            'CUSTOMER_loader',
            'cx_loader',
            'EMPLOYEE_loader',
            'ex_loader',
            'MARKETING_loader',
            'mx_loader',
            'orca_loader',
            'px_loader',
            'PRODUCT_loader',
            'planet_1',
        ],
        filePath: './src/lib/Visuals/XIAnimation/_Util/Lottie.model.ts',
        fileName: 'Lottie.model.ts',
        category: 'Visuals',
    },
    {
        kind: 'type',
        name: 'IconColors',
        type: "'admin' | 'orca' | 'EX' | 'EMPLOYEE' | 'CX' | 'CUSTOMER' | 'MX' | 'MARKETING' | 'PX' | 'PRODUCT' | 'CXIC' | 'system' | 'disabled' | 'negative' | 'neutral' | 'positive' | 'new' | 'open' | 'inProgress' | 'closed' | 'expired' | 'overdue' | 'red_primary' | 'green_primary' | 'yellow_primary' | 'admin_primary' | 'orca_primary' | 'blue_primary' | 'purple_primary' | 'teal_primary' | 'white_primary' | 'magenta_primary' | 'grey_primary' | 'red_light_95' | 'red_light_90' | 'red_light_80' | 'red_light_70' | 'red_light_60' | 'red_light_50' | 'red_light_40' | 'red_light_30' | 'red_light_15' | 'green_light_95' | 'green_light_90' | 'green_light_80' | 'green_light_70' | 'green_light_60' | 'green_light_50' | 'green_light_40' | 'green_light_30' | 'green_light_15' | 'yellow_light_95' | 'yellow_light_90' | 'yellow_light_80' | 'yellow_light_70' | 'yellow_light_60' | 'yellow_light_50' | 'yellow_light_40' | 'yellow_light_30' | 'yellow_light_15' | 'admin_light_95' | 'admin_light_90' | 'admin_light_80' | 'admin_light_70' | 'admin_light_60' | 'admin_light_50' | 'admin_light_40' | 'admin_light_30' | 'admin_light_15' | 'orca_light_95' | 'orca_light_90' | 'orca_light_80' | 'orca_light_70' | 'orca_light_60' | 'orca_light_50' | 'orca_light_40' | 'orca_light_30' | 'orca_light_15' | 'blue_light_95' | 'blue_light_90' | 'blue_light_80' | 'blue_light_70' | 'blue_light_60' | 'blue_light_50' | 'blue_light_40' | 'blue_light_30' | 'blue_light_15' | 'purple_light_95' | 'purple_light_90' | 'purple_light_80' | 'purple_light_70' | 'purple_light_60' | 'purple_light_50' | 'purple_light_40' | 'purple_light_30' | 'purple_light_15' | 'teal_light_95' | 'teal_light_90' | 'teal_light_80' | 'teal_light_70' | 'teal_light_60' | 'teal_light_50' | 'teal_light_40' | 'teal_light_30' | 'teal_light_15' | 'white_light_95' | 'white_light_90' | 'white_light_80' | 'white_light_70' | 'white_light_60' | 'white_light_50' | 'white_light_40' | 'white_light_30' | 'white_light_15' | 'magenta_light_95' | 'magenta_light_90' | 'magenta_light_80' | 'magenta_light_70' | 'magenta_light_60' | 'magenta_light_50' | 'magenta_light_40' | 'magenta_light_30' | 'magenta_light_15' | 'grey_light_95' | 'grey_light_90' | 'grey_light_80' | 'grey_light_70' | 'grey_light_60' | 'grey_light_50' | 'grey_light_40' | 'grey_light_30' | 'grey_light_15' | 'red_dark_40' | 'red_dark_15' | 'red_dark_55' | 'green_dark_40' | 'green_dark_15' | 'green_dark_55' | 'yellow_dark_40' | 'yellow_dark_15' | 'yellow_dark_55' | 'admin_dark_40' | 'admin_dark_15' | 'admin_dark_55' | 'orca_dark_40' | 'orca_dark_15' | 'orca_dark_55' | 'blue_dark_40' | 'blue_dark_15' | 'blue_dark_55' | 'purple_dark_40' | 'purple_dark_15' | 'purple_dark_55' | 'teal_dark_40' | 'teal_dark_15' | 'teal_dark_55' | 'white_dark_40' | 'white_dark_15' | 'white_dark_55' | 'magenta_dark_40' | 'magenta_dark_15' | 'magenta_dark_55' | 'grey_dark_40' | 'grey_dark_15' | 'grey_dark_55' | 'silver' | 'success' | 'warning' | 'error'",
        filePath: './src/lib/Visuals/Visual.model.ts',
        fileName: 'Visual.model.ts',
        category: 'Visuals',
    },
    {
        kind: 'type',
        name: 'Icons',
        type: "'invalid' | 'warning' | 'light' | 'style' | 'role' | 'width' | 'tag' | 'link' | 'indeterminate' | 'cancel' | 'checkmark' | 'comment' | 'favorite' | 'edit' | 'html' | 'menu' | 'search' | 'time' | 'video' | 'filter' | 'day' | 'email' | 'password' | 'ab_testing' | 'account' | 'account_filled' | 'action_planning' | 'action_planning_filled' | 'add_circle' | 'add_circle_filled' | 'analytics' | 'analytics_filled' | 'anomaly' | 'anomaly_detection' | 'anomaly_detection_filled' | 'answer_distribution' | 'answer_distribution_filled' | 'app_admin' | 'app_admin_filled' | 'app_announcements' | 'app_announcements_filled' | 'app_benchmark' | 'app_benchmark_filled' | 'app_campaign_insights' | 'app_campaign_insights_filled' | 'app_case_management' | 'app_case_management_filled' | 'app_case_management_new' | 'app_case_management_new_filled' | 'app_coach' | 'app_coach_filled' | 'app_cx_analyst' | 'app_cx_analyst_filled' | 'app_data_exploration' | 'app_data_exploration_filled' | 'app_discover' | 'app_discover_filled' | 'app_exec_reporting' | 'app_exec_reporting_filled' | 'app_explore' | 'app_explore_filled' | 'app_field_reporting' | 'app_field_reporting_filled' | 'app_home' | 'app_home_filled' | 'app_market_survey' | 'app_market_survey_filled' | 'app_mcx' | 'app_mcx_filled' | 'app_metrics' | 'app_metrics_filled' | 'app_microsurvey' | 'app_microsurvey_filled' | 'app_moments' | 'app_moments_filled' | 'app_reporting' | 'app_reporting_filled' | 'app_resolve' | 'app_resolve_filled' | 'app_review_trackers' | 'app_review_trackers_filled' | 'app_seo' | 'app_seo_filled' | 'app_spotlight' | 'app_summary' | 'app_summary_filled' | 'app_textAnalytics' | 'app_textAnalytics_filled' | 'apps' | 'arrow_down' | 'arrow_left' | 'arrow_link' | 'arrow_right' | 'arrow_up' | 'asterisk' | 'attach' | 'average' | 'average_count' | 'award' | 'award_filled' | 'bar_chart' | 'bar_chart_filled' | 'barometer' | 'barometer_filled' | 'brackets' | 'brand_survey' | 'brand_survey_filled' | 'calendar' | 'calendar_filled' | 'cancel_18' | 'cancel_circle' | 'cancel_circle_filled' | 'case' | 'case_complete' | 'case_complete_filled' | 'case_create' | 'case_create_filled' | 'case_filled' | 'case_remove' | 'case_remove_filled' | 'category_closed' | 'category_open' | 'certificate' | 'certificate_filled' | 'chart' | 'chart_1' | 'chart_filled' | 'chart_filled_1' | 'chart_horizontal' | 'chart_horizontal_filled' | 'check' | 'checkmark_18' | 'circle_arrow_down' | 'circle_arrow_down_filled' | 'circle_arrow_left' | 'circle_arrow_left_filled' | 'circle_arrow_right' | 'circle_arrow_right_filled' | 'circle_arrow_up' | 'circle_arrow_up_filled' | 'circle_check' | 'circle_check_filled' | 'circle_navigation' | 'circle_navigation_filled' | 'city' | 'clipboard' | 'clipboard_2' | 'clock' | 'clock_2' | 'clock_2_filled' | 'clock_filled' | 'coaching' | 'coaching_filled' | 'collections' | 'collections_filled' | 'comment_filled' | 'community' | 'community_filled' | 'condensed_card' | 'condensed_card_filled' | 'convert' | 'cookies' | 'cookies_filled' | 'copy' | 'copy_filled' | 'count' | 'crosstab' | 'crosstab_filled' | 'dark' | 'dark_filled' | 'database' | 'database_connect' | 'day_filled' | 'desktop' | 'desktop_filled' | 'disable' | 'distinct_count' | 'divide' | 'divide_filled' | 'document' | 'document_alert' | 'document_alert_filled' | 'document_bar_chart' | 'document_bar_chart_filled' | 'document_chart' | 'document_chart_filled' | 'document_coach' | 'document_coach_filled' | 'document_comment' | 'document_comment_filled' | 'document_crosstab' | 'document_crosstab_filled' | 'document_dashboard' | 'document_dashboard_filled' | 'document_export' | 'document_export_filled' | 'document_ext_csv' | 'document_ext_excel' | 'document_ext_excel_filled' | 'document_ext_pdf' | 'document_ext_pdf_filled' | 'document_ext_txt' | 'document_ext_xlm' | 'document_ext_xls' | 'document_ext_xml' | 'document_ext_xml_filled' | 'document_field_reporting' | 'document_field_reporting_filled' | 'document_filled' | 'document_multiple' | 'document_multiple_checked' | 'document_multiple_checked_filled' | 'document_multiple_filled' | 'document_report' | 'document_report_filled' | 'document_resolve' | 'document_resolve_filled' | 'document_scorecard' | 'document_scorecard_filled' | 'document_settings' | 'document_settings_filled' | 'document_survey' | 'document_survey_filled' | 'document_trend' | 'document_trend_filled' | 'download' | 'drag_handle' | 'edit_filled' | 'edit_text' | 'edit_text_filled' | 'email_add' | 'email_add_filled' | 'email_checked' | 'email_checked_filled' | 'email_edit' | 'email_edit_filled' | 'email_filled' | 'email_location' | 'email_location_filled' | 'email_location_filled_2' | 'email_open' | 'email_open_filled' | 'email_remove' | 'email_remove_filled' | 'email_search' | 'email_search_filled' | 'email_send' | 'email_send_filled' | 'email_settings' | 'email_settings_filled' | 'enable' | 'equal' | 'exchange' | 'exit' | 'exit_filled' | 'external_link' | 'external_link_filled' | 'eye_scan' | 'eye_scan_filled' | 'fab_plus' | 'favorite_filled' | 'feedback' | 'feedback_filled' | 'filter_add' | 'filter_add_filled' | 'filter_filled' | 'filter_remove' | 'filter_remove_filled' | 'flag' | 'flag_filled' | 'folder' | 'folder_filled' | 'folder_private' | 'folder_private_filled' | 'forward_30' | 'full_screen' | 'full_story' | 'funnel_chart' | 'funnel_chart_filled' | 'game' | 'game_filled' | 'gender' | 'gender_female' | 'gender_male' | 'globe' | 'globe_filled' | 'globe_warning' | 'greater_than_or_equal_to' | 'grid_view' | 'grid_view_filled' | 'history' | 'hour_glass' | 'hour_glass_filled' | 'impact_analysis' | 'indeterminate_18' | 'info' | 'info_filled' | 'integrations' | 'integrations_filled' | 'kabob' | 'kitchen' | 'kitchen_filled' | 'less_than_or_equal_to' | 'light_filled' | 'lightbulb' | 'lightbulb_filled' | 'list_view' | 'location' | 'location_filled' | 'lodge' | 'lodge_filled_1' | 'lodge_filled_2' | 'logging' | 'logging_filled' | 'mapping' | 'mapping_complete' | 'mapping_complete_filled' | 'market_survey' | 'market_survey_filled' | 'meatball' | 'meatball_filled' | 'mobile' | 'mobile_filled' | 'monitor' | 'monitor_filled' | 'more' | 'more_filled' | 'multiple_layer' | 'navigation' | 'navigation_filled' | 'new_window' | 'new_window_filled' | 'no_icon' | 'not_equal_to' | 'notepad' | 'notepad_filled' | 'notification' | 'notification_filled' | 'notification_snooze' | 'notification_snooze_filled' | 'notifications_off' | 'notifications_off_filled' | 'organization' | 'organization_filled' | 'page_count' | 'page_count_filled' | 'parentheses' | 'password_filled' | 'password_open' | 'password_open_filled' | 'pause' | 'pause_filled' | 'percentage' | 'permission' | 'permission_filled' | 'photo' | 'photo_filled' | 'pie_chart' | 'pie_chart_filled' | 'pin' | 'pin_filled' | 'play' | 'play_control' | 'play_control_filled' | 'play_filled' | 'plus' | 'preview' | 'preview_filled' | 'previous_page' | 'previous_page_filled' | 'print' | 'print_filled' | 'product_survey' | 'product_survey_filled' | 'quantum_metric' | 'question_mark' | 'receipt' | 'receipt_filled' | 'refresh' | 'regional_summary' | 'regional_summary_filled' | 'remove_circle' | 'remove_circle_filled' | 'reply' | 'reporting' | 'reporting_filled' | 'research_panel' | 'research_panel_filled' | 'rewind_15' | 'rocket' | 'rocket_filled' | 'role_filled' | 'save' | 'save_filled' | 'saved_views' | 'saved_views_filled' | 'scale' | 'scale_filled' | 'schedule' | 'schedule_filled' | 'search_filled' | 'search_suggestion' | 'search_suggestion_filled' | 'sentiment_negative' | 'sentiment_negative_filled' | 'sentiment_neutral' | 'sentiment_neutral_filled' | 'sentiment_positive' | 'sentiment_positive_filled' | 'settings' | 'settings_filled' | 'share' | 'share_filled' | 'shield' | 'shield_filled' | 'shield_remove' | 'shield_remove_filled' | 'shipping' | 'shipping_filled' | 'signature' | 'signature_filled' | 'single_arrow_down' | 'single_arrow_left' | 'single_arrow_right' | 'single_arrow_up' | 'single_layer' | 'small_circle' | 'small_circle_filled' | 'small_down_triangle' | 'small_down_triangle_filled' | 'small_left_triangle' | 'small_left_triangle_filled' | 'small_right_triangle' | 'small_right_triangle_filled' | 'small_up_triangle' | 'small_up_triangle_filled' | 'sort' | 'sort_most_relevant' | 'sort_order_asc' | 'sort_order_desc' | 'split' | 'split_filled' | 'stacked_columns' | 'stacked_rows' | 'star' | 'star_filled' | 'stethoscope' | 'stethoscope_filled' | 'style_filled' | 'support' | 'support_filled' | 'survey_authoring' | 'survey_authoring_filled' | 'tag_filled' | 'text_formatting' | 'theme' | 'theme_filled' | 'time_filled' | 'tools' | 'tools_filled' | 'translation' | 'translation_filled' | 'trash' | 'trash_filled' | 'tree_picker_collapse' | 'tree_picker_expand' | 'trend_flatten' | 'trend_increase' | 'unassigned' | 'unassigned_filled' | 'upload' | 'user_female' | 'user_female_filled_1' | 'user_female_filled_2' | 'user_male' | 'user_male_filled_1' | 'user_male_filled_2' | 'users' | 'users_filled' | 'video_filled' | 'view_condensed' | 'view_condensed_filled' | 'view_normal' | 'view_normal_filled' | 'view_table' | 'view_table_filled' | 'visibility' | 'visibility_filled' | 'visibility_off' | 'visibility_off_filled' | 'volume_off' | 'volume_off_filled' | 'volume_on' | 'volume_on_filled' | 'warning_filled' | 'width_2' | 'wifi'",
        filePath: './src/lib/Visuals/XIIcon/_Util/Icon.model.ts',
        fileName: 'Icon.model.ts',
        category: 'Visuals',
    },
    {
        kind: 'variable',
        name: 'isAppIcons',
        type: "(value: unknown) => value is 'admin' | 'placeholder' | 'summary' | 'kitchen' | 'market_survey' | 'reporting' | 'admin_white' | 'announcements' | 'announcements_white' | 'benchmark' | 'benchmark_white' | 'campaign_insights' | 'campaign_insights_white' | 'case_management' | 'case_management_new' | 'case_management_new_white' | 'case_management_white' | 'coach' | 'coach_location' | 'coach_white' | 'cx_analyst' | 'cx_analyst_white' | 'cxic_admin' | 'cxic_reporting' | 'dashboard' | 'dashboard_white' | 'data_exploration' | 'data_exploration_white' | 'discover' | 'discover_insights' | 'discover_insights_white' | 'discover_white' | 'exec_reporting' | 'exec_reporting_white' | 'explore' | 'explore_white' | 'field_reporting' | 'field_reporting_white' | 'home' | 'home_white' | 'invitation_management' | 'invitation_management_white' | 'market_survey_white' | 'mcx' | 'mcx_white' | 'metrics' | 'metrics_white' | 'microsurvey' | 'microsurvey_white' | 'moments' | 'moments_white' | 'placeholder_white' | 'reporting_white' | 'research' | 'research_white' | 'resolve' | 'resolve_white' | 'review_trackers' | 'review_trackers_white' | 'seo' | 'seo_white' | 'spotlight' | 'spotlight_white' | 'studio' | 'studio_white' | 'summary_white' | 'survey' | 'survey_white' | 'text_analytics' | 'text_analytics_white' | 'watch_list' | 'watch_list_white' | 'workflow'",
        filePath: './src/lib/Visuals/Visual.model.ts',
        fileName: 'Visual.model.ts',
        category: 'Visuals',
    },
    {
        kind: 'variable',
        name: 'isIcons',
        type: "(value: unknown) => value is 'invalid' | 'warning' | 'light' | 'style' | 'role' | 'width' | 'tag' | 'link' | 'indeterminate' | 'cancel' | 'checkmark' | 'comment' | 'favorite' | 'edit' | 'html' | 'menu' | 'search' | 'time' | 'video' | 'filter' | 'day' | 'email' | 'password' | 'ab_testing' | 'account' | 'account_filled' | 'action_planning' | 'action_planning_filled' | 'add_circle' | 'add_circle_filled' | 'analytics' | 'analytics_filled' | 'anomaly' | 'anomaly_detection' | 'anomaly_detection_filled' | 'answer_distribution' | 'answer_distribution_filled' | 'app_admin' | 'app_admin_filled' | 'app_announcements' | 'app_announcements_filled' | 'app_benchmark' | 'app_benchmark_filled' | 'app_campaign_insights' | 'app_campaign_insights_filled' | 'app_case_management' | 'app_case_management_filled' | 'app_case_management_new' | 'app_case_management_new_filled' | 'app_coach' | 'app_coach_filled' | 'app_cx_analyst' | 'app_cx_analyst_filled' | 'app_data_exploration' | 'app_data_exploration_filled' | 'app_discover' | 'app_discover_filled' | 'app_exec_reporting' | 'app_exec_reporting_filled' | 'app_explore' | 'app_explore_filled' | 'app_field_reporting' | 'app_field_reporting_filled' | 'app_home' | 'app_home_filled' | 'app_market_survey' | 'app_market_survey_filled' | 'app_mcx' | 'app_mcx_filled' | 'app_metrics' | 'app_metrics_filled' | 'app_microsurvey' | 'app_microsurvey_filled' | 'app_moments' | 'app_moments_filled' | 'app_reporting' | 'app_reporting_filled' | 'app_resolve' | 'app_resolve_filled' | 'app_review_trackers' | 'app_review_trackers_filled' | 'app_seo' | 'app_seo_filled' | 'app_spotlight' | 'app_summary' | 'app_summary_filled' | 'app_textAnalytics' | 'app_textAnalytics_filled' | 'apps' | 'arrow_down' | 'arrow_left' | 'arrow_link' | 'arrow_right' | 'arrow_up' | 'asterisk' | 'attach' | 'average' | 'average_count' | 'award' | 'award_filled' | 'bar_chart' | 'bar_chart_filled' | 'barometer' | 'barometer_filled' | 'brackets' | 'brand_survey' | 'brand_survey_filled' | 'calendar' | 'calendar_filled' | 'cancel_18' | 'cancel_circle' | 'cancel_circle_filled' | 'case' | 'case_complete' | 'case_complete_filled' | 'case_create' | 'case_create_filled' | 'case_filled' | 'case_remove' | 'case_remove_filled' | 'category_closed' | 'category_open' | 'certificate' | 'certificate_filled' | 'chart' | 'chart_1' | 'chart_filled' | 'chart_filled_1' | 'chart_horizontal' | 'chart_horizontal_filled' | 'check' | 'checkmark_18' | 'circle_arrow_down' | 'circle_arrow_down_filled' | 'circle_arrow_left' | 'circle_arrow_left_filled' | 'circle_arrow_right' | 'circle_arrow_right_filled' | 'circle_arrow_up' | 'circle_arrow_up_filled' | 'circle_check' | 'circle_check_filled' | 'circle_navigation' | 'circle_navigation_filled' | 'city' | 'clipboard' | 'clipboard_2' | 'clock' | 'clock_2' | 'clock_2_filled' | 'clock_filled' | 'coaching' | 'coaching_filled' | 'collections' | 'collections_filled' | 'comment_filled' | 'community' | 'community_filled' | 'condensed_card' | 'condensed_card_filled' | 'convert' | 'cookies' | 'cookies_filled' | 'copy' | 'copy_filled' | 'count' | 'crosstab' | 'crosstab_filled' | 'dark' | 'dark_filled' | 'database' | 'database_connect' | 'day_filled' | 'desktop' | 'desktop_filled' | 'disable' | 'distinct_count' | 'divide' | 'divide_filled' | 'document' | 'document_alert' | 'document_alert_filled' | 'document_bar_chart' | 'document_bar_chart_filled' | 'document_chart' | 'document_chart_filled' | 'document_coach' | 'document_coach_filled' | 'document_comment' | 'document_comment_filled' | 'document_crosstab' | 'document_crosstab_filled' | 'document_dashboard' | 'document_dashboard_filled' | 'document_export' | 'document_export_filled' | 'document_ext_csv' | 'document_ext_excel' | 'document_ext_excel_filled' | 'document_ext_pdf' | 'document_ext_pdf_filled' | 'document_ext_txt' | 'document_ext_xlm' | 'document_ext_xls' | 'document_ext_xml' | 'document_ext_xml_filled' | 'document_field_reporting' | 'document_field_reporting_filled' | 'document_filled' | 'document_multiple' | 'document_multiple_checked' | 'document_multiple_checked_filled' | 'document_multiple_filled' | 'document_report' | 'document_report_filled' | 'document_resolve' | 'document_resolve_filled' | 'document_scorecard' | 'document_scorecard_filled' | 'document_settings' | 'document_settings_filled' | 'document_survey' | 'document_survey_filled' | 'document_trend' | 'document_trend_filled' | 'download' | 'drag_handle' | 'edit_filled' | 'edit_text' | 'edit_text_filled' | 'email_add' | 'email_add_filled' | 'email_checked' | 'email_checked_filled' | 'email_edit' | 'email_edit_filled' | 'email_filled' | 'email_location' | 'email_location_filled' | 'email_location_filled_2' | 'email_open' | 'email_open_filled' | 'email_remove' | 'email_remove_filled' | 'email_search' | 'email_search_filled' | 'email_send' | 'email_send_filled' | 'email_settings' | 'email_settings_filled' | 'enable' | 'equal' | 'exchange' | 'exit' | 'exit_filled' | 'external_link' | 'external_link_filled' | 'eye_scan' | 'eye_scan_filled' | 'fab_plus' | 'favorite_filled' | 'feedback' | 'feedback_filled' | 'filter_add' | 'filter_add_filled' | 'filter_filled' | 'filter_remove' | 'filter_remove_filled' | 'flag' | 'flag_filled' | 'folder' | 'folder_filled' | 'folder_private' | 'folder_private_filled' | 'forward_30' | 'full_screen' | 'full_story' | 'funnel_chart' | 'funnel_chart_filled' | 'game' | 'game_filled' | 'gender' | 'gender_female' | 'gender_male' | 'globe' | 'globe_filled' | 'globe_warning' | 'greater_than_or_equal_to' | 'grid_view' | 'grid_view_filled' | 'history' | 'hour_glass' | 'hour_glass_filled' | 'impact_analysis' | 'indeterminate_18' | 'info' | 'info_filled' | 'integrations' | 'integrations_filled' | 'kabob' | 'kitchen' | 'kitchen_filled' | 'less_than_or_equal_to' | 'light_filled' | 'lightbulb' | 'lightbulb_filled' | 'list_view' | 'location' | 'location_filled' | 'lodge' | 'lodge_filled_1' | 'lodge_filled_2' | 'logging' | 'logging_filled' | 'mapping' | 'mapping_complete' | 'mapping_complete_filled' | 'market_survey' | 'market_survey_filled' | 'meatball' | 'meatball_filled' | 'mobile' | 'mobile_filled' | 'monitor' | 'monitor_filled' | 'more' | 'more_filled' | 'multiple_layer' | 'navigation' | 'navigation_filled' | 'new_window' | 'new_window_filled' | 'no_icon' | 'not_equal_to' | 'notepad' | 'notepad_filled' | 'notification' | 'notification_filled' | 'notification_snooze' | 'notification_snooze_filled' | 'notifications_off' | 'notifications_off_filled' | 'organization' | 'organization_filled' | 'page_count' | 'page_count_filled' | 'parentheses' | 'password_filled' | 'password_open' | 'password_open_filled' | 'pause' | 'pause_filled' | 'percentage' | 'permission' | 'permission_filled' | 'photo' | 'photo_filled' | 'pie_chart' | 'pie_chart_filled' | 'pin' | 'pin_filled' | 'play' | 'play_control' | 'play_control_filled' | 'play_filled' | 'plus' | 'preview' | 'preview_filled' | 'previous_page' | 'previous_page_filled' | 'print' | 'print_filled' | 'product_survey' | 'product_survey_filled' | 'quantum_metric' | 'question_mark' | 'receipt' | 'receipt_filled' | 'refresh' | 'regional_summary' | 'regional_summary_filled' | 'remove_circle' | 'remove_circle_filled' | 'reply' | 'reporting' | 'reporting_filled' | 'research_panel' | 'research_panel_filled' | 'rewind_15' | 'rocket' | 'rocket_filled' | 'role_filled' | 'save' | 'save_filled' | 'saved_views' | 'saved_views_filled' | 'scale' | 'scale_filled' | 'schedule' | 'schedule_filled' | 'search_filled' | 'search_suggestion' | 'search_suggestion_filled' | 'sentiment_negative' | 'sentiment_negative_filled' | 'sentiment_neutral' | 'sentiment_neutral_filled' | 'sentiment_positive' | 'sentiment_positive_filled' | 'settings' | 'settings_filled' | 'share' | 'share_filled' | 'shield' | 'shield_filled' | 'shield_remove' | 'shield_remove_filled' | 'shipping' | 'shipping_filled' | 'signature' | 'signature_filled' | 'single_arrow_down' | 'single_arrow_left' | 'single_arrow_right' | 'single_arrow_up' | 'single_layer' | 'small_circle' | 'small_circle_filled' | 'small_down_triangle' | 'small_down_triangle_filled' | 'small_left_triangle' | 'small_left_triangle_filled' | 'small_right_triangle' | 'small_right_triangle_filled' | 'small_up_triangle' | 'small_up_triangle_filled' | 'sort' | 'sort_most_relevant' | 'sort_order_asc' | 'sort_order_desc' | 'split' | 'split_filled' | 'stacked_columns' | 'stacked_rows' | 'star' | 'star_filled' | 'stethoscope' | 'stethoscope_filled' | 'style_filled' | 'support' | 'support_filled' | 'survey_authoring' | 'survey_authoring_filled' | 'tag_filled' | 'text_formatting' | 'theme' | 'theme_filled' | 'time_filled' | 'tools' | 'tools_filled' | 'translation' | 'translation_filled' | 'trash' | 'trash_filled' | 'tree_picker_collapse' | 'tree_picker_expand' | 'trend_flatten' | 'trend_increase' | 'unassigned' | 'unassigned_filled' | 'upload' | 'user_female' | 'user_female_filled_1' | 'user_female_filled_2' | 'user_male' | 'user_male_filled_1' | 'user_male_filled_2' | 'users' | 'users_filled' | 'video_filled' | 'view_condensed' | 'view_condensed_filled' | 'view_normal' | 'view_normal_filled' | 'view_table' | 'view_table_filled' | 'visibility' | 'visibility_filled' | 'visibility_off' | 'visibility_off_filled' | 'volume_off' | 'volume_off_filled' | 'volume_on' | 'volume_on_filled' | 'warning_filled' | 'width_2' | 'wifi'",
        filePath: './src/lib/Visuals/Visual.model.ts',
        fileName: 'Visual.model.ts',
        category: 'Visuals',
    },
    {
        kind: 'type',
        name: 'Lotties',
        type: "'planet_1' | 'admin_loader' | 'confetti_hat' | 'CUSTOMER_loader' | 'cx_loader' | 'EMPLOYEE_loader' | 'ex_loader' | 'MARKETING_loader' | 'mx_loader' | 'orca_loader' | 'px_loader' | 'PRODUCT_loader'",
        filePath: './src/lib/Visuals/XIAnimation/_Util/Lottie.model.ts',
        fileName: 'Lottie.model.ts',
        category: 'Visuals',
    },
    {
        kind: 'variable',
        name: 'ProgressBar',
        type: "React.ForwardRefExoticComponent<Omit<ProgressBarProps & ProgressBarEvents, 'ref'> & React.RefAttributes<HTMLDivElement>>",
        description: 'Description: A progress bar indicating the status of some task.',
        filePath: './src/lib/Visuals/ProgressBar/ProgressBar.tsx',
        fileName: 'ProgressBar.tsx',
        category: 'Visuals',
    },
    {
        kind: 'interface',
        name: 'ProgressBarContinuousProgressProps',
        description: 'Describes a smoothly progressing animation from\n     {@link  ProgressBarContinuousProgressProps.start start }  to\n     {@link  ProgressBarContinuousProgressProps.stop stop }  over\n     {@link  ProgressBarContinuousProgressProps.duration duration }  milliseconds.',
        properties: [
            {
                kind: 'interfaceProperty',
                name: 'start',
                type: 'number',
                description: 'The starting progress position.',
                required: true,
            },
            {
                kind: 'interfaceProperty',
                name: 'stop',
                type: 'number',
                description: 'The final progress position.',
                required: true,
            },
            {
                kind: 'interfaceProperty',
                name: 'duration',
                type: 'number',
                description: 'A number, in milliseconds, representing the duration of the progress.',
                required: true,
            },
        ],
        filePath: './src/lib/Visuals/Visual.model.ts',
        fileName: 'Visual.model.ts',
        category: 'Visuals',
    },
    {
        kind: 'class',
        name: 'ProgressBarEvents',
        extends: 'DivHTMLEvents',
        filePath: './src/lib/Visuals/ProgressBar/ProgressBar.tsx',
        fileName: 'ProgressBar.tsx',
        category: 'Visuals',
    },
    {
        kind: 'class',
        name: 'ProgressBarProps',
        extends: 'DivHTMLAttributes',
        properties: [
            {
                kind: 'classProperty',
                name: 'progress',
                type: 'number | ProgressBarContinuousProgressProps',
                description: 'The current progress.\nIf provided as a number, the value should be between 0 and 1. To specify a percentage, provide it as a decimal (e.g., 0.4 for 40%).\nIf provided as an object, see  {@link  ProgressBarContinuousProgressProps } .',
                bound: true,
                required: true,
                default: 'N/A',
            },
            {
                kind: 'classProperty',
                name: 'ref',
                type: 'React.Ref<HTMLDivElement>',
                description: 'A react reference applied to the div.',
                bound: true,
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Visuals/ProgressBar/ProgressBar.tsx',
        fileName: 'ProgressBar.tsx',
        category: 'Visuals',
    },
    {
        kind: 'type',
        name: 'ProgressBarPropsAndEvents',
        type: "Omit<ProgressBarProps & ProgressBarEvents, 'ref'> & React.RefAttributes<HTMLDivElement>",
        filePath: './src/lib/Visuals/ProgressBar/ProgressBar.tsx',
        fileName: 'ProgressBar.tsx',
        category: 'Visuals',
    },
    {
        kind: 'variable',
        name: 'progressBarWidthDurationMilliseconds',
        type: '500',
        description: 'The duration of the animation when the progress transitions from 0% to 100%.\n\n(Kitchen-only note): This is a free parameter that we can modify to get the desired duration.',
        filePath: './src/lib/Visuals/ProgressBar/ProgressBar.tsx',
        fileName: 'ProgressBar.tsx',
        category: 'Visuals',
    },
    {
        kind: 'type',
        name: 'SVGs',
        type: "'security' | 'inmoment_favicon_blue' | 'inmoment_favicon_orca' | 'inmoment_favicon_purple' | 'inmoment_favicon_teal' | 'none' | 'video' | 'email' | 'certificate' | 'chart' | 'globe' | 'location' | 'plus' | 'receipt' | 'stethoscope' | 'survey' | 'binoculars' | 'booking' | 'browser_refresh' | 'burger' | 'camping' | 'car' | 'category' | 'category_cycle' | 'celebration' | 'chart_double' | 'clapper_board' | 'clipboard_planning' | 'clothes_shopping' | 'clothing_hung' | 'cogs' | 'colorful_wave' | 'crane_illustration' | 'crystal_ball' | 'cx_background' | 'cx_edit_dialog_left_bg' | 'discount_tag' | 'display_ab_running' | 'display_app' | 'display_banner' | 'display_bottom_center' | 'display_bottom_left' | 'display_bottom_right' | 'display_default' | 'display_embedded' | 'display_middle_center' | 'display_middle_left' | 'display_middle_right' | 'display_popup' | 'display_rating' | 'display_tab' | 'display_top_center' | 'display_top_left' | 'display_top_right' | 'display_window' | 'document_okay' | 'document_section' | 'employee_engagement' | 'ex_background' | 'ex_edit_dialog_left_bg' | 'facebook' | 'file_upload' | 'four_square' | 'fries' | 'gift_card' | 'google' | 'graph' | 'graph_message' | 'graph_mobile_web' | 'graph_progress_search' | 'graph_search' | 'graph_web' | 'groceries' | 'group' | 'hand_embrace' | 'hand_favorite' | 'hand_money' | 'hand_security' | 'hand_shake' | 'health_grades' | 'hospital' | 'human_message' | 'human_okay' | 'inmoment_favicon_magenta' | 'inmoment_favicon_white' | 'inmoment_main_full_color' | 'inmoment_main_white' | 'inmoment_powered_by_horizontal_full_color' | 'inmoment_powered_by_horizontal_gray' | 'inmoment_powered_by_horizontal_orca' | 'inmoment_powered_by_horizontal_white' | 'inmoment_powered_by_vertical_full_color' | 'inmoment_powered_by_vertical_gray' | 'inmoment_powered_by_vertical_orca' | 'inmoment_powered_by_vertical_white' | 'instagram' | 'international' | 'late_rooms' | 'location_map' | 'message' | 'message_group' | 'mobile_touch' | 'money' | 'mx_background' | 'mx_edit_dialog_left_bg' | 'negative_sentiment' | 'negative_sentiment_filled' | 'negative_sentiment_outlined' | 'neutral_sentiment' | 'neutral_sentiment_filled' | 'neutral_sentiment_outlined' | 'no' | 'numbers_graphic' | 'open_table' | 'other' | 'outbound_call' | 'outbound_email' | 'people_boy' | 'people_girl' | 'person_favorite' | 'planet_1' | 'planet_2' | 'positive_sentiment' | 'positive_sentiment_filled' | 'positive_sentiment_outlined' | 'post_transaction' | 'product_offer' | 'ramen' | 'relationship' | 'secret_code_graphic' | 'skew_clock' | 'skew_desktop_1' | 'skew_desktop_2' | 'skew_desktop_3' | 'skew_phone_1' | 'skew_phone_2' | 'slide_widget_background' | 'sms' | 'spoof' | 'spoof_2' | 'star_circle' | 'star_pointed' | 'target' | 'thumbs_up' | 'ticket' | 'timeout_survey' | 'trip_advisor' | 'trophy' | 'trust_pilot' | 'twitter' | 'user_categories' | 'user_categories_complete' | 'user_cycle' | 'vitals' | 'voice_of_employee' | 'web' | 'window_bank' | 'window_banner' | 'window_banner_above' | 'window_banner_inline' | 'window_default' | 'window_embedded' | 'window_feedback_default' | 'window_popup' | 'xi_icon' | 'yelp' | 'yes' | 'zomato'",
        filePath: './src/lib/Visuals/XISVG/_Util/SVG.model.ts',
        fileName: 'SVG.model.ts',
        category: 'Visuals',
    },
    {
        kind: 'variable',
        name: 'XIAnimation',
        type: "React.ForwardRefExoticComponent<Omit<XIAnimationProps & XIAnimationEvents, 'ref'> & React.RefAttributes<HTMLDivElement>>",
        description: "Description: Conveniently displays different Lottie animations we've preloaded into the platform.",
        filePath: './src/lib/Visuals/XIAnimation/XIAnimation.tsx',
        fileName: 'XIAnimation.tsx',
        category: 'Visuals',
    },
    {
        kind: 'class',
        name: 'XIAnimationEvents',
        extends: 'DivHTMLEvents',
        filePath: './src/lib/Visuals/XIAnimation/XIAnimation.tsx',
        fileName: 'XIAnimation.tsx',
        category: 'Visuals',
    },
    {
        kind: 'class',
        name: 'XIAnimationProps',
        extends: 'DivHTMLAttributes',
        properties: [
            {
                kind: 'classProperty',
                name: 'animation',
                type: 'Lotties',
                description: 'Name of predefined animations.',
                bound: true,
                required: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'loop',
                type: 'boolean',
                description: 'Whether or not the animation loops.',
                bound: true,
                default: 'true',
            },
            {
                kind: 'classProperty',
                name: 'height',
                type: "React.CSSProperties['height']",
                description: 'Controls height of animation.',
                bound: true,
                default: '360',
            },
            {
                kind: 'classProperty',
                name: 'width',
                type: "React.CSSProperties['width']",
                description: 'Controls width of animation.',
                bound: true,
                default: '360',
            },
            {
                kind: 'classProperty',
                name: 'animationDelay',
                type: 'number',
                description: 'Delays the starting of the animations (in ms).',
                bound: true,
                default: '0',
            },
            {
                kind: 'classProperty',
                name: 'ref',
                type: 'React.Ref<HTMLDivElement>',
                description: 'Allows for ref passing to the wrapper component',
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Visuals/XIAnimation/XIAnimation.tsx',
        fileName: 'XIAnimation.tsx',
        category: 'Visuals',
    },
    {
        kind: 'type',
        name: 'XIAnimationPropsAndEvents',
        type: "Omit<XIAnimationProps & XIAnimationEvents, 'ref'> & React.RefAttributes<HTMLDivElement>",
        filePath: './src/lib/Visuals/XIAnimation/XIAnimation.tsx',
        fileName: 'XIAnimation.tsx',
        category: 'Visuals',
    },
    {
        kind: 'variable',
        name: 'XIAppIcon',
        type: "React.ForwardRefExoticComponent<Omit<XIAppIconProps & XIAppIconEvents, 'ref'> & React.RefAttributes<HTMLImageElement>>",
        description: 'Description: Component that displays an Icon in the AppIcon category.',
        filePath: './src/lib/Visuals/XIAppIcon/XIAppIcon.tsx',
        fileName: 'XIAppIcon.tsx',
        category: 'Visuals',
    },
    {
        kind: 'class',
        name: 'XIAppIconEvents',
        extends: 'ImgHTMLEvents',
        filePath: './src/lib/Visuals/XIAppIcon/XIAppIcon.tsx',
        fileName: 'XIAppIcon.tsx',
        category: 'Visuals',
    },
    {
        kind: 'class',
        name: 'XIAppIconProps',
        extends: 'ImgHTMLAttributes',
        properties: [
            {
                kind: 'classProperty',
                name: 'icon',
                type: 'AppIcons',
                description: 'Name of App Icon.',
                bound: true,
                required: true,
                default: 'N/A',
            },
            {
                kind: 'classProperty',
                name: 'iconSize',
                type: 'number',
                description: 'Size of the App Icon.',
                bound: true,
                default: '60',
            },
            {
                kind: 'classProperty',
                name: 'stretch',
                type: 'boolean',
                description: "If set to true, it will fill it's parent div.",
                bound: true,
                default: 'false',
            },
            {
                kind: 'classProperty',
                name: 'ref',
                type: 'React.Ref<HTMLImageElement>',
                description: 'Allows for ref passing to the wrapper component',
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Visuals/XIAppIcon/XIAppIcon.tsx',
        fileName: 'XIAppIcon.tsx',
        category: 'Visuals',
    },
    {
        kind: 'variable',
        name: 'XIIcon',
        type: "React.ForwardRefExoticComponent<Omit<XIIconProps & XIIconEvents & React.ClassAttributes<HTMLSpanElement>, 'ref'> & React.RefAttributes<HTMLSpanElement>>",
        description: 'Description: Component that displays an Icon in the Icons category.',
        filePath: './src/lib/Visuals/XIIcon/XIIcon.tsx',
        fileName: 'XIIcon.tsx',
        category: 'Visuals',
    },
    {
        kind: 'class',
        name: 'XIIconEvents',
        extends: 'SpanHTMLEvents',
        filePath: './src/lib/Visuals/XIIcon/XIIcon.tsx',
        fileName: 'XIIcon.tsx',
        category: 'Visuals',
    },
    {
        kind: 'class',
        name: 'XIIconProps',
        extends: 'SpanHTMLAttributes',
        properties: [
            {
                kind: 'classProperty',
                name: 'icon',
                type: 'Icons',
                description: 'Name of icon.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'color',
                type: 'IconColors',
                description: 'Color of icon.',
                bound: true,
                default: "'orca'",
            },
            {
                kind: 'classProperty',
                name: 'contrast',
                type: 'Contrasts',
                description: 'Controls visibility on a dark background.',
                bound: true,
                default: "'normal'",
            },
            {
                kind: 'classProperty',
                name: 'iconSize',
                type: 'ButtonSizes | number',
                description: 'Size of the icon (in px).',
                bound: true,
                default: "'normal'",
            },
            {
                kind: 'classProperty',
                name: 'tooltipProps',
                type: 'ToolTipProps',
                description: 'Tooltip to display. Note: Adding a tooltip may insert a small amount of space beneath the icon.',
                bound: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'ref',
                type: 'React.Ref<HTMLSpanElement>',
                description: 'Allows for ref passing to the wrapper component.',
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Visuals/XIIcon/XIIcon.tsx',
        fileName: 'XIIcon.tsx',
        category: 'Visuals',
    },
    {
        kind: 'variable',
        name: 'XISVG',
        type: "React.ForwardRefExoticComponent<Omit<XISVGProps & XISVGEvents, 'ref'> & React.RefAttributes<HTMLImageElement>>",
        description: 'Description: Component that displays an svg.',
        filePath: './src/lib/Visuals/XISVG/XISVG.tsx',
        fileName: 'XISVG.tsx',
        category: 'Visuals',
    },
    {
        kind: 'class',
        name: 'XISVGEvents',
        extends: 'ImgHTMLEvents',
        filePath: './src/lib/Visuals/XISVG/XISVG.tsx',
        fileName: 'XISVG.tsx',
        category: 'Visuals',
    },
    {
        kind: 'class',
        name: 'XISVGProps',
        extends: 'ImgHTMLAttributes',
        properties: [
            {
                kind: 'classProperty',
                name: 'svg',
                type: 'SVGs',
                description: 'Name of svg',
                bound: true,
                required: true,
                default: 'undefined',
            },
            {
                kind: 'classProperty',
                name: 'ref',
                type: 'React.Ref<HTMLImageElement>',
                description: 'Allows for ref passing to the wrapper component',
                default: 'undefined',
            },
        ],
        filePath: './src/lib/Visuals/XISVG/XISVG.tsx',
        fileName: 'XISVG.tsx',
        category: 'Visuals',
    },
    {
        kind: 'class',
        name: 'AccordionComponent',
        extends: 'KitchenComponent<AccordionProps, AccordionEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-accordion'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'AccordionComponent', required: true },
        ],
        filePath: './src/lib/web-components/Accordions/Accordion/AccordionComponent.tsx',
        fileName: 'AccordionComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'AccordionItemComponent',
        extends: 'KitchenComponent<AccordionItemProps, AccordionItemEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-accordion-item'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'AccordionItemComponent', required: true },
        ],
        filePath: './src/lib/web-components/Accordions/AccordionItem/AccordionItemComponent.tsx',
        fileName: 'AccordionItemComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'AlertInlineMainComponent',
        extends: 'KitchenComponent<AlertInlineMainProps, AlertInlineMainEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-alert-inline-main'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'AlertInlineMainComponent', required: true },
        ],
        filePath: './src/lib/web-components/Alerts/AlertInlineMain/AlertInlineMainComponent.tsx',
        fileName: 'AlertInlineMainComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'AppSideDisplayComponent',
        extends: 'KitchenComponent<AppSideDisplayProps, AppSideDisplayEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-app-side-display'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'AppSideDisplayComponent', required: true },
        ],
        filePath: './src/lib/web-components/Displays/AppSideDisplay/AppSideDisplayComponent.tsx',
        fileName: 'AppSideDisplayComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'AppTitleBarComponent',
        extends: 'KitchenComponent<AppTitleBarProps, AppTitleBarEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-app-title-bar'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'AppTitleBarComponent', required: true },
        ],
        filePath: './src/lib/web-components/TopBars/AppTitleBar/AppTitleBarComponent.tsx',
        fileName: 'AppTitleBarComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'AriaAttributes',
        implements: ['React.AriaAttributes'],
        properties: [
            {
                kind: 'classProperty',
                name: "'aria-activedescendant'",
                type: 'string',
                description: 'Identifies the currently active element when DOM focus is on a composite widget, textbox, group, or application.',
                bound: true,
            },
            {
                kind: 'classProperty',
                name: "'aria-atomic'",
                type: "boolean | 'false' | 'true'",
                description: 'Indicates whether assistive technologies will present all, or only parts of, the changed region based on the change notifications defined by the aria-relevant attribute.',
                bound: true,
            },
            {
                kind: 'classProperty',
                name: "'aria-autocomplete'",
                type: "'none' | 'inline' | 'list' | 'both'",
                description: "Indicates whether inputting text could trigger display of one or more predictions of the user's intended value for an input and specifies how predictions would be\npresented if they are made.",
                bound: true,
            },
            {
                kind: 'classProperty',
                name: "'aria-busy'",
                type: "boolean | 'false' | 'true'",
                description: 'Indicates an element is being modified and that assistive technologies MAY want to wait until the modifications are complete before exposing them to the user.',
                bound: true,
            },
            {
                kind: 'classProperty',
                name: "'aria-checked'",
                type: "boolean | 'false' | 'mixed' | 'true'",
                description: 'Indicates the current "checked" state of checkboxes, radio buttons, and other widgets.',
                bound: true,
            },
            {
                kind: 'classProperty',
                name: "'aria-colcount'",
                type: 'number',
                description: 'Defines the total number of columns in a table, grid, or treegrid.',
                bound: true,
            },
            {
                kind: 'classProperty',
                name: "'aria-colindex'",
                type: 'number',
                description: "Defines an element's column index or position with respect to the total number of columns within a table, grid, or treegrid.",
                bound: true,
            },
            {
                kind: 'classProperty',
                name: "'aria-colspan'",
                type: 'number',
                description: 'Defines the number of columns spanned by a cell or gridcell within a table, grid, or treegrid.',
                bound: true,
            },
            {
                kind: 'classProperty',
                name: "'aria-controls'",
                type: 'string',
                description: 'Identifies the element (or elements) whose contents or presence are controlled by the current element.',
                bound: true,
            },
            {
                kind: 'classProperty',
                name: "'aria-current'",
                type: "boolean | 'false' | 'true' | 'page' | 'step' | 'location' | 'date' | 'time'",
                description: 'Indicates the element that represents the current item within a container or set of related elements.',
                bound: true,
            },
            {
                kind: 'classProperty',
                name: "'aria-describedby'",
                type: 'string',
                description: 'Identifies the element (or elements) that describes the object.',
                bound: true,
            },
            {
                kind: 'classProperty',
                name: "'aria-details'",
                type: 'string',
                description: 'Identifies the element that provides a detailed, extended description for the object.',
                bound: true,
            },
            {
                kind: 'classProperty',
                name: "'aria-disabled'",
                type: "boolean | 'false' | 'true'",
                description: 'Indicates that the element is perceivable but disabled, so it is not editable or otherwise operable.',
                bound: true,
            },
            {
                kind: 'classProperty',
                name: "'aria-dropeffect'",
                type: "'none' | 'copy' | 'execute' | 'link' | 'move' | 'popup'",
                description: 'Indicates what functions can be performed when a dragged object is released on the drop target.',
                bound: true,
            },
            {
                kind: 'classProperty',
                name: "'aria-errormessage'",
                type: 'string',
                description: 'Identifies the element that provides an error message for the object.',
                bound: true,
            },
            {
                kind: 'classProperty',
                name: "'aria-expanded'",
                type: "boolean | 'false' | 'true'",
                description: 'Indicates whether the element, or another grouping element it controls, is currently expanded or collapsed.',
                bound: true,
            },
            {
                kind: 'classProperty',
                name: "'aria-flowto'",
                type: 'string',
                description: "Identifies the next element (or elements) in an alternate reading order of content which, at the user's discretion,\nallows assistive technology to override the general default of reading in document source order.",
                bound: true,
            },
            {
                kind: 'classProperty',
                name: "'aria-grabbed'",
                type: "boolean | 'false' | 'true'",
                description: 'Indicates an element\'s "grabbed" state in a drag-and-drop operation.',
                bound: true,
            },
            {
                kind: 'classProperty',
                name: "'aria-haspopup'",
                type: "boolean | 'false' | 'true' | 'menu' | 'listbox' | 'tree' | 'grid' | 'dialog'",
                description: 'Indicates the availability and type of interactive popup element, such as menu or dialog, that can be triggered by an element.',
                bound: true,
            },
            {
                kind: 'classProperty',
                name: "'aria-hidden'",
                type: "boolean | 'false' | 'true'",
                description: 'Indicates whether the element is exposed to an accessibility API.',
                bound: true,
            },
            {
                kind: 'classProperty',
                name: "'aria-invalid'",
                type: "boolean | 'false' | 'true' | 'grammar' | 'spelling'",
                description: 'Indicates the entered value does not conform to the format expected by the application.',
                bound: true,
            },
            {
                kind: 'classProperty',
                name: "'aria-keyshortcuts'",
                type: 'string',
                description: 'Indicates keyboard shortcuts that an author has implemented to activate or give focus to an element.',
                bound: true,
            },
            {
                kind: 'classProperty',
                name: "'aria-label'",
                type: 'string',
                description: 'Defines a string value that labels the current element.',
                bound: true,
            },
            {
                kind: 'classProperty',
                name: "'aria-labelledby'",
                type: 'string',
                description: 'Identifies the element (or elements) that labels the current element.',
                bound: true,
            },
            {
                kind: 'classProperty',
                name: "'aria-level'",
                type: 'number',
                description: 'Defines the hierarchical level of an element within a structure.',
                bound: true,
            },
            {
                kind: 'classProperty',
                name: "'aria-live'",
                type: "'off' | 'assertive' | 'polite'",
                description: 'Indicates that an element will be updated, and describes the types of updates the user agents, assistive technologies, and user can expect from the live region.',
                bound: true,
            },
            {
                kind: 'classProperty',
                name: "'aria-modal'",
                type: "boolean | 'false' | 'true'",
                description: 'Indicates whether an element is modal when displayed.',
                bound: true,
            },
            {
                kind: 'classProperty',
                name: "'aria-multiline'",
                type: "boolean | 'false' | 'true'",
                description: 'Indicates whether a text box accepts multiple lines of input or only a single line.',
                bound: true,
            },
            {
                kind: 'classProperty',
                name: "'aria-multiselectable'",
                type: "boolean | 'false' | 'true'",
                description: 'Indicates that the user may select more than one item from the current selectable descendants.',
                bound: true,
            },
            {
                kind: 'classProperty',
                name: "'aria-orientation'",
                type: "'horizontal' | 'vertical'",
                description: "Indicates whether the element's orientation is horizontal, vertical, or unknown/ambiguous.",
                bound: true,
            },
            {
                kind: 'classProperty',
                name: "'aria-owns'",
                type: 'string',
                description: 'Identifies an element (or elements) in order to define a visual, functional, or contextual parent/child relationship\nbetween DOM elements where the DOM hierarchy cannot be used to represent the relationship.',
                bound: true,
            },
            {
                kind: 'classProperty',
                name: "'aria-placeholder'",
                type: 'string',
                description: 'Defines a short hint (a word or short phrase) intended to aid the user with data entry when the control has no value.\nA hint could be a sample value or a brief description of the expected format.',
                bound: true,
            },
            {
                kind: 'classProperty',
                name: "'aria-posinset'",
                type: 'number',
                description: "Defines an element's number or position in the current set of listitems or treeitems. Not required if all elements in the set are present in the DOM.",
                bound: true,
            },
            {
                kind: 'classProperty',
                name: "'aria-pressed'",
                type: "boolean | 'false' | 'mixed' | 'true'",
                description: 'Indicates the current "pressed" state of toggle buttons.',
                bound: true,
            },
            {
                kind: 'classProperty',
                name: "'aria-readonly'",
                type: "boolean | 'false' | 'true'",
                description: 'Indicates that the element is not editable, but is otherwise operable.',
                bound: true,
            },
            {
                kind: 'classProperty',
                name: "'aria-relevant'",
                type: "'additions' | 'additions text' | 'all' | 'removals' | 'text'",
                description: 'Indicates what notifications the user agent will trigger when the accessibility tree within a live region is modified.',
                bound: true,
            },
            {
                kind: 'classProperty',
                name: "'aria-required'",
                type: "boolean | 'false' | 'true'",
                description: 'Indicates that user input is required on the element before a form may be submitted.',
                bound: true,
            },
            {
                kind: 'classProperty',
                name: "'aria-roledescription'",
                type: 'string',
                description: 'Defines a human-readable, author-localized description for the role of an element.',
                bound: true,
            },
            {
                kind: 'classProperty',
                name: "'aria-rowcount'",
                type: 'number',
                description: 'Defines the total number of rows in a table, grid, or treegrid.',
                bound: true,
            },
            {
                kind: 'classProperty',
                name: "'aria-rowindex'",
                type: 'number',
                description: "Defines an element's row index or position with respect to the total number of rows within a table, grid, or treegrid.",
                bound: true,
            },
            {
                kind: 'classProperty',
                name: "'aria-rowspan'",
                type: 'number',
                description: 'Defines the number of rows spanned by a cell or gridcell within a table, grid, or treegrid.',
                bound: true,
            },
            {
                kind: 'classProperty',
                name: "'aria-selected'",
                type: "boolean | 'false' | 'true'",
                description: 'Indicates the current "selected" state of various widgets.',
                bound: true,
            },
            {
                kind: 'classProperty',
                name: "'aria-setsize'",
                type: 'number',
                description: 'Defines the number of items in the current set of listitems or treeitems. Not required if all elements in the set are present in the DOM.',
                bound: true,
            },
            {
                kind: 'classProperty',
                name: "'aria-sort'",
                type: "'none' | 'ascending' | 'descending' | 'other'",
                description: 'Indicates if items in a table or grid are sorted in ascending or descending order.',
                bound: true,
            },
            {
                kind: 'classProperty',
                name: "'aria-valuemax'",
                type: 'number',
                description: 'Defines the maximum allowed value for a range widget.',
                bound: true,
            },
            {
                kind: 'classProperty',
                name: "'aria-valuemin'",
                type: 'number',
                description: 'Defines the minimum allowed value for a range widget.',
                bound: true,
            },
            {
                kind: 'classProperty',
                name: "'aria-valuenow'",
                type: 'number',
                description: 'Defines the current value for a range widget.',
                bound: true,
            },
            {
                kind: 'classProperty',
                name: "'aria-valuetext'",
                type: 'string',
                description: 'Defines the human readable text alternative of aria-valuenow for a range widget.',
                bound: true,
            },
        ],
        filePath: './src/lib/web-components/component-base/types/html-base.ts',
        fileName: 'html-base.ts',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'Attributes',
        implements: ['React.Attributes'],
        properties: [{ kind: 'classProperty', name: 'key', type: 'React.Key' }],
        filePath: './src/lib/web-components/component-base/types/react-base.ts',
        fileName: 'react-base.ts',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'AudioPlayerComponent',
        extends: 'KitchenComponent<AudioPlayerProps, AudioPlayerEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-audio-player'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'AudioPlayerComponent', required: true },
        ],
        filePath: './src/lib/web-components/Media/AudioPlayer/AudioPlayerComponent.tsx',
        fileName: 'AudioPlayerComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'BasicTileComponent',
        extends: 'KitchenComponent<BasicTileProps, BasicTileEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-basic-tile'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'BasicTileComponent', required: true },
        ],
        filePath: './src/lib/web-components/Tiles/BasicTile/BasicTileComponent.tsx',
        fileName: 'BasicTileComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'BigNumberComponent',
        extends: 'KitchenComponent<BigNumberProps, BigNumberEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-big-number'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'BigNumberComponent', required: true },
        ],
        filePath: './src/lib/web-components/Charts/BigNumber/BigNumberComponent.tsx',
        fileName: 'BigNumberComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'ButtonHTMLAttributes',
        extends: 'HTMLAttributes<HTMLButtonElement>',
        implements: ['React.ButtonHTMLAttributes<HTMLButtonElement>'],
        properties: [
            { kind: 'classProperty', name: 'autoFocus', type: 'boolean', bound: true },
            { kind: 'classProperty', name: 'disabled', type: 'boolean', bound: true },
            { kind: 'classProperty', name: 'form', type: 'string', bound: true },
            { kind: 'classProperty', name: 'formAction', type: 'string', bound: true },
            { kind: 'classProperty', name: 'formEncType', type: 'string', bound: true },
            { kind: 'classProperty', name: 'formMethod', type: 'string', bound: true },
            { kind: 'classProperty', name: 'formNoValidate', type: 'boolean', bound: true },
            { kind: 'classProperty', name: 'formTarget', type: 'string', bound: true },
            { kind: 'classProperty', name: 'name', type: 'string', bound: true },
            { kind: 'classProperty', name: 'type', type: "'submit' | 'reset' | 'button'", bound: true },
            { kind: 'classProperty', name: 'value', type: 'string | ReadonlyArray<string> | number', bound: true },
        ],
        filePath: './src/lib/web-components/component-base/types/button-html.ts',
        fileName: 'button-html.ts',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'ButtonHTMLEvents',
        extends: 'DOMEvents<HTMLButtonElement>',
        filePath: './src/lib/web-components/component-base/types/button-html.ts',
        fileName: 'button-html.ts',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'CalendarComponent',
        extends: 'KitchenComponent<CalendarProps, CalendarEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-calendar'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'CalendarComponent', required: true },
        ],
        filePath: './src/lib/web-components/Pickers/Calendar/CalendarComponent.tsx',
        fileName: 'CalendarComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'ChartWrapperComponent',
        extends: 'KitchenComponent<ChartWrapperProps, ChartWrapperEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-chart-wrapper'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'ChartWrapperComponent', required: true },
        ],
        filePath: './src/lib/web-components/ChartWrapper/ChartWrapper/ChartWrapperComponent.tsx',
        fileName: 'ChartWrapperComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'CheckboxComponent',
        extends: 'KitchenComponent<CheckboxProps, CheckboxEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-checkbox'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'CheckboxComponent', required: true },
        ],
        filePath: './src/lib/web-components/Buttons/Checkbox/CheckboxComponent.tsx',
        fileName: 'CheckboxComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'ClassAttributes',
        type: 'ClassAttributes<T>',
        extends: 'Attributes',
        implements: ['React.ClassAttributes<T>'],
        properties: [
            {
                kind: 'classProperty',
                name: 'ref',
                type: 'React.LegacyRef<T>',
                description: 'Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).',
            },
        ],
        filePath: './src/lib/web-components/component-base/types/react-base.ts',
        fileName: 'react-base.ts',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'CloudPillComponent',
        extends: 'KitchenComponent<CloudPillProps, CloudPillEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-cloud-pill'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'CloudPillComponent', required: true },
        ],
        filePath: './src/lib/web-components/Pills/CloudPill/CloudPillComponent.tsx',
        fileName: 'CloudPillComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'ColorPickerComponent',
        extends: 'KitchenComponent<ColorPickerProps, ColorPickerEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-color-picker'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'ColorPickerComponent', required: true },
        ],
        filePath: './src/lib/web-components/Pickers/ColorPicker/ColorPickerComponent.tsx',
        fileName: 'ColorPickerComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'CommentComponent',
        extends: 'KitchenComponent<CommentProps, CommentEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-comment'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'CommentComponent', required: true },
        ],
        filePath: './src/lib/web-components/Cards/Comment/CommentComponent.tsx',
        fileName: 'CommentComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'CondensedExperienceCardComponent',
        extends: 'KitchenComponent<\n  CondensedExperienceCardProps,\n  CondensedExperienceCardEvents\n>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-condensed-experience-card'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'CondensedExperienceCardComponent', required: true },
        ],
        filePath: './src/lib/web-components/Cards/CondensedExperienceCard/CondensedExperienceCardComponent.tsx',
        fileName: 'CondensedExperienceCardComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'CustomPillComponent',
        extends: 'KitchenComponent<CustomPillProps, CustomPillEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-custom-pill'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'CustomPillComponent', required: true },
        ],
        filePath: './src/lib/web-components/Pills/CustomPill/CustomPillComponent.tsx',
        fileName: 'CustomPillComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'DatePickerComponent',
        extends: 'KitchenComponent<DatePickerProps, DatePickerEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-date-picker'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'DatePickerComponent', required: true },
        ],
        filePath: './src/lib/web-components/Pickers/DatePicker/DatePickerComponent.tsx',
        fileName: 'DatePickerComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'DefaultButtonComponent',
        extends: 'KitchenComponent<DefaultButtonProps, DefaultButtonEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-default-button'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'DefaultButtonComponent', required: true },
        ],
        filePath: './src/lib/web-components/Buttons/DefaultButton/DefaultButtonComponent.tsx',
        fileName: 'DefaultButtonComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'DivHTMLAttributes',
        extends: 'HTMLAttributes<HTMLDivElement>',
        filePath: './src/lib/web-components/component-base/types/div-html.ts',
        fileName: 'div-html.ts',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'DivHTMLEvents',
        extends: 'DOMEvents<HTMLDivElement>',
        filePath: './src/lib/web-components/component-base/types/div-html.ts',
        fileName: 'div-html.ts',
        category: 'web-components',
    },
    {
        kind: 'function',
        name: 'DOMAttributes',
        type: '{ new (...args: any[]): (Anonymous class); prototype: DOMAttributes<any>.(Anonymous class); } & T',
        parameters: [{ kind: 'functionParameter', name: 'SuperClass', type: 'T' }],
        filePath: './src/lib/web-components/component-base/types/html-base.ts',
        fileName: 'html-base.ts',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'DOMEvents',
        type: 'DOMEvents<T>',
        implements: ['Partial<React.DOMAttributes<T>>'],
        properties: [
            { kind: 'classProperty', name: 'onCopy', type: 'React.ClipboardEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onCopyCapture', type: 'React.ClipboardEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onCut', type: 'React.ClipboardEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onCutCapture', type: 'React.ClipboardEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onPaste', type: 'React.ClipboardEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onPasteCapture', type: 'React.ClipboardEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onCompositionEnd', type: 'React.CompositionEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onCompositionEndCapture', type: 'React.CompositionEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onCompositionStart', type: 'React.CompositionEventHandler<T>', bound: true },
            {
                kind: 'classProperty',
                name: 'onCompositionStartCapture',
                type: 'React.CompositionEventHandler<T>',
                bound: true,
            },
            { kind: 'classProperty', name: 'onCompositionUpdate', type: 'React.CompositionEventHandler<T>', bound: true },
            {
                kind: 'classProperty',
                name: 'onCompositionUpdateCapture',
                type: 'React.CompositionEventHandler<T>',
                bound: true,
            },
            { kind: 'classProperty', name: 'onFocus', type: 'React.FocusEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onFocusCapture', type: 'React.FocusEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onBlur', type: 'React.FocusEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onBlurCapture', type: 'React.FocusEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onChange', type: 'React.FormEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onChangeCapture', type: 'React.FormEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onBeforeInput', type: 'React.FormEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onBeforeInputCapture', type: 'React.FormEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onInput', type: 'React.FormEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onInputCapture', type: 'React.FormEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onReset', type: 'React.FormEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onResetCapture', type: 'React.FormEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onSubmit', type: 'React.FormEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onSubmitCapture', type: 'React.FormEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onInvalid', type: 'React.FormEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onInvalidCapture', type: 'React.FormEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onLoad', type: 'React.ReactEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onLoadCapture', type: 'React.ReactEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onError', type: 'React.ReactEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onErrorCapture', type: 'React.ReactEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onKeyDown', type: 'React.KeyboardEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onKeyDownCapture', type: 'React.KeyboardEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onKeyPress', type: 'React.KeyboardEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onKeyPressCapture', type: 'React.KeyboardEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onKeyUp', type: 'React.KeyboardEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onKeyUpCapture', type: 'React.KeyboardEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onAbort', type: 'React.ReactEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onAbortCapture', type: 'React.ReactEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onCanPlay', type: 'React.ReactEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onCanPlayCapture', type: 'React.ReactEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onCanPlayThrough', type: 'React.ReactEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onCanPlayThroughCapture', type: 'React.ReactEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onDurationChange', type: 'React.ReactEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onDurationChangeCapture', type: 'React.ReactEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onEmptied', type: 'React.ReactEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onEmptiedCapture', type: 'React.ReactEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onEncrypted', type: 'React.ReactEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onEncryptedCapture', type: 'React.ReactEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onEnded', type: 'React.ReactEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onEndedCapture', type: 'React.ReactEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onLoadedData', type: 'React.ReactEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onLoadedDataCapture', type: 'React.ReactEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onLoadedMetadata', type: 'React.ReactEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onLoadedMetadataCapture', type: 'React.ReactEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onLoadStart', type: 'React.ReactEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onLoadStartCapture', type: 'React.ReactEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onPause', type: 'React.ReactEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onPauseCapture', type: 'React.ReactEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onPlay', type: 'React.ReactEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onPlayCapture', type: 'React.ReactEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onPlaying', type: 'React.ReactEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onPlayingCapture', type: 'React.ReactEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onProgress', type: 'React.ReactEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onProgressCapture', type: 'React.ReactEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onRateChange', type: 'React.ReactEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onRateChangeCapture', type: 'React.ReactEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onSeeked', type: 'React.ReactEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onSeekedCapture', type: 'React.ReactEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onSeeking', type: 'React.ReactEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onSeekingCapture', type: 'React.ReactEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onStalled', type: 'React.ReactEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onStalledCapture', type: 'React.ReactEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onSuspend', type: 'React.ReactEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onSuspendCapture', type: 'React.ReactEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onTimeUpdate', type: 'React.ReactEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onTimeUpdateCapture', type: 'React.ReactEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onVolumeChange', type: 'React.ReactEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onVolumeChangeCapture', type: 'React.ReactEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onWaiting', type: 'React.ReactEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onWaitingCapture', type: 'React.ReactEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onAuxClick', type: 'React.MouseEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onAuxClickCapture', type: 'React.MouseEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onClick', type: 'React.MouseEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onClickCapture', type: 'React.MouseEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onContextMenu', type: 'React.MouseEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onContextMenuCapture', type: 'React.MouseEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onDoubleClick', type: 'React.MouseEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onDoubleClickCapture', type: 'React.MouseEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onDrag', type: 'React.DragEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onDragCapture', type: 'React.DragEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onDragEnd', type: 'React.DragEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onDragEndCapture', type: 'React.DragEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onDragEnter', type: 'React.DragEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onDragEnterCapture', type: 'React.DragEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onDragExit', type: 'React.DragEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onDragExitCapture', type: 'React.DragEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onDragLeave', type: 'React.DragEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onDragLeaveCapture', type: 'React.DragEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onDragOver', type: 'React.DragEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onDragOverCapture', type: 'React.DragEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onDragStart', type: 'React.DragEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onDragStartCapture', type: 'React.DragEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onDrop', type: 'React.DragEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onDropCapture', type: 'React.DragEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onMouseDown', type: 'React.MouseEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onMouseDownCapture', type: 'React.MouseEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onMouseEnter', type: 'React.MouseEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onMouseLeave', type: 'React.MouseEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onMouseMove', type: 'React.MouseEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onMouseMoveCapture', type: 'React.MouseEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onMouseOut', type: 'React.MouseEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onMouseOutCapture', type: 'React.MouseEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onMouseOver', type: 'React.MouseEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onMouseOverCapture', type: 'React.MouseEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onMouseUp', type: 'React.MouseEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onMouseUpCapture', type: 'React.MouseEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onSelect', type: 'React.ReactEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onSelectCapture', type: 'React.ReactEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onTouchCancel', type: 'React.TouchEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onTouchCancelCapture', type: 'React.TouchEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onTouchEnd', type: 'React.TouchEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onTouchEndCapture', type: 'React.TouchEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onTouchMove', type: 'React.TouchEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onTouchMoveCapture', type: 'React.TouchEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onTouchStart', type: 'React.TouchEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onTouchStartCapture', type: 'React.TouchEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onPointerDown', type: 'React.PointerEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onPointerDownCapture', type: 'React.PointerEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onPointerMove', type: 'React.PointerEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onPointerMoveCapture', type: 'React.PointerEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onPointerUp', type: 'React.PointerEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onPointerUpCapture', type: 'React.PointerEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onPointerCancel', type: 'React.PointerEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onPointerCancelCapture', type: 'React.PointerEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onPointerEnter', type: 'React.PointerEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onPointerEnterCapture', type: 'React.PointerEventHandler<T>' },
            { kind: 'classProperty', name: 'onPointerLeave', type: 'React.PointerEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onPointerLeaveCapture', type: 'React.PointerEventHandler<T>' },
            { kind: 'classProperty', name: 'onPointerOver', type: 'React.PointerEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onPointerOverCapture', type: 'React.PointerEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onPointerOut', type: 'React.PointerEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onPointerOutCapture', type: 'React.PointerEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onGotPointerCapture', type: 'React.PointerEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onGotPointerCaptureCapture', type: 'React.PointerEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onLostPointerCapture', type: 'React.PointerEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onLostPointerCaptureCapture', type: 'React.PointerEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onScroll', type: 'React.UIEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onScrollCapture', type: 'React.UIEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onWheel', type: 'React.WheelEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onWheelCapture', type: 'React.WheelEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onAnimationStart', type: 'React.AnimationEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onAnimationStartCapture', type: 'React.AnimationEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onAnimationEnd', type: 'React.AnimationEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onAnimationEndCapture', type: 'React.AnimationEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onAnimationIteration', type: 'React.AnimationEventHandler<T>', bound: true },
            {
                kind: 'classProperty',
                name: 'onAnimationIterationCapture',
                type: 'React.AnimationEventHandler<T>',
                bound: true,
            },
            { kind: 'classProperty', name: 'onTransitionEnd', type: 'React.TransitionEventHandler<T>', bound: true },
            { kind: 'classProperty', name: 'onTransitionEndCapture', type: 'React.TransitionEventHandler<T>', bound: true },
        ],
        filePath: './src/lib/web-components/component-base/types/html-base.ts',
        fileName: 'html-base.ts',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'DrawerComponent',
        extends: 'KitchenComponent<DrawerProps, DrawerEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-drawer'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'DrawerComponent', required: true },
        ],
        filePath: './src/lib/web-components/Drawers/Drawer/DrawerComponent.ts',
        fileName: 'DrawerComponent.ts',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'DropdownComponent',
        extends: 'KitchenComponent<DropdownProps, DropdownEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-dropdown'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'DropdownComponent', required: true },
        ],
        filePath: './src/lib/web-components/Dropdowns/Dropdown/DropdownComponent.tsx',
        fileName: 'DropdownComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'EditableTextComponent',
        extends: 'KitchenComponent<EditableTextProps, EditableTextEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-editable-text'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'EditableTextComponent', required: true },
        ],
        filePath: './src/lib/web-components/TextFields/EditableText/EditableTextComponent.tsx',
        fileName: 'EditableTextComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'ExperienceCardComponent',
        extends: 'KitchenComponent<ExperienceCardProps, ExperienceCardEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-experience-card'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'ExperienceCardComponent', required: true },
        ],
        filePath: './src/lib/web-components/Cards/ExperienceCard/ExperienceCardComponent.tsx',
        fileName: 'ExperienceCardComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'ExperienceHeaderComponent',
        extends: 'KitchenComponent<ExperienceHeaderProps, ExperienceHeaderEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-experience-header'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'ExperienceHeaderComponent', required: true },
        ],
        filePath: './src/lib/web-components/Cards/ExperienceHeader/ExperienceHeaderComponent.tsx',
        fileName: 'ExperienceHeaderComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'FABComponent',
        extends: 'KitchenComponent<FABProps, FABEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-fab'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'FABComponent', required: true },
        ],
        filePath: './src/lib/web-components/Buttons/FAB/FABComponent.tsx',
        fileName: 'FABComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'FilterButtonComponent',
        extends: 'KitchenComponent<FilterButtonProps, FilterButtonEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-filter-button'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'FilterButtonComponent', required: true },
        ],
        filePath: './src/lib/web-components/Buttons/FilterButton/FilterButtonComponent.tsx',
        fileName: 'FilterButtonComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'GenericModalComponent',
        extends: 'KitchenComponent<GenericModalProps, GenericModalEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-generic-modal'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'GenericModalComponent', required: true },
        ],
        filePath: './src/lib/web-components/Modals/GenericModal/GenericModalComponent.tsx',
        fileName: 'GenericModalComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'HeadingButtonComponent',
        extends: 'KitchenComponent<HeadingButtonProps, HeadingButtonEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-heading-button'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'HeadingButtonComponent', required: true },
        ],
        filePath: './src/lib/web-components/Buttons/HeadingButton/HeadingButtonComponent.tsx',
        fileName: 'HeadingButtonComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'HierarchyPickerComponent',
        extends: 'KitchenComponent<HierarchyPickerProps, HierarchyPickerEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-hierarchy-picker'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'HierarchyPickerComponent', required: true },
        ],
        filePath: './src/lib/web-components/Pickers/HierarchyPicker/HierarchyPickerComponent.tsx',
        fileName: 'HierarchyPickerComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'HorizontalTabBarComponent',
        extends: 'KitchenComponent<HorizontalTabBarProps, HorizontalTabBarEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-horizontal-tab-bar'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'HorizontalTabBarComponent', required: true },
        ],
        filePath: './src/lib/web-components/TabBars/HorizontalTabBar/HorizontalTabBarComponent.tsx',
        fileName: 'HorizontalTabBarComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'HTMLAttributes',
        type: 'HTMLAttributes<T>',
        extends: 'DOMAttributes(AriaAttributes)',
        implements: ['React.HTMLAttributes<T>'],
        properties: [
            { kind: 'classProperty', name: "'data-qa'", type: 'string', bound: true },
            { kind: 'classProperty', name: "'data-testid'", type: 'string', bound: true },
            { kind: 'classProperty', name: 'defaultChecked', type: 'boolean', bound: true },
            { kind: 'classProperty', name: 'defaultValue', type: 'string | number | ReadonlyArray<string>', bound: true },
            { kind: 'classProperty', name: 'suppressContentEditableWarning', type: 'boolean', bound: true },
            { kind: 'classProperty', name: 'suppressHydrationWarning', type: 'boolean', bound: true },
            { kind: 'classProperty', name: 'accessKey', type: 'string', bound: true },
            { kind: 'classProperty', name: 'className', type: 'string', bound: true },
            { kind: 'classProperty', name: 'contentEditable', type: "Booleanish | 'inherit'", bound: true },
            { kind: 'classProperty', name: 'contextMenu', type: 'string', bound: true },
            { kind: 'classProperty', name: 'dir', type: 'string', bound: true },
            { kind: 'classProperty', name: 'draggable', type: 'Booleanish', bound: true },
            { kind: 'classProperty', name: 'hidden', type: 'boolean', bound: true },
            { kind: 'classProperty', name: 'id', type: 'string', bound: true },
            { kind: 'classProperty', name: 'lang', type: 'string', bound: true },
            { kind: 'classProperty', name: 'placeholder', type: 'string', bound: true },
            { kind: 'classProperty', name: 'slot', type: 'string', bound: true },
            { kind: 'classProperty', name: 'spellCheck', type: 'Booleanish', bound: true },
            { kind: 'classProperty', name: 'style', type: 'React.CSSProperties' },
            { kind: 'classProperty', name: 'tabIndex', type: 'number', bound: true },
            { kind: 'classProperty', name: 'title', type: 'string', bound: true },
            { kind: 'classProperty', name: 'translate', type: "'yes' | 'no'", bound: true },
            { kind: 'classProperty', name: 'radioGroup', type: 'string', bound: true },
            { kind: 'classProperty', name: 'role', type: 'string', bound: true },
            { kind: 'classProperty', name: 'about', type: 'string', bound: true },
            { kind: 'classProperty', name: 'datatype', type: 'string', bound: true },
            { kind: 'classProperty', name: 'inlist', type: 'any', bound: true },
            { kind: 'classProperty', name: 'prefix', type: 'string', bound: true },
            { kind: 'classProperty', name: 'property', type: 'string', bound: true },
            { kind: 'classProperty', name: 'resource', type: 'string', bound: true },
            { kind: 'classProperty', name: 'typeof', type: 'string', bound: true },
            { kind: 'classProperty', name: 'vocab', type: 'string', bound: true },
            { kind: 'classProperty', name: 'autoCapitalize', type: 'string', bound: true },
            { kind: 'classProperty', name: 'autoCorrect', type: 'string', bound: true },
            { kind: 'classProperty', name: 'autoSave', type: 'string', bound: true },
            { kind: 'classProperty', name: 'color', type: 'string', bound: true },
            { kind: 'classProperty', name: 'itemProp', type: 'string', bound: true },
            { kind: 'classProperty', name: 'itemScope', type: 'boolean', bound: true },
            { kind: 'classProperty', name: 'itemType', type: 'string', bound: true },
            { kind: 'classProperty', name: 'itemID', type: 'string', bound: true },
            { kind: 'classProperty', name: 'itemRef', type: 'string', bound: true },
            { kind: 'classProperty', name: 'results', type: 'number', bound: true },
            { kind: 'classProperty', name: 'security', type: 'string', bound: true },
            { kind: 'classProperty', name: 'unselectable', type: "'on' | 'off'", bound: true },
            {
                kind: 'classProperty',
                name: 'inputMode',
                type: "'none' | 'text' | 'tel' | 'url' | 'email' | 'numeric' | 'decimal' | 'search'",
                description: 'Hints at the type of data that might be entered by the user while editing the element or its contents',
                bound: true,
            },
            {
                kind: 'classProperty',
                name: 'is',
                type: 'string',
                description: 'Specify that a standard HTML element should behave like a defined custom built-in element',
                bound: true,
            },
        ],
        filePath: './src/lib/web-components/component-base/types/html-base.ts',
        fileName: 'html-base.ts',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'IconButtonComponent',
        extends: 'KitchenComponent<IconButtonProps, IconButtonEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-icon-button'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'IconButtonComponent', required: true },
        ],
        filePath: './src/lib/web-components/Buttons/IconButton/IconButtonComponent.tsx',
        fileName: 'IconButtonComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'ImageCarouselComponent',
        extends: 'KitchenComponent<ImageCarouselProps, ImageCarouselEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-image-carousel'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'ImageCarouselComponent', required: true },
        ],
        filePath: './src/lib/web-components/Media/ImageCarousel/ImageCarouselComponent.tsx',
        fileName: 'ImageCarouselComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'ImgHTMLAttributes',
        extends: 'HTMLAttributes<HTMLImageElement>',
        filePath: './src/lib/web-components/component-base/types/img-html.ts',
        fileName: 'img-html.ts',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'ImgHTMLEvents',
        extends: 'DOMEvents<HTMLImageElement>',
        filePath: './src/lib/web-components/component-base/types/img-html.ts',
        fileName: 'img-html.ts',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'InputFieldComponent',
        extends: 'KitchenComponent<InputFieldProps, InputFieldEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-input-field'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'InputFieldComponent', required: true },
        ],
        filePath: './src/lib/web-components/TextFields/InputField/InputFieldComponent.tsx',
        fileName: 'InputFieldComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'InputHTMLAttributes',
        extends: 'HTMLAttributes<HTMLInputElement>',
        implements: ['React.InputHTMLAttributes<HTMLInputElement>'],
        properties: [
            { kind: 'classProperty', name: 'accept', type: 'string', bound: true },
            { kind: 'classProperty', name: 'alt', type: 'string', bound: true },
            { kind: 'classProperty', name: 'autoComplete', type: 'string', bound: true },
            { kind: 'classProperty', name: 'autoFocus', type: 'boolean', bound: true },
            { kind: 'classProperty', name: 'capture', type: "boolean | 'user' | 'environment' | undefined", bound: true },
            { kind: 'classProperty', name: 'checked', type: 'boolean', bound: true },
            { kind: 'classProperty', name: 'crossOrigin', type: 'string', bound: true },
            { kind: 'classProperty', name: 'disabled', type: 'boolean', bound: true },
            { kind: 'classProperty', name: 'form', type: 'string', bound: true },
            { kind: 'classProperty', name: 'formAction', type: 'string', bound: true },
            { kind: 'classProperty', name: 'formEncType', type: 'string', bound: true },
            { kind: 'classProperty', name: 'formMethod', type: 'string', bound: true },
            { kind: 'classProperty', name: 'formNoValidate', type: 'boolean', bound: true },
            { kind: 'classProperty', name: 'formTarget', type: 'string', bound: true },
            { kind: 'classProperty', name: 'height', type: 'number | string', bound: true },
            { kind: 'classProperty', name: 'list', type: 'string', bound: true },
            { kind: 'classProperty', name: 'max', type: 'number | string', bound: true },
            { kind: 'classProperty', name: 'maxLength', type: 'number', bound: true },
            { kind: 'classProperty', name: 'min', type: 'number | string', bound: true },
            { kind: 'classProperty', name: 'minLength', type: 'number', bound: true },
            { kind: 'classProperty', name: 'multiple', type: 'boolean', bound: true },
            { kind: 'classProperty', name: 'name', type: 'string', bound: true },
            { kind: 'classProperty', name: 'pattern', type: 'string', bound: true },
            { kind: 'classProperty', name: 'placeholder', type: 'string', bound: true },
            { kind: 'classProperty', name: 'readOnly', type: 'boolean', bound: true },
            { kind: 'classProperty', name: 'required', type: 'boolean', bound: true },
            { kind: 'classProperty', name: 'size', type: 'number', bound: true },
            { kind: 'classProperty', name: 'src', type: 'string', bound: true },
            { kind: 'classProperty', name: 'step', type: 'number | string', bound: true },
            { kind: 'classProperty', name: 'type', type: 'string', bound: true },
            { kind: 'classProperty', name: 'value', type: 'string | ReadonlyArray<string> | number', bound: true },
            { kind: 'classProperty', name: 'width', type: 'number | string', bound: true },
        ],
        filePath: './src/lib/web-components/component-base/types/input-html.ts',
        fileName: 'input-html.ts',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'InputHTMLEvents',
        extends: 'DOMEvents<HTMLInputElement>',
        properties: [
            { kind: 'classProperty', name: 'onChange', type: 'React.ChangeEventHandler<HTMLInputElement>', bound: true },
        ],
        filePath: './src/lib/web-components/component-base/types/input-html.ts',
        fileName: 'input-html.ts',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'LeftRightPickerComponent',
        extends: 'KitchenComponent<LeftRightPickerProps, LeftRightPickerEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-left-right-picker'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'LeftRightPickerComponent', required: true },
        ],
        filePath: './src/lib/web-components/Pickers/LeftRightPicker/LeftRightPickerComponent.tsx',
        fileName: 'LeftRightPickerComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'LiHTMLAttributes',
        extends: 'HTMLAttributes<HTMLLIElement>',
        filePath: './src/lib/web-components/component-base/types/li-html.ts',
        fileName: 'li-html.ts',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'LiHTMLEvents',
        extends: 'DOMEvents<HTMLLIElement>',
        filePath: './src/lib/web-components/component-base/types/li-html.ts',
        fileName: 'li-html.ts',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'ListComponent',
        extends: 'KitchenComponent<ListProps, ListEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-list'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'ListComponent', required: true },
        ],
        filePath: './src/lib/web-components/Lists/List/ListComponent.tsx',
        fileName: 'ListComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'ListItemComponent',
        extends: 'KitchenComponent<ListItemProps, ListItemEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-list-item'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'ListItemComponent', required: true },
        ],
        filePath: './src/lib/web-components/Lists/ListItem/ListItemComponent.tsx',
        fileName: 'ListItemComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'NotesComponent',
        extends: 'KitchenComponent<NotesProps, NotesEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-notes'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'NotesComponent', required: true },
        ],
        filePath: './src/lib/web-components/Cards/Notes/NotesComponent.tsx',
        fileName: 'NotesComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'PopoutComponent',
        extends: 'KitchenComponent<PopoutProps, PopoutEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-popout'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'PopoutComponent', required: true },
        ],
        filePath: './src/lib/web-components/Modals/Popout/PopoutComponent.tsx',
        fileName: 'PopoutComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'ProgressBarComponent',
        extends: 'KitchenComponent<ProgressBarProps, ProgressBarEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-progress-bar'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                readonly: true,
                required: true,
            },
            { kind: 'classProperty', type: 'ProgressBarComponent', required: true },
        ],
        filePath: './src/lib/web-components/Visuals/ProgressBar/ProgressBarComponent.tsx',
        fileName: 'ProgressBarComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'RadioComponent',
        extends: 'KitchenComponent<RadioProps, RadioEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-radio'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'RadioComponent', required: true },
        ],
        filePath: './src/lib/web-components/Radios/Radio/RadioComponent.tsx',
        fileName: 'RadioComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'function',
        name: 'runAllComponentsOutsideAngular',
        type: 'void',
        description: 'Runs ALL Kitchen components outside of Angular zones (similar to `NgZone.runOutsideAngular`).\n\nNote that this means you must run NgZone.run in event handlers for Angular change detection to run.\n\nThis MUST be run before ANY Kitchen component is added to the DOM.\nThe best place to run this is in the constructor of your NgModule before any of the {ComponentName}Component.define() calls.',
        parameters: [],
        filePath: './src/lib/web-components/component-base/runOutsideAngular.ts',
        fileName: 'runOutsideAngular.ts',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'SearchBoxComponent',
        extends: 'KitchenComponent<SearchBoxProps, SearchBoxEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-search-box'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'SearchBoxComponent', required: true },
        ],
        filePath: './src/lib/web-components/Searches/SearchBox/SearchBoxComponent.tsx',
        fileName: 'SearchBoxComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'SentimentButtonComponent',
        extends: 'KitchenComponent<SentimentButtonProps, SentimentButtonEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-sentiment-button'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'SentimentButtonComponent', required: true },
        ],
        filePath: './src/lib/web-components/Buttons/SentimentButton/SentimentButtonComponent.tsx',
        fileName: 'SentimentButtonComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'SidePanelComponent',
        extends: 'KitchenComponent<SidePanelProps, SidePanelEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-side-panel'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'SidePanelComponent', required: true },
        ],
        filePath: './src/lib/web-components/Drawers/SidePanel/SidePanelComponent.ts',
        fileName: 'SidePanelComponent.ts',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'SliderComponent',
        extends: 'KitchenComponent<SliderProps, SliderEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-slider'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'SliderComponent', required: true },
        ],
        filePath: './src/lib/web-components/Sliders/Slider/SliderComponent.tsx',
        fileName: 'SliderComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'SnackBarComponent',
        extends: 'KitchenComponent<SnackBarProps, SnackBarEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-snack-bar'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'SnackBarComponent', required: true },
        ],
        filePath: './src/lib/web-components/Alerts/SnackBar/SnackBarComponent.tsx',
        fileName: 'SnackBarComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'SpanHTMLAttributes',
        extends: 'HTMLAttributes<HTMLSpanElement>',
        filePath: './src/lib/web-components/component-base/types/span-html.ts',
        fileName: 'span-html.ts',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'SpanHTMLEvents',
        extends: 'DOMEvents<HTMLSpanElement>',
        filePath: './src/lib/web-components/component-base/types/span-html.ts',
        fileName: 'span-html.ts',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'SuccessToasterComponent',
        extends: 'KitchenComponent<SuccessToasterProps, SuccessToasterEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-success-toaster'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'SuccessToasterComponent', required: true },
        ],
        filePath: './src/lib/web-components/Alerts/SuccessToaster/SuccessToasterComponent.tsx',
        fileName: 'SuccessToasterComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'TabBarComponent',
        extends: 'KitchenComponent<TabBarProps, TabBarEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-tab-bar'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'TabBarComponent', required: true },
        ],
        filePath: './src/lib/web-components/TabBars/TabBar/TabBarComponent.tsx',
        fileName: 'TabBarComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'TableComponent',
        extends: 'KitchenComponent<TableProps, TableEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-table'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'TableComponent', required: true },
        ],
        filePath: './src/lib/web-components/Tables/Table/TableComponent.tsx',
        fileName: 'TableComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'TextAreaComponent',
        extends: 'KitchenComponent<TextAreaProps, TextAreaEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-text-area'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'TextAreaComponent', required: true },
        ],
        filePath: './src/lib/web-components/TextFields/TextArea/TextAreaComponent.tsx',
        fileName: 'TextAreaComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'TextAreaHTMLAttributes',
        extends: 'HTMLAttributes<HTMLTextAreaElement>',
        implements: ['React.TextareaHTMLAttributes<HTMLTextAreaElement>'],
        properties: [
            { kind: 'classProperty', name: 'autoComplete', type: 'string', bound: true },
            { kind: 'classProperty', name: 'autoFocus', type: 'boolean', bound: true },
            { kind: 'classProperty', name: 'cols', type: 'number', bound: true },
            { kind: 'classProperty', name: 'dirName', type: 'string', bound: true },
            { kind: 'classProperty', name: 'disabled', type: 'boolean', bound: true },
            { kind: 'classProperty', name: 'form', type: 'string', bound: true },
            { kind: 'classProperty', name: 'maxLength', type: 'number', bound: true },
            { kind: 'classProperty', name: 'minLength', type: 'number', bound: true },
            { kind: 'classProperty', name: 'name', type: 'string', bound: true },
            { kind: 'classProperty', name: 'placeholder', type: 'string', bound: true },
            { kind: 'classProperty', name: 'readOnly', type: 'boolean', bound: true },
            { kind: 'classProperty', name: 'required', type: 'boolean', bound: true },
            { kind: 'classProperty', name: 'rows', type: 'number', bound: true },
            { kind: 'classProperty', name: 'value', type: 'string | ReadonlyArray<string> | number', bound: true },
            { kind: 'classProperty', name: 'wrap', type: 'string', bound: true },
        ],
        filePath: './src/lib/web-components/component-base/types/textarea-html.ts',
        fileName: 'textarea-html.ts',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'TextAreaHTMLEvents',
        extends: 'DOMEvents<HTMLTextAreaElement>',
        properties: [
            { kind: 'classProperty', name: 'onChange', type: 'React.ChangeEventHandler<HTMLTextAreaElement>', bound: true },
        ],
        filePath: './src/lib/web-components/component-base/types/textarea-html.ts',
        fileName: 'textarea-html.ts',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'TileButtonComponent',
        extends: 'KitchenComponent<TileButtonProps, TileButtonEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-tile-button'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'TileButtonComponent', required: true },
        ],
        filePath: './src/lib/web-components/Buttons/TileButton/TileButtonComponent.tsx',
        fileName: 'TileButtonComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'ToggleSwitchComponent',
        extends: 'KitchenComponent<ToggleSwitchProps, ToggleSwitchEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-toggle-switch'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'ToggleSwitchComponent', required: true },
        ],
        filePath: './src/lib/web-components/Switches/ToggleSwitch/ToggleSwitchComponent.tsx',
        fileName: 'ToggleSwitchComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'ToggleTextComponent',
        extends: 'KitchenComponent<ToggleTextProps, ToggleTextEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-toggle-text'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'ToggleTextComponent', required: true },
        ],
        filePath: './src/lib/web-components/Switches/ToggleText/ToggleTextComponent.tsx',
        fileName: 'ToggleTextComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'ToolTipContentComponent',
        extends: 'KitchenComponent<ToolTipContentProps, ToolTipContentEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-tool-tip-content'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'ToolTipContentComponent', required: true },
        ],
        filePath: './src/lib/web-components/ToolTips/ToolTipContent/ToolTipContentComponent.tsx',
        fileName: 'ToolTipContentComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'ToolTipWrapperComponent',
        extends: 'KitchenComponent<ToolTipProps, ToolTipEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-tool-tip-wrapper'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'ToolTipWrapperComponent', required: true },
        ],
        filePath: './src/lib/web-components/ToolTips/ToolTipWrapper/ToolTipWrapperComponent.tsx',
        fileName: 'ToolTipWrapperComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'TreePickerComponent',
        extends: 'KitchenComponent<TreePickerProps, TreePickerEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-tree-picker'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'TreePickerComponent', required: true },
        ],
        filePath: './src/lib/web-components/Pickers/TreePicker/TreePickerComponent.tsx',
        fileName: 'TreePickerComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'UListHTMLAttributes',
        extends: 'HTMLAttributes<HTMLUListElement>',
        filePath: './src/lib/web-components/component-base/types/ulist-html.ts',
        fileName: 'ulist-html.ts',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'UListHTMLEvents',
        extends: 'DOMEvents<HTMLUListElement>',
        filePath: './src/lib/web-components/component-base/types/ulist-html.ts',
        fileName: 'ulist-html.ts',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'VerticalTabBarComponent',
        extends: 'KitchenComponent<VerticalTabBarProps, VerticalTabBarEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-vertical-tab-bar'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'VerticalTabBarComponent', required: true },
        ],
        filePath: './src/lib/web-components/TabBars/VerticalTabBar/VerticalTabBarComponent.tsx',
        fileName: 'VerticalTabBarComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'VideoPlayerComponent',
        extends: 'KitchenComponent<VideoPlayerProps, VideoPlayerEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-video-player'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'VideoPlayerComponent', required: true },
        ],
        filePath: './src/lib/web-components/Media/VideoPlayer/VideoPlayerComponent.tsx',
        fileName: 'VideoPlayerComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'WarningPopupComponent',
        extends: 'KitchenComponent<WarningPopupProps, WarningPopupEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-warning-popup'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'WarningPopupComponent', required: true },
        ],
        filePath: './src/lib/web-components/Alerts/WarningPopup/WarningPopupComponent.tsx',
        fileName: 'WarningPopupComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'WaveTileComponent',
        extends: 'KitchenComponent<WaveTileProps, WaveTileEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-wave-tile'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'WaveTileComponent', required: true },
        ],
        filePath: './src/lib/web-components/Tiles/WaveTile/WaveTileComponent.tsx',
        fileName: 'WaveTileComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'XIAnimationComponent',
        extends: 'KitchenComponent<XIAnimationProps, XIAnimationEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-animation'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'XIAnimationComponent', required: true },
        ],
        filePath: './src/lib/web-components/Visuals/XIAnimation/XIAnimationComponent.tsx',
        fileName: 'XIAnimationComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'XIAppIconComponent',
        extends: 'KitchenComponent<XIAppIconProps, XIAppIconEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-app-icon'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'XIAppIconComponent', required: true },
        ],
        filePath: './src/lib/web-components/Visuals/XIAppIcon/XIAppIconComponent.tsx',
        fileName: 'XIAppIconComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'XIIconComponent',
        extends: 'KitchenComponent<XIIconProps, XIIconEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-icon'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'XIIconComponent', required: true },
        ],
        filePath: './src/lib/web-components/Visuals/XIIcon/XIIconComponent.tsx',
        fileName: 'XIIconComponent.tsx',
        category: 'web-components',
    },
    {
        kind: 'class',
        name: 'XISVGComponent',
        extends: 'KitchenComponent<XISVGProps, XISVGEvents>',
        properties: [
            {
                kind: 'classProperty',
                name: 'tag',
                type: "'xi-svg'",
                description: 'The tag that will be used to create the web component (i.e. xi-icon-button)',
                required: true,
            },
            { kind: 'classProperty', type: 'XISVGComponent', required: true },
        ],
        filePath: './src/lib/web-components/Visuals/XISVG/XISVGComponent.tsx',
        fileName: 'XISVGComponent.tsx',
        category: 'web-components',
    },
];
